import { FluenceApiClientBase, AuthClient } from './ApiClientBase';
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AcctRecClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateCode(): Promise<void> {
        let url_ = this.baseUrl + "/AcctRec/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateCode(_response));
        });
    }

    protected processGenerateCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    accountRecCodeAutogenerate(): Promise<void> {
        let url_ = this.baseUrl + "/AcctRec/accountreccodeautogenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccountRecCodeAutogenerate(_response));
        });
    }

    protected processAccountRecCodeAutogenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AiClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    helpChatTurn(message: HelpChatMessage): Promise<HelpChatMessage> {
        let url_ = this.baseUrl + "/Ai/HelpChatTurn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHelpChatTurn(_response));
        });
    }

    protected processHelpChatTurn(response: Response): Promise<HelpChatMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpChatMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HelpChatMessage>(null as any);
    }

    getHelpArticles(): Promise<HelpArticle[]> {
        let url_ = this.baseUrl + "/Ai";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHelpArticles(_response));
        });
    }

    protected processGetHelpArticles(response: Response): Promise<HelpArticle[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(HelpArticle.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HelpArticle[]>(null as any);
    }
}

export class AnaplanClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getADOActionTypes(datasource: string): Promise<ADOActionType[]> {
        let url_ = this.baseUrl + "/Anaplan/actiontypes/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActionTypes(_response));
        });
    }

    protected processGetADOActionTypes(response: Response): Promise<ADOActionType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOActionType.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOActionType[]>(null as any);
    }

    getADOActionsWithDataspace(datasource: string, actiontype: string, dataspace: string): Promise<ADOAction[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/{actiontype}/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (actiontype === undefined || actiontype === null)
            throw new globalThis.Error("The parameter 'actiontype' must be defined.");
        url_ = url_.replace("{actiontype}", encodeURIComponent("" + actiontype));
        if (dataspace === undefined || dataspace === null)
            throw new globalThis.Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActionsWithDataspace(_response));
        });
    }

    protected processGetADOActionsWithDataspace(response: Response): Promise<ADOAction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOAction.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOAction[]>(null as any);
    }

    triggerJob(datasource: string): Promise<string> {
        let url_ = this.baseUrl + "/Anaplan/actiontypes/{datasource}/pipeline";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTriggerJob(_response));
        });
    }

    protected processTriggerJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getADOPipelines(datasource: string): Promise<PipelineDefinitionItem[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/pipeline";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOPipelines(_response));
        });
    }

    protected processGetADOPipelines(response: Response): Promise<PipelineDefinitionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(PipelineDefinitionItem.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineDefinitionItem[]>(null as any);
    }

    getADOPipelinesWithDataspace(datasource: string, dataspace: string): Promise<PipelineDefinitionItem[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/pipeline/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (dataspace === undefined || dataspace === null)
            throw new globalThis.Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOPipelinesWithDataspace(_response));
        });
    }

    protected processGetADOPipelinesWithDataspace(response: Response): Promise<PipelineDefinitionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(PipelineDefinitionItem.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PipelineDefinitionItem[]>(null as any);
    }

    getADOActions(datasource: string, actiontype: string): Promise<ADOAction[]> {
        let url_ = this.baseUrl + "/Anaplan/actions/{datasource}/{actiontype}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (actiontype === undefined || actiontype === null)
            throw new globalThis.Error("The parameter 'actiontype' must be defined.");
        url_ = url_.replace("{actiontype}", encodeURIComponent("" + actiontype));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetADOActions(_response));
        });
    }

    protected processGetADOActions(response: Response): Promise<ADOAction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADOAction.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADOAction[]>(null as any);
    }

    getWorkflows(datasource: string): Promise<AnaplanWorkflow[]> {
        let url_ = this.baseUrl + "/Anaplan/workflows/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkflows(_response));
        });
    }

    protected processGetWorkflows(response: Response): Promise<AnaplanWorkflow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AnaplanWorkflow.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnaplanWorkflow[]>(null as any);
    }

    getDataspaces(datasource: string): Promise<ADODataspace[]> {
        let url_ = this.baseUrl + "/Anaplan/dataspaces/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataspaces(_response));
        });
    }

    protected processGetDataspaces(response: Response): Promise<ADODataspace[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataspace.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataspace[]>(null as any);
    }

    getDatasetsWithDataspace(datasource: string, dataspace: string): Promise<ADODataset[]> {
        let url_ = this.baseUrl + "/Anaplan/datasets/{datasource}/dataspace/{dataspace}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        if (dataspace === undefined || dataspace === null)
            throw new globalThis.Error("The parameter 'dataspace' must be defined.");
        url_ = url_.replace("{dataspace}", encodeURIComponent("" + dataspace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasetsWithDataspace(_response));
        });
    }

    protected processGetDatasetsWithDataspace(response: Response): Promise<ADODataset[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataset.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataset[]>(null as any);
    }

    getDatasets(datasource: string): Promise<ADODataset[]> {
        let url_ = this.baseUrl + "/Anaplan/datasets/{datasource}";
        if (datasource === undefined || datasource === null)
            throw new globalThis.Error("The parameter 'datasource' must be defined.");
        url_ = url_.replace("{datasource}", encodeURIComponent("" + datasource));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasets(_response));
        });
    }

    protected processGetDatasets(response: Response): Promise<ADODataset[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ADODataset.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADODataset[]>(null as any);
    }
}

export class AnomalyDetectionClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    runFactDataScan(request: RunFactDataScanRequestDto): Promise<FactDataScanSummaryDto> {
        let url_ = this.baseUrl + "/AnomalyDetection/factData/scans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunFactDataScan(_response));
        });
    }

    protected processRunFactDataScan(response: Response): Promise<FactDataScanSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FactDataScanSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FactDataScanSummaryDto>(null as any);
    }

    getFactDataScan(scanRunId: string): Promise<FactDataScanSummaryDto> {
        let url_ = this.baseUrl + "/AnomalyDetection/factData/scans/{scanRunId}";
        if (scanRunId === undefined || scanRunId === null)
            throw new globalThis.Error("The parameter 'scanRunId' must be defined.");
        url_ = url_.replace("{scanRunId}", encodeURIComponent("" + scanRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFactDataScan(_response));
        });
    }

    protected processGetFactDataScan(response: Response): Promise<FactDataScanSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FactDataScanSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FactDataScanSummaryDto>(null as any);
    }

    getLatestCompletedFactDataScan(modelName?: string | null | undefined, detectionMethod?: AnomalyDetectionMethodDto | undefined): Promise<FactDataScanSummaryDto> {
        let url_ = this.baseUrl + "/AnomalyDetection/factData/scans/latest?";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        if (detectionMethod === null)
            throw new globalThis.Error("The parameter 'detectionMethod' cannot be null.");
        else if (detectionMethod !== undefined)
            url_ += "detectionMethod=" + encodeURIComponent("" + detectionMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLatestCompletedFactDataScan(_response));
        });
    }

    protected processGetLatestCompletedFactDataScan(response: Response): Promise<FactDataScanSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FactDataScanSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FactDataScanSummaryDto>(null as any);
    }

    getFactDataResults(scanRunId: string, skip?: number | undefined, take?: number | undefined, period?: string | null | undefined): Promise<PagedFactDataResultsDto> {
        let url_ = this.baseUrl + "/AnomalyDetection/factData/scans/{scanRunId}/results?";
        if (scanRunId === undefined || scanRunId === null)
            throw new globalThis.Error("The parameter 'scanRunId' must be defined.");
        url_ = url_.replace("{scanRunId}", encodeURIComponent("" + scanRunId));
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (period !== undefined && period !== null)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFactDataResults(_response));
        });
    }

    protected processGetFactDataResults(response: Response): Promise<PagedFactDataResultsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedFactDataResultsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedFactDataResultsDto>(null as any);
    }
}

export class AuditTrailClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMetadataAuditLogs(paging: FilteredSortedPaging, timezoneOffsetMinutes?: number | undefined): Promise<MetadataAuditLogResult> {
        let url_ = this.baseUrl + "/AuditTrail?";
        if (timezoneOffsetMinutes === null)
            throw new globalThis.Error("The parameter 'timezoneOffsetMinutes' cannot be null.");
        else if (timezoneOffsetMinutes !== undefined)
            url_ += "timezoneOffsetMinutes=" + encodeURIComponent("" + timezoneOffsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMetadataAuditLogs(_response));
        });
    }

    protected processGetMetadataAuditLogs(response: Response): Promise<MetadataAuditLogResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetadataAuditLogResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetadataAuditLogResult>(null as any);
    }

    exportMetadataAuditTrail(paging: FilteredSortedPaging, format?: string | null | undefined, timezoneOffsetMinutes?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/AuditTrail/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (timezoneOffsetMinutes === null)
            throw new globalThis.Error("The parameter 'timezoneOffsetMinutes' cannot be null.");
        else if (timezoneOffsetMinutes !== undefined)
            url_ += "timezoneOffsetMinutes=" + encodeURIComponent("" + timezoneOffsetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMetadataAuditTrail(_response));
        });
    }

    protected processExportMetadataAuditTrail(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class Auth0ConfigClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Auth0Config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DashboardClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDashboards(): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDashboards(_response));
        });
    }

    protected processGetDashboards(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }

    myDashboards(): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMyDashboards(_response));
        });
    }

    protected processMyDashboards(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }

    createNewDashboard(dashboardSection?: DashboardSection | undefined, source?: number | null | undefined): Promise<DashboardSection> {
        let url_ = this.baseUrl + "/Dashboard?";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSection);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNewDashboard(_response));
        });
    }

    protected processCreateNewDashboard(response: Response): Promise<DashboardSection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection>(null as any);
    }

    updateDashboards(dashboardSections: DashboardSection[], ignoreDashboardControls?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard?";
        if (ignoreDashboardControls === null)
            throw new globalThis.Error("The parameter 'ignoreDashboardControls' cannot be null.");
        else if (ignoreDashboardControls !== undefined)
            url_ += "ignoreDashboardControls=" + encodeURIComponent("" + ignoreDashboardControls) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSections);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDashboards(_response));
        });
    }

    protected processUpdateDashboards(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDashboard(id?: number | undefined): Promise<DashboardSection> {
        let url_ = this.baseUrl + "/Dashboard/id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDashboard(_response));
        });
    }

    protected processGetDashboard(response: Response): Promise<DashboardSection> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSection.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection>(null as any);
    }

    deleteDashboard(id?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard/id?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDashboard(_response));
        });
    }

    protected processDeleteDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDashboard(id: number, dashboardSection: DashboardSection): Promise<void> {
        let url_ = this.baseUrl + "/Dashboard/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSection);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDashboard(_response));
        });
    }

    protected processUpdateDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    export(sectionIds: number[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Dashboard/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sectionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(file?: FileParameter | null | undefined): Promise<DashboardSection[]> {
        let url_ = this.baseUrl + "/Dashboard/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<DashboardSection[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardSection.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSection[]>(null as any);
    }
}

export class DataSourceClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAvailableDataSources(): Promise<DataSource[]> {
        let url_ = this.baseUrl + "/DataSource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableDataSources(_response));
        });
    }

    protected processGetAvailableDataSources(response: Response): Promise<DataSource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSource.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSource[]>(null as any);
    }

    getAvailableDataSourceDetails(): Promise<DataSourceExtended[]> {
        let url_ = this.baseUrl + "/DataSource/ConnectionStrings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableDataSourceDetails(_response));
        });
    }

    protected processGetAvailableDataSourceDetails(response: Response): Promise<DataSourceExtended[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSourceExtended.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSourceExtended[]>(null as any);
    }

    saveDataSources(datasources: DataSourceExtended[]): Promise<void> {
        let url_ = this.baseUrl + "/DataSource/ConnectionStrings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datasources);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataSources(_response));
        });
    }

    protected processSaveDataSources(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DbCleanupClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSettings(): Promise<DbCleanupSettingsDto> {
        let url_ = this.baseUrl + "/dbcleanup/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettings(_response));
        });
    }

    protected processGetSettings(response: Response): Promise<DbCleanupSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DbCleanupSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbCleanupSettingsDto>(null as any);
    }

    updateSettings(dto: DbCleanupSettingsDto): Promise<DbCleanupSettingsDto> {
        let url_ = this.baseUrl + "/dbcleanup/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSettings(_response));
        });
    }

    protected processUpdateSettings(response: Response): Promise<DbCleanupSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DbCleanupSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbCleanupSettingsDto>(null as any);
    }

    runNow(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/dbcleanup/run";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunNow(_response));
        });
    }

    protected processRunNow(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DevOpsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Returns the DevOps environment hierarchy from SYSDB.
     */
    getEnvironments(): Promise<DevOpsEnvironment[]> {
        let url_ = this.baseUrl + "/DevOps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnvironments(_response));
        });
    }

    protected processGetEnvironments(response: Response): Promise<DevOpsEnvironment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DevOpsEnvironment.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevOpsEnvironment[]>(null as any);
    }
}

export class EntraConfigClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/EntraConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EtlClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getStagingTables(): Promise<StagingTableInfo[]> {
        let url_ = this.baseUrl + "/Etl/stagingtables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStagingTables(_response));
        });
    }

    protected processGetStagingTables(response: Response): Promise<StagingTableInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StagingTableInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableInfo[]>(null as any);
    }

    getStagingTableFields(tableName?: string | null | undefined): Promise<StagingTableField[]> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStagingTableFields(_response));
        });
    }

    protected processGetStagingTableFields(response: Response): Promise<StagingTableField[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StagingTableField.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableField[]>(null as any);
    }

    createStagingTable(fields: StagingTableField[], tableName?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateStagingTable(_response));
        });
    }

    protected processCreateStagingTable(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateStagingTable(fields: StagingTableField[], tableName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fields);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStagingTable(_response));
        });
    }

    protected processUpdateStagingTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteStagingTable(tableName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/stagingtable?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteStagingTable(_response));
        });
    }

    protected processDeleteStagingTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    validateCreateStagingTableFromExcelRequest(request: StagingTableFromExcelRequest): Promise<StagingTableFromExcelResponse> {
        let url_ = this.baseUrl + "/Etl/stagingtables/import/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateCreateStagingTableFromExcelRequest(_response));
        });
    }

    protected processValidateCreateStagingTableFromExcelRequest(response: Response): Promise<StagingTableFromExcelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StagingTableFromExcelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableFromExcelResponse>(null as any);
    }

    createStagingTableFromExcel(request: StagingTableFromExcelRequest): Promise<StagingTableFromExcelResponse> {
        let url_ = this.baseUrl + "/Etl/stagingtables/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateStagingTableFromExcel(_response));
        });
    }

    protected processCreateStagingTableFromExcel(response: Response): Promise<StagingTableFromExcelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = StagingTableFromExcelResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StagingTableFromExcelResponse>(null as any);
    }

    prepare(table?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/prepare?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrepare(_response));
        });
    }

    protected processPrepare(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    validate(table?: string | null | undefined, importDefinition?: string | null | undefined, processRunId?: string | undefined, activityRunId?: string | undefined, fileName?: string | null | undefined): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Etl/validate?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (importDefinition !== undefined && importDefinition !== null)
            url_ += "importDefinition=" + encodeURIComponent("" + importDefinition) + "&";
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    validateFromLog(etlLogHeaderId?: number | undefined): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Etl/validate-from-log?";
        if (etlLogHeaderId === null)
            throw new globalThis.Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateFromLog(_response));
        });
    }

    protected processValidateFromLog(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    execute(table?: string | null | undefined, importdef?: string | null | undefined, skipValidation?: boolean | undefined, processRunIdTest?: string | null | undefined, activityRunIdTest?: string | null | undefined, fileName?: string | null | undefined): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Etl/execute?";
        if (table !== undefined && table !== null)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (importdef !== undefined && importdef !== null)
            url_ += "importdef=" + encodeURIComponent("" + importdef) + "&";
        if (skipValidation === null)
            throw new globalThis.Error("The parameter 'skipValidation' cannot be null.");
        else if (skipValidation !== undefined)
            url_ += "skipValidation=" + encodeURIComponent("" + skipValidation) + "&";
        if (processRunIdTest !== undefined && processRunIdTest !== null)
            url_ += "processRunIdTest=" + encodeURIComponent("" + processRunIdTest) + "&";
        if (activityRunIdTest !== undefined && activityRunIdTest !== null)
            url_ += "activityRunIdTest=" + encodeURIComponent("" + activityRunIdTest) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecute(_response));
        });
    }

    protected processExecute(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    copyModelMapping(origModelMappingId: number, request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/copymodelmapping/{origModelMappingId}";
        if (origModelMappingId === undefined || origModelMappingId === null)
            throw new globalThis.Error("The parameter 'origModelMappingId' must be defined.");
        url_ = url_.replace("{origModelMappingId}", encodeURIComponent("" + origModelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyModelMapping(_response));
        });
    }

    protected processCopyModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelMappingInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    createModelMapping(request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/modelmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModelMapping(_response));
        });
    }

    protected processCreateModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelMappingInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    getModelMappings(): Promise<ModelMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelmapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappings(_response));
        });
    }

    protected processGetModelMappings(response: Response): Promise<ModelMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo[]>(null as any);
    }

    updateModelMapping(modelMappingId: number, request: ModelMappingInfo): Promise<ModelMappingInfo> {
        let url_ = this.baseUrl + "/Etl/modelmapping/{modelMappingId}";
        if (modelMappingId === undefined || modelMappingId === null)
            throw new globalThis.Error("The parameter 'modelMappingId' must be defined.");
        url_ = url_.replace("{modelMappingId}", encodeURIComponent("" + modelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModelMapping(_response));
        });
    }

    protected processUpdateModelMapping(response: Response): Promise<ModelMappingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelMappingInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingInfo>(null as any);
    }

    deleteModelMapping(modelMappingId: number): Promise<void> {
        let url_ = this.baseUrl + "/Etl/modelmapping/{modelMappingId}";
        if (modelMappingId === undefined || modelMappingId === null)
            throw new globalThis.Error("The parameter 'modelMappingId' must be defined.");
        url_ = url_.replace("{modelMappingId}", encodeURIComponent("" + modelMappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModelMapping(_response));
        });
    }

    protected processDeleteModelMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getModelMappingData(): Promise<ModelMappingDataInfo> {
        let url_ = this.baseUrl + "/Etl/modelmappingdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappingData(_response));
        });
    }

    protected processGetModelMappingData(response: Response): Promise<ModelMappingDataInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelMappingDataInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelMappingDataInfo>(null as any);
    }

    getDataSlicers(): Promise<DataSlicerInfo[]> {
        let url_ = this.baseUrl + "/Etl/dataslicers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataSlicers(_response));
        });
    }

    protected processGetDataSlicers(response: Response): Promise<DataSlicerInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataSlicerInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataSlicerInfo[]>(null as any);
    }

    getModelFieldMappings(mappingId: number): Promise<ModelFieldMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelfieldmapping/{mappingId}";
        if (mappingId === undefined || mappingId === null)
            throw new globalThis.Error("The parameter 'mappingId' must be defined.");
        url_ = url_.replace("{mappingId}", encodeURIComponent("" + mappingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelFieldMappings(_response));
        });
    }

    protected processGetModelFieldMappings(response: Response): Promise<ModelFieldMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelFieldMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelFieldMappingInfo[]>(null as any);
    }

    getFields(): Promise<SimpleKeyValue[]> {
        let url_ = this.baseUrl + "/Etl/dbfields";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFields(_response));
        });
    }

    protected processGetFields(response: Response): Promise<SimpleKeyValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SimpleKeyValue.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleKeyValue[]>(null as any);
    }

    saveFieldMappings(list: ModelFieldMappingInfo[]): Promise<ModelFieldMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/modelfieldsmappings/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFieldMappings(_response));
        });
    }

    protected processSaveFieldMappings(response: Response): Promise<ModelFieldMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(ModelFieldMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelFieldMappingInfo[]>(null as any);
    }

    saveClearData(list: DataSlicerInfo[]): Promise<DefaultMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/cleardata/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveClearData(_response));
        });
    }

    protected processSaveClearData(response: Response): Promise<DefaultMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(DefaultMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultMappingInfo[]>(null as any);
    }

    saveModelMapRoleWrite(list: RoleWriteObject[], sourceName?: string | null | undefined, parentController?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/modelmaprolewrite/save?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (parentController !== undefined && parentController !== null)
            url_ += "parentController=" + encodeURIComponent("" + parentController) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveModelMapRoleWrite(_response));
        });
    }

    protected processSaveModelMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(RoleWriteObject.fromJS(resultData201[item]));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getModelMappingRoleWrite(sourceName: string): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/modelmappingrolewrite/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModelMappingRoleWrite(_response));
        });
    }

    protected processGetModelMappingRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getAllModelMappingRoleWrite(sourceName?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/allmodelmappingrolewrite?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllModelMappingRoleWrite(_response));
        });
    }

    protected processGetAllModelMappingRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getEtlLogHeader(): Promise<EtlLogHeaderInfo[]> {
        let url_ = this.baseUrl + "/Etl/etllogheader";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogHeader(_response));
        });
    }

    protected processGetEtlLogHeader(response: Response): Promise<EtlLogHeaderInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(EtlLogHeaderInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtlLogHeaderInfo[]>(null as any);
    }

    getEtlLogDetails(take?: number | undefined, skip?: number | undefined, etlLogHeaderid?: number | undefined, recordType?: string | null | undefined): Promise<DrillbackDetailInfo> {
        let url_ = this.baseUrl + "/Etl/etllogdetails?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (etlLogHeaderid === null)
            throw new globalThis.Error("The parameter 'etlLogHeaderid' cannot be null.");
        else if (etlLogHeaderid !== undefined)
            url_ += "etlLogHeaderid=" + encodeURIComponent("" + etlLogHeaderid) + "&";
        if (recordType !== undefined && recordType !== null)
            url_ += "recordType=" + encodeURIComponent("" + recordType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogDetails(_response));
        });
    }

    protected processGetEtlLogDetails(response: Response): Promise<DrillbackDetailInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrillbackDetailInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrillbackDetailInfo>(null as any);
    }

    exportDrillBackDetails(etlLogHeaderId?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/etllogdetails/export?";
        if (etlLogHeaderId === null)
            throw new globalThis.Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDrillBackDetails(_response));
        });
    }

    protected processExportDrillBackDetails(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getEtlLogInfo(etlLogHeaderId?: number | undefined): Promise<EtlLogInfo[]> {
        let url_ = this.baseUrl + "/Etl/etlloginfo?";
        if (etlLogHeaderId === null)
            throw new globalThis.Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEtlLogInfo(_response));
        });
    }

    protected processGetEtlLogInfo(response: Response): Promise<EtlLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(EtlLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtlLogInfo[]>(null as any);
    }

    exportEtlLogInfo(etlLogHeaderId?: number | undefined, timezoneOffset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/etlloginfo/export?";
        if (etlLogHeaderId === null)
            throw new globalThis.Error("The parameter 'etlLogHeaderId' cannot be null.");
        else if (etlLogHeaderId !== undefined)
            url_ += "etlLogHeaderId=" + encodeURIComponent("" + etlLogHeaderId) + "&";
        if (timezoneOffset === null)
            throw new globalThis.Error("The parameter 'timezoneOffset' cannot be null.");
        else if (timezoneOffset !== undefined)
            url_ += "timezoneOffset=" + encodeURIComponent("" + timezoneOffset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportEtlLogInfo(_response));
        });
    }

    protected processExportEtlLogInfo(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDataMaps(): Promise<DataMapInfo[]> {
        let url_ = this.baseUrl + "/Etl/datamap";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMaps(_response));
        });
    }

    protected processGetDataMaps(response: Response): Promise<DataMapInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMapInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo[]>(null as any);
    }

    deleteDataMap(sourceName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/datamap?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDataMap(_response));
        });
    }

    protected processDeleteDataMap(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveDataMap(dataMap: DataMapInfo): Promise<DataMapInfo> {
        let url_ = this.baseUrl + "/Etl/datamap/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataMap);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataMap(_response));
        });
    }

    protected processSaveDataMap(response: Response): Promise<DataMapInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DataMapInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo>(null as any);
    }

    updateDataMap(sourceName: string, request: UpdateDataMapRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/datamap/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDataMap(_response));
        });
    }

    protected processUpdateDataMap(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDataMapsRoles(): Promise<DataMapInfo[]> {
        let url_ = this.baseUrl + "/Etl/datamaproles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMapsRoles(_response));
        });
    }

    protected processGetDataMapsRoles(response: Response): Promise<DataMapInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMapInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMapInfo[]>(null as any);
    }

    getDataMapRoleWrite(sourceName: string): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/datamaprolewrite/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataMapRoleWrite(_response));
        });
    }

    protected processGetDataMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleWriteObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    saveDataMapRoleWrite(list: RoleWriteObject[], sourceName?: string | null | undefined, parentController?: string | null | undefined): Promise<RoleWriteObject[]> {
        let url_ = this.baseUrl + "/Etl/datamaprolewrite/save?";
        if (sourceName !== undefined && sourceName !== null)
            url_ += "sourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (parentController !== undefined && parentController !== null)
            url_ += "parentController=" + encodeURIComponent("" + parentController) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDataMapRoleWrite(_response));
        });
    }

    protected processSaveDataMapRoleWrite(response: Response): Promise<RoleWriteObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(RoleWriteObject.fromJS(resultData201[item]));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWriteObject[]>(null as any);
    }

    getMemberMappings(sourceName: string, translation?: string | null | undefined): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberMappings(_response));
        });
    }

    protected processGetMemberMappings(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    saveMemberMappings(input: SaveDataMappingRequest): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMemberMappings(_response));
        });
    }

    protected processSaveMemberMappings(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item in resultData201)
                    result201!.push(DataMappingInfo.fromJS(resultData201[item]));
            }
            else {
                result201 = null as any;
            }
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    exportWorkflowErrorsAsMemberMappings(sourceName: string, list: DataMappingInfo[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/membermapping/exporterrors/{sourceName}";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportWorkflowErrorsAsMemberMappings(_response));
        });
    }

    protected processExportWorkflowErrorsAsMemberMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportMemberMappings(sourceName: string, format?: string | null | undefined, includeCaptions?: boolean | undefined, translation?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/membermapping/export/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (includeCaptions === null)
            throw new globalThis.Error("The parameter 'includeCaptions' cannot be null.");
        else if (includeCaptions !== undefined)
            url_ += "includeCaptions=" + encodeURIComponent("" + includeCaptions) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMemberMappings(_response));
        });
    }

    protected processExportMemberMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importMemberMappings(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Etl/membermapping/import/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMemberMappings(_response));
        });
    }

    protected processImportMemberMappings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importMemberMappingsClient(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined, translation?: string | null | undefined): Promise<DataMappingInfo[]> {
        let url_ = this.baseUrl + "/Etl/membermapping/importclient/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMemberMappingsClient(_response));
        });
    }

    protected processImportMemberMappingsClient(response: Response): Promise<DataMappingInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DataMappingInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataMappingInfo[]>(null as any);
    }

    getMultiDimMappings(sourceName: string, translation?: string | null | undefined): Promise<MultiDimMappingsDto> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMultiDimMappings(_response));
        });
    }

    protected processGetMultiDimMappings(response: Response): Promise<MultiDimMappingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiDimMappingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDimMappingsDto>(null as any);
    }

    editMultiDimMappings(request: EditMultiDimMappingsRequestDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/multidimmapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditMultiDimMappings(_response));
        });
    }

    protected processEditMultiDimMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importMultiDimMappingInsertRowsFromFile(sourceName: string, isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<MultiDimRowInsertDto[]> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/importclient/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMultiDimMappingInsertRowsFromFile(_response));
        });
    }

    protected processImportMultiDimMappingInsertRowsFromFile(response: Response): Promise<MultiDimRowInsertDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MultiDimRowInsertDto.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDimRowInsertDto[]>(null as any);
    }

    exportMultiDimMappings(sourceName: string, format?: string | null | undefined, includeCaptions?: boolean | undefined, translation?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Etl/multidimmapping/export/{sourceName}?";
        if (sourceName === undefined || sourceName === null)
            throw new globalThis.Error("The parameter 'sourceName' must be defined.");
        url_ = url_.replace("{sourceName}", encodeURIComponent("" + sourceName));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (includeCaptions === null)
            throw new globalThis.Error("The parameter 'includeCaptions' cannot be null.");
        else if (includeCaptions !== undefined)
            url_ += "includeCaptions=" + encodeURIComponent("" + includeCaptions) + "&";
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMultiDimMappings(_response));
        });
    }

    protected processExportMultiDimMappings(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ExtensionClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    dashboardExtensions(): Promise<DashboardExtension[]> {
        let url_ = this.baseUrl + "/Extension/dashboardextensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDashboardExtensions(_response));
        });
    }

    protected processDashboardExtensions(response: Response): Promise<DashboardExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DashboardExtension.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardExtension[]>(null as any);
    }

    homeExtensions(): Promise<HomeExtension[]> {
        let url_ = this.baseUrl + "/Extension/homeextensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHomeExtensions(_response));
        });
    }

    protected processHomeExtensions(response: Response): Promise<HomeExtension[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(HomeExtension.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HomeExtension[]>(null as any);
    }
}

export class FactDataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getIntercompanyGaps(modelName?: string | null | undefined, scenario?: string | null | undefined, time?: string | null | undefined, currency?: string | null | undefined, entity?: string | null | undefined, matchingAccount?: string | null | undefined): Promise<IntercompanyGapResponse[]> {
        let url_ = this.baseUrl + "/FactData/intercompanyGaps?";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (matchingAccount !== undefined && matchingAccount !== null)
            url_ += "matchingAccount=" + encodeURIComponent("" + matchingAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIntercompanyGaps(_response));
        });
    }

    protected processGetIntercompanyGaps(response: Response): Promise<IntercompanyGapResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(IntercompanyGapResponse.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntercompanyGapResponse[]>(null as any);
    }

    getIntercompanyGapsByAccount(modelName?: string | null | undefined, scenario?: string | null | undefined, time?: string | null | undefined, currency?: string | null | undefined, entity?: string | null | undefined, matchingAccount?: string | null | undefined): Promise<IntercompanyGapAccountDetailResponse[]> {
        let url_ = this.baseUrl + "/FactData/intercompanyGapsByAccount?";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (time !== undefined && time !== null)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (matchingAccount !== undefined && matchingAccount !== null)
            url_ += "matchingAccount=" + encodeURIComponent("" + matchingAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIntercompanyGapsByAccount(_response));
        });
    }

    protected processGetIntercompanyGapsByAccount(response: Response): Promise<IntercompanyGapAccountDetailResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(IntercompanyGapAccountDetailResponse.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IntercompanyGapAccountDetailResponse[]>(null as any);
    }
}

export class FeatureFlagClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFeatureFlag(featureName: string): Promise<boolean> {
        let url_ = this.baseUrl + "/FeatureFlag/{featureName}";
        if (featureName === undefined || featureName === null)
            throw new globalThis.Error("The parameter 'featureName' must be defined.");
        url_ = url_.replace("{featureName}", encodeURIComponent("" + featureName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFeatureFlag(_response));
        });
    }

    protected processGetFeatureFlag(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FileSystemClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFileOld(path: string, content?: string | null | undefined, descendants?: boolean | undefined, objectType?: string | null | undefined): Promise<FileSystemObjectContent> {
        let url_ = this.baseUrl + "/FileSystem/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (descendants === null)
            throw new globalThis.Error("The parameter 'descendants' cannot be null.");
        else if (descendants !== undefined)
            url_ += "descendants=" + encodeURIComponent("" + descendants) + "&";
        if (objectType !== undefined && objectType !== null)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileOld(_response));
        });
    }

    protected processGetFileOld(response: Response): Promise<FileSystemObjectContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObjectContent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObjectContent>(null as any);
    }

    delete(path: string): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    post(path: string, request: FileSystemObjectBase, createPath?: boolean | undefined): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (createPath === null)
            throw new globalThis.Error("The parameter 'createPath' cannot be null.");
        else if (createPath !== undefined)
            url_ += "createPath=" + encodeURIComponent("" + createPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FileSystemChangeNotification.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    /**
     * @param content (optional) 
     * @param descendants (optional) 
     * @param tenant (optional) 
     * @param refreshCache (optional) 
     * @param objectType (optional) Optional FileSystemType name. When provided with descendants = true, matching objects are returned as a flat list under the root folder instead of a nested tree.
     */
    getFile(path: string, content?: string | null | undefined, descendants?: boolean | undefined, tenant?: string | null | undefined, refreshCache?: boolean | undefined, objectType?: string | null | undefined): Promise<FileSystemObjectContent> {
        let url_ = this.baseUrl + "/FileSystem/Specific/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (descendants === null)
            throw new globalThis.Error("The parameter 'descendants' cannot be null.");
        else if (descendants !== undefined)
            url_ += "descendants=" + encodeURIComponent("" + descendants) + "&";
        if (tenant !== undefined && tenant !== null)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        if (refreshCache === null)
            throw new globalThis.Error("The parameter 'refreshCache' cannot be null.");
        else if (refreshCache !== undefined)
            url_ += "refreshCache=" + encodeURIComponent("" + refreshCache) + "&";
        if (objectType !== undefined && objectType !== null)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileSystemObjectContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObjectContent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObjectContent>(null as any);
    }

    update(path: string, newContent: FileSystemObjectBase): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/Content/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContent);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    move(path: string, moveTo: string): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/FileSystem/Move/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveTo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMove(_response));
        });
    }

    protected processMove(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    copy(path: string, copyTo: string): Promise<FileSystemChangeNotification> {
        let url_ = this.baseUrl + "/FileSystem/Copy/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyTo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopy(_response));
        });
    }

    protected processCopy(response: Response): Promise<FileSystemChangeNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemChangeNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification>(null as any);
    }

    setupNotifications(): Promise<void> {
        let url_ = this.baseUrl + "/FileSystem/SetupNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetupNotifications(_response));
        });
    }

    protected processSetupNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRelativeObject(fileId: number, relativePath?: string | null | undefined): Promise<FileSystemObject> {
        let url_ = this.baseUrl + "/FileSystem/relative/{fileId}?";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (relativePath !== undefined && relativePath !== null)
            url_ += "relativePath=" + encodeURIComponent("" + relativePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRelativeObject(_response));
        });
    }

    protected processGetRelativeObject(response: Response): Promise<FileSystemObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObject>(null as any);
    }

    export(path: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/Export/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(path: string, file?: FileParameter | null | undefined): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/FileSystem/Import/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    openGenericFile(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/Generic/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenGenericFile(_response));
        });
    }

    protected processOpenGenericFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getMyFavorites(): Promise<string[]> {
        let url_ = this.baseUrl + "/FileSystem/MyFavorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyFavorites(_response));
        });
    }

    protected processGetMyFavorites(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    setMyFavorites(path: string, isFavorite?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/FileSystem/MyFavorites/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (isFavorite === null)
            throw new globalThis.Error("The parameter 'isFavorite' cannot be null.");
        else if (isFavorite !== undefined)
            url_ += "isFavorite=" + encodeURIComponent("" + isFavorite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetMyFavorites(_response));
        });
    }

    protected processSetMyFavorites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDefaulttXl3Server(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/DefaultXl3Server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaulttXl3Server(_response));
        });
    }

    protected processGetDefaulttXl3Server(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getXL3DefaultAjaxCallbackUriTemplate(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/XL3DefaultAjaxCallbackUriTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetXL3DefaultAjaxCallbackUriTemplate(_response));
        });
    }

    protected processGetXL3DefaultAjaxCallbackUriTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDefaulttStandaloneXl3Server(): Promise<string> {
        let url_ = this.baseUrl + "/FileSystem/DefaultStandaloneXl3Server";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaulttStandaloneXl3Server(_response));
        });
    }

    protected processGetDefaulttStandaloneXl3Server(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    renderXL3Report(path: string, format?: ArchiveXL3ReportFormat | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/FileSystem/RenderXL3Report/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (format === null)
            throw new globalThis.Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRenderXL3Report(_response));
        });
    }

    protected processRenderXL3Report(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class FirewallClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sets the firewall rule.
     * @param ipstr (optional) 
     * @return Details about the actions performed.
     */
    setFirewallRule(ipstr?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Firewall?";
        if (ipstr !== undefined && ipstr !== null)
            url_ += "ipstr=" + encodeURIComponent("" + ipstr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetFirewallRule(_response));
        });
    }

    protected processSetFirewallRule(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FluenceXLClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/FluenceXL/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParameters(_response));
        });
    }

    protected processGetParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }
}

export class FormClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFormParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Form/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormParameters(_response));
        });
    }

    protected processGetFormParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }

    openForm(pathOrId: string, parameters: FormParameterCurrentValue[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenForm(_response));
        });
    }

    protected processOpenForm(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    refreshParameterValues(formId: number, parameterName: string, currentValues: FormParameterCurrentValue[]): Promise<FormParameter[]> {
        let url_ = this.baseUrl + "/Form/parameters/{formId}/{parameterName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (parameterName === undefined || parameterName === null)
            throw new globalThis.Error("The parameter 'parameterName' must be defined.");
        url_ = url_.replace("{parameterName}", encodeURIComponent("" + parameterName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currentValues);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshParameterValues(_response));
        });
    }

    protected processRefreshParameterValues(response: Response): Promise<FormParameter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FormParameter.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameter[]>(null as any);
    }

    /**
     * Opens a generic form, not from the file system, given an arbitrary xml and xlsx template. This is intended to preview forms from the form builder.
     * @param template (optional) 
     * @param build (optional) 
     */
    openFormPreview(template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormPreview(_response));
        });
    }

    protected processOpenFormPreview(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    openFormPreviewParameters(form_Template?: FileParameter | null | undefined, form_Build?: string | null | undefined, parameterList?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/previewformparameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (form_Template !== null && form_Template !== undefined)
            content_.append("Form.Template", form_Template.data, form_Template.fileName ? form_Template.fileName : "Form.Template");
        if (form_Build !== null && form_Build !== undefined)
            content_.append("Form.Build", form_Build.toString());
        if (parameterList !== null && parameterList !== undefined)
            content_.append("ParameterList", parameterList.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormPreviewParameters(_response));
        });
    }

    protected processOpenFormPreviewParameters(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFormPreviewParameters(template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Form/parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormPreviewParameters(_response));
        });
    }

    protected processGetFormPreviewParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }

    /**
     * Opens a form from the file system, without parameters
     * @param pathOrId /form/parameters/form_id
     */
    openFormNoParams(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/form/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpenFormNoParams(_response));
        });
    }

    protected processOpenFormNoParams(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createNewForm(pathOrId: string, template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<HttpStatusCodeException> {
        let url_ = this.baseUrl + "/Form/form/publish/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateNewForm(_response));
        });
    }

    protected processCreateNewForm(response: Response): Promise<HttpStatusCodeException> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HttpStatusCodeException.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCodeException>(null as any);
    }

    /**
     * Generates a Control Tab file for opening the form at the specified path (or file system id)
    If a processRunId and an activityRunId are provided, then parameters are retrieved through the InteractiveProcessRunner
     * @param pathOrId file system path or id of the form
     * @param processRunId (optional) the run ID of the the interactive process containing the form
     * @param activityRunId (optional) the run ID of the the interactive process containing the form
     */
    generateOpenControlTab(pathOrId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/control/open/{pathOrId}?";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateOpenControlTab(_response));
        });
    }

    protected processGenerateOpenControlTab(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Generates a Control Tab file for editing the form at the specified path (or file system id)
     * @param pathOrId file system path or id of the form
     */
    generateEditControlTab(pathOrId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/control/edit/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateEditControlTab(_response));
        });
    }

    protected processGenerateEditControlTab(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    saveFormData(formData: string): Promise<void> {
        let url_ = this.baseUrl + "/Form/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFormData(_response));
        });
    }

    protected processSaveFormData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateFormDefinition(pathOrId: string, template?: FileParameter | null | undefined, build?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Form/definition/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (template !== null && template !== undefined)
            content_.append("Template", template.data, template.fileName ? template.fileName : "Template");
        if (build !== null && build !== undefined)
            content_.append("Build", build.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFormDefinition(_response));
        });
    }

    protected processUpdateFormDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runRelationalQuery(formId: number, queryName: string, variables: string[]): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Form/relationalquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new globalThis.Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunRelationalQuery(_response));
        });
    }

    protected processRunRelationalQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDimensionQuery(formId: number, queryName: string, variables: string[], fulltreeview?: boolean | undefined, rootelementkey?: string | null | undefined, rootelementname?: string | null | undefined): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Form/dimensionquery/{formId}/{queryName}?";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new globalThis.Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        if (fulltreeview === null)
            throw new globalThis.Error("The parameter 'fulltreeview' cannot be null.");
        else if (fulltreeview !== undefined)
            url_ += "fulltreeview=" + encodeURIComponent("" + fulltreeview) + "&";
        if (rootelementkey !== undefined && rootelementkey !== null)
            url_ += "rootelementkey=" + encodeURIComponent("" + rootelementkey) + "&";
        if (rootelementname !== undefined && rootelementname !== null)
            url_ += "rootelementname=" + encodeURIComponent("" + rootelementname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQuery(_response));
        });
    }

    protected processRunDimensionQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDrillDownQuery(formId: number, queryName: string, drillDownRequest: DrillDownRequest): Promise<DrillDownResult> {
        let url_ = this.baseUrl + "/Form/drilldownquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new globalThis.Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drillDownRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDrillDownQuery(_response));
        });
    }

    protected processRunDrillDownQuery(response: Response): Promise<DrillDownResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrillDownResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DrillDownResult>(null as any);
    }

    getFormAuditEntries(formId: number): Promise<AuditEntryId[]> {
        let url_ = this.baseUrl + "/Form/audit/{formId}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormAuditEntries(_response));
        });
    }

    protected processGetFormAuditEntries(response: Response): Promise<AuditEntryId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AuditEntryId.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEntryId[]>(null as any);
    }

    getFormAuditHighlight(formId: number, auditEntryId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/audit/{formId}/{auditEntryId}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (auditEntryId === undefined || auditEntryId === null)
            throw new globalThis.Error("The parameter 'auditEntryId' must be defined.");
        url_ = url_.replace("{auditEntryId}", encodeURIComponent("" + auditEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormAuditHighlight(_response));
        });
    }

    protected processGetFormAuditHighlight(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getCellAuditEntries(formId: number, queryName: string, keys: { [key: string]: number; }): Promise<ModelAuditEntry[]> {
        let url_ = this.baseUrl + "/Form/cellaudit/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new globalThis.Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCellAuditEntries(_response));
        });
    }

    protected processGetCellAuditEntries(response: Response): Promise<ModelAuditEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelAuditEntry.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelAuditEntry[]>(null as any);
    }

    getAttachment(formId: number, buildElement: string, keyValues: { [key: string]: any; }): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new globalThis.Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    removeAttachment(formId: number, buildElement: string, keyValues: { [key: string]: any; }): Promise<void> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new globalThis.Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveAttachment(_response));
        });
    }

    protected processRemoveAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadAttachment(formId: number, attachmentName: string, attachmentData: string): Promise<number> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{attachmentName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (attachmentName === undefined || attachmentName === null)
            throw new globalThis.Error("The parameter 'attachmentName' must be defined.");
        url_ = url_.replace("{attachmentName}", encodeURIComponent("" + attachmentName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachment(_response));
        });
    }

    protected processUploadAttachment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateFormAttachment(formId: number, buildElement: string, attachmentId: number, keyValues: { [key: string]: any; }): Promise<void> {
        let url_ = this.baseUrl + "/Form/attachment/{formId}/{buildElement}/{attachmentId}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (buildElement === undefined || buildElement === null)
            throw new globalThis.Error("The parameter 'buildElement' must be defined.");
        url_ = url_.replace("{buildElement}", encodeURIComponent("" + buildElement));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keyValues);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFormAttachment(_response));
        });
    }

    protected processUpdateFormAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runLIDQuery(formId: number, queryName: string, request: LIDRequest): Promise<LIDResult> {
        let url_ = this.baseUrl + "/Form/lidquery/{formId}/{queryName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (queryName === undefined || queryName === null)
            throw new globalThis.Error("The parameter 'queryName' must be defined.");
        url_ = url_.replace("{queryName}", encodeURIComponent("" + queryName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunLIDQuery(_response));
        });
    }

    protected processRunLIDQuery(response: Response): Promise<LIDResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LIDResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LIDResult>(null as any);
    }

    runCommmand(formId: number, commandName: string, variables: string[]): Promise<CommandOutput> {
        let url_ = this.baseUrl + "/Form/command/{formId}/{commandName}";
        if (formId === undefined || formId === null)
            throw new globalThis.Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (commandName === undefined || commandName === null)
            throw new globalThis.Error("The parameter 'commandName' must be defined.");
        url_ = url_.replace("{commandName}", encodeURIComponent("" + commandName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCommmand(_response));
        });
    }

    protected processRunCommmand(response: Response): Promise<CommandOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandOutput.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommandOutput>(null as any);
    }

    runModelQuery(queryLimit: number, query: string): Promise<ModelQueryResult> {
        let url_ = this.baseUrl + "/Form/modelquery/{queryLimit}";
        if (queryLimit === undefined || queryLimit === null)
            throw new globalThis.Error("The parameter 'queryLimit' must be defined.");
        url_ = url_.replace("{queryLimit}", encodeURIComponent("" + queryLimit));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunModelQuery(_response));
        });
    }

    protected processRunModelQuery(response: Response): Promise<ModelQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelQueryResult>(null as any);
    }
}

export class InvestmentRegistryClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getTree(scenario?: string | null | undefined): Promise<InvestmentRegistryTreeNodeDto[]> {
        let url_ = this.baseUrl + "/InvestmentRegistry/tree?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTree(_response));
        });
    }

    protected processGetTree(response: Response): Promise<InvestmentRegistryTreeNodeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(InvestmentRegistryTreeNodeDto.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentRegistryTreeNodeDto[]>(null as any);
    }

    getTransactions(entity?: string | null | undefined, intercompany?: string | null | undefined, scenario?: string | null | undefined): Promise<InvestmentTransactionsDto> {
        let url_ = this.baseUrl + "/InvestmentRegistry/transactions?";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (intercompany !== undefined && intercompany !== null)
            url_ += "intercompany=" + encodeURIComponent("" + intercompany) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTransactions(_response));
        });
    }

    protected processGetTransactions(response: Response): Promise<InvestmentTransactionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentTransactionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentTransactionsDto>(null as any);
    }
}

export class JournalClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getJournals(replaceGlobals?: boolean | undefined, strongRead?: boolean | undefined): Promise<JournalDefinition[]> {
        let url_ = this.baseUrl + "/Journal?";
        if (replaceGlobals === null)
            throw new globalThis.Error("The parameter 'replaceGlobals' cannot be null.");
        else if (replaceGlobals !== undefined)
            url_ += "replaceGlobals=" + encodeURIComponent("" + replaceGlobals) + "&";
        if (strongRead === null)
            throw new globalThis.Error("The parameter 'strongRead' cannot be null.");
        else if (strongRead !== undefined)
            url_ += "strongRead=" + encodeURIComponent("" + strongRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournals(_response));
        });
    }

    protected processGetJournals(response: Response): Promise<JournalDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDefinition.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition[]>(null as any);
    }

    getJournalAuditLogs(query: { [key: string]: any; }, journalName?: string | null | undefined, dimensionsSet?: boolean | undefined): Promise<JournalAuditLogInfo[]> {
        let url_ = this.baseUrl + "/Journal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (dimensionsSet === null)
            throw new globalThis.Error("The parameter 'dimensionsSet' cannot be null.");
        else if (dimensionsSet !== undefined)
            url_ += "dimensionsSet=" + encodeURIComponent("" + dimensionsSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalAuditLogs(_response));
        });
    }

    protected processGetJournalAuditLogs(response: Response): Promise<JournalAuditLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAuditLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAuditLogInfo[]>(null as any);
    }

    getJournalsV2(replaceGlobals?: boolean | undefined, strongRead?: boolean | undefined): Promise<JournalDefinition[]> {
        let url_ = this.baseUrl + "/Journal/GetJournalsV2?";
        if (replaceGlobals === null)
            throw new globalThis.Error("The parameter 'replaceGlobals' cannot be null.");
        else if (replaceGlobals !== undefined)
            url_ += "replaceGlobals=" + encodeURIComponent("" + replaceGlobals) + "&";
        if (strongRead === null)
            throw new globalThis.Error("The parameter 'strongRead' cannot be null.");
        else if (strongRead !== undefined)
            url_ += "strongRead=" + encodeURIComponent("" + strongRead) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalsV2(_response));
        });
    }

    protected processGetJournalsV2(response: Response): Promise<JournalDefinition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDefinition.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition[]>(null as any);
    }

    newJournal(journalName?: string | null | undefined, modelName?: string | null | undefined): Promise<JournalDefinition> {
        let url_ = this.baseUrl + "/Journal/NewJournal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (modelName !== undefined && modelName !== null)
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewJournal(_response));
        });
    }

    protected processNewJournal(response: Response): Promise<JournalDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDefinition>(null as any);
    }

    deleteJournal(journalName?: string | null | undefined, testifPossibleOny?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/DeleteJournal?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (testifPossibleOny === null)
            throw new globalThis.Error("The parameter 'testifPossibleOny' cannot be null.");
        else if (testifPossibleOny !== undefined)
            url_ += "testifPossibleOny=" + encodeURIComponent("" + testifPossibleOny) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteJournal(_response));
        });
    }

    protected processDeleteJournal(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteJournalV2(journalName?: string | null | undefined, testifPossibleOny?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/DeleteJournal-v2?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (testifPossibleOny === null)
            throw new globalThis.Error("The parameter 'testifPossibleOny' cannot be null.");
        else if (testifPossibleOny !== undefined)
            url_ += "testifPossibleOny=" + encodeURIComponent("" + testifPossibleOny) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteJournalV2(_response));
        });
    }

    protected processDeleteJournalV2(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    fixJournal(journalID?: number | undefined, dims?: string[] | null | undefined, isheader?: boolean[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/FixJournal?";
        if (journalID === null)
            throw new globalThis.Error("The parameter 'journalID' cannot be null.");
        else if (journalID !== undefined)
            url_ += "journalID=" + encodeURIComponent("" + journalID) + "&";
        if (dims !== undefined && dims !== null)
            dims && dims.forEach(item => { url_ += "dims=" + encodeURIComponent("" + item) + "&"; });
        if (isheader !== undefined && isheader !== null)
            isheader && isheader.forEach(item => { url_ += "isheader=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixJournal(_response));
        });
    }

    protected processFixJournal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixJournalV2(journalID?: number | undefined, dims?: string[] | null | undefined, isheader?: boolean[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/FixJournalV2?";
        if (journalID === null)
            throw new globalThis.Error("The parameter 'journalID' cannot be null.");
        else if (journalID !== undefined)
            url_ += "journalID=" + encodeURIComponent("" + journalID) + "&";
        if (dims !== undefined && dims !== null)
            dims && dims.forEach(item => { url_ += "dims=" + encodeURIComponent("" + item) + "&"; });
        if (isheader !== undefined && isheader !== null)
            isheader && isheader.forEach(item => { url_ += "isheader=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixJournalV2(_response));
        });
    }

    protected processFixJournalV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    editJournalDefinition(journal: JournalDefinition, recreateTables?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/EditJournalDefinition?";
        if (recreateTables === null)
            throw new globalThis.Error("The parameter 'recreateTables' cannot be null.");
        else if (recreateTables !== undefined)
            url_ += "recreateTables=" + encodeURIComponent("" + recreateTables) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(journal);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditJournalDefinition(_response));
        });
    }

    protected processEditJournalDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    searchHeaders(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined): Promise<JournalHeaderSecure[]> {
        let url_ = this.baseUrl + "/Journal/headers?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchHeaders(_response));
        });
    }

    protected processSearchHeaders(response: Response): Promise<JournalHeaderSecure[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderSecure.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderSecure[]>(null as any);
    }

    searchHeadersV2(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Journal/headers-v2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchHeadersV2(_response));
        });
    }

    protected processSearchHeadersV2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchDetails(filters: JournalFilter[], journal?: string | null | undefined, status?: JournalHeaderStatus | null | undefined, name?: string | null | undefined, description?: string | null | undefined): Promise<JournalDetail[]> {
        let url_ = this.baseUrl + "/Journal/details?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDetails(_response));
        });
    }

    protected processSearchDetails(response: Response): Promise<JournalDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDetail.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDetail[]>(null as any);
    }

    searchDetailsV2(filters: JournalFilter[], journal?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Journal/details-v2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchDetailsV2(_response));
        });
    }

    protected processSearchDetailsV2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveJournalData(data: SaveJournalDataModel, journal?: string | null | undefined): Promise<JournalHeaderWithDetails[]> {
        let url_ = this.baseUrl + "/Journal/save-journal-data?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJournalData(_response));
        });
    }

    protected processSaveJournalData(response: Response): Promise<JournalHeaderWithDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderWithDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderWithDetails[]>(null as any);
    }

    saveJournalDataV2(jsonData: string, journal?: string | null | undefined): Promise<JournalHeaderWithDetails[]> {
        let url_ = this.baseUrl + "/Journal/save-journal-dataV2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jsonData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveJournalDataV2(_response));
        });
    }

    protected processSaveJournalDataV2(response: Response): Promise<JournalHeaderWithDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalHeaderWithDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalHeaderWithDetails[]>(null as any);
    }

    post(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/post?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPost(_response));
        });
    }

    protected processPost(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    postV2(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/postv2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostV2(_response));
        });
    }

    protected processPostV2(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    unPost(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/unpost?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnPost(_response));
        });
    }

    protected processUnPost(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    unPostV2(jeGroupIds: number[], journal?: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/Journal/unpostv2?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jeGroupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnPostV2(_response));
        });
    }

    protected processUnPostV2(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    getAttachments(model?: string | null | undefined, headerId?: number | undefined): Promise<JournalAttachmentInfo[]> {
        let url_ = this.baseUrl + "/Journal/attachments?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (headerId === null)
            throw new globalThis.Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachments(_response));
        });
    }

    protected processGetAttachments(response: Response): Promise<JournalAttachmentInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAttachmentInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachmentInfo[]>(null as any);
    }

    getAttachment(journal?: string | null | undefined, id?: number | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    addAttachment(journal?: string | null | undefined, idHeader?: number | undefined, journal_Id?: number | undefined, journal_CreatedBy?: string | null | undefined, journal_CreatedOn?: Date | undefined, journal_Description?: string | null | undefined, journal_Name?: string | null | undefined, journal_Url?: string | null | undefined, postedFile_File?: FileParameter | null | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (idHeader === null)
            throw new globalThis.Error("The parameter 'idHeader' cannot be null.");
        else if (idHeader !== undefined)
            url_ += "idHeader=" + encodeURIComponent("" + idHeader) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (journal_Id === null || journal_Id === undefined)
            throw new globalThis.Error("The parameter 'journal_Id' cannot be null.");
        else
            content_.append("Journal.Id", journal_Id.toString());
        if (journal_CreatedBy !== null && journal_CreatedBy !== undefined)
            content_.append("Journal.CreatedBy", journal_CreatedBy.toString());
        if (journal_CreatedOn === null || journal_CreatedOn === undefined)
            throw new globalThis.Error("The parameter 'journal_CreatedOn' cannot be null.");
        else
            content_.append("Journal.CreatedOn", journal_CreatedOn.toJSON());
        if (journal_Description !== null && journal_Description !== undefined)
            content_.append("Journal.Description", journal_Description.toString());
        if (journal_Name !== null && journal_Name !== undefined)
            content_.append("Journal.Name", journal_Name.toString());
        if (journal_Url !== null && journal_Url !== undefined)
            content_.append("Journal.Url", journal_Url.toString());
        if (postedFile_File !== null && postedFile_File !== undefined)
            content_.append("PostedFile.File", postedFile_File.data, postedFile_File.fileName ? postedFile_File.fileName : "PostedFile.File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAttachment(_response));
        });
    }

    protected processAddAttachment(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    deleteAttachment(journal?: string | null | undefined, attachmentId?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/attachment?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAttachment(_response));
        });
    }

    protected processDeleteAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAttachmentV2(model?: string | null | undefined, id?: number | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachmentV2(_response));
        });
    }

    protected processGetAttachmentV2(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    addAttachmentV2(model?: string | null | undefined, idHeader?: number | undefined, journal_Id?: number | undefined, journal_CreatedBy?: string | null | undefined, journal_CreatedOn?: Date | undefined, journal_Description?: string | null | undefined, journal_Name?: string | null | undefined, journal_Url?: string | null | undefined, postedFile_File?: FileParameter | null | undefined): Promise<JournalAttachment> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (idHeader === null)
            throw new globalThis.Error("The parameter 'idHeader' cannot be null.");
        else if (idHeader !== undefined)
            url_ += "idHeader=" + encodeURIComponent("" + idHeader) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (journal_Id === null || journal_Id === undefined)
            throw new globalThis.Error("The parameter 'journal_Id' cannot be null.");
        else
            content_.append("Journal.Id", journal_Id.toString());
        if (journal_CreatedBy !== null && journal_CreatedBy !== undefined)
            content_.append("Journal.CreatedBy", journal_CreatedBy.toString());
        if (journal_CreatedOn === null || journal_CreatedOn === undefined)
            throw new globalThis.Error("The parameter 'journal_CreatedOn' cannot be null.");
        else
            content_.append("Journal.CreatedOn", journal_CreatedOn.toJSON());
        if (journal_Description !== null && journal_Description !== undefined)
            content_.append("Journal.Description", journal_Description.toString());
        if (journal_Name !== null && journal_Name !== undefined)
            content_.append("Journal.Name", journal_Name.toString());
        if (journal_Url !== null && journal_Url !== undefined)
            content_.append("Journal.Url", journal_Url.toString());
        if (postedFile_File !== null && postedFile_File !== undefined)
            content_.append("PostedFile.File", postedFile_File.data, postedFile_File.fileName ? postedFile_File.fileName : "PostedFile.File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAttachmentV2(_response));
        });
    }

    protected processAddAttachmentV2(response: Response): Promise<JournalAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAttachment>(null as any);
    }

    deleteAttachmentV2(model?: string | null | undefined, attachmentId?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Journal/attachment-v2?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        if (attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' cannot be null.");
        else if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAttachmentV2(_response));
        });
    }

    protected processDeleteAttachmentV2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAuthorizedMemberKeys(model?: string | null | undefined): Promise<JournalDimensionAuthorizedKeys[]> {
        let url_ = this.baseUrl + "/Journal/authorized-member-keys?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthorizedMemberKeys(_response));
        });
    }

    protected processGetAuthorizedMemberKeys(response: Response): Promise<JournalDimensionAuthorizedKeys[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalDimensionAuthorizedKeys.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalDimensionAuthorizedKeys[]>(null as any);
    }

    getJournalAuditLogsV2(query: { [key: string]: any; }, journalName?: string | null | undefined, dimensionsSet?: boolean | undefined): Promise<JournalAuditLogInfo[]> {
        let url_ = this.baseUrl + "/Journal/journal-audit-logs-v2?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (dimensionsSet === null)
            throw new globalThis.Error("The parameter 'dimensionsSet' cannot be null.");
        else if (dimensionsSet !== undefined)
            url_ += "dimensionsSet=" + encodeURIComponent("" + dimensionsSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournalAuditLogsV2(_response));
        });
    }

    protected processGetJournalAuditLogsV2(response: Response): Promise<JournalAuditLogInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalAuditLogInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalAuditLogInfo[]>(null as any);
    }

    importDetails(csvDelim?: string | undefined, file?: FileParameter | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Journal/import?";
        if (csvDelim === null)
            throw new globalThis.Error("The parameter 'csvDelim' cannot be null.");
        else if (csvDelim !== undefined)
            url_ += "csvDelim=" + encodeURIComponent("" + csvDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDetails(_response));
        });
    }

    protected processImportDetails(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    exportJEAuditLog(auditLogInfo: JournalAuditLogInfo[], journalName?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Journal/export?";
        if (journalName !== undefined && journalName !== null)
            url_ += "journalName=" + encodeURIComponent("" + journalName) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auditLogInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportJEAuditLog(_response));
        });
    }

    protected processExportJEAuditLog(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getFailedValidationRules(journal?: string | null | undefined, headerId?: number | undefined): Promise<JournalRule[]> {
        let url_ = this.baseUrl + "/Journal/ValidationRules?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        if (headerId === null)
            throw new globalThis.Error("The parameter 'headerId' cannot be null.");
        else if (headerId !== undefined)
            url_ += "headerId=" + encodeURIComponent("" + headerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFailedValidationRules(_response));
        });
    }

    protected processGetFailedValidationRules(response: Response): Promise<JournalRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(JournalRule.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalRule[]>(null as any);
    }

    movementClassificationValidation(journal?: string | null | undefined): Promise<JournalMovementClasificationValidation> {
        let url_ = this.baseUrl + "/Journal/MovementClassificationValidation?";
        if (journal !== undefined && journal !== null)
            url_ += "journal=" + encodeURIComponent("" + journal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMovementClassificationValidation(_response));
        });
    }

    protected processMovementClassificationValidation(response: Response): Promise<JournalMovementClasificationValidation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JournalMovementClasificationValidation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JournalMovementClasificationValidation>(null as any);
    }

    getJEFeatureFlag(): Promise<boolean> {
        let url_ = this.baseUrl + "/Journal/jefeatureflag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJEFeatureFlag(_response));
        });
    }

    protected processGetJEFeatureFlag(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class LandscapeManagementClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    manage(): Promise<string> {
        let url_ = this.baseUrl + "/LandscapeManagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processManage(_response));
        });
    }

    protected processManage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getTenants(): Promise<TenantDTO[]> {
        let url_ = this.baseUrl + "/LandscapeManagement/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTenants(_response));
        });
    }

    protected processGetTenants(response: Response): Promise<TenantDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(TenantDTO.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDTO[]>(null as any);
    }

    createChangeSet(changeSetDTO: ChangeSetDTO): Promise<ChangeSet> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateChangeSet(_response));
        });
    }

    protected processCreateChangeSet(response: Response): Promise<ChangeSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeSet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSet>(null as any);
    }

    updateChangeSet(changeSetId: number, changeSetDTO: ChangeSetDTO): Promise<ChangeSet> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetDTO);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateChangeSet(_response));
        });
    }

    protected processUpdateChangeSet(response: Response): Promise<ChangeSet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeSet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSet>(null as any);
    }

    deleteChangeSet(changeSetId: number): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteChangeSet(_response));
        });
    }

    protected processDeleteChangeSet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createChangeSetItems(changeSetId: number, changeSetItemsDTO: ChangeSetItemDTO[]): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/changesetitems";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeSetItemsDTO);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateChangeSetItems(_response));
        });
    }

    protected processCreateChangeSetItems(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getChangeSetItems(changeSetId: number): Promise<ChangeSetItem[]> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/changesetitems";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChangeSetItems(_response));
        });
    }

    protected processGetChangeSetItems(response: Response): Promise<ChangeSetItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ChangeSetItem.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeSetItem[]>(null as any);
    }

    initiateDeployment(changeSetId: number, targetTenantIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/initiatedeployment";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetTenantIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateDeployment(_response));
        });
    }

    protected processInitiateDeployment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    cancelDeployment(changeSetId: number): Promise<void> {
        let url_ = this.baseUrl + "/LandscapeManagement/changeset/{changeSetId}/canceldeployment";
        if (changeSetId === undefined || changeSetId === null)
            throw new globalThis.Error("The parameter 'changeSetId' must be defined.");
        url_ = url_.replace("{changeSetId}", encodeURIComponent("" + changeSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelDeployment(_response));
        });
    }

    protected processCancelDeployment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MaintenanceClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getForms(): Promise<AdminForm[]> {
        let url_ = this.baseUrl + "/Maintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetForms(_response));
        });
    }

    protected processGetForms(response: Response): Promise<AdminForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminForm.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminForm[]>(null as any);
    }

    getFormsByTableName(tableName: string): Promise<AdminForm[]> {
        let url_ = this.baseUrl + "/Maintenance/{tableName}";
        if (tableName === undefined || tableName === null)
            throw new globalThis.Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormsByTableName(_response));
        });
    }

    protected processGetFormsByTableName(response: Response): Promise<AdminForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminForm.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminForm[]>(null as any);
    }

    getFormColumns(formID?: number | undefined): Promise<Column[]> {
        let url_ = this.baseUrl + "/Maintenance/columns?";
        if (formID === null)
            throw new globalThis.Error("The parameter 'formID' cannot be null.");
        else if (formID !== undefined)
            url_ += "formID=" + encodeURIComponent("" + formID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormColumns(_response));
        });
    }

    protected processGetFormColumns(response: Response): Promise<Column[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Column.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Column[]>(null as any);
    }

    getListFromTable(tableName?: string | null | undefined, tableColumn?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/list?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        if (tableColumn !== undefined && tableColumn !== null)
            url_ += "tableColumn=" + encodeURIComponent("" + tableColumn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListFromTable(_response));
        });
    }

    protected processGetListFromTable(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getTableData(formId?: number | undefined, tablePrimaryKey?: string | null | undefined, type?: string | null | undefined, matchingValue?: string | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/data?";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (tablePrimaryKey !== undefined && tablePrimaryKey !== null)
            url_ += "tablePrimaryKey=" + encodeURIComponent("" + tablePrimaryKey) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (matchingValue !== undefined && matchingValue !== null)
            url_ += "matchingValue=" + encodeURIComponent("" + matchingValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTableData(_response));
        });
    }

    protected processGetTableData(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getSpTableData(formQueryModel: AdminFormQueryModel): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/query-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQueryModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSpTableData(_response));
        });
    }

    protected processGetSpTableData(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getTableColumns(formId?: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/table-columns?";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTableColumns(_response));
        });
    }

    protected processGetTableColumns(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    saveFormData(data: SaveAdminFormDataModel): Promise<AdminFormHeader[]> {
        let url_ = this.baseUrl + "/Maintenance/save-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFormData(_response));
        });
    }

    protected processSaveFormData(response: Response): Promise<AdminFormHeader[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminFormHeader.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminFormHeader[]>(null as any);
    }

    runSp(sp: AdminSp): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/run-sp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sp);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunSp(_response));
        });
    }

    protected processRunSp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllCategories(): Promise<AdminCategory[]> {
        let url_ = this.baseUrl + "/Maintenance/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCategories(_response));
        });
    }

    protected processGetAllCategories(response: Response): Promise<AdminCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(AdminCategory.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCategory[]>(null as any);
    }

    getDefaultDateDimension(): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/defaultdatedimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaultDateDimension(_response));
        });
    }

    protected processGetDefaultDateDimension(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    importDetails(encodedCSVDelim?: string | null | undefined, file?: FileParameter | null | undefined): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Maintenance/import?";
        if (encodedCSVDelim !== undefined && encodedCSVDelim !== null)
            url_ += "encodedCSVDelim=" + encodeURIComponent("" + encodedCSVDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDetails(_response));
        });
    }

    protected processImportDetails(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    getFXGlobalRatesJson(scenario?: string | null | undefined, date?: string | null | undefined, currency?: string | null | undefined, formId?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/getfxglobalratesjson?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFXGlobalRatesJson(_response));
        });
    }

    protected processGetFXGlobalRatesJson(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    saveFxGlobalRatesJson(json: string): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/savefxglobalratesjson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveFxGlobalRatesJson(_response));
        });
    }

    protected processSaveFxGlobalRatesJson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importFxGlobalRates(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/importfxglobalrates?";
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new globalThis.Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFxGlobalRates(_response));
        });
    }

    protected processImportFxGlobalRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportFxGlobalRates(csvDelimiter?: string | undefined, scenario?: string | null | undefined, date?: string | null | undefined, currency?: string | null | undefined, formId?: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Maintenance/exportfxglobalrates?";
        if (csvDelimiter === null)
            throw new globalThis.Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportFxGlobalRates(_response));
        });
    }

    protected processExportFxGlobalRates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFormTableData(bulkRequest: MaintenanceBulkRequest): Promise<MaintenanceBulkResponse> {
        let url_ = this.baseUrl + "/Maintenance/FormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFormTableData(_response));
        });
    }

    protected processGetFormTableData(response: Response): Promise<MaintenanceBulkResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceBulkResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaintenanceBulkResponse>(null as any);
    }

    copyDimensionHierarchyData(copyDataRequest: CopyDataRequest): Promise<CopyDataResponse> {
        let url_ = this.baseUrl + "/Maintenance/CopyData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyDataRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopyDimensionHierarchyData(_response));
        });
    }

    protected processCopyDimensionHierarchyData(response: Response): Promise<CopyDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CopyDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CopyDataResponse>(null as any);
    }

    getConfigureOpenPeriods(model?: string | null | undefined): Promise<OpenPeriod[]> {
        let url_ = this.baseUrl + "/Maintenance/ConfigureOpenPeriods?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigureOpenPeriods(_response));
        });
    }

    protected processGetConfigureOpenPeriods(response: Response): Promise<OpenPeriod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(OpenPeriod.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenPeriod[]>(null as any);
    }

    getDeferredTaxRates(scenario?: string | null | undefined, date?: string | null | undefined, country?: string | null | undefined, formId?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/get-deferred-tax-rates?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDeferredTaxRates(_response));
        });
    }

    protected processGetDeferredTaxRates(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    exportDeferredTaxRates(csvDelimiter?: string | undefined, scenario?: string | null | undefined, date?: string | null | undefined, country?: string | null | undefined, formId?: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Maintenance/export-deferred-tax-rates?";
        if (csvDelimiter === null)
            throw new globalThis.Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (formId === null)
            throw new globalThis.Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDeferredTaxRates(_response));
        });
    }

    protected processExportDeferredTaxRates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importDeferredTaxRates(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/import-deferred-tax-rates?";
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new globalThis.Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDeferredTaxRates(_response));
        });
    }

    protected processImportDeferredTaxRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveDeferredTaxRates(json: string): Promise<void> {
        let url_ = this.baseUrl + "/Maintenance/save-deferred-tax-rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(json);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDeferredTaxRates(_response));
        });
    }

    protected processSaveDeferredTaxRates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getGlobalVariableBooleanValues(): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/global-variable-boolean-values";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGlobalVariableBooleanValues(_response));
        });
    }

    protected processGetGlobalVariableBooleanValues(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getValidationTypes(): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/validation-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetValidationTypes(_response));
        });
    }

    protected processGetValidationTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSecurityProfiles(): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/security-profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSecurityProfiles(_response));
        });
    }

    protected processGetSecurityProfiles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getDimensionMembers(dimension?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Maintenance/dimension-members?";
        if (dimension !== undefined && dimension !== null)
            url_ += "dimension=" + encodeURIComponent("" + dimension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionMembers(_response));
        });
    }

    protected processGetDimensionMembers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSettingsFormValueFromKey(key: string): Promise<string> {
        let url_ = this.baseUrl + "/Maintenance/get-settings-form-value/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettingsFormValueFromKey(_response));
        });
    }

    protected processGetSettingsFormValueFromKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Returns a combined ownership tree for a given group and scenario.
     * @param scenario (optional) 
     * @param group (optional) 
     */
    getOwnershipTree(scenario?: string | null | undefined, group?: string | null | undefined): Promise<OwnershipTreeNodeDto[]> {
        let url_ = this.baseUrl + "/Maintenance/ownership-tree?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (group !== undefined && group !== null)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOwnershipTree(_response));
        });
    }

    protected processGetOwnershipTree(response: Response): Promise<OwnershipTreeNodeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(OwnershipTreeNodeDto.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OwnershipTreeNodeDto[]>(null as any);
    }

    /**
     * Returns direct ownership information grouped by entity.
     * @param scenario (optional) 
     * @param entity (optional) 
     * @param intercompany (optional) 
     */
    getDirectOwnership(scenario?: string | null | undefined, entity?: string | null | undefined, intercompany?: string | null | undefined): Promise<DirectOwnershipResultDto> {
        let url_ = this.baseUrl + "/Maintenance/direct-ownership?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (intercompany !== undefined && intercompany !== null)
            url_ += "intercompany=" + encodeURIComponent("" + intercompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDirectOwnership(_response));
        });
    }

    protected processGetDirectOwnership(response: Response): Promise<DirectOwnershipResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectOwnershipResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DirectOwnershipResultDto>(null as any);
    }

    /**
     * Returns manage (group) ownership information grouped by entity.
     * @param scenario (optional) 
     * @param entity (optional) 
     */
    getManageOwnership(scenario?: string | null | undefined, entity?: string | null | undefined): Promise<ManageOwnershipResultDto> {
        let url_ = this.baseUrl + "/Maintenance/manage-ownership?";
        if (scenario !== undefined && scenario !== null)
            url_ += "scenario=" + encodeURIComponent("" + scenario) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetManageOwnership(_response));
        });
    }

    protected processGetManageOwnership(response: Response): Promise<ManageOwnershipResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageOwnershipResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManageOwnershipResultDto>(null as any);
    }

    /**
     * Returns all consolidation methods (keys and display metadata) from the tenant configuration.
     */
    getConsolidationMethods(): Promise<ConsolidationMethodDto[]> {
        let url_ = this.baseUrl + "/Maintenance/consolidation-methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConsolidationMethods(_response));
        });
    }

    protected processGetConsolidationMethods(response: Response): Promise<ConsolidationMethodDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ConsolidationMethodDto.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsolidationMethodDto[]>(null as any);
    }
}

export class MappingSuggestionsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getMappingSuggestions(request: AiMappingRequestsDto): Promise<AiMappingResponsesDto> {
        let url_ = this.baseUrl + "/MappingSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMappingSuggestions(_response));
        });
    }

    protected processGetMappingSuggestions(response: Response): Promise<AiMappingResponsesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiMappingResponsesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiMappingResponsesDto>(null as any);
    }
}

export class MatchingClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    generateMatchingCode(): Promise<void> {
        let url_ = this.baseUrl + "/Matching/matching/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateMatchingCode(_response));
        });
    }

    protected processGenerateMatchingCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMatchingGroups(): Promise<MatchGroupInfo[]> {
        let url_ = this.baseUrl + "/Matching/matching/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMatchingGroups(_response));
        });
    }

    protected processGetMatchingGroups(response: Response): Promise<MatchGroupInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MatchGroupInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchGroupInfo[]>(null as any);
    }

    getMatchingGroup(group: string): Promise<MatchGroupInfo> {
        let url_ = this.baseUrl + "/Matching/matching/groups/{group}";
        if (group === undefined || group === null)
            throw new globalThis.Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMatchingGroup(_response));
        });
    }

    protected processGetMatchingGroup(response: Response): Promise<MatchGroupInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchGroupInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchGroupInfo>(null as any);
    }

    createMatch(match: MatchInfo): Promise<MatchInfo> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(match);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMatch(_response));
        });
    }

    protected processCreateMatch(response: Response): Promise<MatchInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchInfo>(null as any);
    }

    updateMatch(match: MatchInfo): Promise<MatchInfo> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(match);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMatch(_response));
        });
    }

    protected processUpdateMatch(response: Response): Promise<MatchInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchInfo>(null as any);
    }

    deleteMatches(matchIds: number[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchIds);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMatches(_response));
        });
    }

    protected processDeleteMatches(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteMatch(matchId: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/match/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new globalThis.Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMatch(_response));
        });
    }

    protected processDeleteMatch(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getTransactions(matchGroup: string, dataset: string, filter: TransactionFilter, accDimTable?: string | null | undefined, entityDimTable?: string | null | undefined): Promise<TransactionData> {
        let url_ = this.baseUrl + "/Matching/matching/transactions/{matchGroup}/{dataset}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new globalThis.Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (dataset === undefined || dataset === null)
            throw new globalThis.Error("The parameter 'dataset' must be defined.");
        url_ = url_.replace("{dataset}", encodeURIComponent("" + dataset));
        if (accDimTable !== undefined && accDimTable !== null)
            url_ += "accDimTable=" + encodeURIComponent("" + accDimTable) + "&";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTransactions(_response));
        });
    }

    protected processGetTransactions(response: Response): Promise<TransactionData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionData>(null as any);
    }

    deleteTransactions(matchGroup: string, dataset: string, transactionIds: string[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/matching/transactions/{matchGroup}/{dataset}";
        if (matchGroup === undefined || matchGroup === null)
            throw new globalThis.Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (dataset === undefined || dataset === null)
            throw new globalThis.Error("The parameter 'dataset' must be defined.");
        url_ = url_.replace("{dataset}", encodeURIComponent("" + dataset));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionIds);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTransactions(_response));
        });
    }

    protected processDeleteTransactions(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAttachment(id: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Matching/attachment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDimensionTables(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Matching/matching/DimensionTables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionTables(_response));
        });
    }

    protected processGetDimensionTables(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getReconciliationGroupList(acctDimTable?: string | null | undefined, accountName?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/reconciliationGroups?";
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        if (accountName !== undefined && accountName !== null)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReconciliationGroupList(_response));
        });
    }

    protected processGetReconciliationGroupList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getAccountList(reconciliationGroup: string, acctDimTable?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/groupAccounts/{reconciliationGroup}?";
        if (reconciliationGroup === undefined || reconciliationGroup === null)
            throw new globalThis.Error("The parameter 'reconciliationGroup' must be defined.");
        url_ = url_.replace("{reconciliationGroup}", encodeURIComponent("" + reconciliationGroup));
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountList(_response));
        });
    }

    protected processGetAccountList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getEntityList(entityDimTable?: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/entities?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityList(_response));
        });
    }

    protected processGetEntityList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSupportingItemSubtypeList(reconciliationGroup: string): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/supportingItemSubtypes/{reconciliationGroup}";
        if (reconciliationGroup === undefined || reconciliationGroup === null)
            throw new globalThis.Error("The parameter 'reconciliationGroup' must be defined.");
        url_ = url_.replace("{reconciliationGroup}", encodeURIComponent("" + reconciliationGroup));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSupportingItemSubtypeList(_response));
        });
    }

    protected processGetSupportingItemSubtypeList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSupportingItemClassList(): Promise<string[]> {
        let url_ = this.baseUrl + "/Matching/matching/itemClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSupportingItemClassList(_response));
        });
    }

    protected processGetSupportingItemClassList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createSupportingItem(matchGroup: string, itemInfo: SupportingItemInfo, acctDimTable?: string | null | undefined, entityDimTable?: string | null | undefined): Promise<SupportingItemInfo> {
        let url_ = this.baseUrl + "/Matching/matching/createSupportingItem/{matchGroup}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new globalThis.Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (acctDimTable !== undefined && acctDimTable !== null)
            url_ += "acctDimTable=" + encodeURIComponent("" + acctDimTable) + "&";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSupportingItem(_response));
        });
    }

    protected processCreateSupportingItem(response: Response): Promise<SupportingItemInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingItemInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingItemInfo>(null as any);
    }

    updateSupportingItem(matchGroup: string, itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined): Promise<SupportingItemInfo> {
        let url_ = this.baseUrl + "/Matching/matching/updateSupportingItem/{matchGroup}?";
        if (matchGroup === undefined || matchGroup === null)
            throw new globalThis.Error("The parameter 'matchGroup' must be defined.");
        url_ = url_.replace("{matchGroup}", encodeURIComponent("" + matchGroup));
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSupportingItem(_response));
        });
    }

    protected processUpdateSupportingItem(response: Response): Promise<SupportingItemInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportingItemInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportingItemInfo>(null as any);
    }

    deleteSupportingItem(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Matching/matching/deleteSupportingItem?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSupportingItem(_response));
        });
    }

    protected processDeleteSupportingItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    newSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Matching/matching/newSupportingItemValidation?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewSupportingItemValidation(_response));
        });
    }

    protected processNewSupportingItemValidation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    existingSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Matching/matching/existingSupportingItemValidation?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExistingSupportingItemValidation(_response));
        });
    }

    protected processExistingSupportingItemValidation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    preloadSupportingItemValidation(itemInfo: SupportingItemInfo, entityDimTable?: string | null | undefined, timeDimTable?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Matching?";
        if (entityDimTable !== undefined && entityDimTable !== null)
            url_ += "entityDimTable=" + encodeURIComponent("" + entityDimTable) + "&";
        if (timeDimTable !== undefined && timeDimTable !== null)
            url_ += "timeDimTable=" + encodeURIComponent("" + timeDimTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreloadSupportingItemValidation(_response));
        });
    }

    protected processPreloadSupportingItemValidation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MetadataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getModels(): Promise<ModelInfo[]> {
        let url_ = this.baseUrl + "/Metadata/model";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModels(_response));
        });
    }

    protected processGetModels(response: Response): Promise<ModelInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModelInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo[]>(null as any);
    }

    createModel(request: ModelInfo): Promise<ModelInfo> {
        let url_ = this.baseUrl + "/Metadata/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModel(_response));
        });
    }

    protected processCreateModel(response: Response): Promise<ModelInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo>(null as any);
    }

    updateModel(modelName: string, request: ModelInfo): Promise<ModelInfo> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModel(_response));
        });
    }

    protected processUpdateModel(response: Response): Promise<ModelInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelInfo>(null as any);
    }

    deleteModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModel(_response));
        });
    }

    protected processDeleteModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMainReportingCurrencyForModel(modelName: string): Promise<MainReportingCurrencyResponse> {
        let url_ = this.baseUrl + "/Metadata/model/{modelName}/main-reporting-currency";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMainReportingCurrencyForModel(_response));
        });
    }

    protected processGetMainReportingCurrencyForModel(response: Response): Promise<MainReportingCurrencyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MainReportingCurrencyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MainReportingCurrencyResponse>(null as any);
    }

    getDimensionRoles(): Promise<DimensionRoleInfo[]> {
        let url_ = this.baseUrl + "/Metadata/dimensionroles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionRoles(_response));
        });
    }

    protected processGetDimensionRoles(response: Response): Promise<DimensionRoleInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionRoleInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionRoleInfo[]>(null as any);
    }

    getDimensions(): Promise<DimensionInfo[]> {
        let url_ = this.baseUrl + "/Metadata/dimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensions(_response));
        });
    }

    protected processGetDimensions(response: Response): Promise<DimensionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo[]>(null as any);
    }

    createDimension(request: DimensionInfo): Promise<DimensionInfo> {
        let url_ = this.baseUrl + "/Metadata/dimension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDimension(_response));
        });
    }

    protected processCreateDimension(response: Response): Promise<DimensionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DimensionInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo>(null as any);
    }

    deleteDimension(dimensionName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDimension(_response));
        });
    }

    protected processDeleteDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDimension(dimensionName: string, updateData: DimensionInfo): Promise<DimensionInfo> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimension(_response));
        });
    }

    protected processUpdateDimension(response: Response): Promise<DimensionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DimensionInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionInfo>(null as any);
    }

    getDimensionPropertyOptions(dimensionName: string): Promise<DimensionPropertyOptionsResponse> {
        let url_ = this.baseUrl + "/Metadata/dimension/{dimensionName}/propertyoptions";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionPropertyOptions(_response));
        });
    }

    protected processGetDimensionPropertyOptions(response: Response): Promise<DimensionPropertyOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DimensionPropertyOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionPropertyOptionsResponse>(null as any);
    }

    getStandardAttributes(): Promise<StandardAttributeInfo[]> {
        let url_ = this.baseUrl + "/Metadata/standardattributes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStandardAttributes(_response));
        });
    }

    protected processGetStandardAttributes(response: Response): Promise<StandardAttributeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(StandardAttributeInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandardAttributeInfo[]>(null as any);
    }

    createHierarchies(dimensionName: string, request: HierarchyInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchies(_response));
        });
    }

    protected processCreateHierarchies(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteHierarchy(dimensionName: string, hierarchyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchy(_response));
        });
    }

    protected processDeleteHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchy(dimensionName: string, hierarchyName: string, updateData: HierarchyInfo): Promise<HierarchyInfo> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchy(_response));
        });
    }

    protected processUpdateHierarchy(response: Response): Promise<HierarchyInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HierarchyInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HierarchyInfo>(null as any);
    }

    processHierarchy(dimensionName: string, hierarchyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessHierarchy(_response));
        });
    }

    protected processProcessHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSubsets(): Promise<SubsetInfo[]> {
        let url_ = this.baseUrl + "/Metadata/subset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubsets(_response));
        });
    }

    protected processGetSubsets(response: Response): Promise<SubsetInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SubsetInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubsetInfo[]>(null as any);
    }

    createSubset(subset: SubsetInfo): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subset);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSubset(_response));
        });
    }

    protected processCreateSubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSubset(dimensionName: string, subsetName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset/{dimensionName}/{subsetName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (subsetName === undefined || subsetName === null)
            throw new globalThis.Error("The parameter 'subsetName' must be defined.");
        url_ = url_.replace("{subsetName}", encodeURIComponent("" + subsetName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSubset(_response));
        });
    }

    protected processDeleteSubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteHierarchySubset(dimensionName: string, hierarchyName: string, subsetName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/subset/{dimensionName}/{hierarchyName}/{subsetName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (subsetName === undefined || subsetName === null)
            throw new globalThis.Error("The parameter 'subsetName' must be defined.");
        url_ = url_.replace("{subsetName}", encodeURIComponent("" + subsetName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchySubset(_response));
        });
    }

    protected processDeleteHierarchySubset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createProperties(dimensionName: string, request: PropertyInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProperties(_response));
        });
    }

    protected processCreateProperties(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteProperty(dimensionName: string, propertyName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}/{propertyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProperty(_response));
        });
    }

    protected processDeleteProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateProperty(dimensionName: string, propertyName: string, updateData: PropertyInfo): Promise<PropertyInfo> {
        let url_ = this.baseUrl + "/Metadata/property/{dimensionName}/{propertyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (propertyName === undefined || propertyName === null)
            throw new globalThis.Error("The parameter 'propertyName' must be defined.");
        url_ = url_.replace("{propertyName}", encodeURIComponent("" + propertyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateData);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProperty(_response));
        });
    }

    protected processUpdateProperty(response: Response): Promise<PropertyInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyInfo>(null as any);
    }

    getDefaultHierarchyMembers(dimensionName: string, hierarchyName?: string | null | undefined, addVirtualRoot?: boolean | undefined, effectiveDate?: string | null | undefined): Promise<MemberInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName !== undefined && hierarchyName !== null)
            url_ += "hierarchyName=" + encodeURIComponent("" + hierarchyName) + "&";
        if (addVirtualRoot === null)
            throw new globalThis.Error("The parameter 'addVirtualRoot' cannot be null.");
        else if (addVirtualRoot !== undefined)
            url_ += "addVirtualRoot=" + encodeURIComponent("" + addVirtualRoot) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDefaultHierarchyMembers(_response));
        });
    }

    protected processGetDefaultHierarchyMembers(response: Response): Promise<MemberInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfo[]>(null as any);
    }

    deleteDefaultHierarchyMembers(dimensionName: string, keys: number[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDefaultHierarchyMembers(_response));
        });
    }

    protected processDeleteDefaultHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDefaultHierarchyMembers(dimensionName: string, newMembers: MemberInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newMembers);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDefaultHierarchyMembers(_response));
        });
    }

    protected processCreateDefaultHierarchyMembers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getHierarchyMembersSimple(dimensionName: string, translation?: string | null | undefined): Promise<MemberInfoSimple[]> {
        let url_ = this.baseUrl + "/Metadata/membersimple/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (translation !== undefined && translation !== null)
            url_ += "translation=" + encodeURIComponent("" + translation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersSimple(_response));
        });
    }

    protected processGetHierarchyMembersSimple(response: Response): Promise<MemberInfoSimple[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfoSimple.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoSimple[]>(null as any);
    }

    getHierarchyMembers(dimensionName: string, hierarchyName: string, addVirtualRoot?: boolean | undefined, effectiveDate?: string | null | undefined): Promise<MemberInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (addVirtualRoot === null)
            throw new globalThis.Error("The parameter 'addVirtualRoot' cannot be null.");
        else if (addVirtualRoot !== undefined)
            url_ += "addVirtualRoot=" + encodeURIComponent("" + addVirtualRoot) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembers(_response));
        });
    }

    protected processGetHierarchyMembers(response: Response): Promise<MemberInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfo[]>(null as any);
    }

    deleteHierarchyMembers(dimensionName: string, hierarchyName: string, keys: number[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchyMembers(_response));
        });
    }

    protected processDeleteHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createHierarchyMembers(dimensionName: string, hierarchyName: string, newMembers: MemberInfo[]): Promise<string> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newMembers);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchyMembers(_response));
        });
    }

    protected processCreateHierarchyMembers(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getMemberTimeBasedChronology(dimensionName: string, hierarchyName: string, baseKey: number): Promise<MemberChronologyInfo[]> {
        let url_ = this.baseUrl + "/Metadata/member/chronology/{dimensionName}/{hierarchyName}/{baseKey}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (baseKey === undefined || baseKey === null)
            throw new globalThis.Error("The parameter 'baseKey' must be defined.");
        url_ = url_.replace("{baseKey}", encodeURIComponent("" + baseKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberTimeBasedChronology(_response));
        });
    }

    protected processGetMemberTimeBasedChronology(response: Response): Promise<MemberChronologyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MemberChronologyInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberChronologyInfo[]>(null as any);
    }

    getHierarchyMembersSingleGroupByMemberKey(singleGroupRequest: SingleGroupRequest): Promise<MemberInfoSingleGroupResult> {
        let url_ = this.baseUrl + "/Metadata/member/singlegroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(singleGroupRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersSingleGroupByMemberKey(_response));
        });
    }

    protected processGetHierarchyMembersSingleGroupByMemberKey(response: Response): Promise<MemberInfoSingleGroupResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberInfoSingleGroupResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoSingleGroupResult>(null as any);
    }

    getHierarchyMembersServerGrouped(paging: HierarchyMemberPaging): Promise<MemberInfoPagedResults> {
        let url_ = this.baseUrl + "/Metadata/member/twopaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paging);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHierarchyMembersServerGrouped(_response));
        });
    }

    protected processGetHierarchyMembersServerGrouped(response: Response): Promise<MemberInfoPagedResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberInfoPagedResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberInfoPagedResults>(null as any);
    }

    getMemberHasFactData(dimensionName: string, hierarchyName: string, memberKey: number): Promise<boolean> {
        let url_ = this.baseUrl + "/Metadata/member/factcheck/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberKey);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberHasFactData(_response));
        });
    }

    protected processGetMemberHasFactData(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    updateDefaultHierarchyMembers(dimensionName: string, reorder: boolean, changedMembers: MemberInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{reorder}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (reorder === undefined || reorder === null)
            throw new globalThis.Error("The parameter 'reorder' must be defined.");
        url_ = url_.replace("{reorder}", encodeURIComponent("" + reorder));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changedMembers);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDefaultHierarchyMembers(_response));
        });
    }

    protected processUpdateDefaultHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchyMembers(dimensionName: string, hierarchyName: string, reorder: boolean, changedMembers: MemberInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/member/{dimensionName}/{hierarchyName}/{reorder}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (reorder === undefined || reorder === null)
            throw new globalThis.Error("The parameter 'reorder' must be defined.");
        url_ = url_.replace("{reorder}", encodeURIComponent("" + reorder));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changedMembers);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchyMembers(_response));
        });
    }

    protected processUpdateHierarchyMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createModelView(modelName: string, request: ModelViewInfo): Promise<ModelViewInfo> {
        let url_ = this.baseUrl + "/Metadata/view/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModelView(_response));
        });
    }

    protected processCreateModelView(response: Response): Promise<ModelViewInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ModelViewInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelViewInfo>(null as any);
    }

    updateModelView(viewName: string, request: ModelViewInfo): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/view/{viewName}";
        if (viewName === undefined || viewName === null)
            throw new globalThis.Error("The parameter 'viewName' must be defined.");
        url_ = url_.replace("{viewName}", encodeURIComponent("" + viewName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModelView(_response));
        });
    }

    protected processUpdateModelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteModelView(viewName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/view/{viewName}";
        if (viewName === undefined || viewName === null)
            throw new globalThis.Error("The parameter 'viewName' must be defined.");
        url_ = url_.replace("{viewName}", encodeURIComponent("" + viewName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteModelView(_response));
        });
    }

    protected processDeleteModelView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getGlobalVariables(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/globalvariable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGlobalVariables(_response));
        });
    }

    protected processGetGlobalVariables(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getTags(dimensionName?: string | null | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/tags?";
        if (dimensionName !== undefined && dimensionName !== null)
            url_ += "dimensionName=" + encodeURIComponent("" + dimensionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTags(_response));
        });
    }

    protected processGetTags(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    processAllDimensions(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process/dimension";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessAllDimensions(_response));
        });
    }

    protected processProcessAllDimensions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processDimension(dimensionName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessDimension(_response));
        });
    }

    protected processProcessDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processMetadata(sendNotifications?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/process?";
        if (sendNotifications === null)
            throw new globalThis.Error("The parameter 'sendNotifications' cannot be null.");
        else if (sendNotifications !== undefined)
            url_ += "sendNotifications=" + encodeURIComponent("" + sendNotifications) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessMetadata(_response));
        });
    }

    protected processProcessMetadata(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportDimension(dimensionName: string, exportKeys?: boolean | null | undefined, effectiveDate?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/export/dimension/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (exportKeys !== undefined && exportKeys !== null)
            url_ += "exportKeys=" + encodeURIComponent("" + exportKeys) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDimension(_response));
        });
    }

    protected processExportDimension(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportHierarchy(dimensionName: string, hierarchyName: string, exportKeys?: boolean | null | undefined, effectiveDate?: string | null | undefined, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/export/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (exportKeys !== undefined && exportKeys !== null)
            url_ += "exportKeys=" + encodeURIComponent("" + exportKeys) + "&";
        if (effectiveDate !== undefined && effectiveDate !== null)
            url_ += "effectiveDate=" + encodeURIComponent("" + effectiveDate) + "&";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportHierarchy(_response));
        });
    }

    protected processExportHierarchy(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    memberAlreadyExists(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined, isAppend?: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Metadata/import/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMemberAlreadyExists(_response));
        });
    }

    protected processMemberAlreadyExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    importHierarchy(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined, isAppend?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/import/hierarchy/{dimensionName}/{hierarchyName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportHierarchy(_response));
        });
    }

    protected processImportHierarchy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importDimension(dimensionName: string, isAppend: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/import/dimension/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (isAppend === undefined || isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' must be defined.");
        url_ = url_.replace("{isAppend}", encodeURIComponent("" + isAppend));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportDimension(_response));
        });
    }

    protected processImportDimension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDimensionFromFile(dimensionName: string, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/update/hierarchy/{dimensionName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimensionFromFile(_response));
        });
    }

    protected processUpdateDimensionFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateHierarchyFromFile(dimensionName: string, hierarchyName: string, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/update/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHierarchyFromFile(_response));
        });
    }

    protected processUpdateHierarchyFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    synchronizeDimensionFromFile(dimensionName: string, selectedSyncOption: HierarchySyncMode, outputToResultScreen: boolean, reAssignMembers: boolean, doSync: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize/hierarchy/{dimensionName}/{selectedSyncOption}/{outputToResultScreen}/{reAssignMembers}/{doSync}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (selectedSyncOption === undefined || selectedSyncOption === null)
            throw new globalThis.Error("The parameter 'selectedSyncOption' must be defined.");
        url_ = url_.replace("{selectedSyncOption}", encodeURIComponent("" + selectedSyncOption));
        if (outputToResultScreen === undefined || outputToResultScreen === null)
            throw new globalThis.Error("The parameter 'outputToResultScreen' must be defined.");
        url_ = url_.replace("{outputToResultScreen}", encodeURIComponent("" + outputToResultScreen));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new globalThis.Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (doSync === undefined || doSync === null)
            throw new globalThis.Error("The parameter 'doSync' must be defined.");
        url_ = url_.replace("{doSync}", encodeURIComponent("" + doSync));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSynchronizeDimensionFromFile(_response));
        });
    }

    protected processSynchronizeDimensionFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    synchronizeHierarchyFromFile(dimensionName: string, hierarchyName: string, selectedSyncOption: HierarchySyncMode, outputToResultScreen: boolean, reAssignMembers: boolean, doSync: boolean, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize/hierarchy/{dimensionName}/{hierarchyName}/{selectedSyncOption}/{outputToResultScreen}/{reAssignMembers}/{doSync}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (selectedSyncOption === undefined || selectedSyncOption === null)
            throw new globalThis.Error("The parameter 'selectedSyncOption' must be defined.");
        url_ = url_.replace("{selectedSyncOption}", encodeURIComponent("" + selectedSyncOption));
        if (outputToResultScreen === undefined || outputToResultScreen === null)
            throw new globalThis.Error("The parameter 'outputToResultScreen' must be defined.");
        url_ = url_.replace("{outputToResultScreen}", encodeURIComponent("" + outputToResultScreen));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new globalThis.Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (doSync === undefined || doSync === null)
            throw new globalThis.Error("The parameter 'doSync' must be defined.");
        url_ = url_.replace("{doSync}", encodeURIComponent("" + doSync));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSynchronizeHierarchyFromFile(_response));
        });
    }

    protected processSynchronizeHierarchyFromFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteClientDimTable(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/synchronize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteClientDimTable(_response));
        });
    }

    protected processDeleteClientDimTable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getActionTable(dimensionName: string, hierarchyName: string): Promise<DataImportActionResult> {
        let url_ = this.baseUrl + "/Metadata/action/hierarchy/{dimensionName}/{hierarchyName}";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActionTable(_response));
        });
    }

    protected processGetActionTable(response: Response): Promise<DataImportActionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataImportActionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataImportActionResult>(null as any);
    }

    exportDataImportResult(dimensionName: string, reAssignMembers: boolean, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/syncexport/{dimensionName}/{reAssignMembers}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (reAssignMembers === undefined || reAssignMembers === null)
            throw new globalThis.Error("The parameter 'reAssignMembers' must be defined.");
        url_ = url_.replace("{reAssignMembers}", encodeURIComponent("" + reAssignMembers));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportDataImportResult(_response));
        });
    }

    protected processExportDataImportResult(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportMemberInfoResult(dimensionName: string, hierarchyName: string, memberName: string, baseKey: number, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/exportmemberinfo/{dimensionName}/{hierarchyName}/{memberName}/{baseKey}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (hierarchyName === undefined || hierarchyName === null)
            throw new globalThis.Error("The parameter 'hierarchyName' must be defined.");
        url_ = url_.replace("{hierarchyName}", encodeURIComponent("" + hierarchyName));
        if (memberName === undefined || memberName === null)
            throw new globalThis.Error("The parameter 'memberName' must be defined.");
        url_ = url_.replace("{memberName}", encodeURIComponent("" + memberName));
        if (baseKey === undefined || baseKey === null)
            throw new globalThis.Error("The parameter 'baseKey' must be defined.");
        url_ = url_.replace("{baseKey}", encodeURIComponent("" + baseKey));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportMemberInfoResult(_response));
        });
    }

    protected processExportMemberInfoResult(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportFile(processRunId?: string | undefined, activityRunId?: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/file?";
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportFile(_response));
        });
    }

    protected processExportFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importFile(processRunId?: string | undefined, activityRunId?: string | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/file?";
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFile(_response));
        });
    }

    protected processImportFile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    exportTemplate(processRunId?: string | undefined, activityRunId?: string | undefined, fileTypeString?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/file/template?";
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (fileTypeString !== undefined && fileTypeString !== null)
            url_ += "fileTypeString=" + encodeURIComponent("" + fileTypeString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportTemplate(_response));
        });
    }

    protected processExportTemplate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    publishAnalysisServicesModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/publish";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublishAnalysisServicesModel(_response));
        });
    }

    protected processPublishAnalysisServicesModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh SSAS Model Data
     */
    refreshAnalysisServicesModel(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/refresh";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshAnalysisServicesModel(_response));
        });
    }

    protected processRefreshAnalysisServicesModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh SSAS Model Security that includes users and roles.
     */
    refreshAnalysisServicesModelSecurity(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/as/{modelName}/refreshsecurity";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshAnalysisServicesModelSecurity(_response));
        });
    }

    protected processRefreshAnalysisServicesModelSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDatabaseSchemas(): Promise<string[]> {
        let url_ = this.baseUrl + "/Metadata/database/schemas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatabaseSchemas(_response));
        });
    }

    protected processGetDatabaseSchemas(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getDatabaseTables(): Promise<SimpleKeyValue[]> {
        let url_ = this.baseUrl + "/Metadata/database/tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatabaseTables(_response));
        });
    }

    protected processGetDatabaseTables(response: Response): Promise<SimpleKeyValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(SimpleKeyValue.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleKeyValue[]>(null as any);
    }

    getLists(): Promise<ListInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLists(_response));
        });
    }

    protected processGetLists(response: Response): Promise<ListInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListInfo[]>(null as any);
    }

    createList(list: ListInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(list);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateList(_response));
        });
    }

    protected processCreateList(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getListContents(listID: number): Promise<{ [key: string]: any; }[]> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new globalThis.Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListContents(_response));
        });
    }

    protected processGetListContents(response: Response): Promise<{ [key: string]: any; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: any; }[]>(null as any);
    }

    deleteListContents(listID: number, contents: { [key: string]: any; }[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new globalThis.Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contents);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListContents(_response));
        });
    }

    protected processDeleteListContents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateListContents(listID: number, contents: { [key: string]: any; }[]): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/contents/{listID}";
        if (listID === undefined || listID === null)
            throw new globalThis.Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contents);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateListContents(_response));
        });
    }

    protected processUpdateListContents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getListDetails(): Promise<ListDetailsInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListDetails(_response));
        });
    }

    protected processGetListDetails(response: Response): Promise<ListDetailsInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListDetailsInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListDetailsInfo[]>(null as any);
    }

    createListDetails(listDetails: ListDetailsInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListDetails(_response));
        });
    }

    protected processCreateListDetails(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListDetails(listID: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/details/{listID}";
        if (listID === undefined || listID === null)
            throw new globalThis.Error("The parameter 'listID' must be defined.");
        url_ = url_.replace("{listID}", encodeURIComponent("" + listID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListDetails(_response));
        });
    }

    protected processDeleteListDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getListPropertyDetails(): Promise<ListPropertyDetailsInfo[]> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetListPropertyDetails(_response));
        });
    }

    protected processGetListPropertyDetails(response: Response): Promise<ListPropertyDetailsInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ListPropertyDetailsInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListPropertyDetailsInfo[]>(null as any);
    }

    createListPropertyDetails(listPropertyDetails: ListPropertyDetailsInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listPropertyDetails);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListPropertyDetails(_response));
        });
    }

    protected processCreateListPropertyDetails(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListPropertyDetails(propertyID: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/propertydetails/{propertyID}";
        if (propertyID === undefined || propertyID === null)
            throw new globalThis.Error("The parameter 'propertyID' must be defined.");
        url_ = url_.replace("{propertyID}", encodeURIComponent("" + propertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListPropertyDetails(_response));
        });
    }

    protected processDeleteListPropertyDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createListProperties(listProperty: ListPropertyInfo): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/list/listproperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listProperty);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateListProperties(_response));
        });
    }

    protected processCreateListProperties(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteListProperty(id: number): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/list/listproperties/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteListProperty(_response));
        });
    }

    protected processDeleteListProperty(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    consolidationCodeAutoGenerate(): Promise<void> {
        let url_ = this.baseUrl + "/Metadata/ConsolidationCodeAutoGenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConsolidationCodeAutoGenerate(_response));
        });
    }

    protected processConsolidationCodeAutoGenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDictionary(dictionary: string, language: string): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Metadata/dictionary/{dictionary}/{language}";
        if (dictionary === undefined || dictionary === null)
            throw new globalThis.Error("The parameter 'dictionary' must be defined.");
        url_ = url_.replace("{dictionary}", encodeURIComponent("" + dictionary));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDictionary(_response));
        });
    }

    protected processGetDictionary(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Get all Extract Hierarchies from App_ExtractHierarchies table.
     */
    getAllExtractHierarchy(): Promise<ExtractHierarchyInfo[]> {
        let url_ = this.baseUrl + "/Metadata/extracthierarchy/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllExtractHierarchy(_response));
        });
    }

    protected processGetAllExtractHierarchy(response: Response): Promise<ExtractHierarchyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ExtractHierarchyInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtractHierarchyInfo[]>(null as any);
    }

    /**
     * Creates or updates a hierarchy extract.
     * @param extractHierarchy The extract hierarchy definition.
     * @param isEditMode (optional) Indicates if the extract is in edit mode (from FormRoute).
     */
    createHierarchyExtract(extractHierarchy: ExtractHierarchyDetail, isEditMode?: boolean | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Metadata/hierarchyExtract?";
        if (isEditMode === null)
            throw new globalThis.Error("The parameter 'isEditMode' cannot be null.");
        else if (isEditMode !== undefined)
            url_ += "isEditMode=" + encodeURIComponent("" + isEditMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(extractHierarchy);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHierarchyExtract(_response));
        });
    }

    protected processCreateHierarchyExtract(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteHierarchyExtract(extractID: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Metadata/hierarchyExtract/{extractID}";
        if (extractID === undefined || extractID === null)
            throw new globalThis.Error("The parameter 'extractID' must be defined.");
        url_ = url_.replace("{extractID}", encodeURIComponent("" + extractID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteHierarchyExtract(_response));
        });
    }

    protected processDeleteHierarchyExtract(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class OfficeClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getReport(pathOrId: string): Promise<FileSystemObject> {
        let url_ = this.baseUrl + "/Office/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReport(_response));
        });
    }

    protected processGetReport(response: Response): Promise<FileSystemObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemObject>(null as any);
    }

    open(pathOrId: string, parameters: FormParameterCurrentValue[]): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Office/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOpen(_response));
        });
    }

    protected processOpen(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getParameters(pathOrId: string): Promise<FormParameterList> {
        let url_ = this.baseUrl + "/Office/parameters/{pathOrId}";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetParameters(_response));
        });
    }

    protected processGetParameters(response: Response): Promise<FormParameterList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormParameterList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterList>(null as any);
    }
}

export class PowerBIClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEmbedInfo(idOrPath: string): Promise<PowerBIEmbedInfo> {
        let url_ = this.baseUrl + "/PowerBI/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmbedInfo(_response));
        });
    }

    protected processGetEmbedInfo(response: Response): Promise<PowerBIEmbedInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerBIEmbedInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PowerBIEmbedInfo>(null as any);
    }
}

export class ProcessClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    load(path: string): Promise<Process> {
        let url_ = this.baseUrl + "/Process/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad(_response));
        });
    }

    protected processLoad(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Process.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(null as any);
    }

    save(path: string, process: Process): Promise<void> {
        let url_ = this.baseUrl + "/Process/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    load2(path: string): Promise<Process> {
        let url_ = this.baseUrl + "/proces/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad2(_response));
        });
    }

    protected processLoad2(response: Response): Promise<Process> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Process.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Process>(null as any);
    }

    save2(path: string, process: Process): Promise<void> {
        let url_ = this.baseUrl + "/proces/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSave2(_response));
        });
    }

    protected processSave2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    loadInteractive(path: string): Promise<InteractiveProcess> {
        let url_ = this.baseUrl + "/Process/Interactive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadInteractive(_response));
        });
    }

    protected processLoadInteractive(response: Response): Promise<InteractiveProcess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractiveProcess.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractiveProcess>(null as any);
    }

    saveInteractive(path: string, process: InteractiveProcess): Promise<void> {
        let url_ = this.baseUrl + "/Process/Interactive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInteractive(_response));
        });
    }

    protected processSaveInteractive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    loadInteractive2(path: string): Promise<InteractiveProcess> {
        let url_ = this.baseUrl + "/proces/Interactive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadInteractive2(_response));
        });
    }

    protected processLoadInteractive2(response: Response): Promise<InteractiveProcess> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractiveProcess.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractiveProcess>(null as any);
    }

    saveInteractive2(path: string, process: InteractiveProcess): Promise<void> {
        let url_ = this.baseUrl + "/proces/Interactive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveInteractive2(_response));
        });
    }

    protected processSaveInteractive2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixInteractive(path: string): Promise<void> {
        let url_ = this.baseUrl + "/Process/FixInteractive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixInteractive(_response));
        });
    }

    protected processFixInteractive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    fixInteractive2(path: string): Promise<void> {
        let url_ = this.baseUrl + "/proces/FixInteractive/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFixInteractive2(_response));
        });
    }

    protected processFixInteractive2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getActivities(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/Activities/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getActivities2(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/Activities/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities2(_response));
        });
    }

    protected processGetActivities2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getMyActivities(): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/MyActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyActivities(_response));
        });
    }

    protected processGetMyActivities(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getMyActivities2(): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/MyActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyActivities2(_response));
        });
    }

    protected processGetMyActivities2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionState(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/State/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionState(_response));
        });
    }

    protected processGetInteractiveProcessExecutionState(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionState2(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/State/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionState2(_response));
        });
    }

    protected processGetInteractiveProcessExecutionState2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionStateForViewer(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/Process/ViewerState/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionStateForViewer(_response));
        });
    }

    protected processGetInteractiveProcessExecutionStateForViewer(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getInteractiveProcessExecutionStateForViewer2(path: string): Promise<ProcessActivityExecutionState[]> {
        let url_ = this.baseUrl + "/proces/ViewerState/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInteractiveProcessExecutionStateForViewer2(_response));
        });
    }

    protected processGetInteractiveProcessExecutionStateForViewer2(response: Response): Promise<ProcessActivityExecutionState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessActivityExecutionState.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessActivityExecutionState[]>(null as any);
    }

    getActivityDetails(path: string, nodeId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<BaseProcessActivity> {
        let url_ = this.baseUrl + "/Process/ActivityDetails/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityDetails(_response));
        });
    }

    protected processGetActivityDetails(response: Response): Promise<BaseProcessActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseProcessActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseProcessActivity>(null as any);
    }

    getActivityDetails2(path: string, nodeId: string, processRunId?: string | null | undefined, activityRunId?: string | null | undefined): Promise<BaseProcessActivity> {
        let url_ = this.baseUrl + "/proces/ActivityDetails/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId !== undefined && activityRunId !== null)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityDetails2(_response));
        });
    }

    protected processGetActivityDetails2(response: Response): Promise<BaseProcessActivity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseProcessActivity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseProcessActivity>(null as any);
    }

    getActivityLogs(path: string, processRunId?: string | null | undefined): Promise<RecentProcessRunLogs> {
        let url_ = this.baseUrl + "/Process/ActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityLogs(_response));
        });
    }

    protected processGetActivityLogs(response: Response): Promise<RecentProcessRunLogs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecentProcessRunLogs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentProcessRunLogs>(null as any);
    }

    getActivityLogs2(path: string, processRunId?: string | null | undefined): Promise<RecentProcessRunLogs> {
        let url_ = this.baseUrl + "/proces/ActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivityLogs2(_response));
        });
    }

    protected processGetActivityLogs2(response: Response): Promise<RecentProcessRunLogs> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecentProcessRunLogs.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentProcessRunLogs>(null as any);
    }

    exportActivityLogs(path: string, processRunId?: string | null | undefined, offset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Process/ExportActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportActivityLogs(_response));
        });
    }

    protected processExportActivityLogs(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exportActivityLogs2(path: string, processRunId?: string | null | undefined, offset?: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/proces/ExportActivityLogs/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (processRunId !== undefined && processRunId !== null)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportActivityLogs2(_response));
        });
    }

    protected processExportActivityLogs2(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProcessExecutionClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getProcessRunLogs(id: string): Promise<ProcessRun> {
        let url_ = this.baseUrl + "/ProcessExecution/Run/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProcessRunLogs(_response));
        });
    }

    protected processGetProcessRunLogs(response: Response): Promise<ProcessRun> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessRun.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessRun>(null as any);
    }

    executeAnonymous(process: Process): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/ExecuteAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(process);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteAnonymous(_response));
        });
    }

    protected processExecuteAnonymous(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    executeFileSystem(path: string, options: string[][]): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/ExecuteFileSystem/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteFileSystem(_response));
        });
    }

    protected processExecuteFileSystem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    executeInteractiveFileSystem(path: string, options: string[][], runId?: string | null | undefined, sendNotifications?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/ExecuteFileSystem/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (runId !== undefined && runId !== null)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        if (sendNotifications === null)
            throw new globalThis.Error("The parameter 'sendNotifications' cannot be null.");
        else if (sendNotifications !== undefined)
            url_ += "sendNotifications=" + encodeURIComponent("" + sendNotifications) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteInteractiveFileSystem(_response));
        });
    }

    protected processExecuteInteractiveFileSystem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    handleMessage(message: TopicActivityMessage): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/HandleMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHandleMessage(_response));
        });
    }

    protected processHandleMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setInteractiveActivityPercent(activityRunId: string, result: ActivityExecutionResultBase): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/SetInteractiveActivityPercent/{activityRunId}";
        if (activityRunId === undefined || activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' must be defined.");
        url_ = url_.replace("{activityRunId}", encodeURIComponent("" + activityRunId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetInteractiveActivityPercent(_response));
        });
    }

    protected processSetInteractiveActivityPercent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    stopInteractiveProcess(processRunId: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Stop/{processRunId}";
        if (processRunId === undefined || processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopInteractiveProcess(_response));
        });
    }

    protected processStopInteractiveProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restartInteractiveProcessActivity(processRunId: string, nodeId: string, activityRunId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Restart/{processRunId}/{nodeId}?";
        if (processRunId === undefined || processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        if (nodeId === undefined || nodeId === null)
            throw new globalThis.Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartInteractiveProcessActivity(_response));
        });
    }

    protected processRestartInteractiveProcessActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    stopAndRestartInteractiveProcessSubprocessActivity(processRunId: string, subprocessActivityRunId: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/RestartForeach/{processRunId}/{subprocessActivityRunId}";
        if (processRunId === undefined || processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' must be defined.");
        url_ = url_.replace("{processRunId}", encodeURIComponent("" + processRunId));
        if (subprocessActivityRunId === undefined || subprocessActivityRunId === null)
            throw new globalThis.Error("The parameter 'subprocessActivityRunId' must be defined.");
        url_ = url_.replace("{subprocessActivityRunId}", encodeURIComponent("" + subprocessActivityRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStopAndRestartInteractiveProcessSubprocessActivity(_response));
        });
    }

    protected processStopAndRestartInteractiveProcessSubprocessActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setSchedule(schedule: ProcessSchedule[], path: string): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Schedule/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSchedule(_response));
        });
    }

    protected processSetSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSchedule(path: string): Promise<ProcessSchedule[]> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Schedule/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSchedule(_response));
        });
    }

    protected processGetSchedule(response: Response): Promise<ProcessSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ProcessSchedule.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessSchedule[]>(null as any);
    }

    handleScheduleMessage(message: ProcessSchedule): Promise<void> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/HandleScheduleMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHandleScheduleMessage(_response));
        });
    }

    protected processHandleScheduleMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getXl3InterpolatedParameters(pathOrId: string, processRunId?: string | undefined, activityRunId?: string | undefined): Promise<FormParameterCurrentValue[]> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/Xl3Parameters/{pathOrId}?";
        if (pathOrId === undefined || pathOrId === null)
            throw new globalThis.Error("The parameter 'pathOrId' must be defined.");
        url_ = url_.replace("{pathOrId}", encodeURIComponent("" + pathOrId));
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetXl3InterpolatedParameters(_response));
        });
    }

    protected processGetXl3InterpolatedParameters(response: Response): Promise<FormParameterCurrentValue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FormParameterCurrentValue.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormParameterCurrentValue[]>(null as any);
    }

    getInterpolatedFormInteractiveActivityUrl(processRunId?: string | undefined, activityRunId?: string | undefined, url?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/ProcessExecution/Interactive/GetInterpolatedFormInteractiveActivityUrl?";
        if (processRunId === null)
            throw new globalThis.Error("The parameter 'processRunId' cannot be null.");
        else if (processRunId !== undefined)
            url_ += "processRunId=" + encodeURIComponent("" + processRunId) + "&";
        if (activityRunId === null)
            throw new globalThis.Error("The parameter 'activityRunId' cannot be null.");
        else if (activityRunId !== undefined)
            url_ += "activityRunId=" + encodeURIComponent("" + activityRunId) + "&";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInterpolatedFormInteractiveActivityUrl(_response));
        });
    }

    protected processGetInterpolatedFormInteractiveActivityUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class QueryClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    runDimensionQuery(dimensionQuery: string): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Query/dimension";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQuery(_response));
        });
    }

    protected processRunDimensionQuery(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runDimensionQueryCached(dimensionQuery: string): Promise<QueryResult[]> {
        let url_ = this.baseUrl + "/Query/dimension/cached";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDimensionQueryCached(_response));
        });
    }

    protected processRunDimensionQueryCached(response: Response): Promise<QueryResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(QueryResult.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[]>(null as any);
    }

    runMultipleDimensionQueries(dimensionQueries: string[]): Promise<QueryResult[][]> {
        let url_ = this.baseUrl + "/Query/dimension/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionQueries);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunMultipleDimensionQueries(_response));
        });
    }

    protected processRunMultipleDimensionQueries(response: Response): Promise<QueryResult[][]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResult[][]>(null as any);
    }

    runModelQuery(modelQuery: string): Promise<ModelQueryResult> {
        let url_ = this.baseUrl + "/Query/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelQuery);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunModelQuery(_response));
        });
    }

    protected processRunModelQuery(response: Response): Promise<ModelQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelQueryResult>(null as any);
    }

    runRelationalQuery(request: RelationalQueryRequest): Promise<RelationalQueryResult> {
        let url_ = this.baseUrl + "/Query/relational";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunRelationalQuery(_response));
        });
    }

    protected processRunRelationalQuery(response: Response): Promise<RelationalQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationalQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationalQueryResult>(null as any);
    }

    runCalc(calcXml: string): Promise<void> {
        let url_ = this.baseUrl + "/Query/calc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(calcXml);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCalc(_response));
        });
    }

    protected processRunCalc(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runCalcFile(idOrPath: string, variables: string[], async?: boolean | null | undefined): Promise<CalcScriptResult> {
        let url_ = this.baseUrl + "/Query/calc/{idOrPath}?";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        if (async !== undefined && async !== null)
            url_ += "async=" + encodeURIComponent("" + async) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variables);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunCalcFile(_response));
        });
    }

    protected processRunCalcFile(response: Response): Promise<CalcScriptResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalcScriptResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalcScriptResult>(null as any);
    }

    runDrillthroughQuery(query: string): Promise<RelationalQueryResult> {
        let url_ = this.baseUrl + "/Query/drillthrough";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunDrillthroughQuery(_response));
        });
    }

    protected processRunDrillthroughQuery(response: Response): Promise<RelationalQueryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelationalQueryResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelationalQueryResult>(null as any);
    }
}

export class ReportBookClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    loadDefinition(idOrPath: string): Promise<BookDefinition> {
        let url_ = this.baseUrl + "/ReportBook/definition/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadDefinition(_response));
        });
    }

    protected processLoadDefinition(response: Response): Promise<BookDefinition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookDefinition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookDefinition>(null as any);
    }

    saveDefinition(idOrPath: string, bookDefinition: BookDefinition): Promise<void> {
        let url_ = this.baseUrl + "/ReportBook/definition/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookDefinition);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveDefinition(_response));
        });
    }

    protected processSaveDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    load(idOrPath: string): Promise<ReportBookItem> {
        let url_ = this.baseUrl + "/ReportBook/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoad(_response));
        });
    }

    protected processLoad(response: Response): Promise<ReportBookItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportBookItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportBookItem>(null as any);
    }

    newEntry(idOrPath: string): Promise<ReportBookEntry> {
        let url_ = this.baseUrl + "/ReportBook/entry/{idOrPath}";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewEntry(_response));
        });
    }

    protected processNewEntry(response: Response): Promise<ReportBookEntry> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportBookEntry.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportBookEntry>(null as any);
    }

    runReportBook(body: BookDefinitionAndCurrentParameters): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/ReportBook/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunReportBook(_response));
        });
    }

    protected processRunReportBook(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }

    runReportBook2(idOrPath: string, output?: BookOutput | null | undefined, destination?: string | null | undefined, parameters?: FormParameterCurrentValue[] | undefined): Promise<FileSystemChangeNotification[]> {
        let url_ = this.baseUrl + "/ReportBook/run/{idOrPath}?";
        if (idOrPath === undefined || idOrPath === null)
            throw new globalThis.Error("The parameter 'idOrPath' must be defined.");
        url_ = url_.replace("{idOrPath}", encodeURIComponent("" + idOrPath));
        if (output !== undefined && output !== null)
            url_ += "output=" + encodeURIComponent("" + output) + "&";
        if (destination !== undefined && destination !== null)
            url_ += "destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRunReportBook2(_response));
        });
    }

    protected processRunReportBook2(response: Response): Promise<FileSystemChangeNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileSystemChangeNotification.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemChangeNotification[]>(null as any);
    }
}

export class RoleClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getRoles(): Promise<RoleObject[]> {
        let url_ = this.baseUrl + "/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: Response): Promise<RoleObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject[]>(null as any);
    }

    getRoleDetails(): Promise<RoleObject[]> {
        let url_ = this.baseUrl + "/Role/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleDetails(_response));
        });
    }

    protected processGetRoleDetails(response: Response): Promise<RoleObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(RoleObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject[]>(null as any);
    }

    addRole(roleName: string, newRole: RoleObject): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRole);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRole(_response));
        });
    }

    protected processAddRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    removeRole(roleName: string): Promise<void> {
        let url_ = this.baseUrl + "/Role/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveRole(_response));
        });
    }

    protected processRemoveRole(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addUsersToRole(roleName: string, userObjects: UserObject[]): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/AddUsers/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userObjects);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUsersToRole(_response));
        });
    }

    protected processAddUsersToRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    removeUsersFromRole(roleName: string, userObjects: UserObject[]): Promise<RoleObject> {
        let url_ = this.baseUrl + "/Role/RemoveUsers/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userObjects);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveUsersFromRole(_response));
        });
    }

    protected processRemoveUsersFromRole(response: Response): Promise<RoleObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleObject>(null as any);
    }

    exportRolesToFile(roles: string[], format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Role/roles/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportRolesToFile(_response));
        });
    }

    protected processExportRolesToFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importRoles(isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Role/roles/import?";
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportRoles(_response));
        });
    }

    protected processImportRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SecurityClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserImageOld(userName: string): Promise<string> {
        let url_ = this.baseUrl + "/Security/UserImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserImageOld(_response));
        });
    }

    protected processGetUserImageOld(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setUserImage(file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security/UserImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetUserImage(_response));
        });
    }

    protected processSetUserImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserImage(userName: string): Promise<string> {
        let url_ = this.baseUrl + "/Security/UserImage/{userName}";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserImage(_response));
        });
    }

    protected processGetUserImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getUserTenants(): Promise<Tenant[]> {
        let url_ = this.baseUrl + "/Security/UserTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserTenants(_response));
        });
    }

    protected processGetUserTenants(response: Response): Promise<Tenant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Tenant.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tenant[]>(null as any);
    }

    ensureAnaplanInternalConnection(tenantName: string): Promise<AnaplanInternalConnectionResponse> {
        let url_ = this.baseUrl + "/Security/EnsureAnaplanInternalConnection/{tenantName}";
        if (tenantName === undefined || tenantName === null)
            throw new globalThis.Error("The parameter 'tenantName' must be defined.");
        url_ = url_.replace("{tenantName}", encodeURIComponent("" + tenantName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEnsureAnaplanInternalConnection(_response));
        });
    }

    protected processEnsureAnaplanInternalConnection(response: Response): Promise<AnaplanInternalConnectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnaplanInternalConnectionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AnaplanInternalConnectionResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnaplanInternalConnectionResponse>(null as any);
    }

    validateToken(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/validate-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateToken(_response));
        });
    }

    protected processValidateToken(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    exchangeToken(): Promise<FluenceToken> {
        let url_ = this.baseUrl + "/Security/exchange";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExchangeToken(_response));
        });
    }

    protected processExchangeToken(response: Response): Promise<FluenceToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FluenceToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FluenceToken>(null as any);
    }

    getUserData(): Promise<ExtendedUserData> {
        let url_ = this.baseUrl + "/Security/UserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserData(_response));
        });
    }

    protected processGetUserData(response: Response): Promise<ExtendedUserData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtendedUserData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtendedUserData>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDimensionSecurityProfiles(): Promise<string[]> {
        let url_ = this.baseUrl + "/Security/metadata/profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionSecurityProfiles(_response));
        });
    }

    protected processGetDimensionSecurityProfiles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createDimensionSecurityProfile(profileName: string, dimensionSecurity?: DimensionSecurity[] | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/metadata/profiles/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new globalThis.Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionSecurity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDimensionSecurityProfile(_response));
        });
    }

    protected processCreateDimensionSecurityProfile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDimensionSecurityProfile(profileName: string): Promise<void> {
        let url_ = this.baseUrl + "/Security/metadata/profiles/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new globalThis.Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteDimensionSecurityProfile(_response));
        });
    }

    protected processDeleteDimensionSecurityProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDimensionSecurity(profileName: string): Promise<DimensionSecurity[]> {
        let url_ = this.baseUrl + "/Security/metadata/dimension/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new globalThis.Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDimensionSecurity(_response));
        });
    }

    protected processGetDimensionSecurity(response: Response): Promise<DimensionSecurity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(DimensionSecurity.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DimensionSecurity[]>(null as any);
    }

    updateDimensionSecurity(profileName: string, dimensionSecurity: DimensionSecurity[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/metadata/dimension/{profileName}";
        if (profileName === undefined || profileName === null)
            throw new globalThis.Error("The parameter 'profileName' must be defined.");
        url_ = url_.replace("{profileName}", encodeURIComponent("" + profileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dimensionSecurity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDimensionSecurity(_response));
        });
    }

    protected processUpdateDimensionSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEffectiveModuleSecurity(): Promise<Module[]> {
        let url_ = this.baseUrl + "/Security/module/effective";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveModuleSecurity(_response));
        });
    }

    protected processGetEffectiveModuleSecurity(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Module.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    getEffectiveModuleSecurityAsync2(): Promise<ModuleAccess[]> {
        let url_ = this.baseUrl + "/Security/module/effective2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveModuleSecurityAsync2(_response));
        });
    }

    protected processGetEffectiveModuleSecurityAsync2(response: Response): Promise<ModuleAccess[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleAccess[]>(null as any);
    }

    getModuleList(): Promise<Module[]> {
        let url_ = this.baseUrl + "/Security/module/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModuleList(_response));
        });
    }

    protected processGetModuleList(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(Module.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    getModule(iD: number): Promise<Module> {
        let url_ = this.baseUrl + "/Security/module/{ID}";
        if (iD === undefined || iD === null)
            throw new globalThis.Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModule(_response));
        });
    }

    protected processGetModule(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    getRoleModuleSecurity(): Promise<ModuleSecurityInfo[]> {
        let url_ = this.baseUrl + "/Security/module/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleModuleSecurity(_response));
        });
    }

    protected processGetRoleModuleSecurity(response: Response): Promise<ModuleSecurityInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ModuleSecurityInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleSecurityInfo[]>(null as any);
    }

    setRoleModuleSecurity(securityInfo: ModuleSecurityInfo[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/module/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityInfo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetRoleModuleSecurity(_response));
        });
    }

    protected processSetRoleModuleSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportRoleAuthorizations(exportRoleAuthInfo: ExportRoleAuthInfo, format?: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/module/roles/export?";
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportRoleAuthInfo);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportRoleAuthorizations(_response));
        });
    }

    protected processExportRoleAuthorizations(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importRoles(isAppend?: boolean | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security/module/roles/import?";
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportRoles(_response));
        });
    }

    protected processImportRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEffectiveFileSystemSecurity(): Promise<FileSystemSecurity> {
        let url_ = this.baseUrl + "/Security/filesystem/effective";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEffectiveFileSystemSecurity(_response));
        });
    }

    protected processGetEffectiveFileSystemSecurity(response: Response): Promise<FileSystemSecurity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileSystemSecurity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSystemSecurity>(null as any);
    }

    getRoleFileSystemSecurity(fileId: number): Promise<FileRoleSecurity[]> {
        let url_ = this.baseUrl + "/Security/filesystem/roles/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoleFileSystemSecurity(_response));
        });
    }

    protected processGetRoleFileSystemSecurity(response: Response): Promise<FileRoleSecurity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(FileRoleSecurity.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileRoleSecurity[]>(null as any);
    }

    setRoleFileSystemSecurity(fileId: number, securityInfo: FileRoleSecurity[]): Promise<void> {
        let url_ = this.baseUrl + "/Security/filesystem/roles/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityInfo);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetRoleFileSystemSecurity(_response));
        });
    }

    protected processSetRoleFileSystemSecurity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    releaseFormLock(id: number): Promise<void> {
        let url_ = this.baseUrl + "/Security/lock/form/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReleaseFormLock(_response));
        });
    }

    protected processReleaseFormLock(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTenantBgColor(color?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Security?";
        if (color !== undefined && color !== null)
            url_ += "color=" + encodeURIComponent("" + color) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetTenantBgColor(_response));
        });
    }

    protected processSetTenantBgColor(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportSecurityProfilesToFile(profileName: string, csvDelim?: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Security/securityprofile/export?";
        if (csvDelim === null)
            throw new globalThis.Error("The parameter 'csvDelim' cannot be null.");
        else if (csvDelim !== undefined)
            url_ += "csvDelim=" + encodeURIComponent("" + csvDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportSecurityProfilesToFile(_response));
        });
    }

    protected processExportSecurityProfilesToFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    importSecurityProfiles(isAppend?: boolean | undefined, csvDelimiter?: string | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/import?";
        if (isAppend === null)
            throw new globalThis.Error("The parameter 'isAppend' cannot be null.");
        else if (isAppend !== undefined)
            url_ += "isAppend=" + encodeURIComponent("" + isAppend) + "&";
        if (csvDelimiter === null)
            throw new globalThis.Error("The parameter 'csvDelimiter' cannot be null.");
        else if (csvDelimiter !== undefined)
            url_ += "csvDelimiter=" + encodeURIComponent("" + csvDelimiter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportSecurityProfiles(_response));
        });
    }

    protected processImportSecurityProfiles(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    securityProfilesCopyRole(profileName: string, copyFromId?: number | undefined, copyToId?: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/copyrole?";
        if (copyFromId === null)
            throw new globalThis.Error("The parameter 'copyFromId' cannot be null.");
        else if (copyFromId !== undefined)
            url_ += "copyFromId=" + encodeURIComponent("" + copyFromId) + "&";
        if (copyToId === null)
            throw new globalThis.Error("The parameter 'copyToId' cannot be null.");
        else if (copyToId !== undefined)
            url_ += "copyToId=" + encodeURIComponent("" + copyToId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileName);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSecurityProfilesCopyRole(_response));
        });
    }

    protected processSecurityProfilesCopyRole(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    securityProfilesCopyProfile(copyFromProfile?: string | null | undefined, copyToProfile?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/Security/securityprofile/copyprofile?";
        if (copyFromProfile !== undefined && copyFromProfile !== null)
            url_ += "copyFromProfile=" + encodeURIComponent("" + copyFromProfile) + "&";
        if (copyToProfile !== undefined && copyToProfile !== null)
            url_ += "copyToProfile=" + encodeURIComponent("" + copyToProfile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSecurityProfilesCopyProfile(_response));
        });
    }

    protected processSecurityProfilesCopyProfile(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Production rollout: docs/encrypted-connection-strings-rollout.md (IRON-606).
    Postman how-to: https://anaplansite.atlassian.net/wiki/x/iQE3OQE
     * @param request Migration request parameters
     */
    migrateConnectionStrings(request: MigrationRequest): Promise<any> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMigrateConnectionStrings(_response));
        });
    }

    protected processMigrateConnectionStrings(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result202 = resultData202 !== undefined ? resultData202 : null as any;
    
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Returns the most recently started migration jobs (newest first). Useful
    from Postman when the jobId from the original POST has been lost.
     * @param take (optional) 
     */
    listMigrationJobs(take?: number | undefined): Promise<MigrationJob[]> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings?";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListMigrationJobs(_response));
        });
    }

    protected processListMigrationJobs(response: Response): Promise<MigrationJob[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(MigrationJob.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationJob[]>(null as any);
    }

    /**
     * Returns the current state and (partial or final) result of a migration
    job started via POST /Security/migrate-connection-strings. While the job
    is running, the response includes the per-tenant results accumulated so
    far so callers can watch progress by polling.
     * @param jobId Identifier returned by the POST endpoint.
     */
    getMigrationJob(jobId: string): Promise<MigrationJob> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMigrationJob(_response));
        });
    }

    protected processGetMigrationJob(response: Response): Promise<MigrationJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationJob.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationJob>(null as any);
    }

    /**
     * Counts leftover populated plaintext connection-string columns in
    TenantData and AppdataSources. IRON-72 uses this as the
    drop-column precondition. Does not return secret values.
     */
    getRemainingPlaintextConnectionStrings(): Promise<RemainingPlaintextCounts> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings/plaintext-remaining";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRemainingPlaintextConnectionStrings(_response));
        });
    }

    protected processGetRemainingPlaintextConnectionStrings(response: Response): Promise<RemainingPlaintextCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemainingPlaintextCounts.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemainingPlaintextCounts>(null as any);
    }

    /**
     * Synchronously migrates a single tenant. Designed for two use cases:
      - Re-running individual tenants that failed in a previous bulk job.
      - Being driven by Postman's Collection Runner over a CSV/JSON list of
        tenant names when a fully-async flow is not desired.
            
    One tenant is small enough to comfortably complete within standard HTTP
    timeouts.
     * @param tenantName The tenant to migrate.
     * @param request Migration options (DryRun). TargetTenants is ignored.
     */
    migrateConnectionStringsForTenant(tenantName: string, request: MigrationRequest): Promise<MigrationResult> {
        let url_ = this.baseUrl + "/Security/migrate-connection-strings/tenant/{tenantName}";
        if (tenantName === undefined || tenantName === null)
            throw new globalThis.Error("The parameter 'tenantName' must be defined.");
        url_ = url_.replace("{tenantName}", encodeURIComponent("" + tenantName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMigrateConnectionStringsForTenant(_response));
        });
    }

    protected processMigrateConnectionStringsForTenant(response: Response): Promise<MigrationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 207) {
            return response.text().then((_responseText) => {
            let result207: any = null;
            let resultData207 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result207 = MigrationResult.fromJS(resultData207);
            return result207;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MigrationResult>(null as any);
    }

    userHasAllRequiredModuleAccess(keysSeparatedByComma?: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Security/does-user-have-required-module-access?";
        if (keysSeparatedByComma !== undefined && keysSeparatedByComma !== null)
            url_ += "keysSeparatedByComma=" + encodeURIComponent("" + keysSeparatedByComma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserHasAllRequiredModuleAccess(_response));
        });
    }

    protected processUserHasAllRequiredModuleAccess(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getRequiredModuleAccessByKey(keysSeparatedByComma?: string | null | undefined): Promise<{ [key: string]: boolean; }> {
        let url_ = this.baseUrl + "/Security/get-required-module-access-by-key?";
        if (keysSeparatedByComma !== undefined && keysSeparatedByComma !== null)
            url_ += "keysSeparatedByComma=" + encodeURIComponent("" + keysSeparatedByComma) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequiredModuleAccessByKey(_response));
        });
    }

    protected processGetRequiredModuleAccessByKey(response: Response): Promise<{ [key: string]: boolean; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: boolean; }>(null as any);
    }
}

export class ServerDebugClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getServerDebugLogs(): Promise<string> {
        let url_ = this.baseUrl + "/ServerDebug/ServerDebugLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetServerDebugLogs(_response));
        });
    }

    protected processGetServerDebugLogs(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SignalRClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getSignalRConfig(): Promise<SignalRConnfig> {
        let url_ = this.baseUrl + "/SignalR/GetSignalRConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSignalRConfig(_response));
        });
    }

    protected processGetSignalRConfig(response: Response): Promise<SignalRConnfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignalRConnfig.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignalRConnfig>(null as any);
    }
}

export class SpDataClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getDataView(spName: string, dataSource?: string | null | undefined, parameters?: string[][] | null | undefined): Promise<TableData> {
        let url_ = this.baseUrl + "/SpData/{spName}?";
        if (spName === undefined || spName === null)
            throw new globalThis.Error("The parameter 'spName' must be defined.");
        url_ = url_.replace("{spName}", encodeURIComponent("" + spName));
        if (dataSource !== undefined && dataSource !== null)
            url_ += "dataSource=" + encodeURIComponent("" + dataSource) + "&";
        if (parameters !== undefined && parameters !== null)
            parameters && parameters.forEach(item => { url_ += "parameters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataView(_response));
        });
    }

    protected processGetDataView(response: Response): Promise<TableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableData>(null as any);
    }

    getDataViewData(spName: string, parameters: string[][], dataSource?: string | null | undefined): Promise<TableData> {
        let url_ = this.baseUrl + "/SpData/data/{spName}?";
        if (spName === undefined || spName === null)
            throw new globalThis.Error("The parameter 'spName' must be defined.");
        url_ = url_.replace("{spName}", encodeURIComponent("" + spName));
        if (dataSource !== undefined && dataSource !== null)
            url_ += "dataSource=" + encodeURIComponent("" + dataSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataViewData(_response));
        });
    }

    protected processGetDataViewData(response: Response): Promise<TableData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableData>(null as any);
    }
}

export class TestClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get1(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get1";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet1(_response));
        });
    }

    protected processGet1(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    get2(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet2(_response));
        });
    }

    protected processGet2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    ge3(): Promise<string> {
        let url_ = this.baseUrl + "/Test/get3";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGe3(_response));
        });
    }

    protected processGe3(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getError(): Promise<string> {
        let url_ = this.baseUrl + "/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetError(_response));
        });
    }

    protected processGetError(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ThemeClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getThemes(): Promise<ThemeInfo[]> {
        let url_ = this.baseUrl + "/Theme/themes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetThemes(_response));
        });
    }

    protected processGetThemes(response: Response): Promise<ThemeInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ThemeInfo.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo[]>(null as any);
    }

    getTheme(themeName: string): Promise<ThemeInfo> {
        let url_ = this.baseUrl + "/Theme/theme/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new globalThis.Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTheme(_response));
        });
    }

    protected processGetTheme(response: Response): Promise<ThemeInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThemeInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo>(null as any);
    }

    updateTheme(themeName: string, request: any): Promise<void> {
        let url_ = this.baseUrl + "/Theme/theme/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new globalThis.Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTheme(_response));
        });
    }

    protected processUpdateTheme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createTheme(themeName: string | null, request: ThemeInfo): Promise<ThemeInfo> {
        let url_ = this.baseUrl + "/Theme/theme";
        if (themeName === undefined || themeName === null)
            throw new globalThis.Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTheme(_response));
        });
    }

    protected processCreateTheme(response: Response): Promise<ThemeInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ThemeInfo.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThemeInfo>(null as any);
    }

    deleteTheme(themeName: string): Promise<void> {
        let url_ = this.baseUrl + "/Theme/model/{themeName}";
        if (themeName === undefined || themeName === null)
            throw new globalThis.Error("The parameter 'themeName' must be defined.");
        url_ = url_.replace("{themeName}", encodeURIComponent("" + themeName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteTheme(_response));
        });
    }

    protected processDeleteTheme(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUserDetails(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserDetails(_response));
        });
    }

    protected processGetUserDetails(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    addUser(user: UserObject): Promise<SecureUserObject> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUser(_response));
        });
    }

    protected processAddUser(response: Response): Promise<SecureUserObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecureUserObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureUserObject>(null as any);
    }

    editUser(user: UserObject): Promise<SecureUserObject> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditUser(_response));
        });
    }

    protected processEditUser(response: Response): Promise<SecureUserObject> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecureUserObject.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecureUserObject>(null as any);
    }

    getAllowedUserDomains(): Promise<string[]> {
        let url_ = this.baseUrl + "/User/Domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllowedUserDomains(_response));
        });
    }

    protected processGetAllowedUserDomains(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUserShort(): Promise<UserDetailsShort[]> {
        let url_ = this.baseUrl + "/User/UsersShort";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserShort(_response));
        });
    }

    protected processGetUserShort(response: Response): Promise<UserDetailsShort[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserDetailsShort.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailsShort[]>(null as any);
    }

    getUserDetails2(userName: string): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/{userName}";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserDetails2(_response));
        });
    }

    protected processGetUserDetails2(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    removeUser(userName: string): Promise<void> {
        let url_ = this.baseUrl + "/User/{userName}";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveUser(_response));
        });
    }

    protected processRemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLastLoginsInTenant(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/LoginDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLastLoginsInTenant(_response));
        });
    }

    protected processGetLastLoginsInTenant(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    getDateAdded(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/DatesAdded";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDateAdded(_response));
        });
    }

    protected processGetDateAdded(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    export(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/User/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    import(encodedCSVDelim?: string | null | undefined, file?: FileParameter | null | undefined): Promise<UserImportResult> {
        let url_ = this.baseUrl + "/User/Import?";
        if (encodedCSVDelim !== undefined && encodedCSVDelim !== null)
            url_ += "encodedCSVDelim=" + encodeURIComponent("" + encodedCSVDelim) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<UserImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserImportResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserImportResult>(null as any);
    }

    bulkUserImport(users: UserObject[]): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/BulkUserImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(users);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBulkUserImport(_response));
        });
    }

    protected processBulkUserImport(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    syncToActiveDirectory(): Promise<UserObject[]> {
        let url_ = this.baseUrl + "/User/SyncToActiveDirectory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncToActiveDirectory(_response));
        });
    }

    protected processSyncToActiveDirectory(response: Response): Promise<UserObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(UserObject.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserObject[]>(null as any);
    }

    syncTenant(): Promise<void> {
        let url_ = this.baseUrl + "/User/synctenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncTenant(_response));
        });
    }

    protected processSyncTenant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMyTokens(): Promise<ApiToken[]> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMyTokens(_response));
        });
    }

    protected processGetMyTokens(response: Response): Promise<ApiToken[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ApiToken.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiToken[]>(null as any);
    }

    deleteMyToken(token: ApiToken): Promise<void> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMyToken(_response));
        });
    }

    protected processDeleteMyToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveMyToken(token: ApiToken): Promise<ApiToken> {
        let url_ = this.baseUrl + "/User/ApiToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveMyToken(_response));
        });
    }

    protected processSaveMyToken(response: Response): Promise<ApiToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiToken>(null as any);
    }
}

export class WhatsNewClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getArticles(filter?: boolean | undefined): Promise<WhatsNewArticle[]> {
        let url_ = this.baseUrl + "/WhatsNew?";
        if (filter === null)
            throw new globalThis.Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArticles(_response));
        });
    }

    protected processGetArticles(response: Response): Promise<WhatsNewArticle[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(WhatsNewArticle.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsNewArticle[]>(null as any);
    }

    saveArticle(article: WhatsNewArticle): Promise<WhatsNewArticle> {
        let url_ = this.baseUrl + "/WhatsNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveArticle(_response));
        });
    }

    protected processSaveArticle(response: Response): Promise<WhatsNewArticle> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsNewArticle.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WhatsNewArticle>(null as any);
    }

    deleteArticle(article: WhatsNewArticle): Promise<void> {
        let url_ = this.baseUrl + "/WhatsNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(article);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteArticle(_response));
        });
    }

    protected processDeleteArticle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WriteClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    writeModelData(data: WritebackData): Promise<void> {
        let url_ = this.baseUrl + "/Write/model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWriteModelData(_response));
        });
    }

    protected processWriteModelData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSecurity(model: string): Promise<WritebackResolvedSecurity> {
        let url_ = this.baseUrl + "/Write/security/{model}";
        if (model === undefined || model === null)
            throw new globalThis.Error("The parameter 'model' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + model));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSecurity(_response));
        });
    }

    protected processGetSecurity(response: Response): Promise<WritebackResolvedSecurity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WritebackResolvedSecurity.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WritebackResolvedSecurity>(null as any);
    }
}

export class XL3CommentsClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getCubeComment(commentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentById?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "CommentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeComment(_response));
        });
    }

    protected processGetCubeComment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    addCubeComment(model: AddCubeCommentModel): Promise<number> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCubeComment(_response));
        });
    }

    protected processAddCubeComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCubeComment(commentXml: string): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentXml);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCubeComment(_response));
        });
    }

    protected processUpdateCubeComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteCubeComment(nCommentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment?";
        if (nCommentID === null)
            throw new globalThis.Error("The parameter 'nCommentID' cannot be null.");
        else if (nCommentID !== undefined)
            url_ += "nCommentID=" + encodeURIComponent("" + nCommentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCubeComment(_response));
        });
    }

    protected processDeleteCubeComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCubeComments(connectionKey?: string | null | undefined, gridMemberXml?: string | null | undefined, includeDescs?: boolean | undefined, mergeComments?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeComment?";
        if (connectionKey !== undefined && connectionKey !== null)
            url_ += "connectionKey=" + encodeURIComponent("" + connectionKey) + "&";
        if (gridMemberXml !== undefined && gridMemberXml !== null)
            url_ += "gridMemberXml=" + encodeURIComponent("" + gridMemberXml) + "&";
        if (includeDescs === null)
            throw new globalThis.Error("The parameter 'includeDescs' cannot be null.");
        else if (includeDescs !== undefined)
            url_ += "includeDescs=" + encodeURIComponent("" + includeDescs) + "&";
        if (mergeComments === null)
            throw new globalThis.Error("The parameter 'mergeComments' cannot be null.");
        else if (mergeComments !== undefined)
            url_ += "mergeComments=" + encodeURIComponent("" + mergeComments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeComments(_response));
        });
    }

    protected processGetCubeComments(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentsByKey(model: CubeCommentsByKeyModel): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentByKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentsByKey(_response));
        });
    }

    protected processGetCubeCommentsByKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentsWithDescByKey(model: GetCubeCommentsWithDescByKeyModel, mergeComments?: boolean | undefined, exactMatch?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentsWithDescByKey?";
        if (mergeComments === null)
            throw new globalThis.Error("The parameter 'mergeComments' cannot be null.");
        else if (mergeComments !== undefined)
            url_ += "mergeComments=" + encodeURIComponent("" + mergeComments) + "&";
        if (exactMatch === null)
            throw new globalThis.Error("The parameter 'exactMatch' cannot be null.");
        else if (exactMatch !== undefined)
            url_ += "exactMatch=" + encodeURIComponent("" + exactMatch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentsWithDescByKey(_response));
        });
    }

    protected processGetCubeCommentsWithDescByKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchCubeComments(searchTerms: TupleOfStringAndStringAndString[], additionalKey?: string | null | undefined, dtCreatedFrom?: Date | undefined, dtCreatedTo?: Date | undefined, dtUpdatedFrom?: Date | undefined, dtUpdatedTo?: Date | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/SearchCubeComments?";
        if (additionalKey !== undefined && additionalKey !== null)
            url_ += "additionalKey=" + encodeURIComponent("" + additionalKey) + "&";
        if (dtCreatedFrom === null)
            throw new globalThis.Error("The parameter 'dtCreatedFrom' cannot be null.");
        else if (dtCreatedFrom !== undefined)
            url_ += "dtCreatedFrom=" + encodeURIComponent(dtCreatedFrom ? "" + dtCreatedFrom.toISOString() : "") + "&";
        if (dtCreatedTo === null)
            throw new globalThis.Error("The parameter 'dtCreatedTo' cannot be null.");
        else if (dtCreatedTo !== undefined)
            url_ += "dtCreatedTo=" + encodeURIComponent(dtCreatedTo ? "" + dtCreatedTo.toISOString() : "") + "&";
        if (dtUpdatedFrom === null)
            throw new globalThis.Error("The parameter 'dtUpdatedFrom' cannot be null.");
        else if (dtUpdatedFrom !== undefined)
            url_ += "dtUpdatedFrom=" + encodeURIComponent(dtUpdatedFrom ? "" + dtUpdatedFrom.toISOString() : "") + "&";
        if (dtUpdatedTo === null)
            throw new globalThis.Error("The parameter 'dtUpdatedTo' cannot be null.");
        else if (dtUpdatedTo !== undefined)
            url_ += "dtUpdatedTo=" + encodeURIComponent(dtUpdatedTo ? "" + dtUpdatedTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchTerms);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchCubeComments(_response));
        });
    }

    protected processSearchCubeComments(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getTaggableUsers(): Promise<any[]> {
        let url_ = this.baseUrl + "/XL3Comments/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTaggableUsers(_response));
        });
    }

    protected processGetTaggableUsers(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(null as any);
    }

    getCubeCommentPermission(): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentPermission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentPermission(_response));
        });
    }

    protected processGetCubeCommentPermission(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCubeCommentHistory(nCommentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentHistory?";
        if (nCommentID === null)
            throw new globalThis.Error("The parameter 'nCommentID' cannot be null.");
        else if (nCommentID !== undefined)
            url_ += "nCommentID=" + encodeURIComponent("" + nCommentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentHistory(_response));
        });
    }

    protected processGetCubeCommentHistory(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    addCubeCommentAttachment(data: string, name?: string | null | undefined, commentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCubeCommentAttachment(_response));
        });
    }

    protected processAddCubeCommentAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCubeCommentAttachment(commentID?: number | undefined, attachmentID?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        if (attachmentID === null)
            throw new globalThis.Error("The parameter 'attachmentID' cannot be null.");
        else if (attachmentID !== undefined)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCubeCommentAttachment(_response));
        });
    }

    protected processGetCubeCommentAttachment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteCubeCommentAttachment(commentID?: number | undefined, attachmentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/XL3Comments/CubeCommentAttachment?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        if (attachmentID === null)
            throw new globalThis.Error("The parameter 'attachmentID' cannot be null.");
        else if (attachmentID !== undefined)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteCubeCommentAttachment(_response));
        });
    }

    protected processDeleteCubeCommentAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RootClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<string[]> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getVersionInfo(): Promise<string> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVersionInfo(_response));
        });
    }

    protected processGetVersionInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DimensionControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__GetDimensions(): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/dimensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetDimensions(_response));
        });
    }

    protected process2305__GetDimensions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    _2305__GetDimensionMembers(dimensionName: string, page?: number | undefined, pageSize?: number | undefined, format?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/dimensions/{dimensionName}?";
        if (dimensionName === undefined || dimensionName === null)
            throw new globalThis.Error("The parameter 'dimensionName' must be defined.");
        url_ = url_.replace("{dimensionName}", encodeURIComponent("" + dimensionName));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "format": format !== undefined && format !== null ? "" + format : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetDimensionMembers(_response));
        });
    }

    protected process2305__GetDimensionMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ModelControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__GetModelDimensionMembers(modelName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/metadata/models/{modelName}/dimensions";
        if (modelName === undefined || modelName === null)
            throw new globalThis.Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetModelDimensionMembers(_response));
        });
    }

    protected process2305__GetModelDimensionMembers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OdataControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__GetOData(table: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetOData(_response));
        });
    }

    protected process2305__GetOData(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    _2305__PostOData(table: string, item: Item): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__PostOData(_response));
        });
    }

    protected process2305__PostOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    _2305__PutOData(table: string, item: Item2): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__PutOData(_response));
        });
    }

    protected process2305__PutOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    _2305__DeleteOData(table: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/{table}";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__DeleteOData(_response));
        });
    }

    protected process2305__DeleteOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    _2305__BatchOData(table: string, truncateTable?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/odata/batch/{table}?";
        if (table === undefined || table === null)
            throw new globalThis.Error("The parameter 'table' must be defined.");
        url_ = url_.replace("{table}", encodeURIComponent("" + table));
        if (truncateTable === null)
            throw new globalThis.Error("The parameter 'truncateTable' cannot be null.");
        else if (truncateTable !== undefined)
            url_ += "truncateTable=" + encodeURIComponent("" + truncateTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__BatchOData(_response));
        });
    }

    protected process2305__BatchOData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProcessControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__Start(path: string, options: string[][], runId?: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2305.1/process/start/{path}?";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        if (runId !== undefined && runId !== null)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__Start(_response));
        });
    }

    protected process2305__Start(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    _2305__State(path: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v2305.1/process/state/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__State(_response));
        });
    }

    protected process2305__State(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    _2305__StopInteractiveProcess(path: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/process/stop/{path}";
        if (path === undefined || path === null)
            throw new globalThis.Error("The parameter 'path' must be defined.");
        url_ = url_.replace("{path}", encodeURIComponent("" + path));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__StopInteractiveProcess(_response));
        });
    }

    protected process2305__StopInteractiveProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserRolesControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__GetRoles(userName: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetRoles(_response));
        });
    }

    protected process2305__GetRoles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    _2305__AddRole(userName: string, role: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__AddRole(_response));
        });
    }

    protected process2305__AddRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    _2305__RemoveRole(userName: string, role: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2305.1/user/{username}/roles";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__RemoveRole(_response));
        });
    }

    protected process2305__RemoveRole(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(resultData200[item]);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class UsersControllerClient extends FluenceApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    _2305__GetUsersAll(): Promise<ApiUserDetails[]> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetUsersAll(_response));
        });
    }

    protected process2305__GetUsersAll(response: Response): Promise<ApiUserDetails[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item in resultData200)
                    result200!.push(ApiUserDetails.fromJS(resultData200[item]));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails[]>(null as any);
    }

    _2305__AddUser(user: UserObject): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__AddUser(_response));
        });
    }

    protected process2305__AddUser(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    _2305__EditUser(user: UserObject): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__EditUser(_response));
        });
    }

    protected process2305__EditUser(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    _2305__GetUsers(userName: string): Promise<ApiUserDetails> {
        let url_ = this.baseUrl + "/api/v2305.1/users/{userName}";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__GetUsers(_response));
        });
    }

    protected process2305__GetUsers(response: Response): Promise<ApiUserDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiUserDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiUserDetails>(null as any);
    }

    _2305__RemoveUser(userName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2305.1/users/{userName}";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.process2305__RemoveUser(_response));
        });
    }

    protected process2305__RemoveUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HelpChatMessage implements IHelpChatMessage {
    answer?: string | null;
    userMessage!: string;
    hint?: string | null;
    soft?: string | null;
    history?: HelpChatHistoryItem[] | null;

    constructor(data?: IHelpChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answer = data["answer"] !== undefined ? data["answer"] : null as any;
            this.userMessage = data["userMessage"] !== undefined ? data["userMessage"] : null as any;
            this.hint = data["hint"] !== undefined ? data["hint"] : null as any;
            this.soft = data["soft"] !== undefined ? data["soft"] : null as any;
            if (Array.isArray(data["history"])) {
                this.history = [] as any;
                for (let item in data["history"])
                    this.history!.push(HelpChatHistoryItem.fromJS(data["history"][item]));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): HelpChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        data["userMessage"] = this.userMessage !== undefined ? this.userMessage : null as any;
        data["hint"] = this.hint !== undefined ? this.hint : null as any;
        data["soft"] = this.soft !== undefined ? this.soft : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item in this.history)
                data["history"].push(this.history[item] ? this.history[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): HelpChatMessage {
        const json = this.toJSON();
        let result = new HelpChatMessage();
        result.init(json);
        return result;
    }
}

export interface IHelpChatMessage {
    answer?: string | null;
    userMessage: string;
    hint?: string | null;
    soft?: string | null;
    history?: HelpChatHistoryItem[] | null;
}

export class HelpChatHistoryItem implements IHelpChatHistoryItem {
    question?: string | null;
    answer?: string | null;

    constructor(data?: IHelpChatHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.question = data["question"] !== undefined ? data["question"] : null as any;
            this.answer = data["answer"] !== undefined ? data["answer"] : null as any;
        }
    }

    static fromJS(data: any): HelpChatHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question !== undefined ? this.question : null as any;
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        return data;
    }

    clone(): HelpChatHistoryItem {
        const json = this.toJSON();
        let result = new HelpChatHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IHelpChatHistoryItem {
    question?: string | null;
    answer?: string | null;
}

export class HelpArticle implements IHelpArticle {
    key?: string | null;
    zenDeskArticleId?: string | null;

    constructor(data?: IHelpArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.zenDeskArticleId = data["zenDeskArticleId"] !== undefined ? data["zenDeskArticleId"] : null as any;
        }
    }

    static fromJS(data: any): HelpArticle {
        data = typeof data === 'object' ? data : {};
        let result = new HelpArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["zenDeskArticleId"] = this.zenDeskArticleId !== undefined ? this.zenDeskArticleId : null as any;
        return data;
    }

    clone(): HelpArticle {
        const json = this.toJSON();
        let result = new HelpArticle();
        result.init(json);
        return result;
    }
}

export interface IHelpArticle {
    key?: string | null;
    zenDeskArticleId?: string | null;
}

export class ADOActionType implements IADOActionType {
    id?: string | null;
    label?: string | null;

    constructor(data?: IADOActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.label = data["label"] !== undefined ? data["label"] : null as any;
        }
    }

    static fromJS(data: any): ADOActionType {
        data = typeof data === 'object' ? data : {};
        let result = new ADOActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        return data;
    }

    clone(): ADOActionType {
        const json = this.toJSON();
        let result = new ADOActionType();
        result.init(json);
        return result;
    }
}

export interface IADOActionType {
    id?: string | null;
    label?: string | null;
}

export class ADOAction implements IADOAction {
    id?: string | null;
    label?: string | null;

    constructor(data?: IADOAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.label = data["label"] !== undefined ? data["label"] : null as any;
        }
    }

    static fromJS(data: any): ADOAction {
        data = typeof data === 'object' ? data : {};
        let result = new ADOAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        return data;
    }

    clone(): ADOAction {
        const json = this.toJSON();
        let result = new ADOAction();
        result.init(json);
        return result;
    }
}

export interface IADOAction {
    id?: string | null;
    label?: string | null;
}

export class PipelineDefinitionItem implements IPipelineDefinitionItem {
    id?: string | null;
    tenantId?: string | null;
    name?: string | null;
    pipelineDefinitionVersionId?: string | null;
    createdBy?: UserRef | null;
    updatedBy?: UserRef | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    deletedAt?: Date | null;
    pipelineType!: number;
    dataspaceId?: string | null;
    region?: string | null;
    pipelineDefinition?: PipelineDefinitionContainer | null;
    lastExecution?: PipelineLastExecution | null;

    constructor(data?: IPipelineDefinitionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.pipelineDefinitionVersionId = data["pipelineDefinitionVersionId"] !== undefined ? data["pipelineDefinitionVersionId"] : null as any;
            this.createdBy = data["createdBy"] ? UserRef.fromJS(data["createdBy"]) : null as any;
            this.updatedBy = data["updatedBy"] ? UserRef.fromJS(data["updatedBy"]) : null as any;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : null as any;
            this.updatedAt = data["updatedAt"] ? new Date(data["updatedAt"].toString()) : null as any;
            this.deletedAt = data["deletedAt"] ? new Date(data["deletedAt"].toString()) : null as any;
            this.pipelineType = data["pipelineType"] !== undefined ? data["pipelineType"] : null as any;
            this.dataspaceId = data["dataspaceId"] !== undefined ? data["dataspaceId"] : null as any;
            this.region = data["region"] !== undefined ? data["region"] : null as any;
            this.pipelineDefinition = data["pipelineDefinition"] ? PipelineDefinitionContainer.fromJS(data["pipelineDefinition"]) : null as any;
            this.lastExecution = data["lastExecution"] ? PipelineLastExecution.fromJS(data["lastExecution"]) : null as any;
        }
    }

    static fromJS(data: any): PipelineDefinitionItem {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineDefinitionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pipelineDefinitionVersionId"] = this.pipelineDefinitionVersionId !== undefined ? this.pipelineDefinitionVersionId : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : null as any;
        data["pipelineType"] = this.pipelineType !== undefined ? this.pipelineType : null as any;
        data["dataspaceId"] = this.dataspaceId !== undefined ? this.dataspaceId : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["pipelineDefinition"] = this.pipelineDefinition ? this.pipelineDefinition.toJSON() : null as any;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toJSON() : null as any;
        return data;
    }

    clone(): PipelineDefinitionItem {
        const json = this.toJSON();
        let result = new PipelineDefinitionItem();
        result.init(json);
        return result;
    }
}

export interface IPipelineDefinitionItem {
    id?: string | null;
    tenantId?: string | null;
    name?: string | null;
    pipelineDefinitionVersionId?: string | null;
    createdBy?: UserRef | null;
    updatedBy?: UserRef | null;
    createdAt?: Date | null;
    updatedAt?: Date | null;
    deletedAt?: Date | null;
    pipelineType: number;
    dataspaceId?: string | null;
    region?: string | null;
    pipelineDefinition?: PipelineDefinitionContainer | null;
    lastExecution?: PipelineLastExecution | null;
}

export class UserRef implements IUserRef {
    userGuid?: string | null;
    userLastName?: string | null;
    userFirstName?: string | null;
    emailAddress?: string | null;

    constructor(data?: IUserRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userGuid = data["userGuid"] !== undefined ? data["userGuid"] : null as any;
            this.userLastName = data["userLastName"] !== undefined ? data["userLastName"] : null as any;
            this.userFirstName = data["userFirstName"] !== undefined ? data["userFirstName"] : null as any;
            this.emailAddress = data["emailAddress"] !== undefined ? data["emailAddress"] : null as any;
        }
    }

    static fromJS(data: any): UserRef {
        data = typeof data === 'object' ? data : {};
        let result = new UserRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGuid"] = this.userGuid !== undefined ? this.userGuid : null as any;
        data["userLastName"] = this.userLastName !== undefined ? this.userLastName : null as any;
        data["userFirstName"] = this.userFirstName !== undefined ? this.userFirstName : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        return data;
    }

    clone(): UserRef {
        const json = this.toJSON();
        let result = new UserRef();
        result.init(json);
        return result;
    }
}

export interface IUserRef {
    userGuid?: string | null;
    userLastName?: string | null;
    userFirstName?: string | null;
    emailAddress?: string | null;
}

export class PipelineDefinitionContainer implements IPipelineDefinitionContainer {
    pipeline?: Pipeline | null;
    schemaVersion?: string | null;

    constructor(data?: IPipelineDefinitionContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pipeline = data["pipeline"] ? Pipeline.fromJS(data["pipeline"]) : null as any;
            this.schemaVersion = data["schemaVersion"] !== undefined ? data["schemaVersion"] : null as any;
        }
    }

    static fromJS(data: any): PipelineDefinitionContainer {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineDefinitionContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipeline"] = this.pipeline ? this.pipeline.toJSON() : null as any;
        data["schemaVersion"] = this.schemaVersion !== undefined ? this.schemaVersion : null as any;
        return data;
    }

    clone(): PipelineDefinitionContainer {
        const json = this.toJSON();
        let result = new PipelineDefinitionContainer();
        result.init(json);
        return result;
    }
}

export interface IPipelineDefinitionContainer {
    pipeline?: Pipeline | null;
    schemaVersion?: string | null;
}

export class Pipeline implements IPipeline {
    steps?: PipelineStep[] | null;

    constructor(data?: IPipeline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["steps"])) {
                this.steps = [] as any;
                for (let item in data["steps"])
                    this.steps!.push(PipelineStep.fromJS(data["steps"][item]));
            }
            else {
                this.steps = null as any;
            }
        }
    }

    static fromJS(data: any): Pipeline {
        data = typeof data === 'object' ? data : {};
        let result = new Pipeline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item in this.steps)
                data["steps"].push(this.steps[item] ? this.steps[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): Pipeline {
        const json = this.toJSON();
        let result = new Pipeline();
        result.init(json);
        return result;
    }
}

export interface IPipeline {
    steps?: PipelineStep[] | null;
}

export class PipelineStep implements IPipelineStep {
    name?: string | null;
    id?: string | null;
    sourceIds?: string[] | null;
    type?: string | null;
    config?: PipelineStepConfig | null;

    constructor(data?: IPipelineStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            if (Array.isArray(data["sourceIds"])) {
                this.sourceIds = [] as any;
                for (let item in data["sourceIds"])
                    this.sourceIds!.push(data["sourceIds"][item]);
            }
            else {
                this.sourceIds = null as any;
            }
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.config = data["config"] ? PipelineStepConfig.fromJS(data["config"]) : null as any;
        }
    }

    static fromJS(data: any): PipelineStep {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.sourceIds)) {
            data["sourceIds"] = [];
            for (let item in this.sourceIds)
                data["sourceIds"].push(this.sourceIds[item]);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["config"] = this.config ? this.config.toJSON() : null as any;
        return data;
    }

    clone(): PipelineStep {
        const json = this.toJSON();
        let result = new PipelineStep();
        result.init(json);
        return result;
    }
}

export interface IPipelineStep {
    name?: string | null;
    id?: string | null;
    sourceIds?: string[] | null;
    type?: string | null;
    config?: PipelineStepConfig | null;
}

export class PipelineStepConfig implements IPipelineStepConfig {
    type?: string | null;
    connectionId?: string | null;
    fileId?: string | null;
    modelGuid?: string | null;
    workspaceGuid?: string | null;
    outputColumns?: OutputColumn[] | null;
    columns?: string[] | null;
    rowData?: string[][] | null;
    canModifyOutputColumns?: boolean | null;

    constructor(data?: IPipelineStepConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.connectionId = data["connectionId"] !== undefined ? data["connectionId"] : null as any;
            this.fileId = data["fileId"] !== undefined ? data["fileId"] : null as any;
            this.modelGuid = data["modelGuid"] !== undefined ? data["modelGuid"] : null as any;
            this.workspaceGuid = data["workspaceGuid"] !== undefined ? data["workspaceGuid"] : null as any;
            if (Array.isArray(data["outputColumns"])) {
                this.outputColumns = [] as any;
                for (let item in data["outputColumns"])
                    this.outputColumns!.push(OutputColumn.fromJS(data["outputColumns"][item]));
            }
            else {
                this.outputColumns = null as any;
            }
            if (Array.isArray(data["columns"])) {
                this.columns = [] as any;
                for (let item in data["columns"])
                    this.columns!.push(data["columns"][item]);
            }
            else {
                this.columns = null as any;
            }
            if (Array.isArray(data["rowData"])) {
                this.rowData = [] as any;
                for (let item in data["rowData"])
                    this.rowData!.push(data["rowData"][item]);
            }
            else {
                this.rowData = null as any;
            }
            this.canModifyOutputColumns = data["canModifyOutputColumns"] !== undefined ? data["canModifyOutputColumns"] : null as any;
        }
    }

    static fromJS(data: any): PipelineStepConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineStepConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["connectionId"] = this.connectionId !== undefined ? this.connectionId : null as any;
        data["fileId"] = this.fileId !== undefined ? this.fileId : null as any;
        data["modelGuid"] = this.modelGuid !== undefined ? this.modelGuid : null as any;
        data["workspaceGuid"] = this.workspaceGuid !== undefined ? this.workspaceGuid : null as any;
        if (Array.isArray(this.outputColumns)) {
            data["outputColumns"] = [];
            for (let item in this.outputColumns)
                data["outputColumns"].push(this.outputColumns[item] ? this.outputColumns[item].toJSON() : null as any);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item in this.columns)
                data["columns"].push(this.columns[item]);
        }
        if (Array.isArray(this.rowData)) {
            data["rowData"] = [];
            for (let item in this.rowData)
                data["rowData"].push(this.rowData[item]);
        }
        data["canModifyOutputColumns"] = this.canModifyOutputColumns !== undefined ? this.canModifyOutputColumns : null as any;
        return data;
    }

    clone(): PipelineStepConfig {
        const json = this.toJSON();
        let result = new PipelineStepConfig();
        result.init(json);
        return result;
    }
}

export interface IPipelineStepConfig {
    type?: string | null;
    connectionId?: string | null;
    fileId?: string | null;
    modelGuid?: string | null;
    workspaceGuid?: string | null;
    outputColumns?: OutputColumn[] | null;
    columns?: string[] | null;
    rowData?: string[][] | null;
    canModifyOutputColumns?: boolean | null;
}

export class OutputColumn implements IOutputColumn {
    name?: string | null;
    alias?: string | null;
    type?: string | null;

    constructor(data?: IOutputColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.alias = data["alias"] !== undefined ? data["alias"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static fromJS(data: any): OutputColumn {
        data = typeof data === 'object' ? data : {};
        let result = new OutputColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["alias"] = this.alias !== undefined ? this.alias : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): OutputColumn {
        const json = this.toJSON();
        let result = new OutputColumn();
        result.init(json);
        return result;
    }
}

export interface IOutputColumn {
    name?: string | null;
    alias?: string | null;
    type?: string | null;
}

export class PipelineLastExecution implements IPipelineLastExecution {
    status?: string | null;
    completedAt?: Date | null;
    startedAt?: Date | null;
    createdAt?: Date | null;
    createdBy?: UserRef | null;
    startupTime?: number | null;
    executionTime?: number | null;
    totalTime?: number | null;

    constructor(data?: IPipelineLastExecution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : null as any;
            this.startedAt = data["startedAt"] ? new Date(data["startedAt"].toString()) : null as any;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : null as any;
            this.createdBy = data["createdBy"] ? UserRef.fromJS(data["createdBy"]) : null as any;
            this.startupTime = data["startupTime"] !== undefined ? data["startupTime"] : null as any;
            this.executionTime = data["executionTime"] !== undefined ? data["executionTime"] : null as any;
            this.totalTime = data["totalTime"] !== undefined ? data["totalTime"] : null as any;
        }
    }

    static fromJS(data: any): PipelineLastExecution {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineLastExecution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["startupTime"] = this.startupTime !== undefined ? this.startupTime : null as any;
        data["executionTime"] = this.executionTime !== undefined ? this.executionTime : null as any;
        data["totalTime"] = this.totalTime !== undefined ? this.totalTime : null as any;
        return data;
    }

    clone(): PipelineLastExecution {
        const json = this.toJSON();
        let result = new PipelineLastExecution();
        result.init(json);
        return result;
    }
}

export interface IPipelineLastExecution {
    status?: string | null;
    completedAt?: Date | null;
    startedAt?: Date | null;
    createdAt?: Date | null;
    createdBy?: UserRef | null;
    startupTime?: number | null;
    executionTime?: number | null;
    totalTime?: number | null;
}

export class AnaplanWorkflow implements IAnaplanWorkflow {
    guid?: string | null;
    name?: string | null;
    description?: string | null;

    constructor(data?: IAnaplanWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guid = data["guid"] !== undefined ? data["guid"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
        }
    }

    static fromJS(data: any): AnaplanWorkflow {
        data = typeof data === 'object' ? data : {};
        let result = new AnaplanWorkflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): AnaplanWorkflow {
        const json = this.toJSON();
        let result = new AnaplanWorkflow();
        result.init(json);
        return result;
    }
}

export interface IAnaplanWorkflow {
    guid?: string | null;
    name?: string | null;
    description?: string | null;
}

export class ADODataspace implements IADODataspace {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;

    constructor(data?: IADODataspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.display_name = data["display_name"] !== undefined ? data["display_name"] : null as any;
        }
    }

    static fromJS(data: any): ADODataspace {
        data = typeof data === 'object' ? data : {};
        let result = new ADODataspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["display_name"] = this.display_name !== undefined ? this.display_name : null as any;
        return data;
    }

    clone(): ADODataspace {
        const json = this.toJSON();
        let result = new ADODataspace();
        result.init(json);
        return result;
    }
}

export interface IADODataspace {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;
}

export class ADODataset implements IADODataset {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;

    constructor(data?: IADODataset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.display_name = data["display_name"] !== undefined ? data["display_name"] : null as any;
        }
    }

    static fromJS(data: any): ADODataset {
        data = typeof data === 'object' ? data : {};
        let result = new ADODataset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["display_name"] = this.display_name !== undefined ? this.display_name : null as any;
        return data;
    }

    clone(): ADODataset {
        const json = this.toJSON();
        let result = new ADODataset();
        result.init(json);
        return result;
    }
}

export interface IADODataset {
    id?: string | null;
    name?: string | null;
    display_name?: string | null;
}

export class FactDataScanSummaryDto implements IFactDataScanSummaryDto {
    scanRunId!: string;
    modelName?: string | null;
    detectionMethod!: AnomalyDetectionMethodDto;
    status!: AnomalyScanRunStatusDto;
    totalAnomaliesFound?: number | null;
    totalSeriesScanned?: number | null;
    triggerType!: AnomalyScanTriggerTypeDto;
    triggerUser?: string | null;
    errorMessage?: string | null;
    startedAt!: Date;
    completedAt?: Date | null;

    constructor(data?: IFactDataScanSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scanRunId = data["scanRunId"] !== undefined ? data["scanRunId"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.detectionMethod = data["detectionMethod"] !== undefined ? data["detectionMethod"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.totalAnomaliesFound = data["totalAnomaliesFound"] !== undefined ? data["totalAnomaliesFound"] : null as any;
            this.totalSeriesScanned = data["totalSeriesScanned"] !== undefined ? data["totalSeriesScanned"] : null as any;
            this.triggerType = data["triggerType"] !== undefined ? data["triggerType"] : null as any;
            this.triggerUser = data["triggerUser"] !== undefined ? data["triggerUser"] : null as any;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : null as any;
            this.startedAt = data["startedAt"] ? new Date(data["startedAt"].toString()) : null as any;
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): FactDataScanSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FactDataScanSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scanRunId"] = this.scanRunId !== undefined ? this.scanRunId : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["detectionMethod"] = this.detectionMethod !== undefined ? this.detectionMethod : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["totalAnomaliesFound"] = this.totalAnomaliesFound !== undefined ? this.totalAnomaliesFound : null as any;
        data["totalSeriesScanned"] = this.totalSeriesScanned !== undefined ? this.totalSeriesScanned : null as any;
        data["triggerType"] = this.triggerType !== undefined ? this.triggerType : null as any;
        data["triggerUser"] = this.triggerUser !== undefined ? this.triggerUser : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : null as any;
        return data;
    }

    clone(): FactDataScanSummaryDto {
        const json = this.toJSON();
        let result = new FactDataScanSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IFactDataScanSummaryDto {
    scanRunId: string;
    modelName?: string | null;
    detectionMethod: AnomalyDetectionMethodDto;
    status: AnomalyScanRunStatusDto;
    totalAnomaliesFound?: number | null;
    totalSeriesScanned?: number | null;
    triggerType: AnomalyScanTriggerTypeDto;
    triggerUser?: string | null;
    errorMessage?: string | null;
    startedAt: Date;
    completedAt?: Date | null;
}

export enum AnomalyDetectionMethodDto {
    DeltaDeviation = 1,
}

export enum AnomalyScanRunStatusDto {
    Pending = 1,
    Running = 2,
    Completed = 3,
    Failed = 4,
}

export enum AnomalyScanTriggerTypeDto {
    Manual = 1,
    DataImport = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.title = data["title"] !== undefined ? data["title"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.detail = data["detail"] !== undefined ? data["detail"] : null as any;
            this.instance = data["instance"] !== undefined ? data["instance"] : null as any;
            if (data["extensions"]) {
                this.extensions = {} as any;
                for (let key in data["extensions"]) {
                    if (data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = data["extensions"][key] !== undefined ? data["extensions"][key] : null as any;
                }
            }
            else {
                this.extensions = null as any;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = this.extensions[key] !== undefined ? this.extensions[key] : null as any;
            }
        }
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class RunFactDataScanRequestDto implements IRunFactDataScanRequestDto {
    modelName!: string;
    detectionMethod!: AnomalyDetectionMethodDto;
    options?: AnomalyDetectionOptionsDto | null;

    constructor(data?: IRunFactDataScanRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.detectionMethod = data["detectionMethod"] !== undefined ? data["detectionMethod"] : null as any;
            this.options = data["options"] ? AnomalyDetectionOptionsDto.fromJS(data["options"]) : null as any;
        }
    }

    static fromJS(data: any): RunFactDataScanRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RunFactDataScanRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["detectionMethod"] = this.detectionMethod !== undefined ? this.detectionMethod : null as any;
        data["options"] = this.options ? this.options.toJSON() : null as any;
        return data;
    }

    clone(): RunFactDataScanRequestDto {
        const json = this.toJSON();
        let result = new RunFactDataScanRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRunFactDataScanRequestDto {
    modelName: string;
    detectionMethod: AnomalyDetectionMethodDto;
    options?: AnomalyDetectionOptionsDto | null;
}

export class AnomalyDetectionOptionsDto implements IAnomalyDetectionOptionsDto {
    deltaDeviationThreshold?: number | null;
    minDataPoints?: number | null;

    constructor(data?: IAnomalyDetectionOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deltaDeviationThreshold = data["deltaDeviationThreshold"] !== undefined ? data["deltaDeviationThreshold"] : null as any;
            this.minDataPoints = data["minDataPoints"] !== undefined ? data["minDataPoints"] : null as any;
        }
    }

    static fromJS(data: any): AnomalyDetectionOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomalyDetectionOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deltaDeviationThreshold"] = this.deltaDeviationThreshold !== undefined ? this.deltaDeviationThreshold : null as any;
        data["minDataPoints"] = this.minDataPoints !== undefined ? this.minDataPoints : null as any;
        return data;
    }

    clone(): AnomalyDetectionOptionsDto {
        const json = this.toJSON();
        let result = new AnomalyDetectionOptionsDto();
        result.init(json);
        return result;
    }
}

export interface IAnomalyDetectionOptionsDto {
    deltaDeviationThreshold?: number | null;
    minDataPoints?: number | null;
}

export class PagedFactDataResultsDto implements IPagedFactDataResultsDto {
    items?: FactDataResultDto[] | null;
    totalCount!: number;
    skip!: number;
    take!: number;

    constructor(data?: IPagedFactDataResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item in data["items"])
                    this.items!.push(FactDataResultDto.fromJS(data["items"][item]));
            }
            else {
                this.items = null as any;
            }
            this.totalCount = data["totalCount"] !== undefined ? data["totalCount"] : null as any;
            this.skip = data["skip"] !== undefined ? data["skip"] : null as any;
            this.take = data["take"] !== undefined ? data["take"] : null as any;
        }
    }

    static fromJS(data: any): PagedFactDataResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedFactDataResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item in this.items)
                data["items"].push(this.items[item] ? this.items[item].toJSON() : null as any);
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        data["skip"] = this.skip !== undefined ? this.skip : null as any;
        data["take"] = this.take !== undefined ? this.take : null as any;
        return data;
    }

    clone(): PagedFactDataResultsDto {
        const json = this.toJSON();
        let result = new PagedFactDataResultsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedFactDataResultsDto {
    items?: FactDataResultDto[] | null;
    totalCount: number;
    skip: number;
    take: number;
}

export class FactDataResultDto implements IFactDataResultDto {
    id!: number;
    scanRunId!: string;
    modelName?: string | null;
    accountName?: string | null;
    date?: string | null;
    value!: number;
    detectionMethod!: AnomalyDetectionMethodDto;
    deltaValue!: number;
    deltaMean?: number | null;
    deltaStandardDeviation?: number | null;
    deltaZScore?: number | null;
    sliceKey?: string | null;
    columnContext?: { [key: string]: string; } | null;
    timeSeriesContext?: TimeSeriesContextPointDto[] | null;
    createdAt!: Date;

    constructor(data?: IFactDataResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.scanRunId = data["scanRunId"] !== undefined ? data["scanRunId"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : null as any;
            this.date = data["date"] !== undefined ? data["date"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
            this.detectionMethod = data["detectionMethod"] !== undefined ? data["detectionMethod"] : null as any;
            this.deltaValue = data["deltaValue"] !== undefined ? data["deltaValue"] : null as any;
            this.deltaMean = data["deltaMean"] !== undefined ? data["deltaMean"] : null as any;
            this.deltaStandardDeviation = data["deltaStandardDeviation"] !== undefined ? data["deltaStandardDeviation"] : null as any;
            this.deltaZScore = data["deltaZScore"] !== undefined ? data["deltaZScore"] : null as any;
            this.sliceKey = data["sliceKey"] !== undefined ? data["sliceKey"] : null as any;
            if (data["columnContext"]) {
                this.columnContext = {} as any;
                for (let key in data["columnContext"]) {
                    if (data["columnContext"].hasOwnProperty(key))
                        (this.columnContext as any)![key] = data["columnContext"][key] !== undefined ? data["columnContext"][key] : null as any;
                }
            }
            else {
                this.columnContext = null as any;
            }
            if (Array.isArray(data["timeSeriesContext"])) {
                this.timeSeriesContext = [] as any;
                for (let item in data["timeSeriesContext"])
                    this.timeSeriesContext!.push(TimeSeriesContextPointDto.fromJS(data["timeSeriesContext"][item]));
            }
            else {
                this.timeSeriesContext = null as any;
            }
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): FactDataResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FactDataResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["scanRunId"] = this.scanRunId !== undefined ? this.scanRunId : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["date"] = this.date !== undefined ? this.date : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["detectionMethod"] = this.detectionMethod !== undefined ? this.detectionMethod : null as any;
        data["deltaValue"] = this.deltaValue !== undefined ? this.deltaValue : null as any;
        data["deltaMean"] = this.deltaMean !== undefined ? this.deltaMean : null as any;
        data["deltaStandardDeviation"] = this.deltaStandardDeviation !== undefined ? this.deltaStandardDeviation : null as any;
        data["deltaZScore"] = this.deltaZScore !== undefined ? this.deltaZScore : null as any;
        data["sliceKey"] = this.sliceKey !== undefined ? this.sliceKey : null as any;
        if (this.columnContext) {
            data["columnContext"] = {};
            for (let key in this.columnContext) {
                if (this.columnContext.hasOwnProperty(key))
                    (data["columnContext"] as any)[key] = this.columnContext[key] !== undefined ? this.columnContext[key] : null as any;
            }
        }
        if (Array.isArray(this.timeSeriesContext)) {
            data["timeSeriesContext"] = [];
            for (let item in this.timeSeriesContext)
                data["timeSeriesContext"].push(this.timeSeriesContext[item] ? this.timeSeriesContext[item].toJSON() : null as any);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        return data;
    }

    clone(): FactDataResultDto {
        const json = this.toJSON();
        let result = new FactDataResultDto();
        result.init(json);
        return result;
    }
}

export interface IFactDataResultDto {
    id: number;
    scanRunId: string;
    modelName?: string | null;
    accountName?: string | null;
    date?: string | null;
    value: number;
    detectionMethod: AnomalyDetectionMethodDto;
    deltaValue: number;
    deltaMean?: number | null;
    deltaStandardDeviation?: number | null;
    deltaZScore?: number | null;
    sliceKey?: string | null;
    columnContext?: { [key: string]: string; } | null;
    timeSeriesContext?: TimeSeriesContextPointDto[] | null;
    createdAt: Date;
}

export class TimeSeriesContextPointDto implements ITimeSeriesContextPointDto {
    dateMemberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;
    value!: number;
    isAnomaly!: boolean;

    constructor(data?: ITimeSeriesContextPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateMemberName = data["dateMemberName"] !== undefined ? data["dateMemberName"] : null as any;
            this.firstDate = data["firstDate"] ? new Date(data["firstDate"].toString()) : null as any;
            this.lastDate = data["lastDate"] ? new Date(data["lastDate"].toString()) : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
            this.isAnomaly = data["isAnomaly"] !== undefined ? data["isAnomaly"] : null as any;
        }
    }

    static fromJS(data: any): TimeSeriesContextPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesContextPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateMemberName"] = this.dateMemberName !== undefined ? this.dateMemberName : null as any;
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : null as any;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["isAnomaly"] = this.isAnomaly !== undefined ? this.isAnomaly : null as any;
        return data;
    }

    clone(): TimeSeriesContextPointDto {
        const json = this.toJSON();
        let result = new TimeSeriesContextPointDto();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesContextPointDto {
    dateMemberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;
    value: number;
    isAnomaly: boolean;
}

export class MetadataAuditLogResult implements IMetadataAuditLogResult {
    results?: MetadataAuditLogInfo[] | null;
    rowCount!: number;

    constructor(data?: IMetadataAuditLogResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["results"])) {
                this.results = [] as any;
                for (let item in data["results"])
                    this.results!.push(MetadataAuditLogInfo.fromJS(data["results"][item]));
            }
            else {
                this.results = null as any;
            }
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : null as any;
        }
    }

    static fromJS(data: any): MetadataAuditLogResult {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataAuditLogResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item in this.results)
                data["results"].push(this.results[item] ? this.results[item].toJSON() : null as any);
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        return data;
    }

    clone(): MetadataAuditLogResult {
        const json = this.toJSON();
        let result = new MetadataAuditLogResult();
        result.init(json);
        return result;
    }
}

export interface IMetadataAuditLogResult {
    results?: MetadataAuditLogInfo[] | null;
    rowCount: number;
}

export class MetadataAuditLogInfo implements IMetadataAuditLogInfo {
    id?: number | null;
    username?: string | null;
    category!: Category;
    action?: string | null;
    timestamp?: string | null;
    ipAddress?: string | null;
    modelName?: string | null;
    dimensionName?: string | null;
    memberKey?: string | null;
    dimensionProperty?: string | null;
    memberProperty?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
    oldValueName?: string | null;
    newValueName?: string | null;
    hierarchyName?: string | null;
    object?: string | null;
    memberColumn?: MemberColumnType | null;
    processDate?: string | null;
    description?: string | null;

    constructor(data?: IMetadataAuditLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.username = data["username"] !== undefined ? data["username"] : null as any;
            this.category = data["category"] !== undefined ? data["category"] : null as any;
            this.action = data["action"] !== undefined ? data["action"] : null as any;
            this.timestamp = data["timestamp"] !== undefined ? data["timestamp"] : null as any;
            this.ipAddress = data["ipAddress"] !== undefined ? data["ipAddress"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : null as any;
            this.dimensionProperty = data["dimensionProperty"] !== undefined ? data["dimensionProperty"] : null as any;
            this.memberProperty = data["memberProperty"] !== undefined ? data["memberProperty"] : null as any;
            this.oldValue = data["oldValue"] !== undefined ? data["oldValue"] : null as any;
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : null as any;
            this.oldValueName = data["oldValueName"] !== undefined ? data["oldValueName"] : null as any;
            this.newValueName = data["newValueName"] !== undefined ? data["newValueName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
            this.object = data["object"] !== undefined ? data["object"] : null as any;
            this.memberColumn = data["memberColumn"] !== undefined ? data["memberColumn"] : null as any;
            this.processDate = data["processDate"] !== undefined ? data["processDate"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
        }
    }

    static fromJS(data: any): MetadataAuditLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataAuditLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : null as any;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : null as any;
        data["dimensionProperty"] = this.dimensionProperty !== undefined ? this.dimensionProperty : null as any;
        data["memberProperty"] = this.memberProperty !== undefined ? this.memberProperty : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["oldValueName"] = this.oldValueName !== undefined ? this.oldValueName : null as any;
        data["newValueName"] = this.newValueName !== undefined ? this.newValueName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        data["object"] = this.object !== undefined ? this.object : null as any;
        data["memberColumn"] = this.memberColumn !== undefined ? this.memberColumn : null as any;
        data["processDate"] = this.processDate !== undefined ? this.processDate : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): MetadataAuditLogInfo {
        const json = this.toJSON();
        let result = new MetadataAuditLogInfo();
        result.init(json);
        return result;
    }
}

export interface IMetadataAuditLogInfo {
    id?: number | null;
    username?: string | null;
    category: Category;
    action?: string | null;
    timestamp?: string | null;
    ipAddress?: string | null;
    modelName?: string | null;
    dimensionName?: string | null;
    memberKey?: string | null;
    dimensionProperty?: string | null;
    memberProperty?: string | null;
    oldValue?: string | null;
    newValue?: string | null;
    oldValueName?: string | null;
    newValueName?: string | null;
    hierarchyName?: string | null;
    object?: string | null;
    memberColumn?: MemberColumnType | null;
    processDate?: string | null;
    description?: string | null;
}

export enum Category {
    ALL = 0,
    MEMBER = 1,
    MODEL = 2,
    DIMENSION = 3,
    PROCESS = 4,
    MAP = 5,
    MAPPING = 6,
    MULTIDIMMAPPING = 7,
}

export enum MemberColumnType {
    MODEL = 0,
    MODELDIMENSION = 1,
    MODELDIMENSIONROLE = 2,
    CONSOLIDATIONMODEL = 3,
    DEFAULTCONSOLIDATIONMODEL = 4,
    MANAGEDSSASMODEL = 5,
    DIRECTQUERYMODE = 6,
    ASSECURITYPROFILE = 7,
    DIMENSION = 8,
    DIMENSIONPROPERTY = 9,
    DIMENSIONREPORTINGPROPERTY = 10,
    DIMENSIONSTANDARDPROPERTY = 11,
    DIMENSIONPROPERTYTYPEINFO = 12,
    DIMENSIONDEFAULTREPORTINGMEMBER = 13,
    DIMENSIONDEFAULTINPUTMEMBER = 14,
    DIMENSIONNONLEAFDATAMEMBER = 15,
    MEMBER = 16,
    NAME = 17,
    PARENTKEY = 18,
    TAG = 19,
    OPERATOR = 20,
    SHARED = 21,
    MEMBERPROPERTY = 22,
    SORTORDER = 23,
    PROCESS = 24,
    CAPTION = 25,
}

export class Paging implements IPaging {
    take?: number | null;
    skip?: number | null;

    constructor(data?: IPaging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.take = data["take"] !== undefined ? data["take"] : null as any;
            this.skip = data["skip"] !== undefined ? data["skip"] : null as any;
        }
    }

    static fromJS(data: any): Paging {
        data = typeof data === 'object' ? data : {};
        let result = new Paging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["take"] = this.take !== undefined ? this.take : null as any;
        data["skip"] = this.skip !== undefined ? this.skip : null as any;
        return data;
    }

    clone(): Paging {
        const json = this.toJSON();
        let result = new Paging();
        result.init(json);
        return result;
    }
}

export interface IPaging {
    take?: number | null;
    skip?: number | null;
}

export class FilteredSortedPaging extends Paging implements IFilteredSortedPaging {
    filterModel?: any | null;
    sortModel?: { [key: string]: string; }[] | null;

    constructor(data?: IFilteredSortedPaging) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.filterModel = data["filterModel"] !== undefined ? data["filterModel"] : null as any;
            if (Array.isArray(data["sortModel"])) {
                this.sortModel = [] as any;
                for (let item in data["sortModel"])
                    this.sortModel!.push(data["sortModel"][item]);
            }
            else {
                this.sortModel = null as any;
            }
        }
    }

    static override fromJS(data: any): FilteredSortedPaging {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredSortedPaging();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterModel"] = this.filterModel !== undefined ? this.filterModel : null as any;
        if (Array.isArray(this.sortModel)) {
            data["sortModel"] = [];
            for (let item in this.sortModel)
                data["sortModel"].push(this.sortModel[item]);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FilteredSortedPaging {
        const json = this.toJSON();
        let result = new FilteredSortedPaging();
        result.init(json);
        return result;
    }
}

export interface IFilteredSortedPaging extends IPaging {
    filterModel?: any | null;
    sortModel?: { [key: string]: string; }[] | null;
}

export class DashboardSection implements IDashboardSection {
    id!: number;
    name?: string | null;
    userName?: string | null;
    orderNo!: number;
    dashboardControls?: DashboardControl[] | null;

    constructor(data?: IDashboardSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.orderNo = data["orderNo"] !== undefined ? data["orderNo"] : null as any;
            if (Array.isArray(data["dashboardControls"])) {
                this.dashboardControls = [] as any;
                for (let item in data["dashboardControls"])
                    this.dashboardControls!.push(DashboardControl.fromJS(data["dashboardControls"][item]));
            }
            else {
                this.dashboardControls = null as any;
            }
        }
    }

    static fromJS(data: any): DashboardSection {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : null as any;
        if (Array.isArray(this.dashboardControls)) {
            data["dashboardControls"] = [];
            for (let item in this.dashboardControls)
                data["dashboardControls"].push(this.dashboardControls[item] ? this.dashboardControls[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DashboardSection {
        const json = this.toJSON();
        let result = new DashboardSection();
        result.init(json);
        return result;
    }
}

export interface IDashboardSection {
    id: number;
    name?: string | null;
    userName?: string | null;
    orderNo: number;
    dashboardControls?: DashboardControl[] | null;
}

export class DashboardControl implements IDashboardControl {
    id!: number;
    sectionId!: number;
    userName?: string | null;
    title?: string | null;
    fileSystemPath?: string | null;
    configuration?: DashboardControlConfiguration | null;
    x!: number;
    width!: number;
    y!: number;
    height!: number;
    showHeader!: boolean;
    hideBorder!: boolean;
    headerTooltip?: string | null;
    controlTooltip?: string | null;
    mode?: string | null;

    constructor(data?: IDashboardControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.sectionId = data["sectionId"] !== undefined ? data["sectionId"] : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.title = data["title"] !== undefined ? data["title"] : null as any;
            this.fileSystemPath = data["fileSystemPath"] !== undefined ? data["fileSystemPath"] : null as any;
            this.configuration = data["configuration"] ? DashboardControlConfiguration.fromJS(data["configuration"]) : null as any;
            this.x = data["x"] !== undefined ? data["x"] : null as any;
            this.width = data["width"] !== undefined ? data["width"] : null as any;
            this.y = data["y"] !== undefined ? data["y"] : null as any;
            this.height = data["height"] !== undefined ? data["height"] : null as any;
            this.showHeader = data["showHeader"] !== undefined ? data["showHeader"] : null as any;
            this.hideBorder = data["hideBorder"] !== undefined ? data["hideBorder"] : null as any;
            this.headerTooltip = data["headerTooltip"] !== undefined ? data["headerTooltip"] : null as any;
            this.controlTooltip = data["controlTooltip"] !== undefined ? data["controlTooltip"] : null as any;
            this.mode = data["mode"] !== undefined ? data["mode"] : null as any;
        }
    }

    static fromJS(data: any): DashboardControl {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sectionId"] = this.sectionId !== undefined ? this.sectionId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["fileSystemPath"] = this.fileSystemPath !== undefined ? this.fileSystemPath : null as any;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : null as any;
        data["x"] = this.x !== undefined ? this.x : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["y"] = this.y !== undefined ? this.y : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["showHeader"] = this.showHeader !== undefined ? this.showHeader : null as any;
        data["hideBorder"] = this.hideBorder !== undefined ? this.hideBorder : null as any;
        data["headerTooltip"] = this.headerTooltip !== undefined ? this.headerTooltip : null as any;
        data["controlTooltip"] = this.controlTooltip !== undefined ? this.controlTooltip : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        return data;
    }

    clone(): DashboardControl {
        const json = this.toJSON();
        let result = new DashboardControl();
        result.init(json);
        return result;
    }
}

export interface IDashboardControl {
    id: number;
    sectionId: number;
    userName?: string | null;
    title?: string | null;
    fileSystemPath?: string | null;
    configuration?: DashboardControlConfiguration | null;
    x: number;
    width: number;
    y: number;
    height: number;
    showHeader: boolean;
    hideBorder: boolean;
    headerTooltip?: string | null;
    controlTooltip?: string | null;
    mode?: string | null;
}

export class DashboardControlConfiguration implements IDashboardControlConfiguration {
    url?: string | null;
    openType?: string | null;
    containerStyle?: string | null;
    itemStyle?: string | null;
    state?: string | null;
    zoom?: number | null;
    listContent?: DashboardListContent[] | null;
    formatAsTable!: boolean;
    expandLevel!: number;
    genericBits?: boolean[] | null;
    foreachWorkflows?: DashboardControlForeachWorkflow[] | null;

    constructor(data?: IDashboardControlConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"] !== undefined ? data["url"] : null as any;
            this.openType = data["openType"] !== undefined ? data["openType"] : null as any;
            this.containerStyle = data["containerStyle"] !== undefined ? data["containerStyle"] : null as any;
            this.itemStyle = data["itemStyle"] !== undefined ? data["itemStyle"] : null as any;
            this.state = data["state"] !== undefined ? data["state"] : null as any;
            this.zoom = data["zoom"] !== undefined ? data["zoom"] : null as any;
            if (Array.isArray(data["listContent"])) {
                this.listContent = [] as any;
                for (let item in data["listContent"])
                    this.listContent!.push(DashboardListContent.fromJS(data["listContent"][item]));
            }
            else {
                this.listContent = null as any;
            }
            this.formatAsTable = data["formatAsTable"] !== undefined ? data["formatAsTable"] : null as any;
            this.expandLevel = data["expandLevel"] !== undefined ? data["expandLevel"] : null as any;
            if (Array.isArray(data["genericBits"])) {
                this.genericBits = [] as any;
                for (let item in data["genericBits"])
                    this.genericBits!.push(data["genericBits"][item]);
            }
            else {
                this.genericBits = null as any;
            }
            if (Array.isArray(data["foreachWorkflows"])) {
                this.foreachWorkflows = [] as any;
                for (let item in data["foreachWorkflows"])
                    this.foreachWorkflows!.push(DashboardControlForeachWorkflow.fromJS(data["foreachWorkflows"][item]));
            }
            else {
                this.foreachWorkflows = null as any;
            }
        }
    }

    static fromJS(data: any): DashboardControlConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControlConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["openType"] = this.openType !== undefined ? this.openType : null as any;
        data["containerStyle"] = this.containerStyle !== undefined ? this.containerStyle : null as any;
        data["itemStyle"] = this.itemStyle !== undefined ? this.itemStyle : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zoom"] = this.zoom !== undefined ? this.zoom : null as any;
        if (Array.isArray(this.listContent)) {
            data["listContent"] = [];
            for (let item in this.listContent)
                data["listContent"].push(this.listContent[item] ? this.listContent[item].toJSON() : null as any);
        }
        data["formatAsTable"] = this.formatAsTable !== undefined ? this.formatAsTable : null as any;
        data["expandLevel"] = this.expandLevel !== undefined ? this.expandLevel : null as any;
        if (Array.isArray(this.genericBits)) {
            data["genericBits"] = [];
            for (let item in this.genericBits)
                data["genericBits"].push(this.genericBits[item]);
        }
        if (Array.isArray(this.foreachWorkflows)) {
            data["foreachWorkflows"] = [];
            for (let item in this.foreachWorkflows)
                data["foreachWorkflows"].push(this.foreachWorkflows[item] ? this.foreachWorkflows[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DashboardControlConfiguration {
        const json = this.toJSON();
        let result = new DashboardControlConfiguration();
        result.init(json);
        return result;
    }
}

export interface IDashboardControlConfiguration {
    url?: string | null;
    openType?: string | null;
    containerStyle?: string | null;
    itemStyle?: string | null;
    state?: string | null;
    zoom?: number | null;
    listContent?: DashboardListContent[] | null;
    formatAsTable: boolean;
    expandLevel: number;
    genericBits?: boolean[] | null;
    foreachWorkflows?: DashboardControlForeachWorkflow[] | null;
}

export class DashboardListContent implements IDashboardListContent {
    text?: string | null;
    url?: string | null;
    icon?: string | null;
    replacePage?: boolean | null;
    openType?: string | null;
    tooltip?: string | null;
    isExpanded!: boolean;
    isExpandable!: boolean;
    cssListStyle?: string | null;
    children?: DashboardListContent[] | null;

    constructor(data?: IDashboardListContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"] !== undefined ? data["text"] : null as any;
            this.url = data["url"] !== undefined ? data["url"] : null as any;
            this.icon = data["icon"] !== undefined ? data["icon"] : null as any;
            this.replacePage = data["replacePage"] !== undefined ? data["replacePage"] : null as any;
            this.openType = data["openType"] !== undefined ? data["openType"] : null as any;
            this.tooltip = data["tooltip"] !== undefined ? data["tooltip"] : null as any;
            this.isExpanded = data["isExpanded"] !== undefined ? data["isExpanded"] : null as any;
            this.isExpandable = data["isExpandable"] !== undefined ? data["isExpandable"] : null as any;
            this.cssListStyle = data["cssListStyle"] !== undefined ? data["cssListStyle"] : null as any;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(DashboardListContent.fromJS(data["children"][item]));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): DashboardListContent {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardListContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["replacePage"] = this.replacePage !== undefined ? this.replacePage : null as any;
        data["openType"] = this.openType !== undefined ? this.openType : null as any;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : null as any;
        data["isExpanded"] = this.isExpanded !== undefined ? this.isExpanded : null as any;
        data["isExpandable"] = this.isExpandable !== undefined ? this.isExpandable : null as any;
        data["cssListStyle"] = this.cssListStyle !== undefined ? this.cssListStyle : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item] ? this.children[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DashboardListContent {
        const json = this.toJSON();
        let result = new DashboardListContent();
        result.init(json);
        return result;
    }
}

export interface IDashboardListContent {
    text?: string | null;
    url?: string | null;
    icon?: string | null;
    replacePage?: boolean | null;
    openType?: string | null;
    tooltip?: string | null;
    isExpanded: boolean;
    isExpandable: boolean;
    cssListStyle?: string | null;
    children?: DashboardListContent[] | null;
}

export class DashboardControlForeachWorkflow implements IDashboardControlForeachWorkflow {
    fileSystemPath?: string | null;
    foreachActivityName?: string | null;

    constructor(data?: IDashboardControlForeachWorkflow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemPath = data["fileSystemPath"] !== undefined ? data["fileSystemPath"] : null as any;
            this.foreachActivityName = data["foreachActivityName"] !== undefined ? data["foreachActivityName"] : null as any;
        }
    }

    static fromJS(data: any): DashboardControlForeachWorkflow {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardControlForeachWorkflow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemPath"] = this.fileSystemPath !== undefined ? this.fileSystemPath : null as any;
        data["foreachActivityName"] = this.foreachActivityName !== undefined ? this.foreachActivityName : null as any;
        return data;
    }

    clone(): DashboardControlForeachWorkflow {
        const json = this.toJSON();
        let result = new DashboardControlForeachWorkflow();
        result.init(json);
        return result;
    }
}

export interface IDashboardControlForeachWorkflow {
    fileSystemPath?: string | null;
    foreachActivityName?: string | null;
}

export class DataSource implements IDataSource {
    name?: string | null;
    provider!: DataSourceProvider;
    type!: DataSourceType;

    constructor(data?: IDataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.provider = data["provider"] !== undefined ? data["provider"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static fromJS(data: any): DataSource {
        data = typeof data === 'object' ? data : {};
        let result = new DataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["provider"] = this.provider !== undefined ? this.provider : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): DataSource {
        const json = this.toJSON();
        let result = new DataSource();
        result.init(json);
        return result;
    }
}

export interface IDataSource {
    name?: string | null;
    provider: DataSourceProvider;
    type: DataSourceType;
}

export enum DataSourceProvider {
    AppDBMaster = "AppDBMaster",
    SqlServer = "SqlServer",
    Vena = "Vena",
    Slack = "Slack",
    Slack2 = "Slack2",
    Teams = "Teams",
    Azure = "Azure",
    AzureAS = "AzureAS",
    DataBlend = "DataBlend",
    AzureStorage = "AzureStorage",
    AzureSynapse = "AzureSynapse",
    AzureBlobStorage = "AzureBlobStorage",
    Ftp = "Ftp",
    RestApi = "RestApi",
    Anaplan = "Anaplan",
    AnaplanInternal = "AnaplanInternal",
}

export enum DataSourceType {
    Relational = "Relational",
    Olap = "Olap",
    Collaboration = "Collaboration",
    External = "External",
    Unknown = "Unknown",
}

export class DataSourceExtended extends DataSource implements IDataSourceExtended {
    connectionString?: string | null;
    id?: string | null;

    constructor(data?: IDataSourceExtended) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.connectionString = data["connectionString"] !== undefined ? data["connectionString"] : null as any;
            this.id = data["id"] !== undefined ? data["id"] : null as any;
        }
    }

    static override fromJS(data: any): DataSourceExtended {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceExtended();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString !== undefined ? this.connectionString : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DataSourceExtended {
        const json = this.toJSON();
        let result = new DataSourceExtended();
        result.init(json);
        return result;
    }
}

export interface IDataSourceExtended extends IDataSource {
    connectionString?: string | null;
    id?: string | null;
}

export class DbCleanupSettingsDto implements IDbCleanupSettingsDto {
    isEnabled!: boolean;
    cron?: string | null;
    retentionDays!: number;
    batchSize!: number;
    concurrency!: number;

    constructor(data?: IDbCleanupSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"] !== undefined ? data["isEnabled"] : null as any;
            this.cron = data["cron"] !== undefined ? data["cron"] : null as any;
            this.retentionDays = data["retentionDays"] !== undefined ? data["retentionDays"] : null as any;
            this.batchSize = data["batchSize"] !== undefined ? data["batchSize"] : null as any;
            this.concurrency = data["concurrency"] !== undefined ? data["concurrency"] : null as any;
        }
    }

    static fromJS(data: any): DbCleanupSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DbCleanupSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null as any;
        data["cron"] = this.cron !== undefined ? this.cron : null as any;
        data["retentionDays"] = this.retentionDays !== undefined ? this.retentionDays : null as any;
        data["batchSize"] = this.batchSize !== undefined ? this.batchSize : null as any;
        data["concurrency"] = this.concurrency !== undefined ? this.concurrency : null as any;
        return data;
    }

    clone(): DbCleanupSettingsDto {
        const json = this.toJSON();
        let result = new DbCleanupSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IDbCleanupSettingsDto {
    isEnabled: boolean;
    cron?: string | null;
    retentionDays: number;
    batchSize: number;
    concurrency: number;
}

export class DevOpsEnvironment implements IDevOpsEnvironment {
    name?: string | null;
    portalUrl?: string | null;
    parent?: string | null;
    version?: string | null;
    lastUpdated?: Date | null;
    scheduledUpdate?: Date | null;
    gated?: boolean | null;
    children?: DevOpsEnvironment[] | null;

    constructor(data?: IDevOpsEnvironment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.portalUrl = data["portalUrl"] !== undefined ? data["portalUrl"] : null as any;
            this.parent = data["parent"] !== undefined ? data["parent"] : null as any;
            this.version = data["version"] !== undefined ? data["version"] : null as any;
            this.lastUpdated = data["lastUpdated"] ? new Date(data["lastUpdated"].toString()) : null as any;
            this.scheduledUpdate = data["scheduledUpdate"] ? new Date(data["scheduledUpdate"].toString()) : null as any;
            this.gated = data["gated"] !== undefined ? data["gated"] : null as any;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(DevOpsEnvironment.fromJS(data["children"][item]));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): DevOpsEnvironment {
        data = typeof data === 'object' ? data : {};
        let result = new DevOpsEnvironment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["portalUrl"] = this.portalUrl !== undefined ? this.portalUrl : null as any;
        data["parent"] = this.parent !== undefined ? this.parent : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["scheduledUpdate"] = this.scheduledUpdate ? this.scheduledUpdate.toISOString() : null as any;
        data["gated"] = this.gated !== undefined ? this.gated : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item] ? this.children[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DevOpsEnvironment {
        const json = this.toJSON();
        let result = new DevOpsEnvironment();
        result.init(json);
        return result;
    }
}

export interface IDevOpsEnvironment {
    name?: string | null;
    portalUrl?: string | null;
    parent?: string | null;
    version?: string | null;
    lastUpdated?: Date | null;
    scheduledUpdate?: Date | null;
    gated?: boolean | null;
    children?: DevOpsEnvironment[] | null;
}

export class StagingTableInfo implements IStagingTableInfo {
    schema?: string | null;
    tableName?: string | null;

    constructor(data?: IStagingTableInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.schema = data["schema"] !== undefined ? data["schema"] : null as any;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
        }
    }

    static fromJS(data: any): StagingTableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schema"] = this.schema !== undefined ? this.schema : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        return data;
    }

    clone(): StagingTableInfo {
        const json = this.toJSON();
        let result = new StagingTableInfo();
        result.init(json);
        return result;
    }
}

export interface IStagingTableInfo {
    schema?: string | null;
    tableName?: string | null;
}

export class StagingTableField implements IStagingTableField {
    name?: string | null;
    dataType!: StagingTableFieldType;
    sqlDataType!: SqlDbType;
    sqlSize?: number | null;
    sqlPrecision?: number | null;
    primaryKey!: boolean;
    nullable!: boolean;
    autoincrement!: boolean;

    constructor(data?: IStagingTableField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : null as any;
            this.sqlDataType = data["sqlDataType"] !== undefined ? data["sqlDataType"] : null as any;
            this.sqlSize = data["sqlSize"] !== undefined ? data["sqlSize"] : null as any;
            this.sqlPrecision = data["sqlPrecision"] !== undefined ? data["sqlPrecision"] : null as any;
            this.primaryKey = data["primaryKey"] !== undefined ? data["primaryKey"] : null as any;
            this.nullable = data["nullable"] !== undefined ? data["nullable"] : null as any;
            this.autoincrement = data["autoincrement"] !== undefined ? data["autoincrement"] : null as any;
        }
    }

    static fromJS(data: any): StagingTableField {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["sqlDataType"] = this.sqlDataType !== undefined ? this.sqlDataType : null as any;
        data["sqlSize"] = this.sqlSize !== undefined ? this.sqlSize : null as any;
        data["sqlPrecision"] = this.sqlPrecision !== undefined ? this.sqlPrecision : null as any;
        data["primaryKey"] = this.primaryKey !== undefined ? this.primaryKey : null as any;
        data["nullable"] = this.nullable !== undefined ? this.nullable : null as any;
        data["autoincrement"] = this.autoincrement !== undefined ? this.autoincrement : null as any;
        return data;
    }

    clone(): StagingTableField {
        const json = this.toJSON();
        let result = new StagingTableField();
        result.init(json);
        return result;
    }
}

export interface IStagingTableField {
    name?: string | null;
    dataType: StagingTableFieldType;
    sqlDataType: SqlDbType;
    sqlSize?: number | null;
    sqlPrecision?: number | null;
    primaryKey: boolean;
    nullable: boolean;
    autoincrement: boolean;
}

export enum StagingTableFieldType {
    Int = 0,
    Float = 1,
    Date = 2,
    String = 3,
    Custom = 4,
}

export enum SqlDbType {
    BigInt = 0,
    Binary = 1,
    Bit = 2,
    Char = 3,
    DateTime = 4,
    Decimal = 5,
    Float = 6,
    Image = 7,
    Int = 8,
    Money = 9,
    NChar = 10,
    NText = 11,
    NVarChar = 12,
    Real = 13,
    UniqueIdentifier = 14,
    SmallDateTime = 15,
    SmallInt = 16,
    SmallMoney = 17,
    Text = 18,
    Timestamp = 19,
    TinyInt = 20,
    VarBinary = 21,
    VarChar = 22,
    Variant = 23,
    Xml = 25,
    Udt = 29,
    Structured = 30,
    Date = 31,
    Time = 32,
    DateTime2 = 33,
    DateTimeOffset = 34,
    Json = 35,
    Vector = 36,
}

export class StagingTableFromExcelResponse implements IStagingTableFromExcelResponse {
    tableName!: string;
    schema?: string | null;
    validationErrors?: ValidationError[] | null;

    constructor(data?: IStagingTableFromExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            this.schema = data["schema"] !== undefined ? data["schema"] : null as any;
            if (Array.isArray(data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item in data["validationErrors"])
                    this.validationErrors!.push(ValidationError.fromJS(data["validationErrors"][item]));
            }
            else {
                this.validationErrors = null as any;
            }
        }
    }

    static fromJS(data: any): StagingTableFromExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableFromExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["schema"] = this.schema !== undefined ? this.schema : null as any;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item in this.validationErrors)
                data["validationErrors"].push(this.validationErrors[item] ? this.validationErrors[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): StagingTableFromExcelResponse {
        const json = this.toJSON();
        let result = new StagingTableFromExcelResponse();
        result.init(json);
        return result;
    }
}

export interface IStagingTableFromExcelResponse {
    tableName: string;
    schema?: string | null;
    validationErrors?: ValidationError[] | null;
}

export class ValidationError implements IValidationError {
    message?: string | null;
    code?: string | null;
    field?: string | null;
    rowIndex?: number | null;
    columnName?: string | null;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            this.code = data["code"] !== undefined ? data["code"] : null as any;
            this.field = data["field"] !== undefined ? data["field"] : null as any;
            this.rowIndex = data["rowIndex"] !== undefined ? data["rowIndex"] : null as any;
            this.columnName = data["columnName"] !== undefined ? data["columnName"] : null as any;
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["field"] = this.field !== undefined ? this.field : null as any;
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : null as any;
        data["columnName"] = this.columnName !== undefined ? this.columnName : null as any;
        return data;
    }

    clone(): ValidationError {
        const json = this.toJSON();
        let result = new ValidationError();
        result.init(json);
        return result;
    }
}

export interface IValidationError {
    message?: string | null;
    code?: string | null;
    field?: string | null;
    rowIndex?: number | null;
    columnName?: string | null;
}

export class StagingTableFromExcelRequest implements IStagingTableFromExcelRequest {
    tableName!: string;
    columns!: StagingTableFromExcelColumn[];
    rows!: any[][];

    constructor(data?: IStagingTableFromExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.columns = [];
            this.rows = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            if (Array.isArray(data["columns"])) {
                this.columns = [] as any;
                for (let item in data["columns"])
                    this.columns!.push(StagingTableFromExcelColumn.fromJS(data["columns"][item]));
            }
            else {
                this.columns = null as any;
            }
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(data["rows"][item]);
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static fromJS(data: any): StagingTableFromExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableFromExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item in this.columns)
                data["columns"].push(this.columns[item] ? this.columns[item].toJSON() : null as any);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item]);
        }
        return data;
    }

    clone(): StagingTableFromExcelRequest {
        const json = this.toJSON();
        let result = new StagingTableFromExcelRequest();
        result.init(json);
        return result;
    }
}

export interface IStagingTableFromExcelRequest {
    tableName: string;
    columns: StagingTableFromExcelColumn[];
    rows: any[][];
}

export class StagingTableFromExcelColumn implements IStagingTableFromExcelColumn {
    key?: string | null;
    name!: string;
    sourceName?: string | null;
    ordinal!: number;
    inferredType?: string | null;
    selectedType!: string;
    nullable!: boolean;
    primaryKey!: boolean;
    maxLength?: number | null;
    precision?: number | null;
    scale?: number | null;

    constructor(data?: IStagingTableFromExcelColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            this.ordinal = data["ordinal"] !== undefined ? data["ordinal"] : null as any;
            this.inferredType = data["inferredType"] !== undefined ? data["inferredType"] : null as any;
            this.selectedType = data["selectedType"] !== undefined ? data["selectedType"] : null as any;
            this.nullable = data["nullable"] !== undefined ? data["nullable"] : null as any;
            this.primaryKey = data["primaryKey"] !== undefined ? data["primaryKey"] : null as any;
            this.maxLength = data["maxLength"] !== undefined ? data["maxLength"] : null as any;
            this.precision = data["precision"] !== undefined ? data["precision"] : null as any;
            this.scale = data["scale"] !== undefined ? data["scale"] : null as any;
        }
    }

    static fromJS(data: any): StagingTableFromExcelColumn {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableFromExcelColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        data["ordinal"] = this.ordinal !== undefined ? this.ordinal : null as any;
        data["inferredType"] = this.inferredType !== undefined ? this.inferredType : null as any;
        data["selectedType"] = this.selectedType !== undefined ? this.selectedType : null as any;
        data["nullable"] = this.nullable !== undefined ? this.nullable : null as any;
        data["primaryKey"] = this.primaryKey !== undefined ? this.primaryKey : null as any;
        data["maxLength"] = this.maxLength !== undefined ? this.maxLength : null as any;
        data["precision"] = this.precision !== undefined ? this.precision : null as any;
        data["scale"] = this.scale !== undefined ? this.scale : null as any;
        return data;
    }

    clone(): StagingTableFromExcelColumn {
        const json = this.toJSON();
        let result = new StagingTableFromExcelColumn();
        result.init(json);
        return result;
    }
}

export interface IStagingTableFromExcelColumn {
    key?: string | null;
    name: string;
    sourceName?: string | null;
    ordinal: number;
    inferredType?: string | null;
    selectedType: string;
    nullable: boolean;
    primaryKey: boolean;
    maxLength?: number | null;
    precision?: number | null;
    scale?: number | null;
}

export class CommandOutput implements ICommandOutput {
    message?: string | null;
    dataFields?: string[] | null;
    dataValues?: string[][] | null;
    commandItems?: CommandItem[] | null;

    constructor(data?: ICommandOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            if (Array.isArray(data["dataFields"])) {
                this.dataFields = [] as any;
                for (let item in data["dataFields"])
                    this.dataFields!.push(data["dataFields"][item]);
            }
            else {
                this.dataFields = null as any;
            }
            if (Array.isArray(data["dataValues"])) {
                this.dataValues = [] as any;
                for (let item in data["dataValues"])
                    this.dataValues!.push(data["dataValues"][item]);
            }
            else {
                this.dataValues = null as any;
            }
            if (Array.isArray(data["commandItems"])) {
                this.commandItems = [] as any;
                for (let item in data["commandItems"])
                    this.commandItems!.push(CommandItem.fromJS(data["commandItems"][item]));
            }
            else {
                this.commandItems = null as any;
            }
        }
    }

    static fromJS(data: any): CommandOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CommandOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (Array.isArray(this.dataFields)) {
            data["dataFields"] = [];
            for (let item in this.dataFields)
                data["dataFields"].push(this.dataFields[item]);
        }
        if (Array.isArray(this.dataValues)) {
            data["dataValues"] = [];
            for (let item in this.dataValues)
                data["dataValues"].push(this.dataValues[item]);
        }
        if (Array.isArray(this.commandItems)) {
            data["commandItems"] = [];
            for (let item in this.commandItems)
                data["commandItems"].push(this.commandItems[item] ? this.commandItems[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): CommandOutput {
        const json = this.toJSON();
        let result = new CommandOutput();
        result.init(json);
        return result;
    }
}

export interface ICommandOutput {
    message?: string | null;
    dataFields?: string[] | null;
    dataValues?: string[][] | null;
    commandItems?: CommandItem[] | null;
}

export class CommandItem implements ICommandItem {
    sourceValue?: string | null;
    dimension?: string | null;
    dataMapName?: string | null;
    kind?: MappingCommandItemKind | null;

    constructor(data?: ICommandItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : null as any;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.dataMapName = data["dataMapName"] !== undefined ? data["dataMapName"] : null as any;
            this.kind = data["kind"] !== undefined ? data["kind"] : null as any;
        }
    }

    static fromJS(data: any): CommandItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommandItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : null as any;
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["dataMapName"] = this.dataMapName !== undefined ? this.dataMapName : null as any;
        data["kind"] = this.kind !== undefined ? this.kind : null as any;
        return data;
    }

    clone(): CommandItem {
        const json = this.toJSON();
        let result = new CommandItem();
        result.init(json);
        return result;
    }
}

export interface ICommandItem {
    sourceValue?: string | null;
    dimension?: string | null;
    dataMapName?: string | null;
    kind?: MappingCommandItemKind | null;
}

export enum MappingCommandItemKind {
    CannotBeMapped = 0,
    InvalidMappedMember = 1,
}

export class ModelMappingInfo implements IModelMappingInfo {
    mappingId?: number | null;
    name?: string | null;
    modelName?: string | null;
    stagingTableSchema?: string | null;
    stagingTableName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isEditable!: boolean;

    constructor(data?: IModelMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.stagingTableSchema = data["stagingTableSchema"] !== undefined ? data["stagingTableSchema"] : null as any;
            this.stagingTableName = data["stagingTableName"] !== undefined ? data["stagingTableName"] : null as any;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = null as any;
            }
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : null as any;
        }
    }

    static fromJS(data: any): ModelMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["stagingTableSchema"] = this.stagingTableSchema !== undefined ? this.stagingTableSchema : null as any;
        data["stagingTableName"] = this.stagingTableName !== undefined ? this.stagingTableName : null as any;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item] ? this.roleWritePermissions[item].toJSON() : null as any);
        }
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : null as any;
        return data;
    }

    clone(): ModelMappingInfo {
        const json = this.toJSON();
        let result = new ModelMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IModelMappingInfo {
    mappingId?: number | null;
    name?: string | null;
    modelName?: string | null;
    stagingTableSchema?: string | null;
    stagingTableName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isEditable: boolean;
}

export class RoleWriteObject implements IRoleWriteObject {
    parentSourceName?: string | null;
    roleName?: string | null;
    canWrite!: boolean;
    parentController?: string | null;

    constructor(data?: IRoleWriteObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentSourceName = data["parentSourceName"] !== undefined ? data["parentSourceName"] : null as any;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null as any;
            this.canWrite = data["canWrite"] !== undefined ? data["canWrite"] : null as any;
            this.parentController = data["parentController"] !== undefined ? data["parentController"] : null as any;
        }
    }

    static fromJS(data: any): RoleWriteObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoleWriteObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentSourceName"] = this.parentSourceName !== undefined ? this.parentSourceName : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["canWrite"] = this.canWrite !== undefined ? this.canWrite : null as any;
        data["parentController"] = this.parentController !== undefined ? this.parentController : null as any;
        return data;
    }

    clone(): RoleWriteObject {
        const json = this.toJSON();
        let result = new RoleWriteObject();
        result.init(json);
        return result;
    }
}

export interface IRoleWriteObject {
    parentSourceName?: string | null;
    roleName?: string | null;
    canWrite: boolean;
    parentController?: string | null;
}

export class ModelMappingDataInfo implements IModelMappingDataInfo {
    fields?: SimpleKeyValue[] | null;
    modelMappings?: ModelMappingInfo[] | null;
    schemas?: string[] | null;
    databaseTables?: SimpleKeyValue[] | null;

    constructor(data?: IModelMappingDataInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(SimpleKeyValue.fromJS(data["fields"][item]));
            }
            else {
                this.fields = null as any;
            }
            if (Array.isArray(data["modelMappings"])) {
                this.modelMappings = [] as any;
                for (let item in data["modelMappings"])
                    this.modelMappings!.push(ModelMappingInfo.fromJS(data["modelMappings"][item]));
            }
            else {
                this.modelMappings = null as any;
            }
            if (Array.isArray(data["schemas"])) {
                this.schemas = [] as any;
                for (let item in data["schemas"])
                    this.schemas!.push(data["schemas"][item]);
            }
            else {
                this.schemas = null as any;
            }
            if (Array.isArray(data["databaseTables"])) {
                this.databaseTables = [] as any;
                for (let item in data["databaseTables"])
                    this.databaseTables!.push(SimpleKeyValue.fromJS(data["databaseTables"][item]));
            }
            else {
                this.databaseTables = null as any;
            }
        }
    }

    static fromJS(data: any): ModelMappingDataInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelMappingDataInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item] ? this.fields[item].toJSON() : null as any);
        }
        if (Array.isArray(this.modelMappings)) {
            data["modelMappings"] = [];
            for (let item in this.modelMappings)
                data["modelMappings"].push(this.modelMappings[item] ? this.modelMappings[item].toJSON() : null as any);
        }
        if (Array.isArray(this.schemas)) {
            data["schemas"] = [];
            for (let item in this.schemas)
                data["schemas"].push(this.schemas[item]);
        }
        if (Array.isArray(this.databaseTables)) {
            data["databaseTables"] = [];
            for (let item in this.databaseTables)
                data["databaseTables"].push(this.databaseTables[item] ? this.databaseTables[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModelMappingDataInfo {
        const json = this.toJSON();
        let result = new ModelMappingDataInfo();
        result.init(json);
        return result;
    }
}

export interface IModelMappingDataInfo {
    fields?: SimpleKeyValue[] | null;
    modelMappings?: ModelMappingInfo[] | null;
    schemas?: string[] | null;
    databaseTables?: SimpleKeyValue[] | null;
}

export class SimpleKeyValue implements ISimpleKeyValue {
    name?: string | null;
    value?: string | null;

    constructor(data?: ISimpleKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
        }
    }

    static fromJS(data: any): SimpleKeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleKeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): SimpleKeyValue {
        const json = this.toJSON();
        let result = new SimpleKeyValue();
        result.init(json);
        return result;
    }
}

export interface ISimpleKeyValue {
    name?: string | null;
    value?: string | null;
}

export class DataSlicerInfo implements IDataSlicerInfo {
    mappingId!: number;
    slicerId!: number;
    dimensionName?: string | null;
    slicer?: string | null;
    slicerType!: SlicerTypeInfo;
    value1?: string | null;
    value2?: string | null;

    constructor(data?: IDataSlicerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : null as any;
            this.slicerId = data["slicerId"] !== undefined ? data["slicerId"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.slicer = data["slicer"] !== undefined ? data["slicer"] : null as any;
            this.slicerType = data["slicerType"] !== undefined ? data["slicerType"] : null as any;
            this.value1 = data["value1"] !== undefined ? data["value1"] : null as any;
            this.value2 = data["value2"] !== undefined ? data["value2"] : null as any;
        }
    }

    static fromJS(data: any): DataSlicerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataSlicerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["slicerId"] = this.slicerId !== undefined ? this.slicerId : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["slicer"] = this.slicer !== undefined ? this.slicer : null as any;
        data["slicerType"] = this.slicerType !== undefined ? this.slicerType : null as any;
        data["value1"] = this.value1 !== undefined ? this.value1 : null as any;
        data["value2"] = this.value2 !== undefined ? this.value2 : null as any;
        return data;
    }

    clone(): DataSlicerInfo {
        const json = this.toJSON();
        let result = new DataSlicerInfo();
        result.init(json);
        return result;
    }
}

export interface IDataSlicerInfo {
    mappingId: number;
    slicerId: number;
    dimensionName?: string | null;
    slicer?: string | null;
    slicerType: SlicerTypeInfo;
    value1?: string | null;
    value2?: string | null;
}

export enum SlicerTypeInfo {
    StagingUniqueValue = 0,
    StagingRange = 1,
    Fixed = 2,
    DescendantsOf = 3,
    Everything = 4,
}

export class ModelFieldMappingInfo implements IModelFieldMappingInfo {
    mappingId!: number;
    targetType?: string | null;
    target?: string | null;
    mappingType?: string | null;
    sourceField?: string | null;
    value?: string | null;
    flipCredits!: boolean;
    securityProfile?: string | null;
    dataMapSourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;

    constructor(data?: IModelFieldMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : null as any;
            this.targetType = data["targetType"] !== undefined ? data["targetType"] : null as any;
            this.target = data["target"] !== undefined ? data["target"] : null as any;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : null as any;
            this.sourceField = data["sourceField"] !== undefined ? data["sourceField"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
            this.flipCredits = data["flipCredits"] !== undefined ? data["flipCredits"] : null as any;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : null as any;
            this.dataMapSourceName = data["dataMapSourceName"] !== undefined ? data["dataMapSourceName"] : null as any;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = null as any;
            }
        }
    }

    static fromJS(data: any): ModelFieldMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelFieldMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["targetType"] = this.targetType !== undefined ? this.targetType : null as any;
        data["target"] = this.target !== undefined ? this.target : null as any;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : null as any;
        data["sourceField"] = this.sourceField !== undefined ? this.sourceField : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["flipCredits"] = this.flipCredits !== undefined ? this.flipCredits : null as any;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : null as any;
        data["dataMapSourceName"] = this.dataMapSourceName !== undefined ? this.dataMapSourceName : null as any;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item] ? this.roleWritePermissions[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModelFieldMappingInfo {
        const json = this.toJSON();
        let result = new ModelFieldMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IModelFieldMappingInfo {
    mappingId: number;
    targetType?: string | null;
    target?: string | null;
    mappingType?: string | null;
    sourceField?: string | null;
    value?: string | null;
    flipCredits: boolean;
    securityProfile?: string | null;
    dataMapSourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
}

export class DefaultMappingInfo implements IDefaultMappingInfo {
    mappingId!: number;
    sequenceId!: number;
    type?: string | null;
    target?: string | null;
    value?: string | null;
    displayValue?: string | null;

    constructor(data?: IDefaultMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mappingId = data["mappingId"] !== undefined ? data["mappingId"] : null as any;
            this.sequenceId = data["sequenceId"] !== undefined ? data["sequenceId"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.target = data["target"] !== undefined ? data["target"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
            this.displayValue = data["displayValue"] !== undefined ? data["displayValue"] : null as any;
        }
    }

    static fromJS(data: any): DefaultMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId !== undefined ? this.mappingId : null as any;
        data["sequenceId"] = this.sequenceId !== undefined ? this.sequenceId : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["target"] = this.target !== undefined ? this.target : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["displayValue"] = this.displayValue !== undefined ? this.displayValue : null as any;
        return data;
    }

    clone(): DefaultMappingInfo {
        const json = this.toJSON();
        let result = new DefaultMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IDefaultMappingInfo {
    mappingId: number;
    sequenceId: number;
    type?: string | null;
    target?: string | null;
    value?: string | null;
    displayValue?: string | null;
}

export class EtlLogHeaderInfo implements IEtlLogHeaderInfo {
    etlLogHeaderId!: number;
    startDateTime!: Date;
    endDateTime?: Date | null;
    userName?: string | null;
    importDefinitionName?: string | null;
    status!: LogHeaderStatus;
    workflowName?: string | null;
    taskName?: string | null;
    isDrillBackEnabled?: boolean | null;
    importFileName?: string | null;
    canWrite!: boolean;

    constructor(data?: IEtlLogHeaderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.etlLogHeaderId = data["etlLogHeaderId"] !== undefined ? data["etlLogHeaderId"] : null as any;
            this.startDateTime = data["startDateTime"] ? new Date(data["startDateTime"].toString()) : null as any;
            this.endDateTime = data["endDateTime"] ? new Date(data["endDateTime"].toString()) : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.importDefinitionName = data["importDefinitionName"] !== undefined ? data["importDefinitionName"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.workflowName = data["workflowName"] !== undefined ? data["workflowName"] : null as any;
            this.taskName = data["taskName"] !== undefined ? data["taskName"] : null as any;
            this.isDrillBackEnabled = data["isDrillBackEnabled"] !== undefined ? data["isDrillBackEnabled"] : null as any;
            this.importFileName = data["importFileName"] !== undefined ? data["importFileName"] : null as any;
            this.canWrite = data["canWrite"] !== undefined ? data["canWrite"] : null as any;
        }
    }

    static fromJS(data: any): EtlLogHeaderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EtlLogHeaderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etlLogHeaderId"] = this.etlLogHeaderId !== undefined ? this.etlLogHeaderId : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["importDefinitionName"] = this.importDefinitionName !== undefined ? this.importDefinitionName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["workflowName"] = this.workflowName !== undefined ? this.workflowName : null as any;
        data["taskName"] = this.taskName !== undefined ? this.taskName : null as any;
        data["isDrillBackEnabled"] = this.isDrillBackEnabled !== undefined ? this.isDrillBackEnabled : null as any;
        data["importFileName"] = this.importFileName !== undefined ? this.importFileName : null as any;
        data["canWrite"] = this.canWrite !== undefined ? this.canWrite : null as any;
        return data;
    }

    clone(): EtlLogHeaderInfo {
        const json = this.toJSON();
        let result = new EtlLogHeaderInfo();
        result.init(json);
        return result;
    }
}

export interface IEtlLogHeaderInfo {
    etlLogHeaderId: number;
    startDateTime: Date;
    endDateTime?: Date | null;
    userName?: string | null;
    importDefinitionName?: string | null;
    status: LogHeaderStatus;
    workflowName?: string | null;
    taskName?: string | null;
    isDrillBackEnabled?: boolean | null;
    importFileName?: string | null;
    canWrite: boolean;
}

export enum LogHeaderStatus {
    InProgress = 1,
    Failed = 2,
    Completed = 3,
    Errors = 4,
}

export class DrillbackDetailInfo implements IDrillbackDetailInfo {
    logHeaderId!: number;
    executionInstance!: number;
    rowCount!: number;
    dimensionsInfo?: { [key: string]: string; }[] | null;
    dimensionTypeInfo?: DrillbackDimensionTypeInfo[] | null;

    constructor(data?: IDrillbackDetailInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logHeaderId = data["logHeaderId"] !== undefined ? data["logHeaderId"] : null as any;
            this.executionInstance = data["executionInstance"] !== undefined ? data["executionInstance"] : null as any;
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : null as any;
            if (Array.isArray(data["dimensionsInfo"])) {
                this.dimensionsInfo = [] as any;
                for (let item in data["dimensionsInfo"])
                    this.dimensionsInfo!.push(data["dimensionsInfo"][item]);
            }
            else {
                this.dimensionsInfo = null as any;
            }
            if (Array.isArray(data["dimensionTypeInfo"])) {
                this.dimensionTypeInfo = [] as any;
                for (let item in data["dimensionTypeInfo"])
                    this.dimensionTypeInfo!.push(DrillbackDimensionTypeInfo.fromJS(data["dimensionTypeInfo"][item]));
            }
            else {
                this.dimensionTypeInfo = null as any;
            }
        }
    }

    static fromJS(data: any): DrillbackDetailInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DrillbackDetailInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logHeaderId"] = this.logHeaderId !== undefined ? this.logHeaderId : null as any;
        data["executionInstance"] = this.executionInstance !== undefined ? this.executionInstance : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.dimensionsInfo)) {
            data["dimensionsInfo"] = [];
            for (let item in this.dimensionsInfo)
                data["dimensionsInfo"].push(this.dimensionsInfo[item]);
        }
        if (Array.isArray(this.dimensionTypeInfo)) {
            data["dimensionTypeInfo"] = [];
            for (let item in this.dimensionTypeInfo)
                data["dimensionTypeInfo"].push(this.dimensionTypeInfo[item] ? this.dimensionTypeInfo[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DrillbackDetailInfo {
        const json = this.toJSON();
        let result = new DrillbackDetailInfo();
        result.init(json);
        return result;
    }
}

export interface IDrillbackDetailInfo {
    logHeaderId: number;
    executionInstance: number;
    rowCount: number;
    dimensionsInfo?: { [key: string]: string; }[] | null;
    dimensionTypeInfo?: DrillbackDimensionTypeInfo[] | null;
}

export class DrillbackDimensionTypeInfo implements IDrillbackDimensionTypeInfo {
    dimensionName?: string | null;
    isMeasure!: boolean;
    dimensionType!: number;
    isSourceOnly!: boolean;
    isSourceCaptionEmpty!: boolean;

    constructor(data?: IDrillbackDimensionTypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.isMeasure = data["isMeasure"] !== undefined ? data["isMeasure"] : null as any;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : null as any;
            this.isSourceOnly = data["isSourceOnly"] !== undefined ? data["isSourceOnly"] : null as any;
            this.isSourceCaptionEmpty = data["isSourceCaptionEmpty"] !== undefined ? data["isSourceCaptionEmpty"] : null as any;
        }
    }

    static fromJS(data: any): DrillbackDimensionTypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DrillbackDimensionTypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["isMeasure"] = this.isMeasure !== undefined ? this.isMeasure : null as any;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : null as any;
        data["isSourceOnly"] = this.isSourceOnly !== undefined ? this.isSourceOnly : null as any;
        data["isSourceCaptionEmpty"] = this.isSourceCaptionEmpty !== undefined ? this.isSourceCaptionEmpty : null as any;
        return data;
    }

    clone(): DrillbackDimensionTypeInfo {
        const json = this.toJSON();
        let result = new DrillbackDimensionTypeInfo();
        result.init(json);
        return result;
    }
}

export interface IDrillbackDimensionTypeInfo {
    dimensionName?: string | null;
    isMeasure: boolean;
    dimensionType: number;
    isSourceOnly: boolean;
    isSourceCaptionEmpty: boolean;
}

export class EtlLogInfo implements IEtlLogInfo {
    runId!: string;
    etlLogHeaderId!: number;
    timestamp!: Date;
    message?: string | null;

    constructor(data?: IEtlLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.runId = data["runId"] !== undefined ? data["runId"] : null as any;
            this.etlLogHeaderId = data["etlLogHeaderId"] !== undefined ? data["etlLogHeaderId"] : null as any;
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : null as any;
            this.message = data["message"] !== undefined ? data["message"] : null as any;
        }
    }

    static fromJS(data: any): EtlLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EtlLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId !== undefined ? this.runId : null as any;
        data["etlLogHeaderId"] = this.etlLogHeaderId !== undefined ? this.etlLogHeaderId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): EtlLogInfo {
        const json = this.toJSON();
        let result = new EtlLogInfo();
        result.init(json);
        return result;
    }
}

export interface IEtlLogInfo {
    runId: string;
    etlLogHeaderId: number;
    timestamp: Date;
    message?: string | null;
}

export class DataMapInfo implements IDataMapInfo {
    sourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isSignBasedMappingsEnabled!: boolean;
    isEditable!: boolean;
    canEditIsSignBasedMappingsEnabled?: boolean | null;
    dataMapType!: DataMapType;
    stagingTableName?: string | null;
    sourceFields?: string[] | null;
    canEditSourceFields?: boolean | null;

    constructor(data?: IDataMapInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            if (Array.isArray(data["roleWritePermissions"])) {
                this.roleWritePermissions = [] as any;
                for (let item in data["roleWritePermissions"])
                    this.roleWritePermissions!.push(RoleWriteObject.fromJS(data["roleWritePermissions"][item]));
            }
            else {
                this.roleWritePermissions = null as any;
            }
            this.isSignBasedMappingsEnabled = data["isSignBasedMappingsEnabled"] !== undefined ? data["isSignBasedMappingsEnabled"] : null as any;
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : null as any;
            this.canEditIsSignBasedMappingsEnabled = data["canEditIsSignBasedMappingsEnabled"] !== undefined ? data["canEditIsSignBasedMappingsEnabled"] : null as any;
            this.dataMapType = data["dataMapType"] !== undefined ? data["dataMapType"] : null as any;
            this.stagingTableName = data["stagingTableName"] !== undefined ? data["stagingTableName"] : null as any;
            if (Array.isArray(data["sourceFields"])) {
                this.sourceFields = [] as any;
                for (let item in data["sourceFields"])
                    this.sourceFields!.push(data["sourceFields"][item]);
            }
            else {
                this.sourceFields = null as any;
            }
            this.canEditSourceFields = data["canEditSourceFields"] !== undefined ? data["canEditSourceFields"] : null as any;
        }
    }

    static fromJS(data: any): DataMapInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataMapInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        if (Array.isArray(this.roleWritePermissions)) {
            data["roleWritePermissions"] = [];
            for (let item in this.roleWritePermissions)
                data["roleWritePermissions"].push(this.roleWritePermissions[item] ? this.roleWritePermissions[item].toJSON() : null as any);
        }
        data["isSignBasedMappingsEnabled"] = this.isSignBasedMappingsEnabled !== undefined ? this.isSignBasedMappingsEnabled : null as any;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : null as any;
        data["canEditIsSignBasedMappingsEnabled"] = this.canEditIsSignBasedMappingsEnabled !== undefined ? this.canEditIsSignBasedMappingsEnabled : null as any;
        data["dataMapType"] = this.dataMapType !== undefined ? this.dataMapType : null as any;
        data["stagingTableName"] = this.stagingTableName !== undefined ? this.stagingTableName : null as any;
        if (Array.isArray(this.sourceFields)) {
            data["sourceFields"] = [];
            for (let item in this.sourceFields)
                data["sourceFields"].push(this.sourceFields[item]);
        }
        data["canEditSourceFields"] = this.canEditSourceFields !== undefined ? this.canEditSourceFields : null as any;
        return data;
    }

    clone(): DataMapInfo {
        const json = this.toJSON();
        let result = new DataMapInfo();
        result.init(json);
        return result;
    }
}

export interface IDataMapInfo {
    sourceName?: string | null;
    roleWritePermissions?: RoleWriteObject[] | null;
    isSignBasedMappingsEnabled: boolean;
    isEditable: boolean;
    canEditIsSignBasedMappingsEnabled?: boolean | null;
    dataMapType: DataMapType;
    stagingTableName?: string | null;
    sourceFields?: string[] | null;
    canEditSourceFields?: boolean | null;
}

export enum DataMapType {
    Single = 1,
    Multi = 2,
}

export class UpdateDataMapRequest implements IUpdateDataMapRequest {
    isSignBasedMappingsEnabled!: boolean;
    multiDimSourceFields?: string[] | null;

    constructor(data?: IUpdateDataMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSignBasedMappingsEnabled = data["isSignBasedMappingsEnabled"] !== undefined ? data["isSignBasedMappingsEnabled"] : null as any;
            if (Array.isArray(data["multiDimSourceFields"])) {
                this.multiDimSourceFields = [] as any;
                for (let item in data["multiDimSourceFields"])
                    this.multiDimSourceFields!.push(data["multiDimSourceFields"][item]);
            }
            else {
                this.multiDimSourceFields = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateDataMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSignBasedMappingsEnabled"] = this.isSignBasedMappingsEnabled !== undefined ? this.isSignBasedMappingsEnabled : null as any;
        if (Array.isArray(this.multiDimSourceFields)) {
            data["multiDimSourceFields"] = [];
            for (let item in this.multiDimSourceFields)
                data["multiDimSourceFields"].push(this.multiDimSourceFields[item]);
        }
        return data;
    }

    clone(): UpdateDataMapRequest {
        const json = this.toJSON();
        let result = new UpdateDataMapRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateDataMapRequest {
    isSignBasedMappingsEnabled: boolean;
    multiDimSourceFields?: string[] | null;
}

export class DataMappingInfo implements IDataMappingInfo {
    saveType?: string | null;
    orderIndex!: number;
    sourceName?: string | null;
    dimensionName?: string | null;
    sourceValue?: string | null;
    sourceSign?: string | null;
    sourceCaption?: string | null;
    sourceValueOriginal?: string | null;
    sourceSignOriginal?: string | null;
    dimensionNameOriginal?: string | null;
    targetMemberName?: string | null;
    caption?: string | null;
    mappingType?: string | null;
    isAiSuggestion?: boolean | null;

    constructor(data?: IDataMappingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saveType = data["saveType"] !== undefined ? data["saveType"] : null as any;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null as any;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : null as any;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : null as any;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : null as any;
            this.sourceValueOriginal = data["sourceValueOriginal"] !== undefined ? data["sourceValueOriginal"] : null as any;
            this.sourceSignOriginal = data["sourceSignOriginal"] !== undefined ? data["sourceSignOriginal"] : null as any;
            this.dimensionNameOriginal = data["dimensionNameOriginal"] !== undefined ? data["dimensionNameOriginal"] : null as any;
            this.targetMemberName = data["targetMemberName"] !== undefined ? data["targetMemberName"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : null as any;
            this.isAiSuggestion = data["isAiSuggestion"] !== undefined ? data["isAiSuggestion"] : null as any;
        }
    }

    static fromJS(data: any): DataMappingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DataMappingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveType"] = this.saveType !== undefined ? this.saveType : null as any;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null as any;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : null as any;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : null as any;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : null as any;
        data["sourceValueOriginal"] = this.sourceValueOriginal !== undefined ? this.sourceValueOriginal : null as any;
        data["sourceSignOriginal"] = this.sourceSignOriginal !== undefined ? this.sourceSignOriginal : null as any;
        data["dimensionNameOriginal"] = this.dimensionNameOriginal !== undefined ? this.dimensionNameOriginal : null as any;
        data["targetMemberName"] = this.targetMemberName !== undefined ? this.targetMemberName : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : null as any;
        data["isAiSuggestion"] = this.isAiSuggestion !== undefined ? this.isAiSuggestion : null as any;
        return data;
    }

    clone(): DataMappingInfo {
        const json = this.toJSON();
        let result = new DataMappingInfo();
        result.init(json);
        return result;
    }
}

export interface IDataMappingInfo {
    saveType?: string | null;
    orderIndex: number;
    sourceName?: string | null;
    dimensionName?: string | null;
    sourceValue?: string | null;
    sourceSign?: string | null;
    sourceCaption?: string | null;
    sourceValueOriginal?: string | null;
    sourceSignOriginal?: string | null;
    dimensionNameOriginal?: string | null;
    targetMemberName?: string | null;
    caption?: string | null;
    mappingType?: string | null;
    isAiSuggestion?: boolean | null;
}

export class SaveDataMappingRequest implements ISaveDataMappingRequest {
    isAppend!: boolean;
    items?: DataMappingInfo[] | null;

    constructor(data?: ISaveDataMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isAppend = data["isAppend"] !== undefined ? data["isAppend"] : null as any;
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item in data["items"])
                    this.items!.push(DataMappingInfo.fromJS(data["items"][item]));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): SaveDataMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDataMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAppend"] = this.isAppend !== undefined ? this.isAppend : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item in this.items)
                data["items"].push(this.items[item] ? this.items[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): SaveDataMappingRequest {
        const json = this.toJSON();
        let result = new SaveDataMappingRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveDataMappingRequest {
    isAppend: boolean;
    items?: DataMappingInfo[] | null;
}

export class MultiDimMappingsDto implements IMultiDimMappingsDto {
    sourceName?: string | null;
    sourceColumns?: SourceColumnDto[] | null;
    targetRows?: TargetRowDto[] | null;

    constructor(data?: IMultiDimMappingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            if (Array.isArray(data["sourceColumns"])) {
                this.sourceColumns = [] as any;
                for (let item in data["sourceColumns"])
                    this.sourceColumns!.push(SourceColumnDto.fromJS(data["sourceColumns"][item]));
            }
            else {
                this.sourceColumns = null as any;
            }
            if (Array.isArray(data["targetRows"])) {
                this.targetRows = [] as any;
                for (let item in data["targetRows"])
                    this.targetRows!.push(TargetRowDto.fromJS(data["targetRows"][item]));
            }
            else {
                this.targetRows = null as any;
            }
        }
    }

    static fromJS(data: any): MultiDimMappingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimMappingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        if (Array.isArray(this.sourceColumns)) {
            data["sourceColumns"] = [];
            for (let item in this.sourceColumns)
                data["sourceColumns"].push(this.sourceColumns[item] ? this.sourceColumns[item].toJSON() : null as any);
        }
        if (Array.isArray(this.targetRows)) {
            data["targetRows"] = [];
            for (let item in this.targetRows)
                data["targetRows"].push(this.targetRows[item] ? this.targetRows[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MultiDimMappingsDto {
        const json = this.toJSON();
        let result = new MultiDimMappingsDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimMappingsDto {
    sourceName?: string | null;
    sourceColumns?: SourceColumnDto[] | null;
    targetRows?: TargetRowDto[] | null;
}

export class SourceColumnDto implements ISourceColumnDto {
    dataMapSourceFieldId!: string;
    displayName?: string | null;

    constructor(data?: ISourceColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : null as any;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null as any;
        }
    }

    static fromJS(data: any): SourceColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        return data;
    }

    clone(): SourceColumnDto {
        const json = this.toJSON();
        let result = new SourceColumnDto();
        result.init(json);
        return result;
    }
}

export interface ISourceColumnDto {
    dataMapSourceFieldId: string;
    displayName?: string | null;
}

export class TargetRowDto implements ITargetRowDto {
    id!: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    targetMemberCaption?: string | null;
    sourceSign?: string | null;
    orderIndex!: number;
    sources?: SourceCriterionDto[] | null;

    constructor(data?: ITargetRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : null as any;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : null as any;
            this.targetMemberCaption = data["targetMemberCaption"] !== undefined ? data["targetMemberCaption"] : null as any;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : null as any;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null as any;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(SourceCriterionDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = null as any;
            }
        }
    }

    static fromJS(data: any): TargetRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : null as any;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : null as any;
        data["targetMemberCaption"] = this.targetMemberCaption !== undefined ? this.targetMemberCaption : null as any;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : null as any;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item] ? this.sources[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): TargetRowDto {
        const json = this.toJSON();
        let result = new TargetRowDto();
        result.init(json);
        return result;
    }
}

export interface ITargetRowDto {
    id: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    targetMemberCaption?: string | null;
    sourceSign?: string | null;
    orderIndex: number;
    sources?: SourceCriterionDto[] | null;
}

export class SourceCriterionDto implements ISourceCriterionDto {
    dataMapSourceFieldId!: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;

    constructor(data?: ISourceCriterionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : null as any;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : null as any;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : null as any;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : null as any;
        }
    }

    static fromJS(data: any): SourceCriterionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceCriterionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : null as any;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : null as any;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : null as any;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : null as any;
        return data;
    }

    clone(): SourceCriterionDto {
        const json = this.toJSON();
        let result = new SourceCriterionDto();
        result.init(json);
        return result;
    }
}

export interface ISourceCriterionDto {
    dataMapSourceFieldId: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;
}

export class EditMultiDimMappingsRequestDto implements IEditMultiDimMappingsRequestDto {
    sourceName?: string | null;
    inserts?: MultiDimRowInsertDto[] | null;
    updates?: MultiDimRowUpdateDto[] | null;
    deleteIds?: string[] | null;
    changeIndexes?: MultiDimRowChangeIndexDto[] | null;

    constructor(data?: IEditMultiDimMappingsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            if (Array.isArray(data["inserts"])) {
                this.inserts = [] as any;
                for (let item in data["inserts"])
                    this.inserts!.push(MultiDimRowInsertDto.fromJS(data["inserts"][item]));
            }
            else {
                this.inserts = null as any;
            }
            if (Array.isArray(data["updates"])) {
                this.updates = [] as any;
                for (let item in data["updates"])
                    this.updates!.push(MultiDimRowUpdateDto.fromJS(data["updates"][item]));
            }
            else {
                this.updates = null as any;
            }
            if (Array.isArray(data["deleteIds"])) {
                this.deleteIds = [] as any;
                for (let item in data["deleteIds"])
                    this.deleteIds!.push(data["deleteIds"][item]);
            }
            else {
                this.deleteIds = null as any;
            }
            if (Array.isArray(data["changeIndexes"])) {
                this.changeIndexes = [] as any;
                for (let item in data["changeIndexes"])
                    this.changeIndexes!.push(MultiDimRowChangeIndexDto.fromJS(data["changeIndexes"][item]));
            }
            else {
                this.changeIndexes = null as any;
            }
        }
    }

    static fromJS(data: any): EditMultiDimMappingsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditMultiDimMappingsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        if (Array.isArray(this.inserts)) {
            data["inserts"] = [];
            for (let item in this.inserts)
                data["inserts"].push(this.inserts[item] ? this.inserts[item].toJSON() : null as any);
        }
        if (Array.isArray(this.updates)) {
            data["updates"] = [];
            for (let item in this.updates)
                data["updates"].push(this.updates[item] ? this.updates[item].toJSON() : null as any);
        }
        if (Array.isArray(this.deleteIds)) {
            data["deleteIds"] = [];
            for (let item in this.deleteIds)
                data["deleteIds"].push(this.deleteIds[item]);
        }
        if (Array.isArray(this.changeIndexes)) {
            data["changeIndexes"] = [];
            for (let item in this.changeIndexes)
                data["changeIndexes"].push(this.changeIndexes[item] ? this.changeIndexes[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): EditMultiDimMappingsRequestDto {
        const json = this.toJSON();
        let result = new EditMultiDimMappingsRequestDto();
        result.init(json);
        return result;
    }
}

export interface IEditMultiDimMappingsRequestDto {
    sourceName?: string | null;
    inserts?: MultiDimRowInsertDto[] | null;
    updates?: MultiDimRowUpdateDto[] | null;
    deleteIds?: string[] | null;
    changeIndexes?: MultiDimRowChangeIndexDto[] | null;
}

export class MultiDimRowInsertDto implements IMultiDimRowInsertDto {
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    orderIndex!: number;
    sources?: MultiDimSourceUpsertDto[] | null;

    constructor(data?: IMultiDimRowInsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : null as any;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : null as any;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : null as any;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null as any;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(MultiDimSourceUpsertDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = null as any;
            }
        }
    }

    static fromJS(data: any): MultiDimRowInsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowInsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : null as any;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : null as any;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : null as any;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item] ? this.sources[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MultiDimRowInsertDto {
        const json = this.toJSON();
        let result = new MultiDimRowInsertDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowInsertDto {
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    orderIndex: number;
    sources?: MultiDimSourceUpsertDto[] | null;
}

export class MultiDimSourceUpsertDto implements IMultiDimSourceUpsertDto {
    dataMapSourceFieldId!: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;

    constructor(data?: IMultiDimSourceUpsertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataMapSourceFieldId = data["dataMapSourceFieldId"] !== undefined ? data["dataMapSourceFieldId"] : null as any;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : null as any;
            this.sourceValue = data["sourceValue"] !== undefined ? data["sourceValue"] : null as any;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : null as any;
        }
    }

    static fromJS(data: any): MultiDimSourceUpsertDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimSourceUpsertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataMapSourceFieldId"] = this.dataMapSourceFieldId !== undefined ? this.dataMapSourceFieldId : null as any;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : null as any;
        data["sourceValue"] = this.sourceValue !== undefined ? this.sourceValue : null as any;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : null as any;
        return data;
    }

    clone(): MultiDimSourceUpsertDto {
        const json = this.toJSON();
        let result = new MultiDimSourceUpsertDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimSourceUpsertDto {
    dataMapSourceFieldId: string;
    mappingType?: string | null;
    sourceValue?: string | null;
    sourceCaption?: string | null;
}

export class MultiDimRowUpdateDto implements IMultiDimRowUpdateDto {
    targetRowId!: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    sources?: MultiDimSourceUpsertDto[] | null;

    constructor(data?: IMultiDimRowUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetRowId = data["targetRowId"] !== undefined ? data["targetRowId"] : null as any;
            this.targetDimension = data["targetDimension"] !== undefined ? data["targetDimension"] : null as any;
            this.targetMember = data["targetMember"] !== undefined ? data["targetMember"] : null as any;
            this.sourceSign = data["sourceSign"] !== undefined ? data["sourceSign"] : null as any;
            if (Array.isArray(data["sources"])) {
                this.sources = [] as any;
                for (let item in data["sources"])
                    this.sources!.push(MultiDimSourceUpsertDto.fromJS(data["sources"][item]));
            }
            else {
                this.sources = null as any;
            }
        }
    }

    static fromJS(data: any): MultiDimRowUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetRowId"] = this.targetRowId !== undefined ? this.targetRowId : null as any;
        data["targetDimension"] = this.targetDimension !== undefined ? this.targetDimension : null as any;
        data["targetMember"] = this.targetMember !== undefined ? this.targetMember : null as any;
        data["sourceSign"] = this.sourceSign !== undefined ? this.sourceSign : null as any;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item in this.sources)
                data["sources"].push(this.sources[item] ? this.sources[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MultiDimRowUpdateDto {
        const json = this.toJSON();
        let result = new MultiDimRowUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowUpdateDto {
    targetRowId: string;
    targetDimension?: string | null;
    targetMember?: string | null;
    sourceSign?: string | null;
    sources?: MultiDimSourceUpsertDto[] | null;
}

export class MultiDimRowChangeIndexDto implements IMultiDimRowChangeIndexDto {
    targetRowId!: string;
    orderIndex!: number;

    constructor(data?: IMultiDimRowChangeIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetRowId = data["targetRowId"] !== undefined ? data["targetRowId"] : null as any;
            this.orderIndex = data["orderIndex"] !== undefined ? data["orderIndex"] : null as any;
        }
    }

    static fromJS(data: any): MultiDimRowChangeIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiDimRowChangeIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetRowId"] = this.targetRowId !== undefined ? this.targetRowId : null as any;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : null as any;
        return data;
    }

    clone(): MultiDimRowChangeIndexDto {
        const json = this.toJSON();
        let result = new MultiDimRowChangeIndexDto();
        result.init(json);
        return result;
    }
}

export interface IMultiDimRowChangeIndexDto {
    targetRowId: string;
    orderIndex: number;
}

export class DashboardExtension implements IDashboardExtension {
    id!: number;
    type?: string | null;
    label?: string | null;
    editUrl?: string | null;
    renderUrl?: string | null;
    svg?: string | null;

    constructor(data?: IDashboardExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.label = data["label"] !== undefined ? data["label"] : null as any;
            this.editUrl = data["editUrl"] !== undefined ? data["editUrl"] : null as any;
            this.renderUrl = data["renderUrl"] !== undefined ? data["renderUrl"] : null as any;
            this.svg = data["svg"] !== undefined ? data["svg"] : null as any;
        }
    }

    static fromJS(data: any): DashboardExtension {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["editUrl"] = this.editUrl !== undefined ? this.editUrl : null as any;
        data["renderUrl"] = this.renderUrl !== undefined ? this.renderUrl : null as any;
        data["svg"] = this.svg !== undefined ? this.svg : null as any;
        return data;
    }

    clone(): DashboardExtension {
        const json = this.toJSON();
        let result = new DashboardExtension();
        result.init(json);
        return result;
    }
}

export interface IDashboardExtension {
    id: number;
    type?: string | null;
    label?: string | null;
    editUrl?: string | null;
    renderUrl?: string | null;
    svg?: string | null;
}

export class HomeExtension implements IHomeExtension {
    id!: number;
    caption?: string | null;
    url?: string | null;
    svg?: string | null;
    allowComms!: boolean;
    postJwt!: boolean;

    constructor(data?: IHomeExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.url = data["url"] !== undefined ? data["url"] : null as any;
            this.svg = data["svg"] !== undefined ? data["svg"] : null as any;
            this.allowComms = data["allowComms"] !== undefined ? data["allowComms"] : null as any;
            this.postJwt = data["postJwt"] !== undefined ? data["postJwt"] : null as any;
        }
    }

    static fromJS(data: any): HomeExtension {
        data = typeof data === 'object' ? data : {};
        let result = new HomeExtension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["svg"] = this.svg !== undefined ? this.svg : null as any;
        data["allowComms"] = this.allowComms !== undefined ? this.allowComms : null as any;
        data["postJwt"] = this.postJwt !== undefined ? this.postJwt : null as any;
        return data;
    }

    clone(): HomeExtension {
        const json = this.toJSON();
        let result = new HomeExtension();
        result.init(json);
        return result;
    }
}

export interface IHomeExtension {
    id: number;
    caption?: string | null;
    url?: string | null;
    svg?: string | null;
    allowComms: boolean;
    postJwt: boolean;
}

export class IntercompanyGapResponse implements IIntercompanyGapResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    intercompanyGapAmount?: number | null;

    constructor(data?: IIntercompanyGapResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] !== undefined ? data["entityName"] : null as any;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : null as any;
            this.entityKey = data["entityKey"] !== undefined ? data["entityKey"] : null as any;
            this.intercompanyName = data["intercompanyName"] !== undefined ? data["intercompanyName"] : null as any;
            this.intercompanyCaption = data["intercompanyCaption"] !== undefined ? data["intercompanyCaption"] : null as any;
            this.intercompanyKey = data["intercompanyKey"] !== undefined ? data["intercompanyKey"] : null as any;
            this.intercompanyGapAmount = data["intercompanyGapAmount"] !== undefined ? data["intercompanyGapAmount"] : null as any;
        }
    }

    static fromJS(data: any): IntercompanyGapResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntercompanyGapResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName !== undefined ? this.entityName : null as any;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : null as any;
        data["entityKey"] = this.entityKey !== undefined ? this.entityKey : null as any;
        data["intercompanyName"] = this.intercompanyName !== undefined ? this.intercompanyName : null as any;
        data["intercompanyCaption"] = this.intercompanyCaption !== undefined ? this.intercompanyCaption : null as any;
        data["intercompanyKey"] = this.intercompanyKey !== undefined ? this.intercompanyKey : null as any;
        data["intercompanyGapAmount"] = this.intercompanyGapAmount !== undefined ? this.intercompanyGapAmount : null as any;
        return data;
    }

    clone(): IntercompanyGapResponse {
        const json = this.toJSON();
        let result = new IntercompanyGapResponse();
        result.init(json);
        return result;
    }
}

export interface IIntercompanyGapResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    intercompanyGapAmount?: number | null;
}

export class IntercompanyGapAccountDetailResponse implements IIntercompanyGapAccountDetailResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    accountARName?: string | null;
    accountARCaption?: string | null;
    accountAPName?: string | null;
    accountAPCaption?: string | null;
    amountAR?: number | null;
    amountAP?: number | null;
    accountGap?: number | null;

    constructor(data?: IIntercompanyGapAccountDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] !== undefined ? data["entityName"] : null as any;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : null as any;
            this.entityKey = data["entityKey"] !== undefined ? data["entityKey"] : null as any;
            this.intercompanyName = data["intercompanyName"] !== undefined ? data["intercompanyName"] : null as any;
            this.intercompanyCaption = data["intercompanyCaption"] !== undefined ? data["intercompanyCaption"] : null as any;
            this.intercompanyKey = data["intercompanyKey"] !== undefined ? data["intercompanyKey"] : null as any;
            this.accountARName = data["accountARName"] !== undefined ? data["accountARName"] : null as any;
            this.accountARCaption = data["accountARCaption"] !== undefined ? data["accountARCaption"] : null as any;
            this.accountAPName = data["accountAPName"] !== undefined ? data["accountAPName"] : null as any;
            this.accountAPCaption = data["accountAPCaption"] !== undefined ? data["accountAPCaption"] : null as any;
            this.amountAR = data["amountAR"] !== undefined ? data["amountAR"] : null as any;
            this.amountAP = data["amountAP"] !== undefined ? data["amountAP"] : null as any;
            this.accountGap = data["accountGap"] !== undefined ? data["accountGap"] : null as any;
        }
    }

    static fromJS(data: any): IntercompanyGapAccountDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IntercompanyGapAccountDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName !== undefined ? this.entityName : null as any;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : null as any;
        data["entityKey"] = this.entityKey !== undefined ? this.entityKey : null as any;
        data["intercompanyName"] = this.intercompanyName !== undefined ? this.intercompanyName : null as any;
        data["intercompanyCaption"] = this.intercompanyCaption !== undefined ? this.intercompanyCaption : null as any;
        data["intercompanyKey"] = this.intercompanyKey !== undefined ? this.intercompanyKey : null as any;
        data["accountARName"] = this.accountARName !== undefined ? this.accountARName : null as any;
        data["accountARCaption"] = this.accountARCaption !== undefined ? this.accountARCaption : null as any;
        data["accountAPName"] = this.accountAPName !== undefined ? this.accountAPName : null as any;
        data["accountAPCaption"] = this.accountAPCaption !== undefined ? this.accountAPCaption : null as any;
        data["amountAR"] = this.amountAR !== undefined ? this.amountAR : null as any;
        data["amountAP"] = this.amountAP !== undefined ? this.amountAP : null as any;
        data["accountGap"] = this.accountGap !== undefined ? this.accountGap : null as any;
        return data;
    }

    clone(): IntercompanyGapAccountDetailResponse {
        const json = this.toJSON();
        let result = new IntercompanyGapAccountDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IIntercompanyGapAccountDetailResponse {
    entityName?: string | null;
    entityCaption?: string | null;
    entityKey?: number | null;
    intercompanyName?: string | null;
    intercompanyCaption?: string | null;
    intercompanyKey?: number | null;
    accountARName?: string | null;
    accountARCaption?: string | null;
    accountAPName?: string | null;
    accountAPCaption?: string | null;
    amountAR?: number | null;
    amountAP?: number | null;
    accountGap?: number | null;
}

export class FileSystemObjectBase implements IFileSystemObjectBase {
    objectType!: FileSystemType;
    textContent?: string | null;
    binaryContent?: string | null;

    constructor(data?: IFileSystemObjectBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.objectType = data["objectType"] !== undefined ? data["objectType"] : null as any;
            this.textContent = data["textContent"] !== undefined ? data["textContent"] : null as any;
            this.binaryContent = data["binaryContent"] !== undefined ? data["binaryContent"] : null as any;
        }
    }

    static fromJS(data: any): FileSystemObjectBase {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObjectBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectType"] = this.objectType !== undefined ? this.objectType : null as any;
        data["textContent"] = this.textContent !== undefined ? this.textContent : null as any;
        data["binaryContent"] = this.binaryContent !== undefined ? this.binaryContent : null as any;
        return data;
    }

    clone(): FileSystemObjectBase {
        const json = this.toJSON();
        let result = new FileSystemObjectBase();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObjectBase {
    objectType: FileSystemType;
    textContent?: string | null;
    binaryContent?: string | null;
}

export class FileSystemObject extends FileSystemObjectBase implements IFileSystemObject {
    id!: number;
    isGlobal!: boolean;
    name?: string | null;
    path?: string | null;
    isRoot!: boolean;
    parentId!: number;
    lastModified?: Date | null;
    lastModifiedBy?: string | null;
    objectRights!: AccessRights;
    folderRights!: AccessRights;
    fullPath?: string | null;

    constructor(data?: IFileSystemObject) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.isGlobal = data["isGlobal"] !== undefined ? data["isGlobal"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.path = data["path"] !== undefined ? data["path"] : null as any;
            this.isRoot = data["isRoot"] !== undefined ? data["isRoot"] : null as any;
            this.parentId = data["parentId"] !== undefined ? data["parentId"] : null as any;
            this.lastModified = data["lastModified"] ? new Date(data["lastModified"].toString()) : null as any;
            this.lastModifiedBy = data["lastModifiedBy"] !== undefined ? data["lastModifiedBy"] : null as any;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : null as any;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : null as any;
            this.fullPath = data["fullPath"] !== undefined ? data["fullPath"] : null as any;
        }
    }

    static override fromJS(data: any): FileSystemObject {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObject();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["isRoot"] = this.isRoot !== undefined ? this.isRoot : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : null as any;
        data["lastModifiedBy"] = this.lastModifiedBy !== undefined ? this.lastModifiedBy : null as any;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : null as any;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : null as any;
        data["fullPath"] = this.fullPath !== undefined ? this.fullPath : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FileSystemObject {
        const json = this.toJSON();
        let result = new FileSystemObject();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObject extends IFileSystemObjectBase {
    id: number;
    isGlobal: boolean;
    name?: string | null;
    path?: string | null;
    isRoot: boolean;
    parentId: number;
    lastModified?: Date | null;
    lastModifiedBy?: string | null;
    objectRights: AccessRights;
    folderRights: AccessRights;
    fullPath?: string | null;
}

export class FileSystemObjectContent extends FileSystemObject implements IFileSystemObjectContent {
    textContentSize!: number;
    binaryContentSize!: number;
    folderContent?: FileSystemObjectContent[] | null;

    constructor(data?: IFileSystemObjectContent) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.textContentSize = data["textContentSize"] !== undefined ? data["textContentSize"] : null as any;
            this.binaryContentSize = data["binaryContentSize"] !== undefined ? data["binaryContentSize"] : null as any;
            if (Array.isArray(data["folderContent"])) {
                this.folderContent = [] as any;
                for (let item in data["folderContent"])
                    this.folderContent!.push(FileSystemObjectContent.fromJS(data["folderContent"][item]));
            }
            else {
                this.folderContent = null as any;
            }
        }
    }

    static override fromJS(data: any): FileSystemObjectContent {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemObjectContent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["textContentSize"] = this.textContentSize !== undefined ? this.textContentSize : null as any;
        data["binaryContentSize"] = this.binaryContentSize !== undefined ? this.binaryContentSize : null as any;
        if (Array.isArray(this.folderContent)) {
            data["folderContent"] = [];
            for (let item in this.folderContent)
                data["folderContent"].push(this.folderContent[item] ? this.folderContent[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FileSystemObjectContent {
        const json = this.toJSON();
        let result = new FileSystemObjectContent();
        result.init(json);
        return result;
    }
}

export interface IFileSystemObjectContent extends IFileSystemObject {
    textContentSize: number;
    binaryContentSize: number;
    folderContent?: FileSystemObjectContent[] | null;
}

export enum AccessRights {
    None = 0,
    Read = 1,
    Write = 2,
}

export enum FileSystemType {
    Folder = 0,
    Form = 1,
    Process = 2,
    InteractiveProcess = 3,
    PowerBI = 4,
    Generic = 5,
    ReportBook = 6,
    DocxReport = 7,
    PptxReport = 8,
    None = 9,
    XL3 = 10,
    CalcScript = 11,
    Url = 12,
}

export class FileSystemChangeNotification implements IFileSystemChangeNotification {
    time!: Date;
    type!: ChangeType;
    uid?: string | null;
    objectName?: string | null;
    path?: string | null;
    id?: number | null;
    parentId?: number | null;
    message?: string | null;
    tenant?: string | null;

    constructor(data?: IFileSystemChangeNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.time = data["time"] ? new Date(data["time"].toString()) : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.uid = data["uid"] !== undefined ? data["uid"] : null as any;
            this.objectName = data["objectName"] !== undefined ? data["objectName"] : null as any;
            this.path = data["path"] !== undefined ? data["path"] : null as any;
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.parentId = data["parentId"] !== undefined ? data["parentId"] : null as any;
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : null as any;
        }
    }

    static fromJS(data: any): FileSystemChangeNotification {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemChangeNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["objectName"] = this.objectName !== undefined ? this.objectName : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["parentId"] = this.parentId !== undefined ? this.parentId : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["tenant"] = this.tenant !== undefined ? this.tenant : null as any;
        return data;
    }

    clone(): FileSystemChangeNotification {
        const json = this.toJSON();
        let result = new FileSystemChangeNotification();
        result.init(json);
        return result;
    }
}

export interface IFileSystemChangeNotification {
    time: Date;
    type: ChangeType;
    uid?: string | null;
    objectName?: string | null;
    path?: string | null;
    id?: number | null;
    parentId?: number | null;
    message?: string | null;
    tenant?: string | null;
}

export enum ChangeType {
    Create = 0,
    Delete = 1,
    Update = 2,
    Move = 3,
    Rename = 4,
    Copy = 5,
    Import = 6,
}

export enum ArchiveXL3ReportFormat {
    Pdf = 0,
    Excel = 1,
    Powerpoint = 2,
}

export class FormParameterList implements IFormParameterList {
    formId!: number;
    parameters?: FormParameter[] | null;
    currentValues?: FormParameterCurrentValue[] | null;

    constructor(data?: IFormParameterList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(FormParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            if (Array.isArray(data["currentValues"])) {
                this.currentValues = [] as any;
                for (let item in data["currentValues"])
                    this.currentValues!.push(FormParameterCurrentValue.fromJS(data["currentValues"][item]));
            }
            else {
                this.currentValues = null as any;
            }
        }
    }

    static fromJS(data: any): FormParameterList {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        if (Array.isArray(this.currentValues)) {
            data["currentValues"] = [];
            for (let item in this.currentValues)
                data["currentValues"].push(this.currentValues[item] ? this.currentValues[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): FormParameterList {
        const json = this.toJSON();
        let result = new FormParameterList();
        result.init(json);
        return result;
    }
}

export interface IFormParameterList {
    formId: number;
    parameters?: FormParameter[] | null;
    currentValues?: FormParameterCurrentValue[] | null;
}

export class FormParameter implements IFormParameter {
    name?: string | null;
    label?: string | null;
    display?: string | null;
    isHidden!: boolean;
    style?: string | null;
    fullTreeView!: boolean;
    isMultiSelect!: boolean;
    separator?: string | null;
    dependencies?: string[] | null;
    isPinned!: boolean;
    values?: FormParameterValue[] | null;
    currentValue?: FormParameterValue | null;

    constructor(data?: IFormParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.label = data["label"] !== undefined ? data["label"] : null as any;
            this.display = data["display"] !== undefined ? data["display"] : null as any;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : null as any;
            this.style = data["style"] !== undefined ? data["style"] : null as any;
            this.fullTreeView = data["fullTreeView"] !== undefined ? data["fullTreeView"] : null as any;
            this.isMultiSelect = data["isMultiSelect"] !== undefined ? data["isMultiSelect"] : null as any;
            this.separator = data["separator"] !== undefined ? data["separator"] : null as any;
            if (Array.isArray(data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item in data["dependencies"])
                    this.dependencies!.push(data["dependencies"][item]);
            }
            else {
                this.dependencies = null as any;
            }
            this.isPinned = data["isPinned"] !== undefined ? data["isPinned"] : null as any;
            if (Array.isArray(data["values"])) {
                this.values = [] as any;
                for (let item in data["values"])
                    this.values!.push(FormParameterValue.fromJS(data["values"][item]));
            }
            else {
                this.values = null as any;
            }
            this.currentValue = data["currentValue"] ? FormParameterValue.fromJS(data["currentValue"]) : null as any;
        }
    }

    static fromJS(data: any): FormParameter {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["display"] = this.display !== undefined ? this.display : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["style"] = this.style !== undefined ? this.style : null as any;
        data["fullTreeView"] = this.fullTreeView !== undefined ? this.fullTreeView : null as any;
        data["isMultiSelect"] = this.isMultiSelect !== undefined ? this.isMultiSelect : null as any;
        data["separator"] = this.separator !== undefined ? this.separator : null as any;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item in this.dependencies)
                data["dependencies"].push(this.dependencies[item]);
        }
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : null as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item in this.values)
                data["values"].push(this.values[item] ? this.values[item].toJSON() : null as any);
        }
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : null as any;
        return data;
    }

    clone(): FormParameter {
        const json = this.toJSON();
        let result = new FormParameter();
        result.init(json);
        return result;
    }
}

export interface IFormParameter {
    name?: string | null;
    label?: string | null;
    display?: string | null;
    isHidden: boolean;
    style?: string | null;
    fullTreeView: boolean;
    isMultiSelect: boolean;
    separator?: string | null;
    dependencies?: string[] | null;
    isPinned: boolean;
    values?: FormParameterValue[] | null;
    currentValue?: FormParameterValue | null;
}

export class FormParameterValue implements IFormParameterValue {
    key?: string | null;
    name?: string | null;
    caption?: string | null;
    parentKey?: string | null;
    isLeaf!: boolean;
    displayOnly!: boolean;

    constructor(data?: IFormParameterValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : null as any;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : null as any;
            this.displayOnly = data["displayOnly"] !== undefined ? data["displayOnly"] : null as any;
        }
    }

    static fromJS(data: any): FormParameterValue {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : null as any;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : null as any;
        data["displayOnly"] = this.displayOnly !== undefined ? this.displayOnly : null as any;
        return data;
    }

    clone(): FormParameterValue {
        const json = this.toJSON();
        let result = new FormParameterValue();
        result.init(json);
        return result;
    }
}

export interface IFormParameterValue {
    key?: string | null;
    name?: string | null;
    caption?: string | null;
    parentKey?: string | null;
    isLeaf: boolean;
    displayOnly: boolean;
}

export class FormParameterCurrentValue implements IFormParameterCurrentValue {
    name?: string | null;
    currentValue?: FormParameterValue | null;
    isPinned!: boolean;

    constructor(data?: IFormParameterCurrentValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.currentValue = data["currentValue"] ? FormParameterValue.fromJS(data["currentValue"]) : null as any;
            this.isPinned = data["isPinned"] !== undefined ? data["isPinned"] : null as any;
        }
    }

    static fromJS(data: any): FormParameterCurrentValue {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterCurrentValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : null as any;
        data["isPinned"] = this.isPinned !== undefined ? this.isPinned : null as any;
        return data;
    }

    clone(): FormParameterCurrentValue {
        const json = this.toJSON();
        let result = new FormParameterCurrentValue();
        result.init(json);
        return result;
    }
}

export interface IFormParameterCurrentValue {
    name?: string | null;
    currentValue?: FormParameterValue | null;
    isPinned: boolean;
}

export class Exception implements IException {
    message!: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["Message"] !== undefined ? data["Message"] : null as any;
            this.innerException = data["InnerException"] ? Exception.fromJS(data["InnerException"]) : null as any;
            this.source = data["Source"] !== undefined ? data["Source"] : null as any;
            this.stackTrace = data["StackTrace"] !== undefined ? data["StackTrace"] : null as any;
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Message"] = this.message !== undefined ? this.message : null as any;
        data["InnerException"] = this.innerException ? this.innerException.toJSON() : null as any;
        data["Source"] = this.source !== undefined ? this.source : null as any;
        data["StackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        return data;
    }

    clone(): Exception {
        const json = this.toJSON();
        let result = new Exception();
        result.init(json);
        return result;
    }
}

export interface IException {
    message: string;
    innerException?: Exception | null;
    source?: string | null;
    stackTrace?: string | null;
}

export class HttpStatusCodeException extends Exception implements IHttpStatusCodeException {
    statusCode!: number;

    constructor(data?: IHttpStatusCodeException) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.statusCode = data["statusCode"] !== undefined ? data["statusCode"] : null as any;
        }
    }

    static override fromJS(data: any): HttpStatusCodeException {
        data = typeof data === 'object' ? data : {};
        let result = new HttpStatusCodeException();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): HttpStatusCodeException {
        const json = this.toJSON();
        let result = new HttpStatusCodeException();
        result.init(json);
        return result;
    }
}

export interface IHttpStatusCodeException extends IException {
    statusCode: number;
}

export class QueryResult implements IQueryResult {

    [key: string]: any;

    constructor(data?: IQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): QueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): QueryResult {
        const json = this.toJSON();
        let result = new QueryResult();
        result.init(json);
        return result;
    }
}

export interface IQueryResult {

    [key: string]: any;
}

export class DrillDownResult implements IDrillDownResult {
    columnDataType?: string[] | null;
    resultRows?: DrillDownResultRow[] | null;

    constructor(data?: IDrillDownResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["columnDataType"])) {
                this.columnDataType = [] as any;
                for (let item in data["columnDataType"])
                    this.columnDataType!.push(data["columnDataType"][item]);
            }
            else {
                this.columnDataType = null as any;
            }
            if (Array.isArray(data["resultRows"])) {
                this.resultRows = [] as any;
                for (let item in data["resultRows"])
                    this.resultRows!.push(DrillDownResultRow.fromJS(data["resultRows"][item]));
            }
            else {
                this.resultRows = null as any;
            }
        }
    }

    static fromJS(data: any): DrillDownResult {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnDataType)) {
            data["columnDataType"] = [];
            for (let item in this.columnDataType)
                data["columnDataType"].push(this.columnDataType[item]);
        }
        if (Array.isArray(this.resultRows)) {
            data["resultRows"] = [];
            for (let item in this.resultRows)
                data["resultRows"].push(this.resultRows[item] ? this.resultRows[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DrillDownResult {
        const json = this.toJSON();
        let result = new DrillDownResult();
        result.init(json);
        return result;
    }
}

export interface IDrillDownResult {
    columnDataType?: string[] | null;
    resultRows?: DrillDownResultRow[] | null;
}

export class DrillDownResultRow implements IDrillDownResultRow {
    rowMetadata?: AxisTuple | null;
    data?: string[] | null;

    constructor(data?: IDrillDownResultRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowMetadata = data["rowMetadata"] ? AxisTuple.fromJS(data["rowMetadata"]) : null as any;
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): DrillDownResultRow {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownResultRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowMetadata"] = this.rowMetadata ? this.rowMetadata.toJSON() : null as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): DrillDownResultRow {
        const json = this.toJSON();
        let result = new DrillDownResultRow();
        result.init(json);
        return result;
    }
}

export interface IDrillDownResultRow {
    rowMetadata?: AxisTuple | null;
    data?: string[] | null;
}

export class AxisTuple implements IAxisTuple {
    keys?: number[] | null;
    names?: string[] | null;
    levels?: number[] | null;
    dimensions?: string[] | null;
    hierarchies?: string[] | null;
    attributes?: { [key: string]: any; } | null;
    dataType?: string | null;
    measureIndex!: number;
    queryRange!: number;

    constructor(data?: IAxisTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["keys"])) {
                this.keys = [] as any;
                for (let item in data["keys"])
                    this.keys!.push(data["keys"][item]);
            }
            else {
                this.keys = null as any;
            }
            if (Array.isArray(data["names"])) {
                this.names = [] as any;
                for (let item in data["names"])
                    this.names!.push(data["names"][item]);
            }
            else {
                this.names = null as any;
            }
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item in data["levels"])
                    this.levels!.push(data["levels"][item]);
            }
            else {
                this.levels = null as any;
            }
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = null as any;
            }
            if (Array.isArray(data["hierarchies"])) {
                this.hierarchies = [] as any;
                for (let item in data["hierarchies"])
                    this.hierarchies!.push(data["hierarchies"][item]);
            }
            else {
                this.hierarchies = null as any;
            }
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = data["attributes"][key] !== undefined ? data["attributes"][key] : null as any;
                }
            }
            else {
                this.attributes = null as any;
            }
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : null as any;
            this.measureIndex = data["measureIndex"] !== undefined ? data["measureIndex"] : null as any;
            this.queryRange = data["queryRange"] !== undefined ? data["queryRange"] : null as any;
        }
    }

    static fromJS(data: any): AxisTuple {
        data = typeof data === 'object' ? data : {};
        let result = new AxisTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item in this.keys)
                data["keys"].push(this.keys[item]);
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item in this.names)
                data["names"].push(this.names[item]);
        }
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item in this.levels)
                data["levels"].push(this.levels[item]);
        }
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.hierarchies)) {
            data["hierarchies"] = [];
            for (let item in this.hierarchies)
                data["hierarchies"].push(this.hierarchies[item]);
        }
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = this.attributes[key] !== undefined ? this.attributes[key] : null as any;
            }
        }
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["measureIndex"] = this.measureIndex !== undefined ? this.measureIndex : null as any;
        data["queryRange"] = this.queryRange !== undefined ? this.queryRange : null as any;
        return data;
    }

    clone(): AxisTuple {
        const json = this.toJSON();
        let result = new AxisTuple();
        result.init(json);
        return result;
    }
}

export interface IAxisTuple {
    keys?: number[] | null;
    names?: string[] | null;
    levels?: number[] | null;
    dimensions?: string[] | null;
    hierarchies?: string[] | null;
    attributes?: { [key: string]: any; } | null;
    dataType?: string | null;
    measureIndex: number;
    queryRange: number;
}

export class DrillDownRequest implements IDrillDownRequest {
    rowTuples?: number[][] | null;
    columnTuples?: number[][] | null;
    slicerTuple?: number[] | null;
    drillDimension?: string | null;

    constructor(data?: IDrillDownRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["rowTuples"])) {
                this.rowTuples = [] as any;
                for (let item in data["rowTuples"])
                    this.rowTuples!.push(data["rowTuples"][item]);
            }
            else {
                this.rowTuples = null as any;
            }
            if (Array.isArray(data["columnTuples"])) {
                this.columnTuples = [] as any;
                for (let item in data["columnTuples"])
                    this.columnTuples!.push(data["columnTuples"][item]);
            }
            else {
                this.columnTuples = null as any;
            }
            if (Array.isArray(data["slicerTuple"])) {
                this.slicerTuple = [] as any;
                for (let item in data["slicerTuple"])
                    this.slicerTuple!.push(data["slicerTuple"][item]);
            }
            else {
                this.slicerTuple = null as any;
            }
            this.drillDimension = data["drillDimension"] !== undefined ? data["drillDimension"] : null as any;
        }
    }

    static fromJS(data: any): DrillDownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowTuples)) {
            data["rowTuples"] = [];
            for (let item in this.rowTuples)
                data["rowTuples"].push(this.rowTuples[item]);
        }
        if (Array.isArray(this.columnTuples)) {
            data["columnTuples"] = [];
            for (let item in this.columnTuples)
                data["columnTuples"].push(this.columnTuples[item]);
        }
        if (Array.isArray(this.slicerTuple)) {
            data["slicerTuple"] = [];
            for (let item in this.slicerTuple)
                data["slicerTuple"].push(this.slicerTuple[item]);
        }
        data["drillDimension"] = this.drillDimension !== undefined ? this.drillDimension : null as any;
        return data;
    }

    clone(): DrillDownRequest {
        const json = this.toJSON();
        let result = new DrillDownRequest();
        result.init(json);
        return result;
    }
}

export interface IDrillDownRequest {
    rowTuples?: number[][] | null;
    columnTuples?: number[][] | null;
    slicerTuple?: number[] | null;
    drillDimension?: string | null;
}

export class AuditEntryId implements IAuditEntryId {
    id?: string | null;
    timestamp!: Date;
    userDisplayName?: string | null;

    constructor(data?: IAuditEntryId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : null as any;
            this.userDisplayName = data["userDisplayName"] !== undefined ? data["userDisplayName"] : null as any;
        }
    }

    static fromJS(data: any): AuditEntryId {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEntryId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["userDisplayName"] = this.userDisplayName !== undefined ? this.userDisplayName : null as any;
        return data;
    }

    clone(): AuditEntryId {
        const json = this.toJSON();
        let result = new AuditEntryId();
        result.init(json);
        return result;
    }
}

export interface IAuditEntryId {
    id?: string | null;
    timestamp: Date;
    userDisplayName?: string | null;
}

export class ModelAuditEntry implements IModelAuditEntry {
    timestamp!: Date;
    user?: string | null;
    newValue?: string | null;
    modelAuditEntryType?: string | null;
    formId!: number;
    formAuditId?: string | null;
    formName?: string | null;

    constructor(data?: IModelAuditEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timestamp = data["timestamp"] ? new Date(data["timestamp"].toString()) : null as any;
            this.user = data["user"] !== undefined ? data["user"] : null as any;
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : null as any;
            this.modelAuditEntryType = data["modelAuditEntryType"] !== undefined ? data["modelAuditEntryType"] : null as any;
            this.formId = data["formId"] !== undefined ? data["formId"] : null as any;
            this.formAuditId = data["formAuditId"] !== undefined ? data["formAuditId"] : null as any;
            this.formName = data["formName"] !== undefined ? data["formName"] : null as any;
        }
    }

    static fromJS(data: any): ModelAuditEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ModelAuditEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["user"] = this.user !== undefined ? this.user : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        data["modelAuditEntryType"] = this.modelAuditEntryType !== undefined ? this.modelAuditEntryType : null as any;
        data["formId"] = this.formId !== undefined ? this.formId : null as any;
        data["formAuditId"] = this.formAuditId !== undefined ? this.formAuditId : null as any;
        data["formName"] = this.formName !== undefined ? this.formName : null as any;
        return data;
    }

    clone(): ModelAuditEntry {
        const json = this.toJSON();
        let result = new ModelAuditEntry();
        result.init(json);
        return result;
    }
}

export interface IModelAuditEntry {
    timestamp: Date;
    user?: string | null;
    newValue?: string | null;
    modelAuditEntryType?: string | null;
    formId: number;
    formAuditId?: string | null;
    formName?: string | null;
}

export class LIDResult implements ILIDResult {
    result!: LIDQueryResult;
    rows?: LIDRow[] | null;

    constructor(data?: ILIDResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"] !== undefined ? data["result"] : null as any;
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(LIDRow.fromJS(data["rows"][item]));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static fromJS(data: any): LIDResult {
        data = typeof data === 'object' ? data : {};
        let result = new LIDResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item] ? this.rows[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): LIDResult {
        const json = this.toJSON();
        let result = new LIDResult();
        result.init(json);
        return result;
    }
}

export interface ILIDResult {
    result: LIDQueryResult;
    rows?: LIDRow[] | null;
}

export enum LIDQueryResult {
    Success = 1,
    NoRequestData = 2,
    NotLeaf = 3,
}

export class LIDRow implements ILIDRow {
    rowRangeNo!: number;
    rowIndex!: number;
    description?: string | null;
    columnRangeNo?: number[] | null;
    columnIndex?: number[] | null;
    values?: string[] | null;

    constructor(data?: ILIDRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowRangeNo = data["rowRangeNo"] !== undefined ? data["rowRangeNo"] : null as any;
            this.rowIndex = data["rowIndex"] !== undefined ? data["rowIndex"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            if (Array.isArray(data["columnRangeNo"])) {
                this.columnRangeNo = [] as any;
                for (let item in data["columnRangeNo"])
                    this.columnRangeNo!.push(data["columnRangeNo"][item]);
            }
            else {
                this.columnRangeNo = null as any;
            }
            if (Array.isArray(data["columnIndex"])) {
                this.columnIndex = [] as any;
                for (let item in data["columnIndex"])
                    this.columnIndex!.push(data["columnIndex"][item]);
            }
            else {
                this.columnIndex = null as any;
            }
            if (Array.isArray(data["values"])) {
                this.values = [] as any;
                for (let item in data["values"])
                    this.values!.push(data["values"][item]);
            }
            else {
                this.values = null as any;
            }
        }
    }

    static fromJS(data: any): LIDRow {
        data = typeof data === 'object' ? data : {};
        let result = new LIDRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowRangeNo"] = this.rowRangeNo !== undefined ? this.rowRangeNo : null as any;
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        if (Array.isArray(this.columnRangeNo)) {
            data["columnRangeNo"] = [];
            for (let item in this.columnRangeNo)
                data["columnRangeNo"].push(this.columnRangeNo[item]);
        }
        if (Array.isArray(this.columnIndex)) {
            data["columnIndex"] = [];
            for (let item in this.columnIndex)
                data["columnIndex"].push(this.columnIndex[item]);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item in this.values)
                data["values"].push(this.values[item]);
        }
        return data;
    }

    clone(): LIDRow {
        const json = this.toJSON();
        let result = new LIDRow();
        result.init(json);
        return result;
    }
}

export interface ILIDRow {
    rowRangeNo: number;
    rowIndex: number;
    description?: string | null;
    columnRangeNo?: number[] | null;
    columnIndex?: number[] | null;
    values?: string[] | null;
}

export class LIDRequest implements ILIDRequest {
    rowTuple?: VisibleAxisTuple | null;
    columnTuples?: VisibleAxisTuple[][] | null;
    slicerTuple?: SlicerTuple[] | null;

    constructor(data?: ILIDRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowTuple = data["rowTuple"] ? VisibleAxisTuple.fromJS(data["rowTuple"]) : null as any;
            if (Array.isArray(data["columnTuples"])) {
                this.columnTuples = [] as any;
                for (let item in data["columnTuples"])
                    this.columnTuples!.push(data["columnTuples"][item]);
            }
            else {
                this.columnTuples = null as any;
            }
            if (Array.isArray(data["slicerTuple"])) {
                this.slicerTuple = [] as any;
                for (let item in data["slicerTuple"])
                    this.slicerTuple!.push(SlicerTuple.fromJS(data["slicerTuple"][item]));
            }
            else {
                this.slicerTuple = null as any;
            }
        }
    }

    static fromJS(data: any): LIDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LIDRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowTuple"] = this.rowTuple ? this.rowTuple.toJSON() : null as any;
        if (Array.isArray(this.columnTuples)) {
            data["columnTuples"] = [];
            for (let item in this.columnTuples)
                data["columnTuples"].push(this.columnTuples[item]);
        }
        if (Array.isArray(this.slicerTuple)) {
            data["slicerTuple"] = [];
            for (let item in this.slicerTuple)
                data["slicerTuple"].push(this.slicerTuple[item] ? this.slicerTuple[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): LIDRequest {
        const json = this.toJSON();
        let result = new LIDRequest();
        result.init(json);
        return result;
    }
}

export interface ILIDRequest {
    rowTuple?: VisibleAxisTuple | null;
    columnTuples?: VisibleAxisTuple[][] | null;
    slicerTuple?: SlicerTuple[] | null;
}

export class VisibleAxisTuple implements IVisibleAxisTuple {
    tuple?: DimensionMember[] | null;
    dimensionCount!: number;

    constructor(data?: IVisibleAxisTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["tuple"])) {
                this.tuple = [] as any;
                for (let item in data["tuple"])
                    this.tuple!.push(DimensionMember.fromJS(data["tuple"][item]));
            }
            else {
                this.tuple = null as any;
            }
            this.dimensionCount = data["dimensionCount"] !== undefined ? data["dimensionCount"] : null as any;
        }
    }

    static fromJS(data: any): VisibleAxisTuple {
        data = typeof data === 'object' ? data : {};
        let result = new VisibleAxisTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tuple)) {
            data["tuple"] = [];
            for (let item in this.tuple)
                data["tuple"].push(this.tuple[item] ? this.tuple[item].toJSON() : null as any);
        }
        data["dimensionCount"] = this.dimensionCount !== undefined ? this.dimensionCount : null as any;
        return data;
    }

    clone(): VisibleAxisTuple {
        const json = this.toJSON();
        let result = new VisibleAxisTuple();
        result.init(json);
        return result;
    }
}

export interface IVisibleAxisTuple {
    tuple?: DimensionMember[] | null;
    dimensionCount: number;
}

export class DimensionMember implements IDimensionMember {
    key!: number;
    name?: string | null;
    level!: number;

    constructor(data?: IDimensionMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.level = data["level"] !== undefined ? data["level"] : null as any;
        }
    }

    static fromJS(data: any): DimensionMember {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        return data;
    }

    clone(): DimensionMember {
        const json = this.toJSON();
        let result = new DimensionMember();
        result.init(json);
        return result;
    }
}

export interface IDimensionMember {
    key: number;
    name?: string | null;
    level: number;
}

export class SlicerTuple implements ISlicerTuple {
    dimension?: string | null;
    hierarchy?: string | null;
    key!: number;
    name?: string | null;

    constructor(data?: ISlicerTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : null as any;
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
        }
    }

    static fromJS(data: any): SlicerTuple {
        data = typeof data === 'object' ? data : {};
        let result = new SlicerTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): SlicerTuple {
        const json = this.toJSON();
        let result = new SlicerTuple();
        result.init(json);
        return result;
    }
}

export interface ISlicerTuple {
    dimension?: string | null;
    hierarchy?: string | null;
    key: number;
    name?: string | null;
}

export class ModelQueryResult implements IModelQueryResult {
    rows!: number;
    columns!: number;
    axes?: number[] | null;
    rowDimensions?: ModelQueryResultDimension[] | null;
    columnDimensions?: ModelQueryResultDimension[] | null;
    axisDimensions?: ModelQueryResultDimension[][] | null;
    slicerDimensions?: ModelQueryResultDimension[] | null;
    data?: ModelQueryResultData[] | null;

    constructor(data?: IModelQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rows = data["rows"] !== undefined ? data["rows"] : null as any;
            this.columns = data["columns"] !== undefined ? data["columns"] : null as any;
            if (Array.isArray(data["axes"])) {
                this.axes = [] as any;
                for (let item in data["axes"])
                    this.axes!.push(data["axes"][item]);
            }
            else {
                this.axes = null as any;
            }
            if (Array.isArray(data["rowDimensions"])) {
                this.rowDimensions = [] as any;
                for (let item in data["rowDimensions"])
                    this.rowDimensions!.push(ModelQueryResultDimension.fromJS(data["rowDimensions"][item]));
            }
            else {
                this.rowDimensions = null as any;
            }
            if (Array.isArray(data["columnDimensions"])) {
                this.columnDimensions = [] as any;
                for (let item in data["columnDimensions"])
                    this.columnDimensions!.push(ModelQueryResultDimension.fromJS(data["columnDimensions"][item]));
            }
            else {
                this.columnDimensions = null as any;
            }
            if (Array.isArray(data["axisDimensions"])) {
                this.axisDimensions = [] as any;
                for (let item in data["axisDimensions"])
                    this.axisDimensions!.push(data["axisDimensions"][item]);
            }
            else {
                this.axisDimensions = null as any;
            }
            if (Array.isArray(data["slicerDimensions"])) {
                this.slicerDimensions = [] as any;
                for (let item in data["slicerDimensions"])
                    this.slicerDimensions!.push(ModelQueryResultDimension.fromJS(data["slicerDimensions"][item]));
            }
            else {
                this.slicerDimensions = null as any;
            }
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(ModelQueryResultData.fromJS(data["data"][item]));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): ModelQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rows"] = this.rows !== undefined ? this.rows : null as any;
        data["columns"] = this.columns !== undefined ? this.columns : null as any;
        if (Array.isArray(this.axes)) {
            data["axes"] = [];
            for (let item in this.axes)
                data["axes"].push(this.axes[item]);
        }
        if (Array.isArray(this.rowDimensions)) {
            data["rowDimensions"] = [];
            for (let item in this.rowDimensions)
                data["rowDimensions"].push(this.rowDimensions[item] ? this.rowDimensions[item].toJSON() : null as any);
        }
        if (Array.isArray(this.columnDimensions)) {
            data["columnDimensions"] = [];
            for (let item in this.columnDimensions)
                data["columnDimensions"].push(this.columnDimensions[item] ? this.columnDimensions[item].toJSON() : null as any);
        }
        if (Array.isArray(this.axisDimensions)) {
            data["axisDimensions"] = [];
            for (let item in this.axisDimensions)
                data["axisDimensions"].push(this.axisDimensions[item]);
        }
        if (Array.isArray(this.slicerDimensions)) {
            data["slicerDimensions"] = [];
            for (let item in this.slicerDimensions)
                data["slicerDimensions"].push(this.slicerDimensions[item] ? this.slicerDimensions[item].toJSON() : null as any);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item] ? this.data[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModelQueryResult {
        const json = this.toJSON();
        let result = new ModelQueryResult();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResult {
    rows: number;
    columns: number;
    axes?: number[] | null;
    rowDimensions?: ModelQueryResultDimension[] | null;
    columnDimensions?: ModelQueryResultDimension[] | null;
    axisDimensions?: ModelQueryResultDimension[][] | null;
    slicerDimensions?: ModelQueryResultDimension[] | null;
    data?: ModelQueryResultData[] | null;
}

export class ModelQueryResultDimension implements IModelQueryResultDimension {
    name?: string | null;
    metaData?: ModelQueryResultDimensionMeta[] | null;

    constructor(data?: IModelQueryResultDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            if (Array.isArray(data["metaData"])) {
                this.metaData = [] as any;
                for (let item in data["metaData"])
                    this.metaData!.push(ModelQueryResultDimensionMeta.fromJS(data["metaData"][item]));
            }
            else {
                this.metaData = null as any;
            }
        }
    }

    static fromJS(data: any): ModelQueryResultDimension {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultDimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item in this.metaData)
                data["metaData"].push(this.metaData[item] ? this.metaData[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModelQueryResultDimension {
        const json = this.toJSON();
        let result = new ModelQueryResultDimension();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultDimension {
    name?: string | null;
    metaData?: ModelQueryResultDimensionMeta[] | null;
}

export class ModelQueryResultDimensionMeta implements IModelQueryResultDimensionMeta {
    index!: number;
    attributes?: { [key: string]: any; } | null;

    constructor(data?: IModelQueryResultDimensionMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.index = data["index"] !== undefined ? data["index"] : null as any;
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (this.attributes as any)![key] = data["attributes"][key] !== undefined ? data["attributes"][key] : null as any;
                }
            }
            else {
                this.attributes = null as any;
            }
        }
    }

    static fromJS(data: any): ModelQueryResultDimensionMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultDimensionMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : null as any;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (data["attributes"] as any)[key] = this.attributes[key] !== undefined ? this.attributes[key] : null as any;
            }
        }
        return data;
    }

    clone(): ModelQueryResultDimensionMeta {
        const json = this.toJSON();
        let result = new ModelQueryResultDimensionMeta();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultDimensionMeta {
    index: number;
    attributes?: { [key: string]: any; } | null;
}

export class ModelQueryResultData implements IModelQueryResultData {
    rowIndex!: number;
    columnIndex!: number;
    axisIndex?: number[] | null;
    data?: any | null;
    updateable?: boolean | null;

    constructor(data?: IModelQueryResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowIndex = data["rowIndex"] !== undefined ? data["rowIndex"] : null as any;
            this.columnIndex = data["columnIndex"] !== undefined ? data["columnIndex"] : null as any;
            if (Array.isArray(data["axisIndex"])) {
                this.axisIndex = [] as any;
                for (let item in data["axisIndex"])
                    this.axisIndex!.push(data["axisIndex"][item]);
            }
            else {
                this.axisIndex = null as any;
            }
            this.data = data["data"] !== undefined ? data["data"] : null as any;
            this.updateable = data["updateable"] !== undefined ? data["updateable"] : null as any;
        }
    }

    static fromJS(data: any): ModelQueryResultData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelQueryResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : null as any;
        data["columnIndex"] = this.columnIndex !== undefined ? this.columnIndex : null as any;
        if (Array.isArray(this.axisIndex)) {
            data["axisIndex"] = [];
            for (let item in this.axisIndex)
                data["axisIndex"].push(this.axisIndex[item]);
        }
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["updateable"] = this.updateable !== undefined ? this.updateable : null as any;
        return data;
    }

    clone(): ModelQueryResultData {
        const json = this.toJSON();
        let result = new ModelQueryResultData();
        result.init(json);
        return result;
    }
}

export interface IModelQueryResultData {
    rowIndex: number;
    columnIndex: number;
    axisIndex?: number[] | null;
    data?: any | null;
    updateable?: boolean | null;
}

export class InvestmentRegistryTreeNodeDto implements IInvestmentRegistryTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    ownership?: number | null;
    investees?: InvestmentRegistryTreeNodeDto[] | null;

    constructor(data?: IInvestmentRegistryTreeNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"] !== undefined ? data["entity"] : null as any;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : null as any;
            this.ownership = data["ownership"] !== undefined ? data["ownership"] : null as any;
            if (Array.isArray(data["investees"])) {
                this.investees = [] as any;
                for (let item in data["investees"])
                    this.investees!.push(InvestmentRegistryTreeNodeDto.fromJS(data["investees"][item]));
            }
            else {
                this.investees = null as any;
            }
        }
    }

    static fromJS(data: any): InvestmentRegistryTreeNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentRegistryTreeNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity !== undefined ? this.entity : null as any;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : null as any;
        data["ownership"] = this.ownership !== undefined ? this.ownership : null as any;
        if (Array.isArray(this.investees)) {
            data["investees"] = [];
            for (let item in this.investees)
                data["investees"].push(this.investees[item] ? this.investees[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): InvestmentRegistryTreeNodeDto {
        const json = this.toJSON();
        let result = new InvestmentRegistryTreeNodeDto();
        result.init(json);
        return result;
    }
}

export interface IInvestmentRegistryTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    ownership?: number | null;
    investees?: InvestmentRegistryTreeNodeDto[] | null;
}

export class InvestmentTransactionsDto implements IInvestmentTransactionsDto {
    summary!: InvestmentTransactionSummaryDto;
    rows!: InvestmentTransactionRowDto[];

    constructor(data?: IInvestmentTransactionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.summary = new InvestmentTransactionSummaryDto();
            this.rows = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.summary = data["summary"] ? InvestmentTransactionSummaryDto.fromJS(data["summary"]) : new InvestmentTransactionSummaryDto();
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(InvestmentTransactionRowDto.fromJS(data["rows"][item]));
            }
            else {
                this.rows = null as any;
            }
        }
    }

    static fromJS(data: any): InvestmentTransactionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentTransactionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : null as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item] ? this.rows[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): InvestmentTransactionsDto {
        const json = this.toJSON();
        let result = new InvestmentTransactionsDto();
        result.init(json);
        return result;
    }
}

export interface IInvestmentTransactionsDto {
    summary: InvestmentTransactionSummaryDto;
    rows: InvestmentTransactionRowDto[];
}

export class InvestmentTransactionSummaryDto implements IInvestmentTransactionSummaryDto {
    control!: boolean;
    ownershipPct!: number;
    sharesHeld!: number;
    totalShares!: number;
    netInvestment!: number;
    currency?: string | null;

    constructor(data?: IInvestmentTransactionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.control = data["control"] !== undefined ? data["control"] : null as any;
            this.ownershipPct = data["ownershipPct"] !== undefined ? data["ownershipPct"] : null as any;
            this.sharesHeld = data["sharesHeld"] !== undefined ? data["sharesHeld"] : null as any;
            this.totalShares = data["totalShares"] !== undefined ? data["totalShares"] : null as any;
            this.netInvestment = data["netInvestment"] !== undefined ? data["netInvestment"] : null as any;
            this.currency = data["currency"] !== undefined ? data["currency"] : null as any;
        }
    }

    static fromJS(data: any): InvestmentTransactionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentTransactionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["control"] = this.control !== undefined ? this.control : null as any;
        data["ownershipPct"] = this.ownershipPct !== undefined ? this.ownershipPct : null as any;
        data["sharesHeld"] = this.sharesHeld !== undefined ? this.sharesHeld : null as any;
        data["totalShares"] = this.totalShares !== undefined ? this.totalShares : null as any;
        data["netInvestment"] = this.netInvestment !== undefined ? this.netInvestment : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        return data;
    }

    clone(): InvestmentTransactionSummaryDto {
        const json = this.toJSON();
        let result = new InvestmentTransactionSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IInvestmentTransactionSummaryDto {
    control: boolean;
    ownershipPct: number;
    sharesHeld: number;
    totalShares: number;
    netInvestment: number;
    currency?: string | null;
}

export class InvestmentTransactionRowDto implements IInvestmentTransactionRowDto {
    acquisitionId!: number;
    transactionTypeId?: number | null;
    transactionType?: string | null;
    description?: string | null;
    transactionDate?: Date | null;
    periodKey?: number | null;
    period?: string | null;
    shareType?: string | null;
    amount?: number | null;
    control!: boolean;
    numberOfShares?: number | null;
    totalShares?: number | null;
    percentageChange?: number | null;
    totalPercentage!: number;
    averagePrice?: number | null;
    isPeriodOpen!: boolean;
    drawer!: InvestmentTransactionDrawerDto;

    constructor(data?: IInvestmentTransactionRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.drawer = new InvestmentTransactionDrawerDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.acquisitionId = data["acquisitionId"] !== undefined ? data["acquisitionId"] : null as any;
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null as any;
            this.transactionType = data["transactionType"] !== undefined ? data["transactionType"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.transactionDate = data["transactionDate"] ? new Date(data["transactionDate"].toString()) : null as any;
            this.periodKey = data["periodKey"] !== undefined ? data["periodKey"] : null as any;
            this.period = data["period"] !== undefined ? data["period"] : null as any;
            this.shareType = data["shareType"] !== undefined ? data["shareType"] : null as any;
            this.amount = data["amount"] !== undefined ? data["amount"] : null as any;
            this.control = data["control"] !== undefined ? data["control"] : null as any;
            this.numberOfShares = data["numberOfShares"] !== undefined ? data["numberOfShares"] : null as any;
            this.totalShares = data["totalShares"] !== undefined ? data["totalShares"] : null as any;
            this.percentageChange = data["percentageChange"] !== undefined ? data["percentageChange"] : null as any;
            this.totalPercentage = data["totalPercentage"] !== undefined ? data["totalPercentage"] : null as any;
            this.averagePrice = data["averagePrice"] !== undefined ? data["averagePrice"] : null as any;
            this.isPeriodOpen = data["isPeriodOpen"] !== undefined ? data["isPeriodOpen"] : null as any;
            this.drawer = data["drawer"] ? InvestmentTransactionDrawerDto.fromJS(data["drawer"]) : new InvestmentTransactionDrawerDto();
        }
    }

    static fromJS(data: any): InvestmentTransactionRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentTransactionRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acquisitionId"] = this.acquisitionId !== undefined ? this.acquisitionId : null as any;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null as any;
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : null as any;
        data["periodKey"] = this.periodKey !== undefined ? this.periodKey : null as any;
        data["period"] = this.period !== undefined ? this.period : null as any;
        data["shareType"] = this.shareType !== undefined ? this.shareType : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["control"] = this.control !== undefined ? this.control : null as any;
        data["numberOfShares"] = this.numberOfShares !== undefined ? this.numberOfShares : null as any;
        data["totalShares"] = this.totalShares !== undefined ? this.totalShares : null as any;
        data["percentageChange"] = this.percentageChange !== undefined ? this.percentageChange : null as any;
        data["totalPercentage"] = this.totalPercentage !== undefined ? this.totalPercentage : null as any;
        data["averagePrice"] = this.averagePrice !== undefined ? this.averagePrice : null as any;
        data["isPeriodOpen"] = this.isPeriodOpen !== undefined ? this.isPeriodOpen : null as any;
        data["drawer"] = this.drawer ? this.drawer.toJSON() : null as any;
        return data;
    }

    clone(): InvestmentTransactionRowDto {
        const json = this.toJSON();
        let result = new InvestmentTransactionRowDto();
        result.init(json);
        return result;
    }
}

export interface IInvestmentTransactionRowDto {
    acquisitionId: number;
    transactionTypeId?: number | null;
    transactionType?: string | null;
    description?: string | null;
    transactionDate?: Date | null;
    periodKey?: number | null;
    period?: string | null;
    shareType?: string | null;
    amount?: number | null;
    control: boolean;
    numberOfShares?: number | null;
    totalShares?: number | null;
    percentageChange?: number | null;
    totalPercentage: number;
    averagePrice?: number | null;
    isPeriodOpen: boolean;
    drawer: InvestmentTransactionDrawerDto;
}

export class InvestmentTransactionDrawerDto implements IInvestmentTransactionDrawerDto {
    investeeCurrency?: string | null;
    localAmount?: number | null;
    fxRate?: number | null;

    constructor(data?: IInvestmentTransactionDrawerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.investeeCurrency = data["investeeCurrency"] !== undefined ? data["investeeCurrency"] : null as any;
            this.localAmount = data["localAmount"] !== undefined ? data["localAmount"] : null as any;
            this.fxRate = data["fxRate"] !== undefined ? data["fxRate"] : null as any;
        }
    }

    static fromJS(data: any): InvestmentTransactionDrawerDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentTransactionDrawerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investeeCurrency"] = this.investeeCurrency !== undefined ? this.investeeCurrency : null as any;
        data["localAmount"] = this.localAmount !== undefined ? this.localAmount : null as any;
        data["fxRate"] = this.fxRate !== undefined ? this.fxRate : null as any;
        return data;
    }

    clone(): InvestmentTransactionDrawerDto {
        const json = this.toJSON();
        let result = new InvestmentTransactionDrawerDto();
        result.init(json);
        return result;
    }
}

export interface IInvestmentTransactionDrawerDto {
    investeeCurrency?: string | null;
    localAmount?: number | null;
    fxRate?: number | null;
}

export class JournalDefinition implements IJournalDefinition {
    id!: number;
    name?: string | null;
    model?: string | null;
    dimensions?: JournalDimension[] | null;
    incomplete!: boolean;
    missingDims?: string[] | null;

    constructor(data?: IJournalDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.model = data["model"] !== undefined ? data["model"] : null as any;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(JournalDimension.fromJS(data["dimensions"][item]));
            }
            else {
                this.dimensions = null as any;
            }
            this.incomplete = data["incomplete"] !== undefined ? data["incomplete"] : null as any;
            if (Array.isArray(data["missingDims"])) {
                this.missingDims = [] as any;
                for (let item in data["missingDims"])
                    this.missingDims!.push(data["missingDims"][item]);
            }
            else {
                this.missingDims = null as any;
            }
        }
    }

    static fromJS(data: any): JournalDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["model"] = this.model !== undefined ? this.model : null as any;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item] ? this.dimensions[item].toJSON() : null as any);
        }
        data["incomplete"] = this.incomplete !== undefined ? this.incomplete : null as any;
        if (Array.isArray(this.missingDims)) {
            data["missingDims"] = [];
            for (let item in this.missingDims)
                data["missingDims"].push(this.missingDims[item]);
        }
        return data;
    }

    clone(): JournalDefinition {
        const json = this.toJSON();
        let result = new JournalDefinition();
        result.init(json);
        return result;
    }
}

export interface IJournalDefinition {
    id: number;
    name?: string | null;
    model?: string | null;
    dimensions?: JournalDimension[] | null;
    incomplete: boolean;
    missingDims?: string[] | null;
}

export class JournalDimension implements IJournalDimension {
    id!: number;
    dimensionName?: string | null;
    isTimeDimension!: boolean;
    isAccountDimension!: boolean;
    isHeader!: boolean;
    isHidden!: boolean;
    isDetail!: boolean;
    isInitialQuery!: boolean;
    defaultValue?: string | null;
    defaultQueryValue?: string | null;
    constantValue?: string | null;
    atributeFilter?: string | null;
    descendentsFilter?: string | null;
    isMultiSelect!: boolean;
    timeBasedHierarchy!: boolean;
    nonLeafDataMembers!: boolean;
    role?: string | null;

    constructor(data?: IJournalDimension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.isTimeDimension = data["isTimeDimension"] !== undefined ? data["isTimeDimension"] : null as any;
            this.isAccountDimension = data["isAccountDimension"] !== undefined ? data["isAccountDimension"] : null as any;
            this.isHeader = data["isHeader"] !== undefined ? data["isHeader"] : null as any;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : null as any;
            this.isDetail = data["isDetail"] !== undefined ? data["isDetail"] : null as any;
            this.isInitialQuery = data["isInitialQuery"] !== undefined ? data["isInitialQuery"] : null as any;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : null as any;
            this.defaultQueryValue = data["defaultQueryValue"] !== undefined ? data["defaultQueryValue"] : null as any;
            this.constantValue = data["constantValue"] !== undefined ? data["constantValue"] : null as any;
            this.atributeFilter = data["atributeFilter"] !== undefined ? data["atributeFilter"] : null as any;
            this.descendentsFilter = data["descendentsFilter"] !== undefined ? data["descendentsFilter"] : null as any;
            this.isMultiSelect = data["isMultiSelect"] !== undefined ? data["isMultiSelect"] : null as any;
            this.timeBasedHierarchy = data["timeBasedHierarchy"] !== undefined ? data["timeBasedHierarchy"] : null as any;
            this.nonLeafDataMembers = data["nonLeafDataMembers"] !== undefined ? data["nonLeafDataMembers"] : null as any;
            this.role = data["role"] !== undefined ? data["role"] : null as any;
        }
    }

    static fromJS(data: any): JournalDimension {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDimension();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["isTimeDimension"] = this.isTimeDimension !== undefined ? this.isTimeDimension : null as any;
        data["isAccountDimension"] = this.isAccountDimension !== undefined ? this.isAccountDimension : null as any;
        data["isHeader"] = this.isHeader !== undefined ? this.isHeader : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["isDetail"] = this.isDetail !== undefined ? this.isDetail : null as any;
        data["isInitialQuery"] = this.isInitialQuery !== undefined ? this.isInitialQuery : null as any;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : null as any;
        data["defaultQueryValue"] = this.defaultQueryValue !== undefined ? this.defaultQueryValue : null as any;
        data["constantValue"] = this.constantValue !== undefined ? this.constantValue : null as any;
        data["atributeFilter"] = this.atributeFilter !== undefined ? this.atributeFilter : null as any;
        data["descendentsFilter"] = this.descendentsFilter !== undefined ? this.descendentsFilter : null as any;
        data["isMultiSelect"] = this.isMultiSelect !== undefined ? this.isMultiSelect : null as any;
        data["timeBasedHierarchy"] = this.timeBasedHierarchy !== undefined ? this.timeBasedHierarchy : null as any;
        data["nonLeafDataMembers"] = this.nonLeafDataMembers !== undefined ? this.nonLeafDataMembers : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }

    clone(): JournalDimension {
        const json = this.toJSON();
        let result = new JournalDimension();
        result.init(json);
        return result;
    }
}

export interface IJournalDimension {
    id: number;
    dimensionName?: string | null;
    isTimeDimension: boolean;
    isAccountDimension: boolean;
    isHeader: boolean;
    isHidden: boolean;
    isDetail: boolean;
    isInitialQuery: boolean;
    defaultValue?: string | null;
    defaultQueryValue?: string | null;
    constantValue?: string | null;
    atributeFilter?: string | null;
    descendentsFilter?: string | null;
    isMultiSelect: boolean;
    timeBasedHierarchy: boolean;
    nonLeafDataMembers: boolean;
    role?: string | null;
}

export class JournalHeader implements IJournalHeader {
    id!: number;
    groupId!: number;
    sourceJeId?: number | null;
    readOnly?: boolean | null;
    name?: string | null;
    description?: string | null;
    recurringFromKey?: string | null;
    recurringToKey?: string | null;
    status!: JournalHeaderStatus;
    validationWarnings?: number | null;
    validationErrors?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachmentInfo[] | null;
    headerIdKeyMap?: { [key: string]: any; }[] | null;

    constructor(data?: IJournalHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.groupId = data["groupId"] !== undefined ? data["groupId"] : null as any;
            this.sourceJeId = data["sourceJeId"] !== undefined ? data["sourceJeId"] : null as any;
            this.readOnly = data["readOnly"] !== undefined ? data["readOnly"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.recurringFromKey = data["recurringFromKey"] !== undefined ? data["recurringFromKey"] : null as any;
            this.recurringToKey = data["recurringToKey"] !== undefined ? data["recurringToKey"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.validationWarnings = data["validationWarnings"] !== undefined ? data["validationWarnings"] : null as any;
            this.validationErrors = data["validationErrors"] !== undefined ? data["validationErrors"] : null as any;
            if (Array.isArray(data["dimensionValues"])) {
                this.dimensionValues = [] as any;
                for (let item in data["dimensionValues"])
                    this.dimensionValues!.push(JournalFilter.fromJS(data["dimensionValues"][item]));
            }
            else {
                this.dimensionValues = null as any;
            }
            if (Array.isArray(data["attachments"])) {
                this.attachments = [] as any;
                for (let item in data["attachments"])
                    this.attachments!.push(JournalAttachmentInfo.fromJS(data["attachments"][item]));
            }
            else {
                this.attachments = null as any;
            }
            if (Array.isArray(data["headerIdKeyMap"])) {
                this.headerIdKeyMap = [] as any;
                for (let item in data["headerIdKeyMap"])
                    this.headerIdKeyMap!.push(data["headerIdKeyMap"][item]);
            }
            else {
                this.headerIdKeyMap = null as any;
            }
        }
    }

    static fromJS(data: any): JournalHeader {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["sourceJeId"] = this.sourceJeId !== undefined ? this.sourceJeId : null as any;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["recurringFromKey"] = this.recurringFromKey !== undefined ? this.recurringFromKey : null as any;
        data["recurringToKey"] = this.recurringToKey !== undefined ? this.recurringToKey : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["validationWarnings"] = this.validationWarnings !== undefined ? this.validationWarnings : null as any;
        data["validationErrors"] = this.validationErrors !== undefined ? this.validationErrors : null as any;
        if (Array.isArray(this.dimensionValues)) {
            data["dimensionValues"] = [];
            for (let item in this.dimensionValues)
                data["dimensionValues"].push(this.dimensionValues[item] ? this.dimensionValues[item].toJSON() : null as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item in this.attachments)
                data["attachments"].push(this.attachments[item] ? this.attachments[item].toJSON() : null as any);
        }
        if (Array.isArray(this.headerIdKeyMap)) {
            data["headerIdKeyMap"] = [];
            for (let item in this.headerIdKeyMap)
                data["headerIdKeyMap"].push(this.headerIdKeyMap[item]);
        }
        return data;
    }

    clone(): JournalHeader {
        const json = this.toJSON();
        let result = new JournalHeader();
        result.init(json);
        return result;
    }
}

export interface IJournalHeader {
    id: number;
    groupId: number;
    sourceJeId?: number | null;
    readOnly?: boolean | null;
    name?: string | null;
    description?: string | null;
    recurringFromKey?: string | null;
    recurringToKey?: string | null;
    status: JournalHeaderStatus;
    validationWarnings?: number | null;
    validationErrors?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachmentInfo[] | null;
    headerIdKeyMap?: { [key: string]: any; }[] | null;
}

export class JournalHeaderSecure extends JournalHeader implements IJournalHeaderSecure {
    accessType!: JournalHeaderAccess;

    constructor(data?: IJournalHeaderSecure) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.accessType = data["accessType"] !== undefined ? data["accessType"] : null as any;
        }
    }

    static override fromJS(data: any): JournalHeaderSecure {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeaderSecure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessType"] = this.accessType !== undefined ? this.accessType : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): JournalHeaderSecure {
        const json = this.toJSON();
        let result = new JournalHeaderSecure();
        result.init(json);
        return result;
    }
}

export interface IJournalHeaderSecure extends IJournalHeader {
    accessType: JournalHeaderAccess;
}

export enum JournalHeaderAccess {
    Read = 0,
    Write = 1,
}

export enum JournalHeaderStatus {
    New = 0,
    Posted = 1,
}

export class JournalFilter implements IJournalFilter {
    dimensionName?: string | null;
    dimensionMemberKey?: string | null;
    role?: string | null;

    constructor(data?: IJournalFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.dimensionMemberKey = data["dimensionMemberKey"] !== undefined ? data["dimensionMemberKey"] : null as any;
            this.role = data["role"] !== undefined ? data["role"] : null as any;
        }
    }

    static fromJS(data: any): JournalFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JournalFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["dimensionMemberKey"] = this.dimensionMemberKey !== undefined ? this.dimensionMemberKey : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }

    clone(): JournalFilter {
        const json = this.toJSON();
        let result = new JournalFilter();
        result.init(json);
        return result;
    }
}

export interface IJournalFilter {
    dimensionName?: string | null;
    dimensionMemberKey?: string | null;
    role?: string | null;
}

export class JournalAttachmentInfo implements IJournalAttachmentInfo {
    id!: number;
    createdBy?: string | null;
    createdOn!: Date;
    description?: string | null;
    name?: string | null;
    url?: string | null;

    constructor(data?: IJournalAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.createdBy = data["createdBy"] !== undefined ? data["createdBy"] : null as any;
            this.createdOn = data["createdOn"] ? new Date(data["createdOn"].toString()) : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.url = data["url"] !== undefined ? data["url"] : null as any;
        }
    }

    static fromJS(data: any): JournalAttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        return data;
    }

    clone(): JournalAttachmentInfo {
        const json = this.toJSON();
        let result = new JournalAttachmentInfo();
        result.init(json);
        return result;
    }
}

export interface IJournalAttachmentInfo {
    id: number;
    createdBy?: string | null;
    createdOn: Date;
    description?: string | null;
    name?: string | null;
    url?: string | null;
}

export class JournalDetail implements IJournalDetail {
    id!: number;
    header_Id!: number;
    readOnly?: boolean | null;
    isGenerated?: boolean | null;
    debit?: number | null;
    credit?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachment[] | null;

    constructor(data?: IJournalDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.header_Id = data["header_Id"] !== undefined ? data["header_Id"] : null as any;
            this.readOnly = data["readOnly"] !== undefined ? data["readOnly"] : null as any;
            this.isGenerated = data["isGenerated"] !== undefined ? data["isGenerated"] : null as any;
            this.debit = data["debit"] !== undefined ? data["debit"] : null as any;
            this.credit = data["credit"] !== undefined ? data["credit"] : null as any;
            if (Array.isArray(data["dimensionValues"])) {
                this.dimensionValues = [] as any;
                for (let item in data["dimensionValues"])
                    this.dimensionValues!.push(JournalFilter.fromJS(data["dimensionValues"][item]));
            }
            else {
                this.dimensionValues = null as any;
            }
            if (Array.isArray(data["attachments"])) {
                this.attachments = [] as any;
                for (let item in data["attachments"])
                    this.attachments!.push(JournalAttachment.fromJS(data["attachments"][item]));
            }
            else {
                this.attachments = null as any;
            }
        }
    }

    static fromJS(data: any): JournalDetail {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["header_Id"] = this.header_Id !== undefined ? this.header_Id : null as any;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : null as any;
        data["isGenerated"] = this.isGenerated !== undefined ? this.isGenerated : null as any;
        data["debit"] = this.debit !== undefined ? this.debit : null as any;
        data["credit"] = this.credit !== undefined ? this.credit : null as any;
        if (Array.isArray(this.dimensionValues)) {
            data["dimensionValues"] = [];
            for (let item in this.dimensionValues)
                data["dimensionValues"].push(this.dimensionValues[item] ? this.dimensionValues[item].toJSON() : null as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item in this.attachments)
                data["attachments"].push(this.attachments[item] ? this.attachments[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): JournalDetail {
        const json = this.toJSON();
        let result = new JournalDetail();
        result.init(json);
        return result;
    }
}

export interface IJournalDetail {
    id: number;
    header_Id: number;
    readOnly?: boolean | null;
    isGenerated?: boolean | null;
    debit?: number | null;
    credit?: number | null;
    dimensionValues?: JournalFilter[] | null;
    attachments?: JournalAttachment[] | null;
}

export class JournalAttachment extends JournalAttachmentInfo implements IJournalAttachment {
    binaryContent?: string | null;

    constructor(data?: IJournalAttachment) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.binaryContent = data["binaryContent"] !== undefined ? data["binaryContent"] : null as any;
        }
    }

    static override fromJS(data: any): JournalAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAttachment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["binaryContent"] = this.binaryContent !== undefined ? this.binaryContent : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): JournalAttachment {
        const json = this.toJSON();
        let result = new JournalAttachment();
        result.init(json);
        return result;
    }
}

export interface IJournalAttachment extends IJournalAttachmentInfo {
    binaryContent?: string | null;
}

export class JournalHeaderWithDetails extends JournalHeader implements IJournalHeaderWithDetails {
    details?: JournalDetail[] | null;

    constructor(data?: IJournalHeaderWithDetails) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(JournalDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static override fromJS(data: any): JournalHeaderWithDetails {
        data = typeof data === 'object' ? data : {};
        let result = new JournalHeaderWithDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item] ? this.details[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): JournalHeaderWithDetails {
        const json = this.toJSON();
        let result = new JournalHeaderWithDetails();
        result.init(json);
        return result;
    }
}

export interface IJournalHeaderWithDetails extends IJournalHeader {
    details?: JournalDetail[] | null;
}

export class SaveJournalDataModel implements ISaveJournalDataModel {
    deleteHeaders?: JournalHeader[] | null;
    upsertHeaders?: JournalHeaderWithDetails[] | null;

    constructor(data?: ISaveJournalDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["deleteHeaders"])) {
                this.deleteHeaders = [] as any;
                for (let item in data["deleteHeaders"])
                    this.deleteHeaders!.push(JournalHeader.fromJS(data["deleteHeaders"][item]));
            }
            else {
                this.deleteHeaders = null as any;
            }
            if (Array.isArray(data["upsertHeaders"])) {
                this.upsertHeaders = [] as any;
                for (let item in data["upsertHeaders"])
                    this.upsertHeaders!.push(JournalHeaderWithDetails.fromJS(data["upsertHeaders"][item]));
            }
            else {
                this.upsertHeaders = null as any;
            }
        }
    }

    static fromJS(data: any): SaveJournalDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveJournalDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deleteHeaders)) {
            data["deleteHeaders"] = [];
            for (let item in this.deleteHeaders)
                data["deleteHeaders"].push(this.deleteHeaders[item] ? this.deleteHeaders[item].toJSON() : null as any);
        }
        if (Array.isArray(this.upsertHeaders)) {
            data["upsertHeaders"] = [];
            for (let item in this.upsertHeaders)
                data["upsertHeaders"].push(this.upsertHeaders[item] ? this.upsertHeaders[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): SaveJournalDataModel {
        const json = this.toJSON();
        let result = new SaveJournalDataModel();
        result.init(json);
        return result;
    }
}

export interface ISaveJournalDataModel {
    deleteHeaders?: JournalHeader[] | null;
    upsertHeaders?: JournalHeaderWithDetails[] | null;
}

export class JournalDimensionAuthorizedKeys implements IJournalDimensionAuthorizedKeys {
    dimensionName?: string | null;
    authorizedReadKeys?: number[] | null;
    authorizedWriteKeys?: number[] | null;

    constructor(data?: IJournalDimensionAuthorizedKeys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            if (Array.isArray(data["authorizedReadKeys"])) {
                this.authorizedReadKeys = [] as any;
                for (let item in data["authorizedReadKeys"])
                    this.authorizedReadKeys!.push(data["authorizedReadKeys"][item]);
            }
            else {
                this.authorizedReadKeys = null as any;
            }
            if (Array.isArray(data["authorizedWriteKeys"])) {
                this.authorizedWriteKeys = [] as any;
                for (let item in data["authorizedWriteKeys"])
                    this.authorizedWriteKeys!.push(data["authorizedWriteKeys"][item]);
            }
            else {
                this.authorizedWriteKeys = null as any;
            }
        }
    }

    static fromJS(data: any): JournalDimensionAuthorizedKeys {
        data = typeof data === 'object' ? data : {};
        let result = new JournalDimensionAuthorizedKeys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        if (Array.isArray(this.authorizedReadKeys)) {
            data["authorizedReadKeys"] = [];
            for (let item in this.authorizedReadKeys)
                data["authorizedReadKeys"].push(this.authorizedReadKeys[item]);
        }
        if (Array.isArray(this.authorizedWriteKeys)) {
            data["authorizedWriteKeys"] = [];
            for (let item in this.authorizedWriteKeys)
                data["authorizedWriteKeys"].push(this.authorizedWriteKeys[item]);
        }
        return data;
    }

    clone(): JournalDimensionAuthorizedKeys {
        const json = this.toJSON();
        let result = new JournalDimensionAuthorizedKeys();
        result.init(json);
        return result;
    }
}

export interface IJournalDimensionAuthorizedKeys {
    dimensionName?: string | null;
    authorizedReadKeys?: number[] | null;
    authorizedWriteKeys?: number[] | null;
}

export class JournalAuditLogInfo implements IJournalAuditLogInfo {
    audit_ID!: number;
    jE_ID!: number;
    recurring_ID!: number;
    dimensions?: { [key: string]: string[]; } | null;
    description?: string | null;
    jE_Tag?: string | null;
    status?: string | null;
    creation_Date?: string | null;
    creation_User?: string | null;
    modified_Date?: string | null;
    modified_User?: string | null;
    unposting_Date?: string | null;
    unposting_User?: string | null;
    posting_Date?: string | null;
    posting_User?: string | null;

    constructor(data?: IJournalAuditLogInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.audit_ID = data["audit_ID"] !== undefined ? data["audit_ID"] : null as any;
            this.jE_ID = data["jE_ID"] !== undefined ? data["jE_ID"] : null as any;
            this.recurring_ID = data["recurring_ID"] !== undefined ? data["recurring_ID"] : null as any;
            if (data["dimensions"]) {
                this.dimensions = {} as any;
                for (let key in data["dimensions"]) {
                    if (data["dimensions"].hasOwnProperty(key))
                        (this.dimensions as any)![key] = data["dimensions"][key] !== undefined ? data["dimensions"][key] : [];
                }
            }
            else {
                this.dimensions = null as any;
            }
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.jE_Tag = data["jE_Tag"] !== undefined ? data["jE_Tag"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.creation_Date = data["creation_Date"] !== undefined ? data["creation_Date"] : null as any;
            this.creation_User = data["creation_User"] !== undefined ? data["creation_User"] : null as any;
            this.modified_Date = data["modified_Date"] !== undefined ? data["modified_Date"] : null as any;
            this.modified_User = data["modified_User"] !== undefined ? data["modified_User"] : null as any;
            this.unposting_Date = data["unposting_Date"] !== undefined ? data["unposting_Date"] : null as any;
            this.unposting_User = data["unposting_User"] !== undefined ? data["unposting_User"] : null as any;
            this.posting_Date = data["posting_Date"] !== undefined ? data["posting_Date"] : null as any;
            this.posting_User = data["posting_User"] !== undefined ? data["posting_User"] : null as any;
        }
    }

    static fromJS(data: any): JournalAuditLogInfo {
        data = typeof data === 'object' ? data : {};
        let result = new JournalAuditLogInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["audit_ID"] = this.audit_ID !== undefined ? this.audit_ID : null as any;
        data["jE_ID"] = this.jE_ID !== undefined ? this.jE_ID : null as any;
        data["recurring_ID"] = this.recurring_ID !== undefined ? this.recurring_ID : null as any;
        if (this.dimensions) {
            data["dimensions"] = {};
            for (let key in this.dimensions) {
                if (this.dimensions.hasOwnProperty(key))
                    (data["dimensions"] as any)[key] = this.dimensions[key] !== undefined ? this.dimensions[key] : null as any;
            }
        }
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["jE_Tag"] = this.jE_Tag !== undefined ? this.jE_Tag : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["creation_Date"] = this.creation_Date !== undefined ? this.creation_Date : null as any;
        data["creation_User"] = this.creation_User !== undefined ? this.creation_User : null as any;
        data["modified_Date"] = this.modified_Date !== undefined ? this.modified_Date : null as any;
        data["modified_User"] = this.modified_User !== undefined ? this.modified_User : null as any;
        data["unposting_Date"] = this.unposting_Date !== undefined ? this.unposting_Date : null as any;
        data["unposting_User"] = this.unposting_User !== undefined ? this.unposting_User : null as any;
        data["posting_Date"] = this.posting_Date !== undefined ? this.posting_Date : null as any;
        data["posting_User"] = this.posting_User !== undefined ? this.posting_User : null as any;
        return data;
    }

    clone(): JournalAuditLogInfo {
        const json = this.toJSON();
        let result = new JournalAuditLogInfo();
        result.init(json);
        return result;
    }
}

export interface IJournalAuditLogInfo {
    audit_ID: number;
    jE_ID: number;
    recurring_ID: number;
    dimensions?: { [key: string]: string[]; } | null;
    description?: string | null;
    jE_Tag?: string | null;
    status?: string | null;
    creation_Date?: string | null;
    creation_User?: string | null;
    modified_Date?: string | null;
    modified_User?: string | null;
    unposting_Date?: string | null;
    unposting_User?: string | null;
    posting_Date?: string | null;
    posting_User?: string | null;
}

export class JournalRule implements IJournalRule {
    caption?: string | null;
    amount!: number;
    tolerance!: number;
    isError!: boolean;

    constructor(data?: IJournalRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.amount = data["amount"] !== undefined ? data["amount"] : null as any;
            this.tolerance = data["tolerance"] !== undefined ? data["tolerance"] : null as any;
            this.isError = data["isError"] !== undefined ? data["isError"] : null as any;
        }
    }

    static fromJS(data: any): JournalRule {
        data = typeof data === 'object' ? data : {};
        let result = new JournalRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["tolerance"] = this.tolerance !== undefined ? this.tolerance : null as any;
        data["isError"] = this.isError !== undefined ? this.isError : null as any;
        return data;
    }

    clone(): JournalRule {
        const json = this.toJSON();
        let result = new JournalRule();
        result.init(json);
        return result;
    }
}

export interface IJournalRule {
    caption?: string | null;
    amount: number;
    tolerance: number;
    isError: boolean;
}

export class JournalMovementClasificationValidation implements IJournalMovementClasificationValidation {
    accountDimension?: string | null;
    movementDimension?: string | null;
    validCombinations?: JournalMovementClasificationValidationItem[] | null;

    constructor(data?: IJournalMovementClasificationValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountDimension = data["accountDimension"] !== undefined ? data["accountDimension"] : null as any;
            this.movementDimension = data["movementDimension"] !== undefined ? data["movementDimension"] : null as any;
            if (Array.isArray(data["validCombinations"])) {
                this.validCombinations = [] as any;
                for (let item in data["validCombinations"])
                    this.validCombinations!.push(JournalMovementClasificationValidationItem.fromJS(data["validCombinations"][item]));
            }
            else {
                this.validCombinations = null as any;
            }
        }
    }

    static fromJS(data: any): JournalMovementClasificationValidation {
        data = typeof data === 'object' ? data : {};
        let result = new JournalMovementClasificationValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountDimension"] = this.accountDimension !== undefined ? this.accountDimension : null as any;
        data["movementDimension"] = this.movementDimension !== undefined ? this.movementDimension : null as any;
        if (Array.isArray(this.validCombinations)) {
            data["validCombinations"] = [];
            for (let item in this.validCombinations)
                data["validCombinations"].push(this.validCombinations[item] ? this.validCombinations[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): JournalMovementClasificationValidation {
        const json = this.toJSON();
        let result = new JournalMovementClasificationValidation();
        result.init(json);
        return result;
    }
}

export interface IJournalMovementClasificationValidation {
    accountDimension?: string | null;
    movementDimension?: string | null;
    validCombinations?: JournalMovementClasificationValidationItem[] | null;
}

export class JournalMovementClasificationValidationItem implements IJournalMovementClasificationValidationItem {
    accountKey!: number;
    movementKey!: number;
    accountName?: string | null;
    movementName?: string | null;
    allowInput!: boolean;

    constructor(data?: IJournalMovementClasificationValidationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountKey = data["accountKey"] !== undefined ? data["accountKey"] : null as any;
            this.movementKey = data["movementKey"] !== undefined ? data["movementKey"] : null as any;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : null as any;
            this.movementName = data["movementName"] !== undefined ? data["movementName"] : null as any;
            this.allowInput = data["allowInput"] !== undefined ? data["allowInput"] : null as any;
        }
    }

    static fromJS(data: any): JournalMovementClasificationValidationItem {
        data = typeof data === 'object' ? data : {};
        let result = new JournalMovementClasificationValidationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountKey"] = this.accountKey !== undefined ? this.accountKey : null as any;
        data["movementKey"] = this.movementKey !== undefined ? this.movementKey : null as any;
        data["accountName"] = this.accountName !== undefined ? this.accountName : null as any;
        data["movementName"] = this.movementName !== undefined ? this.movementName : null as any;
        data["allowInput"] = this.allowInput !== undefined ? this.allowInput : null as any;
        return data;
    }

    clone(): JournalMovementClasificationValidationItem {
        const json = this.toJSON();
        let result = new JournalMovementClasificationValidationItem();
        result.init(json);
        return result;
    }
}

export interface IJournalMovementClasificationValidationItem {
    accountKey: number;
    movementKey: number;
    accountName?: string | null;
    movementName?: string | null;
    allowInput: boolean;
}

export class TenantDTO implements ITenantDTO {
    id!: number;
    name?: string | null;
    isALMSource!: boolean;
    isALMTarget!: boolean;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.isALMSource = data["isALMSource"] !== undefined ? data["isALMSource"] : null as any;
            this.isALMTarget = data["isALMTarget"] !== undefined ? data["isALMTarget"] : null as any;
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isALMSource"] = this.isALMSource !== undefined ? this.isALMSource : null as any;
        data["isALMTarget"] = this.isALMTarget !== undefined ? this.isALMTarget : null as any;
        return data;
    }

    clone(): TenantDTO {
        const json = this.toJSON();
        let result = new TenantDTO();
        result.init(json);
        return result;
    }
}

export interface ITenantDTO {
    id: number;
    name?: string | null;
    isALMSource: boolean;
    isALMTarget: boolean;
}

export class ChangeSet implements IChangeSet {
    id!: number;
    name?: string | null;
    description?: string | null;
    sourceTenant?: ChangeSetTenant | null;
    targetTenants?: ChangeSetTenant[] | null;
    createdBy?: string | null;
    createdAt!: Date;
    updatedAt!: Date;
    isDraft!: boolean;
    isDeleted!: boolean;

    constructor(data?: IChangeSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.sourceTenant = data["sourceTenant"] ? ChangeSetTenant.fromJS(data["sourceTenant"]) : null as any;
            if (Array.isArray(data["targetTenants"])) {
                this.targetTenants = [] as any;
                for (let item in data["targetTenants"])
                    this.targetTenants!.push(ChangeSetTenant.fromJS(data["targetTenants"][item]));
            }
            else {
                this.targetTenants = null as any;
            }
            this.createdBy = data["createdBy"] !== undefined ? data["createdBy"] : null as any;
            this.createdAt = data["createdAt"] ? new Date(data["createdAt"].toString()) : null as any;
            this.updatedAt = data["updatedAt"] ? new Date(data["updatedAt"].toString()) : null as any;
            this.isDraft = data["isDraft"] !== undefined ? data["isDraft"] : null as any;
            this.isDeleted = data["isDeleted"] !== undefined ? data["isDeleted"] : null as any;
        }
    }

    static fromJS(data: any): ChangeSet {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["sourceTenant"] = this.sourceTenant ? this.sourceTenant.toJSON() : null as any;
        if (Array.isArray(this.targetTenants)) {
            data["targetTenants"] = [];
            for (let item in this.targetTenants)
                data["targetTenants"].push(this.targetTenants[item] ? this.targetTenants[item].toJSON() : null as any);
        }
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : null as any;
        data["isDraft"] = this.isDraft !== undefined ? this.isDraft : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        return data;
    }

    clone(): ChangeSet {
        const json = this.toJSON();
        let result = new ChangeSet();
        result.init(json);
        return result;
    }
}

export interface IChangeSet {
    id: number;
    name?: string | null;
    description?: string | null;
    sourceTenant?: ChangeSetTenant | null;
    targetTenants?: ChangeSetTenant[] | null;
    createdBy?: string | null;
    createdAt: Date;
    updatedAt: Date;
    isDraft: boolean;
    isDeleted: boolean;
}

export class ChangeSetTenant implements IChangeSetTenant {
    id!: number;
    name?: string | null;

    constructor(data?: IChangeSetTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
        }
    }

    static fromJS(data: any): ChangeSetTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): ChangeSetTenant {
        const json = this.toJSON();
        let result = new ChangeSetTenant();
        result.init(json);
        return result;
    }
}

export interface IChangeSetTenant {
    id: number;
    name?: string | null;
}

export class ChangeSetDTO implements IChangeSetDTO {
    name!: string;
    description?: string | null;
    sourceTenantId!: number;
    targetTenantIds!: number[];
    isDraft!: boolean;

    constructor(data?: IChangeSetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.targetTenantIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.sourceTenantId = data["sourceTenantId"] !== undefined ? data["sourceTenantId"] : null as any;
            if (Array.isArray(data["targetTenantIds"])) {
                this.targetTenantIds = [] as any;
                for (let item in data["targetTenantIds"])
                    this.targetTenantIds!.push(data["targetTenantIds"][item]);
            }
            else {
                this.targetTenantIds = null as any;
            }
            this.isDraft = data["isDraft"] !== undefined ? data["isDraft"] : null as any;
        }
    }

    static fromJS(data: any): ChangeSetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["sourceTenantId"] = this.sourceTenantId !== undefined ? this.sourceTenantId : null as any;
        if (Array.isArray(this.targetTenantIds)) {
            data["targetTenantIds"] = [];
            for (let item in this.targetTenantIds)
                data["targetTenantIds"].push(this.targetTenantIds[item]);
        }
        data["isDraft"] = this.isDraft !== undefined ? this.isDraft : null as any;
        return data;
    }

    clone(): ChangeSetDTO {
        const json = this.toJSON();
        let result = new ChangeSetDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeSetDTO {
    name: string;
    description?: string | null;
    sourceTenantId: number;
    targetTenantIds: number[];
    isDraft: boolean;
}

export class ChangeSetItemDTO implements IChangeSetItemDTO {
    itemType!: string;
    itemId?: number | null;
    itemName?: string | null;

    constructor(data?: IChangeSetItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemType = data["itemType"] !== undefined ? data["itemType"] : null as any;
            this.itemId = data["itemId"] !== undefined ? data["itemId"] : null as any;
            this.itemName = data["itemName"] !== undefined ? data["itemName"] : null as any;
        }
    }

    static fromJS(data: any): ChangeSetItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemType"] = this.itemType !== undefined ? this.itemType : null as any;
        data["itemId"] = this.itemId !== undefined ? this.itemId : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        return data;
    }

    clone(): ChangeSetItemDTO {
        const json = this.toJSON();
        let result = new ChangeSetItemDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeSetItemDTO {
    itemType: string;
    itemId?: number | null;
    itemName?: string | null;
}

export class ChangeSetItem implements IChangeSetItem {
    id!: number;
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;

    constructor(data?: IChangeSetItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.itemType = data["itemType"] !== undefined ? data["itemType"] : null as any;
            this.itemId = data["itemId"] !== undefined ? data["itemId"] : null as any;
            this.itemName = data["itemName"] !== undefined ? data["itemName"] : null as any;
        }
    }

    static fromJS(data: any): ChangeSetItem {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSetItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["itemType"] = this.itemType !== undefined ? this.itemType : null as any;
        data["itemId"] = this.itemId !== undefined ? this.itemId : null as any;
        data["itemName"] = this.itemName !== undefined ? this.itemName : null as any;
        return data;
    }

    clone(): ChangeSetItem {
        const json = this.toJSON();
        let result = new ChangeSetItem();
        result.init(json);
        return result;
    }
}

export interface IChangeSetItem {
    id: number;
    itemType?: string | null;
    itemId?: number | null;
    itemName?: string | null;
}

export class AdminForm implements IAdminForm {
    id!: number;
    name?: string | null;
    displayName?: string | null;
    tableName?: string | null;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    category?: string | null;
    headerId?: number | null;
    isActive?: number | null;
    importExport?: number | null;
    allowImport?: number | null;
    allowExport?: number | null;
    validateName?: number | null;
    querySP?: string | null;
    storedProcedures?: AdminSp[] | null;
    headerWithDetails?: HeaderWithDetails[] | null;

    constructor(data?: IAdminForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null as any;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : null as any;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : null as any;
            this.category = data["category"] !== undefined ? data["category"] : null as any;
            this.headerId = data["headerId"] !== undefined ? data["headerId"] : null as any;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null as any;
            this.importExport = data["importExport"] !== undefined ? data["importExport"] : null as any;
            this.allowImport = data["allowImport"] !== undefined ? data["allowImport"] : null as any;
            this.allowExport = data["allowExport"] !== undefined ? data["allowExport"] : null as any;
            this.validateName = data["validateName"] !== undefined ? data["validateName"] : null as any;
            this.querySP = data["querySP"] !== undefined ? data["querySP"] : null as any;
            if (Array.isArray(data["storedProcedures"])) {
                this.storedProcedures = [] as any;
                for (let item in data["storedProcedures"])
                    this.storedProcedures!.push(AdminSp.fromJS(data["storedProcedures"][item]));
            }
            else {
                this.storedProcedures = null as any;
            }
            if (Array.isArray(data["headerWithDetails"])) {
                this.headerWithDetails = [] as any;
                for (let item in data["headerWithDetails"])
                    this.headerWithDetails!.push(HeaderWithDetails.fromJS(data["headerWithDetails"][item]));
            }
            else {
                this.headerWithDetails = null as any;
            }
        }
    }

    static fromJS(data: any): AdminForm {
        data = typeof data === 'object' ? data : {};
        let result = new AdminForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : null as any;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["headerId"] = this.headerId !== undefined ? this.headerId : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["importExport"] = this.importExport !== undefined ? this.importExport : null as any;
        data["allowImport"] = this.allowImport !== undefined ? this.allowImport : null as any;
        data["allowExport"] = this.allowExport !== undefined ? this.allowExport : null as any;
        data["validateName"] = this.validateName !== undefined ? this.validateName : null as any;
        data["querySP"] = this.querySP !== undefined ? this.querySP : null as any;
        if (Array.isArray(this.storedProcedures)) {
            data["storedProcedures"] = [];
            for (let item in this.storedProcedures)
                data["storedProcedures"].push(this.storedProcedures[item] ? this.storedProcedures[item].toJSON() : null as any);
        }
        if (Array.isArray(this.headerWithDetails)) {
            data["headerWithDetails"] = [];
            for (let item in this.headerWithDetails)
                data["headerWithDetails"].push(this.headerWithDetails[item] ? this.headerWithDetails[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AdminForm {
        const json = this.toJSON();
        let result = new AdminForm();
        result.init(json);
        return result;
    }
}

export interface IAdminForm {
    id: number;
    name?: string | null;
    displayName?: string | null;
    tableName?: string | null;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    category?: string | null;
    headerId?: number | null;
    isActive?: number | null;
    importExport?: number | null;
    allowImport?: number | null;
    allowExport?: number | null;
    validateName?: number | null;
    querySP?: string | null;
    storedProcedures?: AdminSp[] | null;
    headerWithDetails?: HeaderWithDetails[] | null;
}

export class AdminSp implements IAdminSp {
    id!: number;
    displayName?: string | null;
    displayType?: string | null;
    icon?: string | null;
    parametersConfig?: any | null;
    inputParameters?: { [key: string]: any; } | null;

    constructor(data?: IAdminSp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null as any;
            this.displayType = data["displayType"] !== undefined ? data["displayType"] : null as any;
            this.icon = data["icon"] !== undefined ? data["icon"] : null as any;
            this.parametersConfig = data["parametersConfig"] !== undefined ? data["parametersConfig"] : null as any;
            if (data["inputParameters"]) {
                this.inputParameters = {} as any;
                for (let key in data["inputParameters"]) {
                    if (data["inputParameters"].hasOwnProperty(key))
                        (this.inputParameters as any)![key] = data["inputParameters"][key] !== undefined ? data["inputParameters"][key] : null as any;
                }
            }
            else {
                this.inputParameters = null as any;
            }
        }
    }

    static fromJS(data: any): AdminSp {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["displayType"] = this.displayType !== undefined ? this.displayType : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["parametersConfig"] = this.parametersConfig !== undefined ? this.parametersConfig : null as any;
        if (this.inputParameters) {
            data["inputParameters"] = {};
            for (let key in this.inputParameters) {
                if (this.inputParameters.hasOwnProperty(key))
                    (data["inputParameters"] as any)[key] = this.inputParameters[key] !== undefined ? this.inputParameters[key] : null as any;
            }
        }
        return data;
    }

    clone(): AdminSp {
        const json = this.toJSON();
        let result = new AdminSp();
        result.init(json);
        return result;
    }
}

export interface IAdminSp {
    id: number;
    displayName?: string | null;
    displayType?: string | null;
    icon?: string | null;
    parametersConfig?: any | null;
    inputParameters?: { [key: string]: any; } | null;
}

export class Header implements IHeader {
    id!: number;

    constructor(data?: IHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
        }
    }

    static fromJS(data: any): Header {
        data = typeof data === 'object' ? data : {};
        let result = new Header();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): Header {
        const json = this.toJSON();
        let result = new Header();
        result.init(json);
        return result;
    }
}

export interface IHeader {
    id: number;
}

export class HeaderWithDetails extends Header implements IHeaderWithDetails {
    details?: Detail[] | null;

    constructor(data?: IHeaderWithDetails) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(Detail.fromJS(data["details"][item]));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static override fromJS(data: any): HeaderWithDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderWithDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item] ? this.details[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): HeaderWithDetails {
        const json = this.toJSON();
        let result = new HeaderWithDetails();
        result.init(json);
        return result;
    }
}

export interface IHeaderWithDetails extends IHeader {
    details?: Detail[] | null;
}

export class Detail implements IDetail {
    id!: number;
    header_Id!: number;

    constructor(data?: IDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.header_Id = data["header_Id"] !== undefined ? data["header_Id"] : null as any;
        }
    }

    static fromJS(data: any): Detail {
        data = typeof data === 'object' ? data : {};
        let result = new Detail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["header_Id"] = this.header_Id !== undefined ? this.header_Id : null as any;
        return data;
    }

    clone(): Detail {
        const json = this.toJSON();
        let result = new Detail();
        result.init(json);
        return result;
    }
}

export interface IDetail {
    id: number;
    header_Id: number;
}

export class Column implements IColumn {
    formId!: number;
    name?: string | null;
    displayName?: string | null;
    type?: string | null;
    displayType?: string | null;
    dateType?: string | null;
    dimension?: string | null;
    dimensionSpec?: string | null;
    tableName?: string | null;
    displayColumn?: string | null;
    returnColumnPairs?: string | null;
    role?: string | null;
    defaultValue?: string | null;
    isName?: boolean | null;
    isModel?: boolean | null;
    isHidden?: boolean | null;
    isEditable?: boolean | null;
    isRequired?: boolean | null;
    isUniqueConstraint?: boolean | null;
    isActive?: boolean | null;
    isGroupedBy?: boolean | null;
    isParameter?: boolean | null;
    refColID?: number | null;
    refColTableName?: string | null;
    refColPrimaryKey?: string | null;
    paramIsVisible?: boolean | null;
    paramTag?: string | null;
    paramDefaultValue?: string | null;
    sortOrder?: number | null;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.displayType = data["displayType"] !== undefined ? data["displayType"] : null as any;
            this.dateType = data["dateType"] !== undefined ? data["dateType"] : null as any;
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.dimensionSpec = data["dimensionSpec"] !== undefined ? data["dimensionSpec"] : null as any;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            this.displayColumn = data["displayColumn"] !== undefined ? data["displayColumn"] : null as any;
            this.returnColumnPairs = data["returnColumnPairs"] !== undefined ? data["returnColumnPairs"] : null as any;
            this.role = data["role"] !== undefined ? data["role"] : null as any;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : null as any;
            this.isName = data["isName"] !== undefined ? data["isName"] : null as any;
            this.isModel = data["isModel"] !== undefined ? data["isModel"] : null as any;
            this.isHidden = data["isHidden"] !== undefined ? data["isHidden"] : null as any;
            this.isEditable = data["isEditable"] !== undefined ? data["isEditable"] : null as any;
            this.isRequired = data["isRequired"] !== undefined ? data["isRequired"] : null as any;
            this.isUniqueConstraint = data["isUniqueConstraint"] !== undefined ? data["isUniqueConstraint"] : null as any;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : null as any;
            this.isGroupedBy = data["isGroupedBy"] !== undefined ? data["isGroupedBy"] : null as any;
            this.isParameter = data["isParameter"] !== undefined ? data["isParameter"] : null as any;
            this.refColID = data["refColID"] !== undefined ? data["refColID"] : null as any;
            this.refColTableName = data["refColTableName"] !== undefined ? data["refColTableName"] : null as any;
            this.refColPrimaryKey = data["refColPrimaryKey"] !== undefined ? data["refColPrimaryKey"] : null as any;
            this.paramIsVisible = data["paramIsVisible"] !== undefined ? data["paramIsVisible"] : null as any;
            this.paramTag = data["paramTag"] !== undefined ? data["paramTag"] : null as any;
            this.paramDefaultValue = data["paramDefaultValue"] !== undefined ? data["paramDefaultValue"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["displayType"] = this.displayType !== undefined ? this.displayType : null as any;
        data["dateType"] = this.dateType !== undefined ? this.dateType : null as any;
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["dimensionSpec"] = this.dimensionSpec !== undefined ? this.dimensionSpec : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["displayColumn"] = this.displayColumn !== undefined ? this.displayColumn : null as any;
        data["returnColumnPairs"] = this.returnColumnPairs !== undefined ? this.returnColumnPairs : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : null as any;
        data["isName"] = this.isName !== undefined ? this.isName : null as any;
        data["isModel"] = this.isModel !== undefined ? this.isModel : null as any;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : null as any;
        data["isEditable"] = this.isEditable !== undefined ? this.isEditable : null as any;
        data["isRequired"] = this.isRequired !== undefined ? this.isRequired : null as any;
        data["isUniqueConstraint"] = this.isUniqueConstraint !== undefined ? this.isUniqueConstraint : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["isGroupedBy"] = this.isGroupedBy !== undefined ? this.isGroupedBy : null as any;
        data["isParameter"] = this.isParameter !== undefined ? this.isParameter : null as any;
        data["refColID"] = this.refColID !== undefined ? this.refColID : null as any;
        data["refColTableName"] = this.refColTableName !== undefined ? this.refColTableName : null as any;
        data["refColPrimaryKey"] = this.refColPrimaryKey !== undefined ? this.refColPrimaryKey : null as any;
        data["paramIsVisible"] = this.paramIsVisible !== undefined ? this.paramIsVisible : null as any;
        data["paramTag"] = this.paramTag !== undefined ? this.paramTag : null as any;
        data["paramDefaultValue"] = this.paramDefaultValue !== undefined ? this.paramDefaultValue : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }

    clone(): Column {
        const json = this.toJSON();
        let result = new Column();
        result.init(json);
        return result;
    }
}

export interface IColumn {
    formId: number;
    name?: string | null;
    displayName?: string | null;
    type?: string | null;
    displayType?: string | null;
    dateType?: string | null;
    dimension?: string | null;
    dimensionSpec?: string | null;
    tableName?: string | null;
    displayColumn?: string | null;
    returnColumnPairs?: string | null;
    role?: string | null;
    defaultValue?: string | null;
    isName?: boolean | null;
    isModel?: boolean | null;
    isHidden?: boolean | null;
    isEditable?: boolean | null;
    isRequired?: boolean | null;
    isUniqueConstraint?: boolean | null;
    isActive?: boolean | null;
    isGroupedBy?: boolean | null;
    isParameter?: boolean | null;
    refColID?: number | null;
    refColTableName?: string | null;
    refColPrimaryKey?: string | null;
    paramIsVisible?: boolean | null;
    paramTag?: string | null;
    paramDefaultValue?: string | null;
    sortOrder?: number | null;
}

export class AdminFormQueryModel implements IAdminFormQueryModel {
    formId!: number;
    parameters?: { [key: string]: any; } | null;

    constructor(data?: IAdminFormQueryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formId = data["formId"] !== undefined ? data["formId"] : null as any;
            if (data["parameters"]) {
                this.parameters = {} as any;
                for (let key in data["parameters"]) {
                    if (data["parameters"].hasOwnProperty(key))
                        (this.parameters as any)![key] = data["parameters"][key] !== undefined ? data["parameters"][key] : null as any;
                }
            }
            else {
                this.parameters = null as any;
            }
        }
    }

    static fromJS(data: any): AdminFormQueryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormQueryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : null as any;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (data["parameters"] as any)[key] = this.parameters[key] !== undefined ? this.parameters[key] : null as any;
            }
        }
        return data;
    }

    clone(): AdminFormQueryModel {
        const json = this.toJSON();
        let result = new AdminFormQueryModel();
        result.init(json);
        return result;
    }
}

export interface IAdminFormQueryModel {
    formId: number;
    parameters?: { [key: string]: any; } | null;
}

export class AdminFormHeader implements IAdminFormHeader {
    id!: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
    details?: AdminFormDetail[] | null;

    constructor(data?: IAdminFormHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : null as any;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : null as any;
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = data["data"][key] !== undefined ? data["data"][key] : null as any;
                }
            }
            else {
                this.data = null as any;
            }
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(AdminFormDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): AdminFormHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : null as any;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : null as any;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = this.data[key] !== undefined ? this.data[key] : null as any;
            }
        }
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item] ? this.details[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AdminFormHeader {
        const json = this.toJSON();
        let result = new AdminFormHeader();
        result.init(json);
        return result;
    }
}

export interface IAdminFormHeader {
    id: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
    details?: AdminFormDetail[] | null;
}

export class AdminFormDetail implements IAdminFormDetail {
    id!: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;

    constructor(data?: IAdminFormDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.tableColumnRef = data["tableColumnRef"] !== undefined ? data["tableColumnRef"] : null as any;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : null as any;
            if (data["data"]) {
                this.data = {} as any;
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = data["data"][key] !== undefined ? data["data"][key] : null as any;
                }
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): AdminFormDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AdminFormDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tableColumnRef"] = this.tableColumnRef !== undefined ? this.tableColumnRef : null as any;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : null as any;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = this.data[key] !== undefined ? this.data[key] : null as any;
            }
        }
        return data;
    }

    clone(): AdminFormDetail {
        const json = this.toJSON();
        let result = new AdminFormDetail();
        result.init(json);
        return result;
    }
}

export interface IAdminFormDetail {
    id: number;
    tableColumnRef?: string | null;
    tablePrimaryKey?: string | null;
    data?: { [key: string]: any; } | null;
}

export class SaveAdminFormDataModel implements ISaveAdminFormDataModel {
    headerForm?: AdminForm | null;
    detailForm?: AdminForm | null;
    deleteHeaders?: AdminFormHeader[] | null;
    deleteDetails?: AdminFormDetail[] | null;
    upsertHeaders?: AdminFormHeader[] | null;
    afterSaveParameters?: { [key: string]: any; } | null;

    constructor(data?: ISaveAdminFormDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.headerForm = data["headerForm"] ? AdminForm.fromJS(data["headerForm"]) : null as any;
            this.detailForm = data["detailForm"] ? AdminForm.fromJS(data["detailForm"]) : null as any;
            if (Array.isArray(data["deleteHeaders"])) {
                this.deleteHeaders = [] as any;
                for (let item in data["deleteHeaders"])
                    this.deleteHeaders!.push(AdminFormHeader.fromJS(data["deleteHeaders"][item]));
            }
            else {
                this.deleteHeaders = null as any;
            }
            if (Array.isArray(data["deleteDetails"])) {
                this.deleteDetails = [] as any;
                for (let item in data["deleteDetails"])
                    this.deleteDetails!.push(AdminFormDetail.fromJS(data["deleteDetails"][item]));
            }
            else {
                this.deleteDetails = null as any;
            }
            if (Array.isArray(data["upsertHeaders"])) {
                this.upsertHeaders = [] as any;
                for (let item in data["upsertHeaders"])
                    this.upsertHeaders!.push(AdminFormHeader.fromJS(data["upsertHeaders"][item]));
            }
            else {
                this.upsertHeaders = null as any;
            }
            if (data["afterSaveParameters"]) {
                this.afterSaveParameters = {} as any;
                for (let key in data["afterSaveParameters"]) {
                    if (data["afterSaveParameters"].hasOwnProperty(key))
                        (this.afterSaveParameters as any)![key] = data["afterSaveParameters"][key] !== undefined ? data["afterSaveParameters"][key] : null as any;
                }
            }
            else {
                this.afterSaveParameters = null as any;
            }
        }
    }

    static fromJS(data: any): SaveAdminFormDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAdminFormDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerForm"] = this.headerForm ? this.headerForm.toJSON() : null as any;
        data["detailForm"] = this.detailForm ? this.detailForm.toJSON() : null as any;
        if (Array.isArray(this.deleteHeaders)) {
            data["deleteHeaders"] = [];
            for (let item in this.deleteHeaders)
                data["deleteHeaders"].push(this.deleteHeaders[item] ? this.deleteHeaders[item].toJSON() : null as any);
        }
        if (Array.isArray(this.deleteDetails)) {
            data["deleteDetails"] = [];
            for (let item in this.deleteDetails)
                data["deleteDetails"].push(this.deleteDetails[item] ? this.deleteDetails[item].toJSON() : null as any);
        }
        if (Array.isArray(this.upsertHeaders)) {
            data["upsertHeaders"] = [];
            for (let item in this.upsertHeaders)
                data["upsertHeaders"].push(this.upsertHeaders[item] ? this.upsertHeaders[item].toJSON() : null as any);
        }
        if (this.afterSaveParameters) {
            data["afterSaveParameters"] = {};
            for (let key in this.afterSaveParameters) {
                if (this.afterSaveParameters.hasOwnProperty(key))
                    (data["afterSaveParameters"] as any)[key] = this.afterSaveParameters[key] !== undefined ? this.afterSaveParameters[key] : null as any;
            }
        }
        return data;
    }

    clone(): SaveAdminFormDataModel {
        const json = this.toJSON();
        let result = new SaveAdminFormDataModel();
        result.init(json);
        return result;
    }
}

export interface ISaveAdminFormDataModel {
    headerForm?: AdminForm | null;
    detailForm?: AdminForm | null;
    deleteHeaders?: AdminFormHeader[] | null;
    deleteDetails?: AdminFormDetail[] | null;
    upsertHeaders?: AdminFormHeader[] | null;
    afterSaveParameters?: { [key: string]: any; } | null;
}

export class AdminCategory implements IAdminCategory {
    id!: number;
    name?: string | null;
    icon?: string | null;
    displayName?: string | null;
    forms?: AdminForm[] | null;

    constructor(data?: IAdminCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.icon = data["icon"] !== undefined ? data["icon"] : null as any;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null as any;
            if (Array.isArray(data["forms"])) {
                this.forms = [] as any;
                for (let item in data["forms"])
                    this.forms!.push(AdminForm.fromJS(data["forms"][item]));
            }
            else {
                this.forms = null as any;
            }
        }
    }

    static fromJS(data: any): AdminCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item in this.forms)
                data["forms"].push(this.forms[item] ? this.forms[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AdminCategory {
        const json = this.toJSON();
        let result = new AdminCategory();
        result.init(json);
        return result;
    }
}

export interface IAdminCategory {
    id: number;
    name?: string | null;
    icon?: string | null;
    displayName?: string | null;
    forms?: AdminForm[] | null;
}

export class MaintenanceBulkResponse implements IMaintenanceBulkResponse {
    results?: { [key: string]: { [key: string]: any; }[]; } | null;

    constructor(data?: IMaintenanceBulkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["results"]) {
                this.results = {} as any;
                for (let key in data["results"]) {
                    if (data["results"].hasOwnProperty(key))
                        (this.results as any)![key] = data["results"][key] !== undefined ? data["results"][key] : [];
                }
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): MaintenanceBulkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceBulkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.results) {
            data["results"] = {};
            for (let key in this.results) {
                if (this.results.hasOwnProperty(key))
                    (data["results"] as any)[key] = this.results[key] !== undefined ? this.results[key] : null as any;
            }
        }
        return data;
    }

    clone(): MaintenanceBulkResponse {
        const json = this.toJSON();
        let result = new MaintenanceBulkResponse();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceBulkResponse {
    results?: { [key: string]: { [key: string]: any; }[]; } | null;
}

export class MaintenanceBulkRequest implements IMaintenanceBulkRequest {
    requests?: MaintenanceDataRequest[] | null;

    constructor(data?: IMaintenanceBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["requests"])) {
                this.requests = [] as any;
                for (let item in data["requests"])
                    this.requests!.push(MaintenanceDataRequest.fromJS(data["requests"][item]));
            }
            else {
                this.requests = null as any;
            }
        }
    }

    static fromJS(data: any): MaintenanceBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item in this.requests)
                data["requests"].push(this.requests[item] ? this.requests[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MaintenanceBulkRequest {
        const json = this.toJSON();
        let result = new MaintenanceBulkRequest();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceBulkRequest {
    requests?: MaintenanceDataRequest[] | null;
}

export class MaintenanceDataRequest implements IMaintenanceDataRequest {
    requestId?: string | null;
    formId!: number;
    tablePrimaryKey?: string | null;
    type?: string | null;
    matchingValue?: string | null;

    constructor(data?: IMaintenanceDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestId = data["requestId"] !== undefined ? data["requestId"] : null as any;
            this.formId = data["formId"] !== undefined ? data["formId"] : null as any;
            this.tablePrimaryKey = data["tablePrimaryKey"] !== undefined ? data["tablePrimaryKey"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.matchingValue = data["matchingValue"] !== undefined ? data["matchingValue"] : null as any;
        }
    }

    static fromJS(data: any): MaintenanceDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId !== undefined ? this.requestId : null as any;
        data["formId"] = this.formId !== undefined ? this.formId : null as any;
        data["tablePrimaryKey"] = this.tablePrimaryKey !== undefined ? this.tablePrimaryKey : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["matchingValue"] = this.matchingValue !== undefined ? this.matchingValue : null as any;
        return data;
    }

    clone(): MaintenanceDataRequest {
        const json = this.toJSON();
        let result = new MaintenanceDataRequest();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceDataRequest {
    requestId?: string | null;
    formId: number;
    tablePrimaryKey?: string | null;
    type?: string | null;
    matchingValue?: string | null;
}

export class CopyDataResponse implements ICopyDataResponse {
    updated!: number;
    deleted!: number;
    inserted!: number;

    constructor(data?: ICopyDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.updated = data["updated"] !== undefined ? data["updated"] : null as any;
            this.deleted = data["deleted"] !== undefined ? data["deleted"] : null as any;
            this.inserted = data["inserted"] !== undefined ? data["inserted"] : null as any;
        }
    }

    static fromJS(data: any): CopyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated !== undefined ? this.updated : null as any;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null as any;
        data["inserted"] = this.inserted !== undefined ? this.inserted : null as any;
        return data;
    }

    clone(): CopyDataResponse {
        const json = this.toJSON();
        let result = new CopyDataResponse();
        result.init(json);
        return result;
    }
}

export interface ICopyDataResponse {
    updated: number;
    deleted: number;
    inserted: number;
}

export class CopyDataRequest implements ICopyDataRequest {
    user?: string | null;
    model?: string | null;
    json?: string | null;
    clear!: boolean;

    constructor(data?: ICopyDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] !== undefined ? data["user"] : null as any;
            this.model = data["model"] !== undefined ? data["model"] : null as any;
            this.json = data["json"] !== undefined ? data["json"] : null as any;
            this.clear = data["clear"] !== undefined ? data["clear"] : null as any;
        }
    }

    static fromJS(data: any): CopyDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user !== undefined ? this.user : null as any;
        data["model"] = this.model !== undefined ? this.model : null as any;
        data["json"] = this.json !== undefined ? this.json : null as any;
        data["clear"] = this.clear !== undefined ? this.clear : null as any;
        return data;
    }

    clone(): CopyDataRequest {
        const json = this.toJSON();
        let result = new CopyDataRequest();
        result.init(json);
        return result;
    }
}

export interface ICopyDataRequest {
    user?: string | null;
    model?: string | null;
    json?: string | null;
    clear: boolean;
}

export class OpenPeriod implements IOpenPeriod {
    scenario_Key?: any | null;
    date_Key?: any | null;

    constructor(data?: IOpenPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scenario_Key = data["scenario_Key"] !== undefined ? data["scenario_Key"] : null as any;
            this.date_Key = data["date_Key"] !== undefined ? data["date_Key"] : null as any;
        }
    }

    static fromJS(data: any): OpenPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new OpenPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenario_Key"] = this.scenario_Key !== undefined ? this.scenario_Key : null as any;
        data["date_Key"] = this.date_Key !== undefined ? this.date_Key : null as any;
        return data;
    }

    clone(): OpenPeriod {
        const json = this.toJSON();
        let result = new OpenPeriod();
        result.init(json);
        return result;
    }
}

export interface IOpenPeriod {
    scenario_Key?: any | null;
    date_Key?: any | null;
}

export class OwnershipTreeNodeDto implements IOwnershipTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    groupInfo?: OwnershipGroupInfoDto | null;
    directInfo?: OwnershipDirectInfoDto | null;
    subsidiaries?: OwnershipTreeNodeDto[] | null;

    constructor(data?: IOwnershipTreeNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"] !== undefined ? data["entity"] : null as any;
            this.entityCaption = data["entityCaption"] !== undefined ? data["entityCaption"] : null as any;
            this.groupInfo = data["groupInfo"] ? OwnershipGroupInfoDto.fromJS(data["groupInfo"]) : null as any;
            this.directInfo = data["directInfo"] ? OwnershipDirectInfoDto.fromJS(data["directInfo"]) : null as any;
            if (Array.isArray(data["subsidiaries"])) {
                this.subsidiaries = [] as any;
                for (let item in data["subsidiaries"])
                    this.subsidiaries!.push(OwnershipTreeNodeDto.fromJS(data["subsidiaries"][item]));
            }
            else {
                this.subsidiaries = null as any;
            }
        }
    }

    static fromJS(data: any): OwnershipTreeNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipTreeNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity !== undefined ? this.entity : null as any;
        data["entityCaption"] = this.entityCaption !== undefined ? this.entityCaption : null as any;
        data["groupInfo"] = this.groupInfo ? this.groupInfo.toJSON() : null as any;
        data["directInfo"] = this.directInfo ? this.directInfo.toJSON() : null as any;
        if (Array.isArray(this.subsidiaries)) {
            data["subsidiaries"] = [];
            for (let item in this.subsidiaries)
                data["subsidiaries"].push(this.subsidiaries[item] ? this.subsidiaries[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): OwnershipTreeNodeDto {
        const json = this.toJSON();
        let result = new OwnershipTreeNodeDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipTreeNodeDto {
    entity?: string | null;
    entityCaption?: string | null;
    groupInfo?: OwnershipGroupInfoDto | null;
    directInfo?: OwnershipDirectInfoDto | null;
    subsidiaries?: OwnershipTreeNodeDto[] | null;
}

export class OwnershipGroupInfoDto implements IOwnershipGroupInfoDto {
    group?: string | null;
    scenario?: string | null;
    method?: string | null;
    groupPercentage?: number | null;
    controlPercentage?: number | null;
    minorityPercentage?: number | null;
    groupDateRange?: DateMemberRangeDto | null;

    constructor(data?: IOwnershipGroupInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.group = data["group"] !== undefined ? data["group"] : null as any;
            this.scenario = data["scenario"] !== undefined ? data["scenario"] : null as any;
            this.method = data["method"] !== undefined ? data["method"] : null as any;
            this.groupPercentage = data["groupPercentage"] !== undefined ? data["groupPercentage"] : null as any;
            this.controlPercentage = data["controlPercentage"] !== undefined ? data["controlPercentage"] : null as any;
            this.minorityPercentage = data["minorityPercentage"] !== undefined ? data["minorityPercentage"] : null as any;
            this.groupDateRange = data["groupDateRange"] ? DateMemberRangeDto.fromJS(data["groupDateRange"]) : null as any;
        }
    }

    static fromJS(data: any): OwnershipGroupInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipGroupInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group !== undefined ? this.group : null as any;
        data["scenario"] = this.scenario !== undefined ? this.scenario : null as any;
        data["method"] = this.method !== undefined ? this.method : null as any;
        data["groupPercentage"] = this.groupPercentage !== undefined ? this.groupPercentage : null as any;
        data["controlPercentage"] = this.controlPercentage !== undefined ? this.controlPercentage : null as any;
        data["minorityPercentage"] = this.minorityPercentage !== undefined ? this.minorityPercentage : null as any;
        data["groupDateRange"] = this.groupDateRange ? this.groupDateRange.toJSON() : null as any;
        return data;
    }

    clone(): OwnershipGroupInfoDto {
        const json = this.toJSON();
        let result = new OwnershipGroupInfoDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipGroupInfoDto {
    group?: string | null;
    scenario?: string | null;
    method?: string | null;
    groupPercentage?: number | null;
    controlPercentage?: number | null;
    minorityPercentage?: number | null;
    groupDateRange?: DateMemberRangeDto | null;
}

export class DateMemberRangeDto implements IDateMemberRangeDto {
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IDateMemberRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : null as any;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : null as any;
        }
    }

    static fromJS(data: any): DateMemberRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateMemberRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toJSON() : null as any;
        data["end"] = this.end ? this.end.toJSON() : null as any;
        return data;
    }

    clone(): DateMemberRangeDto {
        const json = this.toJSON();
        let result = new DateMemberRangeDto();
        result.init(json);
        return result;
    }
}

export interface IDateMemberRangeDto {
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class DateRangeDto implements IDateRangeDto {
    memberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.firstDate = data["firstDate"] ? new Date(data["firstDate"].toString()) : null as any;
            this.lastDate = data["lastDate"] ? new Date(data["lastDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["firstDate"] = this.firstDate ? this.firstDate.toISOString() : null as any;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : null as any;
        return data;
    }

    clone(): DateRangeDto {
        const json = this.toJSON();
        let result = new DateRangeDto();
        result.init(json);
        return result;
    }
}

export interface IDateRangeDto {
    memberName?: string | null;
    firstDate?: Date | null;
    lastDate?: Date | null;
}

export class OwnershipDirectInfoDto implements IOwnershipDirectInfoDto {
    scenario?: string | null;
    directPercentage?: number | null;
    directDateRange?: DateMemberRangeDto | null;

    constructor(data?: IOwnershipDirectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scenario = data["scenario"] !== undefined ? data["scenario"] : null as any;
            this.directPercentage = data["directPercentage"] !== undefined ? data["directPercentage"] : null as any;
            this.directDateRange = data["directDateRange"] ? DateMemberRangeDto.fromJS(data["directDateRange"]) : null as any;
        }
    }

    static fromJS(data: any): OwnershipDirectInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnershipDirectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenario"] = this.scenario !== undefined ? this.scenario : null as any;
        data["directPercentage"] = this.directPercentage !== undefined ? this.directPercentage : null as any;
        data["directDateRange"] = this.directDateRange ? this.directDateRange.toJSON() : null as any;
        return data;
    }

    clone(): OwnershipDirectInfoDto {
        const json = this.toJSON();
        let result = new OwnershipDirectInfoDto();
        result.init(json);
        return result;
    }
}

export interface IOwnershipDirectInfoDto {
    scenario?: string | null;
    directPercentage?: number | null;
    directDateRange?: DateMemberRangeDto | null;
}

export class DirectOwnershipResultDto implements IDirectOwnershipResultDto {
    entityOwnership?: { [key: string]: DirectOwnershipEntryDto[]; } | null;

    constructor(data?: IDirectOwnershipResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["entityOwnership"]) {
                this.entityOwnership = {} as any;
                for (let key in data["entityOwnership"]) {
                    if (data["entityOwnership"].hasOwnProperty(key))
                        (this.entityOwnership as any)![key] = data["entityOwnership"][key] ? data["entityOwnership"][key].map((i: any) => DirectOwnershipEntryDto.fromJS(i)) : [];
                }
            }
            else {
                this.entityOwnership = null as any;
            }
        }
    }

    static fromJS(data: any): DirectOwnershipResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectOwnershipResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entityOwnership) {
            data["entityOwnership"] = {};
            for (let key in this.entityOwnership) {
                if (this.entityOwnership.hasOwnProperty(key))
                    (data["entityOwnership"] as any)[key] = this.entityOwnership[key] !== undefined ? this.entityOwnership[key] : null as any;
            }
        }
        return data;
    }

    clone(): DirectOwnershipResultDto {
        const json = this.toJSON();
        let result = new DirectOwnershipResultDto();
        result.init(json);
        return result;
    }
}

export interface IDirectOwnershipResultDto {
    entityOwnership?: { [key: string]: DirectOwnershipEntryDto[]; } | null;
}

export class DirectOwnershipEntryDto implements IDirectOwnershipEntryDto {
    dataId!: number;
    intercompany?: string | null;
    ownership!: number;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IDirectOwnershipEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataId = data["dataId"] !== undefined ? data["dataId"] : null as any;
            this.intercompany = data["intercompany"] !== undefined ? data["intercompany"] : null as any;
            this.ownership = data["ownership"] !== undefined ? data["ownership"] : null as any;
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : null as any;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : null as any;
        }
    }

    static fromJS(data: any): DirectOwnershipEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectOwnershipEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataId"] = this.dataId !== undefined ? this.dataId : null as any;
        data["intercompany"] = this.intercompany !== undefined ? this.intercompany : null as any;
        data["ownership"] = this.ownership !== undefined ? this.ownership : null as any;
        data["start"] = this.start ? this.start.toJSON() : null as any;
        data["end"] = this.end ? this.end.toJSON() : null as any;
        return data;
    }

    clone(): DirectOwnershipEntryDto {
        const json = this.toJSON();
        let result = new DirectOwnershipEntryDto();
        result.init(json);
        return result;
    }
}

export interface IDirectOwnershipEntryDto {
    dataId: number;
    intercompany?: string | null;
    ownership: number;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class ManageOwnershipResultDto implements IManageOwnershipResultDto {
    entityOwnership?: { [key: string]: ManageOwnershipEntryDto[]; } | null;

    constructor(data?: IManageOwnershipResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["entityOwnership"]) {
                this.entityOwnership = {} as any;
                for (let key in data["entityOwnership"]) {
                    if (data["entityOwnership"].hasOwnProperty(key))
                        (this.entityOwnership as any)![key] = data["entityOwnership"][key] ? data["entityOwnership"][key].map((i: any) => ManageOwnershipEntryDto.fromJS(i)) : [];
                }
            }
            else {
                this.entityOwnership = null as any;
            }
        }
    }

    static fromJS(data: any): ManageOwnershipResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageOwnershipResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entityOwnership) {
            data["entityOwnership"] = {};
            for (let key in this.entityOwnership) {
                if (this.entityOwnership.hasOwnProperty(key))
                    (data["entityOwnership"] as any)[key] = this.entityOwnership[key] !== undefined ? this.entityOwnership[key] : null as any;
            }
        }
        return data;
    }

    clone(): ManageOwnershipResultDto {
        const json = this.toJSON();
        let result = new ManageOwnershipResultDto();
        result.init(json);
        return result;
    }
}

export interface IManageOwnershipResultDto {
    entityOwnership?: { [key: string]: ManageOwnershipEntryDto[]; } | null;
}

export class ManageOwnershipEntryDto implements IManageOwnershipEntryDto {
    dataId!: number;
    group?: string | null;
    methodKey!: number;
    method?: string | null;
    pown?: number | null;
    pcon?: number | null;
    pmin?: number | null;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;

    constructor(data?: IManageOwnershipEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataId = data["dataId"] !== undefined ? data["dataId"] : null as any;
            this.group = data["group"] !== undefined ? data["group"] : null as any;
            this.methodKey = data["methodKey"] !== undefined ? data["methodKey"] : null as any;
            this.method = data["method"] !== undefined ? data["method"] : null as any;
            this.pown = data["pown"] !== undefined ? data["pown"] : null as any;
            this.pcon = data["pcon"] !== undefined ? data["pcon"] : null as any;
            this.pmin = data["pmin"] !== undefined ? data["pmin"] : null as any;
            this.start = data["start"] ? DateRangeDto.fromJS(data["start"]) : null as any;
            this.end = data["end"] ? DateRangeDto.fromJS(data["end"]) : null as any;
        }
    }

    static fromJS(data: any): ManageOwnershipEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageOwnershipEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataId"] = this.dataId !== undefined ? this.dataId : null as any;
        data["group"] = this.group !== undefined ? this.group : null as any;
        data["methodKey"] = this.methodKey !== undefined ? this.methodKey : null as any;
        data["method"] = this.method !== undefined ? this.method : null as any;
        data["pown"] = this.pown !== undefined ? this.pown : null as any;
        data["pcon"] = this.pcon !== undefined ? this.pcon : null as any;
        data["pmin"] = this.pmin !== undefined ? this.pmin : null as any;
        data["start"] = this.start ? this.start.toJSON() : null as any;
        data["end"] = this.end ? this.end.toJSON() : null as any;
        return data;
    }

    clone(): ManageOwnershipEntryDto {
        const json = this.toJSON();
        let result = new ManageOwnershipEntryDto();
        result.init(json);
        return result;
    }
}

export interface IManageOwnershipEntryDto {
    dataId: number;
    group?: string | null;
    methodKey: number;
    method?: string | null;
    pown?: number | null;
    pcon?: number | null;
    pmin?: number | null;
    start?: DateRangeDto | null;
    end?: DateRangeDto | null;
}

export class ConsolidationMethodDto implements IConsolidationMethodDto {
    key!: number;
    name?: string | null;
    caption?: string | null;
    methodType?: string | null;
    sortOrder!: number;

    constructor(data?: IConsolidationMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.methodType = data["methodType"] !== undefined ? data["methodType"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ConsolidationMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidationMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["methodType"] = this.methodType !== undefined ? this.methodType : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }

    clone(): ConsolidationMethodDto {
        const json = this.toJSON();
        let result = new ConsolidationMethodDto();
        result.init(json);
        return result;
    }
}

export interface IConsolidationMethodDto {
    key: number;
    name?: string | null;
    caption?: string | null;
    methodType?: string | null;
    sortOrder: number;
}

export class AiMappingResponsesDto implements IAiMappingResponsesDto {
    mappingResponses?: AiMappingResponseDto[] | null;

    constructor(data?: IAiMappingResponsesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["mappingResponses"])) {
                this.mappingResponses = [] as any;
                for (let item in data["mappingResponses"])
                    this.mappingResponses!.push(AiMappingResponseDto.fromJS(data["mappingResponses"][item]));
            }
            else {
                this.mappingResponses = null as any;
            }
        }
    }

    static fromJS(data: any): AiMappingResponsesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingResponsesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappingResponses)) {
            data["mappingResponses"] = [];
            for (let item in this.mappingResponses)
                data["mappingResponses"].push(this.mappingResponses[item] ? this.mappingResponses[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AiMappingResponsesDto {
        const json = this.toJSON();
        let result = new AiMappingResponsesDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingResponsesDto {
    mappingResponses?: AiMappingResponseDto[] | null;
}

export class AiMappingResponseDto implements IAiMappingResponseDto {
    dimensionName?: string | null;
    mappingType!: MappingType;
    sourceName?: string | null;
    sourceCaption?: string | null;
    suggestedTargetName?: string | null;
    targetCaption?: string | null;
    confidencePercentage!: number;

    constructor(data?: IAiMappingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.mappingType = data["mappingType"] !== undefined ? data["mappingType"] : null as any;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : null as any;
            this.suggestedTargetName = data["suggestedTargetName"] !== undefined ? data["suggestedTargetName"] : null as any;
            this.targetCaption = data["targetCaption"] !== undefined ? data["targetCaption"] : null as any;
            this.confidencePercentage = data["confidencePercentage"] !== undefined ? data["confidencePercentage"] : null as any;
        }
    }

    static fromJS(data: any): AiMappingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["mappingType"] = this.mappingType !== undefined ? this.mappingType : null as any;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : null as any;
        data["suggestedTargetName"] = this.suggestedTargetName !== undefined ? this.suggestedTargetName : null as any;
        data["targetCaption"] = this.targetCaption !== undefined ? this.targetCaption : null as any;
        data["confidencePercentage"] = this.confidencePercentage !== undefined ? this.confidencePercentage : null as any;
        return data;
    }

    clone(): AiMappingResponseDto {
        const json = this.toJSON();
        let result = new AiMappingResponseDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingResponseDto {
    dimensionName?: string | null;
    mappingType: MappingType;
    sourceName?: string | null;
    sourceCaption?: string | null;
    suggestedTargetName?: string | null;
    targetCaption?: string | null;
    confidencePercentage: number;
}

export enum MappingType {
    Exact = 1,
    In = 2,
    Range = 3,
    Wildcard = 4,
}

export class AiMappingRequestsDto implements IAiMappingRequestsDto {
    mappingRequests!: AiMappingRequestDto[];

    constructor(data?: IAiMappingRequestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.mappingRequests = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["mappingRequests"])) {
                this.mappingRequests = [] as any;
                for (let item in data["mappingRequests"])
                    this.mappingRequests!.push(AiMappingRequestDto.fromJS(data["mappingRequests"][item]));
            }
            else {
                this.mappingRequests = null as any;
            }
        }
    }

    static fromJS(data: any): AiMappingRequestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingRequestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mappingRequests)) {
            data["mappingRequests"] = [];
            for (let item in this.mappingRequests)
                data["mappingRequests"].push(this.mappingRequests[item] ? this.mappingRequests[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AiMappingRequestsDto {
        const json = this.toJSON();
        let result = new AiMappingRequestsDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingRequestsDto {
    mappingRequests: AiMappingRequestDto[];
}

export class AiMappingRequestDto implements IAiMappingRequestDto {
    dimensionName?: string | null;
    sourceName?: string | null;
    sourceCaption?: string | null;

    constructor(data?: IAiMappingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
            this.sourceCaption = data["sourceCaption"] !== undefined ? data["sourceCaption"] : null as any;
        }
    }

    static fromJS(data: any): AiMappingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiMappingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        data["sourceCaption"] = this.sourceCaption !== undefined ? this.sourceCaption : null as any;
        return data;
    }

    clone(): AiMappingRequestDto {
        const json = this.toJSON();
        let result = new AiMappingRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAiMappingRequestDto {
    dimensionName?: string | null;
    sourceName?: string | null;
    sourceCaption?: string | null;
}

export class MatchGroupInfo implements IMatchGroupInfo {
    matchGroup?: string | null;
    leftDatasets?: DatasetInfo[] | null;
    rightDatasets?: DatasetInfo[] | null;
    manualMatchMaxVariance!: number;
    active!: boolean;

    constructor(data?: IMatchGroupInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : null as any;
            if (Array.isArray(data["leftDatasets"])) {
                this.leftDatasets = [] as any;
                for (let item in data["leftDatasets"])
                    this.leftDatasets!.push(DatasetInfo.fromJS(data["leftDatasets"][item]));
            }
            else {
                this.leftDatasets = null as any;
            }
            if (Array.isArray(data["rightDatasets"])) {
                this.rightDatasets = [] as any;
                for (let item in data["rightDatasets"])
                    this.rightDatasets!.push(DatasetInfo.fromJS(data["rightDatasets"][item]));
            }
            else {
                this.rightDatasets = null as any;
            }
            this.manualMatchMaxVariance = data["manualMatchMaxVariance"] !== undefined ? data["manualMatchMaxVariance"] : null as any;
            this.active = data["active"] !== undefined ? data["active"] : null as any;
        }
    }

    static fromJS(data: any): MatchGroupInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MatchGroupInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : null as any;
        if (Array.isArray(this.leftDatasets)) {
            data["leftDatasets"] = [];
            for (let item in this.leftDatasets)
                data["leftDatasets"].push(this.leftDatasets[item] ? this.leftDatasets[item].toJSON() : null as any);
        }
        if (Array.isArray(this.rightDatasets)) {
            data["rightDatasets"] = [];
            for (let item in this.rightDatasets)
                data["rightDatasets"].push(this.rightDatasets[item] ? this.rightDatasets[item].toJSON() : null as any);
        }
        data["manualMatchMaxVariance"] = this.manualMatchMaxVariance !== undefined ? this.manualMatchMaxVariance : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }

    clone(): MatchGroupInfo {
        const json = this.toJSON();
        let result = new MatchGroupInfo();
        result.init(json);
        return result;
    }
}

export interface IMatchGroupInfo {
    matchGroup?: string | null;
    leftDatasets?: DatasetInfo[] | null;
    rightDatasets?: DatasetInfo[] | null;
    manualMatchMaxVariance: number;
    active: boolean;
}

export class DatasetInfo implements IDatasetInfo {
    name?: string | null;
    table?: string | null;
    idField?: string | null;
    dateField?: string | null;
    amountField?: string | null;
    filterLogic?: string | null;

    constructor(data?: IDatasetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.table = data["table"] !== undefined ? data["table"] : null as any;
            this.idField = data["idField"] !== undefined ? data["idField"] : null as any;
            this.dateField = data["dateField"] !== undefined ? data["dateField"] : null as any;
            this.amountField = data["amountField"] !== undefined ? data["amountField"] : null as any;
            this.filterLogic = data["filterLogic"] !== undefined ? data["filterLogic"] : null as any;
        }
    }

    static fromJS(data: any): DatasetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["table"] = this.table !== undefined ? this.table : null as any;
        data["idField"] = this.idField !== undefined ? this.idField : null as any;
        data["dateField"] = this.dateField !== undefined ? this.dateField : null as any;
        data["amountField"] = this.amountField !== undefined ? this.amountField : null as any;
        data["filterLogic"] = this.filterLogic !== undefined ? this.filterLogic : null as any;
        return data;
    }

    clone(): DatasetInfo {
        const json = this.toJSON();
        let result = new DatasetInfo();
        result.init(json);
        return result;
    }
}

export interface IDatasetInfo {
    name?: string | null;
    table?: string | null;
    idField?: string | null;
    dateField?: string | null;
    amountField?: string | null;
    filterLogic?: string | null;
}

export class MatchInfo implements IMatchInfo {
    matchId?: string | null;
    matchGroup?: string | null;
    matchType!: number;
    confidence!: number;
    dataset1?: string | null;
    dataset2?: string | null;
    auditTimestamp?: string | null;
    ruleId?: number | null;
    ruleName?: string | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    auditUsername?: string | null;
    variance?: number | null;
    matchNotes?: MatchNote[] | null;
    matchData?: MatchData[] | null;

    constructor(data?: IMatchInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchId = data["matchId"] !== undefined ? data["matchId"] : null as any;
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : null as any;
            this.matchType = data["matchType"] !== undefined ? data["matchType"] : null as any;
            this.confidence = data["confidence"] !== undefined ? data["confidence"] : null as any;
            this.dataset1 = data["dataset1"] !== undefined ? data["dataset1"] : null as any;
            this.dataset2 = data["dataset2"] !== undefined ? data["dataset2"] : null as any;
            this.auditTimestamp = data["auditTimestamp"] !== undefined ? data["auditTimestamp"] : null as any;
            this.ruleId = data["ruleId"] !== undefined ? data["ruleId"] : null as any;
            this.ruleName = data["ruleName"] !== undefined ? data["ruleName"] : null as any;
            this.subtotal1Mod = data["subtotal1Mod"] !== undefined ? data["subtotal1Mod"] : null as any;
            this.subtotal1 = data["subtotal1"] !== undefined ? data["subtotal1"] : null as any;
            this.subtotal2Mod = data["subtotal2Mod"] !== undefined ? data["subtotal2Mod"] : null as any;
            this.subtotal2 = data["subtotal2"] !== undefined ? data["subtotal2"] : null as any;
            this.auditUsername = data["auditUsername"] !== undefined ? data["auditUsername"] : null as any;
            this.variance = data["variance"] !== undefined ? data["variance"] : null as any;
            if (Array.isArray(data["matchNotes"])) {
                this.matchNotes = [] as any;
                for (let item in data["matchNotes"])
                    this.matchNotes!.push(MatchNote.fromJS(data["matchNotes"][item]));
            }
            else {
                this.matchNotes = null as any;
            }
            if (Array.isArray(data["matchData"])) {
                this.matchData = [] as any;
                for (let item in data["matchData"])
                    this.matchData!.push(MatchData.fromJS(data["matchData"][item]));
            }
            else {
                this.matchData = null as any;
            }
        }
    }

    static fromJS(data: any): MatchInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MatchInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId !== undefined ? this.matchId : null as any;
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : null as any;
        data["matchType"] = this.matchType !== undefined ? this.matchType : null as any;
        data["confidence"] = this.confidence !== undefined ? this.confidence : null as any;
        data["dataset1"] = this.dataset1 !== undefined ? this.dataset1 : null as any;
        data["dataset2"] = this.dataset2 !== undefined ? this.dataset2 : null as any;
        data["auditTimestamp"] = this.auditTimestamp !== undefined ? this.auditTimestamp : null as any;
        data["ruleId"] = this.ruleId !== undefined ? this.ruleId : null as any;
        data["ruleName"] = this.ruleName !== undefined ? this.ruleName : null as any;
        data["subtotal1Mod"] = this.subtotal1Mod !== undefined ? this.subtotal1Mod : null as any;
        data["subtotal1"] = this.subtotal1 !== undefined ? this.subtotal1 : null as any;
        data["subtotal2Mod"] = this.subtotal2Mod !== undefined ? this.subtotal2Mod : null as any;
        data["subtotal2"] = this.subtotal2 !== undefined ? this.subtotal2 : null as any;
        data["auditUsername"] = this.auditUsername !== undefined ? this.auditUsername : null as any;
        data["variance"] = this.variance !== undefined ? this.variance : null as any;
        if (Array.isArray(this.matchNotes)) {
            data["matchNotes"] = [];
            for (let item in this.matchNotes)
                data["matchNotes"].push(this.matchNotes[item] ? this.matchNotes[item].toJSON() : null as any);
        }
        if (Array.isArray(this.matchData)) {
            data["matchData"] = [];
            for (let item in this.matchData)
                data["matchData"].push(this.matchData[item] ? this.matchData[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MatchInfo {
        const json = this.toJSON();
        let result = new MatchInfo();
        result.init(json);
        return result;
    }
}

export interface IMatchInfo {
    matchId?: string | null;
    matchGroup?: string | null;
    matchType: number;
    confidence: number;
    dataset1?: string | null;
    dataset2?: string | null;
    auditTimestamp?: string | null;
    ruleId?: number | null;
    ruleName?: string | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    auditUsername?: string | null;
    variance?: number | null;
    matchNotes?: MatchNote[] | null;
    matchData?: MatchData[] | null;
}

export class MatchNote implements IMatchNote {
    note?: string | null;
    noteId!: number;
    username?: string | null;
    timestamp?: string | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;

    constructor(data?: IMatchNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"] !== undefined ? data["note"] : null as any;
            this.noteId = data["noteId"] !== undefined ? data["noteId"] : null as any;
            this.username = data["username"] !== undefined ? data["username"] : null as any;
            this.timestamp = data["timestamp"] !== undefined ? data["timestamp"] : null as any;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null as any;
            this.fileData = data["fileData"] !== undefined ? data["fileData"] : null as any;
            this.attachmentId = data["attachmentId"] !== undefined ? data["attachmentId"] : null as any;
        }
    }

    static fromJS(data: any): MatchNote {
        data = typeof data === 'object' ? data : {};
        let result = new MatchNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null as any;
        data["noteId"] = this.noteId !== undefined ? this.noteId : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileData"] = this.fileData !== undefined ? this.fileData : null as any;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        return data;
    }

    clone(): MatchNote {
        const json = this.toJSON();
        let result = new MatchNote();
        result.init(json);
        return result;
    }
}

export interface IMatchNote {
    note?: string | null;
    noteId: number;
    username?: string | null;
    timestamp?: string | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
}

export class MatchData implements IMatchData {
    dataset?: string | null;
    transactionId?: string | null;

    constructor(data?: IMatchData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataset = data["dataset"] !== undefined ? data["dataset"] : null as any;
            this.transactionId = data["transactionId"] !== undefined ? data["transactionId"] : null as any;
        }
    }

    static fromJS(data: any): MatchData {
        data = typeof data === 'object' ? data : {};
        let result = new MatchData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataset"] = this.dataset !== undefined ? this.dataset : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        return data;
    }

    clone(): MatchData {
        const json = this.toJSON();
        let result = new MatchData();
        result.init(json);
        return result;
    }
}

export interface IMatchData {
    dataset?: string | null;
    transactionId?: string | null;
}

export class TransactionData implements ITransactionData {
    fields?: string[] | null;
    type?: string[] | null;
    moreData!: boolean;
    matchFieldIndex!: number;
    detailFieldUnmatchIndex!: number;
    detailFieldMatchIndex!: number;
    idFieldIndex!: number;
    dateFieldIndex!: number;
    amountFieldIndex!: number;
    errorMessage?: string | null;
    rows?: DataRow[] | null;
    matches?: MatchInfo[] | null;
    supportingItems?: SupportingItemInfo[] | null;

    constructor(data?: ITransactionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(data["fields"][item]);
            }
            else {
                this.fields = null as any;
            }
            if (Array.isArray(data["type"])) {
                this.type = [] as any;
                for (let item in data["type"])
                    this.type!.push(data["type"][item]);
            }
            else {
                this.type = null as any;
            }
            this.moreData = data["moreData"] !== undefined ? data["moreData"] : null as any;
            this.matchFieldIndex = data["matchFieldIndex"] !== undefined ? data["matchFieldIndex"] : null as any;
            this.detailFieldUnmatchIndex = data["detailFieldUnmatchIndex"] !== undefined ? data["detailFieldUnmatchIndex"] : null as any;
            this.detailFieldMatchIndex = data["detailFieldMatchIndex"] !== undefined ? data["detailFieldMatchIndex"] : null as any;
            this.idFieldIndex = data["idFieldIndex"] !== undefined ? data["idFieldIndex"] : null as any;
            this.dateFieldIndex = data["dateFieldIndex"] !== undefined ? data["dateFieldIndex"] : null as any;
            this.amountFieldIndex = data["amountFieldIndex"] !== undefined ? data["amountFieldIndex"] : null as any;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : null as any;
            if (Array.isArray(data["rows"])) {
                this.rows = [] as any;
                for (let item in data["rows"])
                    this.rows!.push(DataRow.fromJS(data["rows"][item]));
            }
            else {
                this.rows = null as any;
            }
            if (Array.isArray(data["matches"])) {
                this.matches = [] as any;
                for (let item in data["matches"])
                    this.matches!.push(MatchInfo.fromJS(data["matches"][item]));
            }
            else {
                this.matches = null as any;
            }
            if (Array.isArray(data["supportingItems"])) {
                this.supportingItems = [] as any;
                for (let item in data["supportingItems"])
                    this.supportingItems!.push(SupportingItemInfo.fromJS(data["supportingItems"][item]));
            }
            else {
                this.supportingItems = null as any;
            }
        }
    }

    static fromJS(data: any): TransactionData {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item]);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item in this.type)
                data["type"].push(this.type[item]);
        }
        data["moreData"] = this.moreData !== undefined ? this.moreData : null as any;
        data["matchFieldIndex"] = this.matchFieldIndex !== undefined ? this.matchFieldIndex : null as any;
        data["detailFieldUnmatchIndex"] = this.detailFieldUnmatchIndex !== undefined ? this.detailFieldUnmatchIndex : null as any;
        data["detailFieldMatchIndex"] = this.detailFieldMatchIndex !== undefined ? this.detailFieldMatchIndex : null as any;
        data["idFieldIndex"] = this.idFieldIndex !== undefined ? this.idFieldIndex : null as any;
        data["dateFieldIndex"] = this.dateFieldIndex !== undefined ? this.dateFieldIndex : null as any;
        data["amountFieldIndex"] = this.amountFieldIndex !== undefined ? this.amountFieldIndex : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item in this.rows)
                data["rows"].push(this.rows[item] ? this.rows[item].toJSON() : null as any);
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item in this.matches)
                data["matches"].push(this.matches[item] ? this.matches[item].toJSON() : null as any);
        }
        if (Array.isArray(this.supportingItems)) {
            data["supportingItems"] = [];
            for (let item in this.supportingItems)
                data["supportingItems"].push(this.supportingItems[item] ? this.supportingItems[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): TransactionData {
        const json = this.toJSON();
        let result = new TransactionData();
        result.init(json);
        return result;
    }
}

export interface ITransactionData {
    fields?: string[] | null;
    type?: string[] | null;
    moreData: boolean;
    matchFieldIndex: number;
    detailFieldUnmatchIndex: number;
    detailFieldMatchIndex: number;
    idFieldIndex: number;
    dateFieldIndex: number;
    amountFieldIndex: number;
    errorMessage?: string | null;
    rows?: DataRow[] | null;
    matches?: MatchInfo[] | null;
    supportingItems?: SupportingItemInfo[] | null;
}

export class DataRow implements IDataRow {
    fieldValues?: any[] | null;

    constructor(data?: IDataRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["fieldValues"])) {
                this.fieldValues = [] as any;
                for (let item in data["fieldValues"])
                    this.fieldValues!.push(data["fieldValues"][item]);
            }
            else {
                this.fieldValues = null as any;
            }
        }
    }

    static fromJS(data: any): DataRow {
        data = typeof data === 'object' ? data : {};
        let result = new DataRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldValues)) {
            data["fieldValues"] = [];
            for (let item in this.fieldValues)
                data["fieldValues"].push(this.fieldValues[item]);
        }
        return data;
    }

    clone(): DataRow {
        const json = this.toJSON();
        let result = new DataRow();
        result.init(json);
        return result;
    }
}

export interface IDataRow {
    fieldValues?: any[] | null;
}

export class SupportingItemInfo implements ISupportingItemInfo {
    supportingItemId?: string | null;
    description?: string | null;
    reconciliationGroup?: string | null;
    account_Name?: string | null;
    entity_Name?: string | null;
    supportingItemSubtype?: string | null;
    itemClass?: string | null;
    notes?: string | null;
    amount!: number;
    startDate?: Date | null;
    endDate?: Date | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    variance?: number | null;
    reverseAmount!: boolean;
    matchGroup?: string | null;
    dataset1?: string | null;
    dataset2?: string | null;
    auditUsername?: string | null;
    auditTimestamp?: string | null;
    transactionData?: MatchData[] | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
    oldAttachmentId?: number | null;
    matchId?: string | null;
    supportingItemDetailId?: string | null;

    constructor(data?: ISupportingItemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supportingItemId = data["supportingItemId"] !== undefined ? data["supportingItemId"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.reconciliationGroup = data["reconciliationGroup"] !== undefined ? data["reconciliationGroup"] : null as any;
            this.account_Name = data["account_Name"] !== undefined ? data["account_Name"] : null as any;
            this.entity_Name = data["entity_Name"] !== undefined ? data["entity_Name"] : null as any;
            this.supportingItemSubtype = data["supportingItemSubtype"] !== undefined ? data["supportingItemSubtype"] : null as any;
            this.itemClass = data["itemClass"] !== undefined ? data["itemClass"] : null as any;
            this.notes = data["notes"] !== undefined ? data["notes"] : null as any;
            this.amount = data["amount"] !== undefined ? data["amount"] : null as any;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : null as any;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : null as any;
            this.subtotal1Mod = data["subtotal1Mod"] !== undefined ? data["subtotal1Mod"] : null as any;
            this.subtotal1 = data["subtotal1"] !== undefined ? data["subtotal1"] : null as any;
            this.subtotal2Mod = data["subtotal2Mod"] !== undefined ? data["subtotal2Mod"] : null as any;
            this.subtotal2 = data["subtotal2"] !== undefined ? data["subtotal2"] : null as any;
            this.variance = data["variance"] !== undefined ? data["variance"] : null as any;
            this.reverseAmount = data["reverseAmount"] !== undefined ? data["reverseAmount"] : null as any;
            this.matchGroup = data["matchGroup"] !== undefined ? data["matchGroup"] : null as any;
            this.dataset1 = data["dataset1"] !== undefined ? data["dataset1"] : null as any;
            this.dataset2 = data["dataset2"] !== undefined ? data["dataset2"] : null as any;
            this.auditUsername = data["auditUsername"] !== undefined ? data["auditUsername"] : null as any;
            this.auditTimestamp = data["auditTimestamp"] !== undefined ? data["auditTimestamp"] : null as any;
            if (Array.isArray(data["transactionData"])) {
                this.transactionData = [] as any;
                for (let item in data["transactionData"])
                    this.transactionData!.push(MatchData.fromJS(data["transactionData"][item]));
            }
            else {
                this.transactionData = null as any;
            }
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null as any;
            this.fileData = data["fileData"] !== undefined ? data["fileData"] : null as any;
            this.attachmentId = data["attachmentId"] !== undefined ? data["attachmentId"] : null as any;
            this.oldAttachmentId = data["oldAttachmentId"] !== undefined ? data["oldAttachmentId"] : null as any;
            this.matchId = data["matchId"] !== undefined ? data["matchId"] : null as any;
            this.supportingItemDetailId = data["supportingItemDetailId"] !== undefined ? data["supportingItemDetailId"] : null as any;
        }
    }

    static fromJS(data: any): SupportingItemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingItemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportingItemId"] = this.supportingItemId !== undefined ? this.supportingItemId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["reconciliationGroup"] = this.reconciliationGroup !== undefined ? this.reconciliationGroup : null as any;
        data["account_Name"] = this.account_Name !== undefined ? this.account_Name : null as any;
        data["entity_Name"] = this.entity_Name !== undefined ? this.entity_Name : null as any;
        data["supportingItemSubtype"] = this.supportingItemSubtype !== undefined ? this.supportingItemSubtype : null as any;
        data["itemClass"] = this.itemClass !== undefined ? this.itemClass : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["subtotal1Mod"] = this.subtotal1Mod !== undefined ? this.subtotal1Mod : null as any;
        data["subtotal1"] = this.subtotal1 !== undefined ? this.subtotal1 : null as any;
        data["subtotal2Mod"] = this.subtotal2Mod !== undefined ? this.subtotal2Mod : null as any;
        data["subtotal2"] = this.subtotal2 !== undefined ? this.subtotal2 : null as any;
        data["variance"] = this.variance !== undefined ? this.variance : null as any;
        data["reverseAmount"] = this.reverseAmount !== undefined ? this.reverseAmount : null as any;
        data["matchGroup"] = this.matchGroup !== undefined ? this.matchGroup : null as any;
        data["dataset1"] = this.dataset1 !== undefined ? this.dataset1 : null as any;
        data["dataset2"] = this.dataset2 !== undefined ? this.dataset2 : null as any;
        data["auditUsername"] = this.auditUsername !== undefined ? this.auditUsername : null as any;
        data["auditTimestamp"] = this.auditTimestamp !== undefined ? this.auditTimestamp : null as any;
        if (Array.isArray(this.transactionData)) {
            data["transactionData"] = [];
            for (let item in this.transactionData)
                data["transactionData"].push(this.transactionData[item] ? this.transactionData[item].toJSON() : null as any);
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileData"] = this.fileData !== undefined ? this.fileData : null as any;
        data["attachmentId"] = this.attachmentId !== undefined ? this.attachmentId : null as any;
        data["oldAttachmentId"] = this.oldAttachmentId !== undefined ? this.oldAttachmentId : null as any;
        data["matchId"] = this.matchId !== undefined ? this.matchId : null as any;
        data["supportingItemDetailId"] = this.supportingItemDetailId !== undefined ? this.supportingItemDetailId : null as any;
        return data;
    }

    clone(): SupportingItemInfo {
        const json = this.toJSON();
        let result = new SupportingItemInfo();
        result.init(json);
        return result;
    }
}

export interface ISupportingItemInfo {
    supportingItemId?: string | null;
    description?: string | null;
    reconciliationGroup?: string | null;
    account_Name?: string | null;
    entity_Name?: string | null;
    supportingItemSubtype?: string | null;
    itemClass?: string | null;
    notes?: string | null;
    amount: number;
    startDate?: Date | null;
    endDate?: Date | null;
    subtotal1Mod?: string | null;
    subtotal1?: number | null;
    subtotal2Mod?: string | null;
    subtotal2?: number | null;
    variance?: number | null;
    reverseAmount: boolean;
    matchGroup?: string | null;
    dataset1?: string | null;
    dataset2?: string | null;
    auditUsername?: string | null;
    auditTimestamp?: string | null;
    transactionData?: MatchData[] | null;
    fileName?: string | null;
    fileData?: string | null;
    attachmentId?: number | null;
    oldAttachmentId?: number | null;
    matchId?: string | null;
    supportingItemDetailId?: string | null;
}

export class TransactionFilter implements ITransactionFilter {
    matchFilter!: MatchFilter;
    matchTypeFilter!: MatchTypeFilter;
    confidenceFilter!: ConfidenceFilter;
    supportFilter!: SupportFilter;
    supportMatchFilter!: SupportMatchFilter;
    varianceLow?: number | null;
    varianceHigh?: number | null;
    fieldFilters?: Filter[] | null;
    freeClauseFilter?: string | null;

    constructor(data?: ITransactionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.matchFilter = data["matchFilter"] !== undefined ? data["matchFilter"] : null as any;
            this.matchTypeFilter = data["matchTypeFilter"] !== undefined ? data["matchTypeFilter"] : null as any;
            this.confidenceFilter = data["confidenceFilter"] !== undefined ? data["confidenceFilter"] : null as any;
            this.supportFilter = data["supportFilter"] !== undefined ? data["supportFilter"] : null as any;
            this.supportMatchFilter = data["supportMatchFilter"] !== undefined ? data["supportMatchFilter"] : null as any;
            this.varianceLow = data["varianceLow"] !== undefined ? data["varianceLow"] : null as any;
            this.varianceHigh = data["varianceHigh"] !== undefined ? data["varianceHigh"] : null as any;
            if (Array.isArray(data["fieldFilters"])) {
                this.fieldFilters = [] as any;
                for (let item in data["fieldFilters"])
                    this.fieldFilters!.push(Filter.fromJS(data["fieldFilters"][item]));
            }
            else {
                this.fieldFilters = null as any;
            }
            this.freeClauseFilter = data["freeClauseFilter"] !== undefined ? data["freeClauseFilter"] : null as any;
        }
    }

    static fromJS(data: any): TransactionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchFilter"] = this.matchFilter !== undefined ? this.matchFilter : null as any;
        data["matchTypeFilter"] = this.matchTypeFilter !== undefined ? this.matchTypeFilter : null as any;
        data["confidenceFilter"] = this.confidenceFilter !== undefined ? this.confidenceFilter : null as any;
        data["supportFilter"] = this.supportFilter !== undefined ? this.supportFilter : null as any;
        data["supportMatchFilter"] = this.supportMatchFilter !== undefined ? this.supportMatchFilter : null as any;
        data["varianceLow"] = this.varianceLow !== undefined ? this.varianceLow : null as any;
        data["varianceHigh"] = this.varianceHigh !== undefined ? this.varianceHigh : null as any;
        if (Array.isArray(this.fieldFilters)) {
            data["fieldFilters"] = [];
            for (let item in this.fieldFilters)
                data["fieldFilters"].push(this.fieldFilters[item] ? this.fieldFilters[item].toJSON() : null as any);
        }
        data["freeClauseFilter"] = this.freeClauseFilter !== undefined ? this.freeClauseFilter : null as any;
        return data;
    }

    clone(): TransactionFilter {
        const json = this.toJSON();
        let result = new TransactionFilter();
        result.init(json);
        return result;
    }
}

export interface ITransactionFilter {
    matchFilter: MatchFilter;
    matchTypeFilter: MatchTypeFilter;
    confidenceFilter: ConfidenceFilter;
    supportFilter: SupportFilter;
    supportMatchFilter: SupportMatchFilter;
    varianceLow?: number | null;
    varianceHigh?: number | null;
    fieldFilters?: Filter[] | null;
    freeClauseFilter?: string | null;
}

export enum MatchFilter {
    All = 0,
    Matched = 1,
    Unmatched = 2,
}

export enum MatchTypeFilter {
    All = 0,
    Manual = 1,
    Automatic = 2,
    ManuallyApproved = 3,
}

export enum ConfidenceFilter {
    All = 0,
    High = 1,
    Medium = 2,
    Low = 3,
}

export enum SupportFilter {
    All = 0,
    HasSupport = 1,
    HasOpenSupport = 2,
    HasClosedSupport = 3,
    NoSupport = 4,
}

export enum SupportMatchFilter {
    All = 0,
    HasSupportMatch = 1,
    HasOpenSupportMatch = 2,
    HasClosedSupportMatch = 3,
    NoSupportMatch = 4,
}

export class Filter implements IFilter {
    filterId?: number | null;
    field?: string | null;
    operation?: string | null;
    value?: string | null;
    additionalValue?: string | null;
    sql?: string | null;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterId = data["filterId"] !== undefined ? data["filterId"] : null as any;
            this.field = data["field"] !== undefined ? data["field"] : null as any;
            this.operation = data["operation"] !== undefined ? data["operation"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
            this.additionalValue = data["additionalValue"] !== undefined ? data["additionalValue"] : null as any;
            this.sql = data["sql"] !== undefined ? data["sql"] : null as any;
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId !== undefined ? this.filterId : null as any;
        data["field"] = this.field !== undefined ? this.field : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["additionalValue"] = this.additionalValue !== undefined ? this.additionalValue : null as any;
        data["sql"] = this.sql !== undefined ? this.sql : null as any;
        return data;
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    filterId?: number | null;
    field?: string | null;
    operation?: string | null;
    value?: string | null;
    additionalValue?: string | null;
    sql?: string | null;
}

export class ModelInfo implements IModelInfo {
    modelName?: string | null;
    managedModel?: boolean | null;
    directQueryMode?: boolean | null;
    analysisServiceSecurityProfile?: string | null;
    readSecurityProfile?: string | null;
    writeSecurityProfile?: string | null;
    consolidationModel?: boolean | null;
    defaultConsolidationModel?: boolean | null;
    extendedDrillback?: boolean | null;
    enforceOpenClosedForWriteback?: boolean | null;
    dimensions?: string[] | null;
    dimensionInfo?: ModelDimensionInfo[] | null;
    modelViews?: ModelViewInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    isModelPostedJournal?: boolean | null;

    constructor(data?: IModelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.managedModel = data["managedModel"] !== undefined ? data["managedModel"] : null as any;
            this.directQueryMode = data["directQueryMode"] !== undefined ? data["directQueryMode"] : null as any;
            this.analysisServiceSecurityProfile = data["analysisServiceSecurityProfile"] !== undefined ? data["analysisServiceSecurityProfile"] : null as any;
            this.readSecurityProfile = data["readSecurityProfile"] !== undefined ? data["readSecurityProfile"] : null as any;
            this.writeSecurityProfile = data["writeSecurityProfile"] !== undefined ? data["writeSecurityProfile"] : null as any;
            this.consolidationModel = data["consolidationModel"] !== undefined ? data["consolidationModel"] : null as any;
            this.defaultConsolidationModel = data["defaultConsolidationModel"] !== undefined ? data["defaultConsolidationModel"] : null as any;
            this.extendedDrillback = data["extendedDrillback"] !== undefined ? data["extendedDrillback"] : null as any;
            this.enforceOpenClosedForWriteback = data["enforceOpenClosedForWriteback"] !== undefined ? data["enforceOpenClosedForWriteback"] : null as any;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = null as any;
            }
            if (Array.isArray(data["dimensionInfo"])) {
                this.dimensionInfo = [] as any;
                for (let item in data["dimensionInfo"])
                    this.dimensionInfo!.push(ModelDimensionInfo.fromJS(data["dimensionInfo"][item]));
            }
            else {
                this.dimensionInfo = null as any;
            }
            if (Array.isArray(data["modelViews"])) {
                this.modelViews = [] as any;
                for (let item in data["modelViews"])
                    this.modelViews!.push(ModelViewInfo.fromJS(data["modelViews"][item]));
            }
            else {
                this.modelViews = null as any;
            }
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : null as any;
            this.isModelPostedJournal = data["isModelPostedJournal"] !== undefined ? data["isModelPostedJournal"] : null as any;
        }
    }

    static fromJS(data: any): ModelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["managedModel"] = this.managedModel !== undefined ? this.managedModel : null as any;
        data["directQueryMode"] = this.directQueryMode !== undefined ? this.directQueryMode : null as any;
        data["analysisServiceSecurityProfile"] = this.analysisServiceSecurityProfile !== undefined ? this.analysisServiceSecurityProfile : null as any;
        data["readSecurityProfile"] = this.readSecurityProfile !== undefined ? this.readSecurityProfile : null as any;
        data["writeSecurityProfile"] = this.writeSecurityProfile !== undefined ? this.writeSecurityProfile : null as any;
        data["consolidationModel"] = this.consolidationModel !== undefined ? this.consolidationModel : null as any;
        data["defaultConsolidationModel"] = this.defaultConsolidationModel !== undefined ? this.defaultConsolidationModel : null as any;
        data["extendedDrillback"] = this.extendedDrillback !== undefined ? this.extendedDrillback : null as any;
        data["enforceOpenClosedForWriteback"] = this.enforceOpenClosedForWriteback !== undefined ? this.enforceOpenClosedForWriteback : null as any;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.dimensionInfo)) {
            data["dimensionInfo"] = [];
            for (let item in this.dimensionInfo)
                data["dimensionInfo"].push(this.dimensionInfo[item] ? this.dimensionInfo[item].toJSON() : null as any);
        }
        if (Array.isArray(this.modelViews)) {
            data["modelViews"] = [];
            for (let item in this.modelViews)
                data["modelViews"].push(this.modelViews[item] ? this.modelViews[item].toJSON() : null as any);
        }
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        data["isModelPostedJournal"] = this.isModelPostedJournal !== undefined ? this.isModelPostedJournal : null as any;
        return data;
    }

    clone(): ModelInfo {
        const json = this.toJSON();
        let result = new ModelInfo();
        result.init(json);
        return result;
    }
}

export interface IModelInfo {
    modelName?: string | null;
    managedModel?: boolean | null;
    directQueryMode?: boolean | null;
    analysisServiceSecurityProfile?: string | null;
    readSecurityProfile?: string | null;
    writeSecurityProfile?: string | null;
    consolidationModel?: boolean | null;
    defaultConsolidationModel?: boolean | null;
    extendedDrillback?: boolean | null;
    enforceOpenClosedForWriteback?: boolean | null;
    dimensions?: string[] | null;
    dimensionInfo?: ModelDimensionInfo[] | null;
    modelViews?: ModelViewInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    isModelPostedJournal?: boolean | null;
}

export class ModelDimensionInfo implements IModelDimensionInfo {
    dimensionName?: string | null;
    dimensionType!: DimensionType;
    processingStatus?: ProcessingStatus | null;
    role?: string | null;

    constructor(data?: IModelDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : null as any;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : null as any;
            this.role = data["role"] !== undefined ? data["role"] : null as any;
        }
    }

    static fromJS(data: any): ModelDimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : null as any;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }

    clone(): ModelDimensionInfo {
        const json = this.toJSON();
        let result = new ModelDimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IModelDimensionInfo {
    dimensionName?: string | null;
    dimensionType: DimensionType;
    processingStatus?: ProcessingStatus | null;
    role?: string | null;
}

export enum DimensionType {
    Other = 0,
    Measure = 1,
    Account = 2,
    Time = 3,
    Entity = 4,
    Currency = 5,
    Movement = 6,
    DataView = 7,
    Audit = 8,
    Scenario = 9,
    Intercompany = 10,
    Group = 11,
    Driver = 12,
    MarketAnalysis = 13,
}

export enum ProcessingStatus {
    Active = 0,
    New = 1,
    Updated = 2,
    Deleted = -1,
}

export class ModelViewInfo implements IModelViewInfo {
    viewName?: string | null;
    modelName?: string | null;
    errorMessage?: string | null;
    modelViewDimensions?: ModelViewDimensionInfo[] | null;

    constructor(data?: IModelViewInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.viewName = data["viewName"] !== undefined ? data["viewName"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : null as any;
            if (Array.isArray(data["modelViewDimensions"])) {
                this.modelViewDimensions = [] as any;
                for (let item in data["modelViewDimensions"])
                    this.modelViewDimensions!.push(ModelViewDimensionInfo.fromJS(data["modelViewDimensions"][item]));
            }
            else {
                this.modelViewDimensions = null as any;
            }
        }
    }

    static fromJS(data: any): ModelViewInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelViewInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewName"] = this.viewName !== undefined ? this.viewName : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        if (Array.isArray(this.modelViewDimensions)) {
            data["modelViewDimensions"] = [];
            for (let item in this.modelViewDimensions)
                data["modelViewDimensions"].push(this.modelViewDimensions[item] ? this.modelViewDimensions[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModelViewInfo {
        const json = this.toJSON();
        let result = new ModelViewInfo();
        result.init(json);
        return result;
    }
}

export interface IModelViewInfo {
    viewName?: string | null;
    modelName?: string | null;
    errorMessage?: string | null;
    modelViewDimensions?: ModelViewDimensionInfo[] | null;
}

export class ModelViewDimensionInfo implements IModelViewDimensionInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    axis!: ViewAxis;
    order!: number;
    querySpec?: HierarchicalSpec | null;

    constructor(data?: IModelViewDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
            this.axis = data["axis"] !== undefined ? data["axis"] : null as any;
            this.order = data["order"] !== undefined ? data["order"] : null as any;
            this.querySpec = data["querySpec"] ? HierarchicalSpec.fromJS(data["querySpec"]) : null as any;
        }
    }

    static fromJS(data: any): ModelViewDimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelViewDimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        data["axis"] = this.axis !== undefined ? this.axis : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["querySpec"] = this.querySpec ? this.querySpec.toJSON() : null as any;
        return data;
    }

    clone(): ModelViewDimensionInfo {
        const json = this.toJSON();
        let result = new ModelViewDimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IModelViewDimensionInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    axis: ViewAxis;
    order: number;
    querySpec?: HierarchicalSpec | null;
}

export enum ViewAxis {
    Columns = 0,
    Rows = 1,
    Hidden = -3,
    Slicer = -2,
}

export class BaseElement implements IBaseElement {
    name?: string | null;

    constructor(data?: IBaseElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
        }
    }

    static fromJS(data: any): BaseElement {
        data = typeof data === 'object' ? data : {};
        let result = new BaseElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): BaseElement {
        const json = this.toJSON();
        let result = new BaseElement();
        result.init(json);
        return result;
    }
}

export interface IBaseElement {
    name?: string | null;
}

export class HierarchicalSpec extends BaseElement implements IHierarchicalSpec {
    operation?: string | null;
    memberKey?: string | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberRelationship?: string | null;
    isLeaf!: boolean;
    filterProperty?: string | null;
    filterRelationship?: string | null;
    filterValue?: string | null;
    subsetName?: string | null;
    levelNumber?: string | null;
    fromLevel?: string | null;
    removeDuplicates?: boolean | null;
    toLevel?: string | null;
    count?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    children?: HierarchicalSpec[] | null;

    constructor(data?: IHierarchicalSpec) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.operation = data["operation"] !== undefined ? data["operation"] : null as any;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : null as any;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.memberTag = data["memberTag"] !== undefined ? data["memberTag"] : null as any;
            this.memberRelationship = data["memberRelationship"] !== undefined ? data["memberRelationship"] : null as any;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : null as any;
            this.filterProperty = data["filterProperty"] !== undefined ? data["filterProperty"] : null as any;
            this.filterRelationship = data["filterRelationship"] !== undefined ? data["filterRelationship"] : null as any;
            this.filterValue = data["filterValue"] !== undefined ? data["filterValue"] : null as any;
            this.subsetName = data["subsetName"] !== undefined ? data["subsetName"] : null as any;
            this.levelNumber = data["levelNumber"] !== undefined ? data["levelNumber"] : null as any;
            this.fromLevel = data["fromLevel"] !== undefined ? data["fromLevel"] : null as any;
            this.removeDuplicates = data["removeDuplicates"] !== undefined ? data["removeDuplicates"] : null as any;
            this.toLevel = data["toLevel"] !== undefined ? data["toLevel"] : null as any;
            this.count = data["count"] !== undefined ? data["count"] : null as any;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : null as any;
            this.securityProfileType = data["securityProfileType"] !== undefined ? data["securityProfileType"] : null as any;
            this.securityModel = data["securityModel"] !== undefined ? data["securityModel"] : null as any;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(HierarchicalSpec.fromJS(data["children"][item]));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static override fromJS(data: any): HierarchicalSpec {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchicalSpec();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : null as any;
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["memberTag"] = this.memberTag !== undefined ? this.memberTag : null as any;
        data["memberRelationship"] = this.memberRelationship !== undefined ? this.memberRelationship : null as any;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : null as any;
        data["filterProperty"] = this.filterProperty !== undefined ? this.filterProperty : null as any;
        data["filterRelationship"] = this.filterRelationship !== undefined ? this.filterRelationship : null as any;
        data["filterValue"] = this.filterValue !== undefined ? this.filterValue : null as any;
        data["subsetName"] = this.subsetName !== undefined ? this.subsetName : null as any;
        data["levelNumber"] = this.levelNumber !== undefined ? this.levelNumber : null as any;
        data["fromLevel"] = this.fromLevel !== undefined ? this.fromLevel : null as any;
        data["removeDuplicates"] = this.removeDuplicates !== undefined ? this.removeDuplicates : null as any;
        data["toLevel"] = this.toLevel !== undefined ? this.toLevel : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : null as any;
        data["securityProfileType"] = this.securityProfileType !== undefined ? this.securityProfileType : null as any;
        data["securityModel"] = this.securityModel !== undefined ? this.securityModel : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item] ? this.children[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): HierarchicalSpec {
        const json = this.toJSON();
        let result = new HierarchicalSpec();
        result.init(json);
        return result;
    }
}

export interface IHierarchicalSpec extends IBaseElement {
    operation?: string | null;
    memberKey?: string | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberRelationship?: string | null;
    isLeaf: boolean;
    filterProperty?: string | null;
    filterRelationship?: string | null;
    filterValue?: string | null;
    subsetName?: string | null;
    levelNumber?: string | null;
    fromLevel?: string | null;
    removeDuplicates?: boolean | null;
    toLevel?: string | null;
    count?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    children?: HierarchicalSpec[] | null;
}

export class MainReportingCurrencyResponse implements IMainReportingCurrencyResponse {
    modelName?: string | null;
    dimensionName?: string | null;
    memberName?: string | null;
    memberCaption?: string | null;

    constructor(data?: IMainReportingCurrencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : null as any;
        }
    }

    static fromJS(data: any): MainReportingCurrencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MainReportingCurrencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : null as any;
        return data;
    }

    clone(): MainReportingCurrencyResponse {
        const json = this.toJSON();
        let result = new MainReportingCurrencyResponse();
        result.init(json);
        return result;
    }
}

export interface IMainReportingCurrencyResponse {
    modelName?: string | null;
    dimensionName?: string | null;
    memberName?: string | null;
    memberCaption?: string | null;
}

export class DimensionRoleInfo implements IDimensionRoleInfo {
    dimensionType!: DimensionType;
    roles?: string[] | null;

    constructor(data?: IDimensionRoleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : null as any;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static fromJS(data: any): DimensionRoleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionRoleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        return data;
    }

    clone(): DimensionRoleInfo {
        const json = this.toJSON();
        let result = new DimensionRoleInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionRoleInfo {
    dimensionType: DimensionType;
    roles?: string[] | null;
}

export class DimensionInfo implements IDimensionInfo {
    dimensionName?: string | null;
    dimensionType?: DimensionType | null;
    nonLeafDataMembers?: boolean | null;
    timeBasedHierarchies?: boolean | null;
    translations?: string | null;
    defaultMember?: string | null;
    defaultHierarchyMaxDepth!: number;
    relatedDimension?: string | null;
    hierarchies?: HierarchyInfo[] | null;
    properties?: PropertyInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    syncType?: DimensionSyncType | null;

    constructor(data?: IDimensionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : null as any;
            this.nonLeafDataMembers = data["nonLeafDataMembers"] !== undefined ? data["nonLeafDataMembers"] : null as any;
            this.timeBasedHierarchies = data["timeBasedHierarchies"] !== undefined ? data["timeBasedHierarchies"] : null as any;
            this.translations = data["translations"] !== undefined ? data["translations"] : null as any;
            this.defaultMember = data["defaultMember"] !== undefined ? data["defaultMember"] : null as any;
            this.defaultHierarchyMaxDepth = data["defaultHierarchyMaxDepth"] !== undefined ? data["defaultHierarchyMaxDepth"] : null as any;
            this.relatedDimension = data["relatedDimension"] !== undefined ? data["relatedDimension"] : null as any;
            if (Array.isArray(data["hierarchies"])) {
                this.hierarchies = [] as any;
                for (let item in data["hierarchies"])
                    this.hierarchies!.push(HierarchyInfo.fromJS(data["hierarchies"][item]));
            }
            else {
                this.hierarchies = null as any;
            }
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(PropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : null as any;
            this.syncType = data["syncType"] !== undefined ? data["syncType"] : null as any;
        }
    }

    static fromJS(data: any): DimensionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : null as any;
        data["nonLeafDataMembers"] = this.nonLeafDataMembers !== undefined ? this.nonLeafDataMembers : null as any;
        data["timeBasedHierarchies"] = this.timeBasedHierarchies !== undefined ? this.timeBasedHierarchies : null as any;
        data["translations"] = this.translations !== undefined ? this.translations : null as any;
        data["defaultMember"] = this.defaultMember !== undefined ? this.defaultMember : null as any;
        data["defaultHierarchyMaxDepth"] = this.defaultHierarchyMaxDepth !== undefined ? this.defaultHierarchyMaxDepth : null as any;
        data["relatedDimension"] = this.relatedDimension !== undefined ? this.relatedDimension : null as any;
        if (Array.isArray(this.hierarchies)) {
            data["hierarchies"] = [];
            for (let item in this.hierarchies)
                data["hierarchies"].push(this.hierarchies[item] ? this.hierarchies[item].toJSON() : null as any);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        data["syncType"] = this.syncType !== undefined ? this.syncType : null as any;
        return data;
    }

    clone(): DimensionInfo {
        const json = this.toJSON();
        let result = new DimensionInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionInfo {
    dimensionName?: string | null;
    dimensionType?: DimensionType | null;
    nonLeafDataMembers?: boolean | null;
    timeBasedHierarchies?: boolean | null;
    translations?: string | null;
    defaultMember?: string | null;
    defaultHierarchyMaxDepth: number;
    relatedDimension?: string | null;
    hierarchies?: HierarchyInfo[] | null;
    properties?: PropertyInfo[] | null;
    processingStatus?: ProcessingStatus | null;
    syncType?: DimensionSyncType | null;
}

export class HierarchyInfo implements IHierarchyInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    maxDepth?: number | null;
    defaultSecurityProfile?: string | null;
    defaultReportingMemberKey?: number | null;
    defaultInputMemberKey?: number | null;
    processingStatus?: ProcessingStatus | null;
    isDefaultHierarchy!: boolean;

    constructor(data?: IHierarchyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
            this.maxDepth = data["maxDepth"] !== undefined ? data["maxDepth"] : null as any;
            this.defaultSecurityProfile = data["defaultSecurityProfile"] !== undefined ? data["defaultSecurityProfile"] : null as any;
            this.defaultReportingMemberKey = data["defaultReportingMemberKey"] !== undefined ? data["defaultReportingMemberKey"] : null as any;
            this.defaultInputMemberKey = data["defaultInputMemberKey"] !== undefined ? data["defaultInputMemberKey"] : null as any;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : null as any;
            this.isDefaultHierarchy = data["isDefaultHierarchy"] !== undefined ? data["isDefaultHierarchy"] : null as any;
        }
    }

    static fromJS(data: any): HierarchyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        data["maxDepth"] = this.maxDepth !== undefined ? this.maxDepth : null as any;
        data["defaultSecurityProfile"] = this.defaultSecurityProfile !== undefined ? this.defaultSecurityProfile : null as any;
        data["defaultReportingMemberKey"] = this.defaultReportingMemberKey !== undefined ? this.defaultReportingMemberKey : null as any;
        data["defaultInputMemberKey"] = this.defaultInputMemberKey !== undefined ? this.defaultInputMemberKey : null as any;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        data["isDefaultHierarchy"] = this.isDefaultHierarchy !== undefined ? this.isDefaultHierarchy : null as any;
        return data;
    }

    clone(): HierarchyInfo {
        const json = this.toJSON();
        let result = new HierarchyInfo();
        result.init(json);
        return result;
    }
}

export interface IHierarchyInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    maxDepth?: number | null;
    defaultSecurityProfile?: string | null;
    defaultReportingMemberKey?: number | null;
    defaultInputMemberKey?: number | null;
    processingStatus?: ProcessingStatus | null;
    isDefaultHierarchy: boolean;
}

export class PropertyInfo implements IPropertyInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    standardProperty?: boolean | null;
    reportingProperty?: boolean | null;
    readonlyProperty!: boolean;
    processingStatus?: ProcessingStatus | null;
    typeInfo?: string | null;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : null as any;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : null as any;
            this.standardProperty = data["standardProperty"] !== undefined ? data["standardProperty"] : null as any;
            this.reportingProperty = data["reportingProperty"] !== undefined ? data["reportingProperty"] : null as any;
            this.readonlyProperty = data["readonlyProperty"] !== undefined ? data["readonlyProperty"] : null as any;
            this.processingStatus = data["processingStatus"] !== undefined ? data["processingStatus"] : null as any;
            this.typeInfo = data["typeInfo"] !== undefined ? data["typeInfo"] : null as any;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        data["standardProperty"] = this.standardProperty !== undefined ? this.standardProperty : null as any;
        data["reportingProperty"] = this.reportingProperty !== undefined ? this.reportingProperty : null as any;
        data["readonlyProperty"] = this.readonlyProperty !== undefined ? this.readonlyProperty : null as any;
        data["processingStatus"] = this.processingStatus !== undefined ? this.processingStatus : null as any;
        data["typeInfo"] = this.typeInfo !== undefined ? this.typeInfo : null as any;
        return data;
    }

    clone(): PropertyInfo {
        const json = this.toJSON();
        let result = new PropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IPropertyInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    standardProperty?: boolean | null;
    reportingProperty?: boolean | null;
    readonlyProperty: boolean;
    processingStatus?: ProcessingStatus | null;
    typeInfo?: string | null;
}

export enum DimensionSyncType {
    Hierarchical = 1,
    FlatList = 2,
    None = 3,
}

export class DimensionPropertyOptionsResponse implements IDimensionPropertyOptionsResponse {
    properties?: DimensionPropertyOptionsInfo[] | null;

    constructor(data?: IDimensionPropertyOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(DimensionPropertyOptionsInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
        }
    }

    static fromJS(data: any): DimensionPropertyOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionPropertyOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DimensionPropertyOptionsResponse {
        const json = this.toJSON();
        let result = new DimensionPropertyOptionsResponse();
        result.init(json);
        return result;
    }
}

export interface IDimensionPropertyOptionsResponse {
    properties?: DimensionPropertyOptionsInfo[] | null;
}

export class DimensionPropertyOptionsInfo implements IDimensionPropertyOptionsInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    isStandard!: boolean;
    validValues?: string[] | null;
    dimensionName?: string | null;

    constructor(data?: IDimensionPropertyOptionsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : null as any;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : null as any;
            this.isStandard = data["isStandard"] !== undefined ? data["isStandard"] : null as any;
            if (Array.isArray(data["validValues"])) {
                this.validValues = [] as any;
                for (let item in data["validValues"])
                    this.validValues!.push(data["validValues"][item]);
            }
            else {
                this.validValues = null as any;
            }
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
        }
    }

    static fromJS(data: any): DimensionPropertyOptionsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionPropertyOptionsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        data["isStandard"] = this.isStandard !== undefined ? this.isStandard : null as any;
        if (Array.isArray(this.validValues)) {
            data["validValues"] = [];
            for (let item in this.validValues)
                data["validValues"].push(this.validValues[item]);
        }
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        return data;
    }

    clone(): DimensionPropertyOptionsInfo {
        const json = this.toJSON();
        let result = new DimensionPropertyOptionsInfo();
        result.init(json);
        return result;
    }
}

export interface IDimensionPropertyOptionsInfo {
    propertyName?: string | null;
    propertyType?: string | null;
    isStandard: boolean;
    validValues?: string[] | null;
    dimensionName?: string | null;
}

export class StandardAttributeInfo implements IStandardAttributeInfo {
    dimensionType!: DimensionType;
    attributes?: StandardAttribute[] | null;

    constructor(data?: IStandardAttributeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionType = data["dimensionType"] !== undefined ? data["dimensionType"] : null as any;
            if (Array.isArray(data["attributes"])) {
                this.attributes = [] as any;
                for (let item in data["attributes"])
                    this.attributes!.push(StandardAttribute.fromJS(data["attributes"][item]));
            }
            else {
                this.attributes = null as any;
            }
        }
    }

    static fromJS(data: any): StandardAttributeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StandardAttributeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionType"] = this.dimensionType !== undefined ? this.dimensionType : null as any;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item in this.attributes)
                data["attributes"].push(this.attributes[item] ? this.attributes[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): StandardAttributeInfo {
        const json = this.toJSON();
        let result = new StandardAttributeInfo();
        result.init(json);
        return result;
    }
}

export interface IStandardAttributeInfo {
    dimensionType: DimensionType;
    attributes?: StandardAttribute[] | null;
}

export class StandardAttribute implements IStandardAttribute {
    name?: string | null;
    dataType?: string | null;
    typeInfo?: string | null;

    constructor(data?: IStandardAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.dataType = data["dataType"] !== undefined ? data["dataType"] : null as any;
            this.typeInfo = data["typeInfo"] !== undefined ? data["typeInfo"] : null as any;
        }
    }

    static fromJS(data: any): StandardAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StandardAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["dataType"] = this.dataType !== undefined ? this.dataType : null as any;
        data["typeInfo"] = this.typeInfo !== undefined ? this.typeInfo : null as any;
        return data;
    }

    clone(): StandardAttribute {
        const json = this.toJSON();
        let result = new StandardAttribute();
        result.init(json);
        return result;
    }
}

export interface IStandardAttribute {
    name?: string | null;
    dataType?: string | null;
    typeInfo?: string | null;
}

export class SubsetInfo implements ISubsetInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    subsetName?: string | null;
    members?: string[] | null;

    constructor(data?: ISubsetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
            this.subsetName = data["subsetName"] !== undefined ? data["subsetName"] : null as any;
            if (Array.isArray(data["members"])) {
                this.members = [] as any;
                for (let item in data["members"])
                    this.members!.push(data["members"][item]);
            }
            else {
                this.members = null as any;
            }
        }
    }

    static fromJS(data: any): SubsetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SubsetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        data["subsetName"] = this.subsetName !== undefined ? this.subsetName : null as any;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item in this.members)
                data["members"].push(this.members[item]);
        }
        return data;
    }

    clone(): SubsetInfo {
        const json = this.toJSON();
        let result = new SubsetInfo();
        result.init(json);
        return result;
    }
}

export interface ISubsetInfo {
    dimensionName?: string | null;
    hierarchyName?: string | null;
    subsetName?: string | null;
    members?: string[] | null;
}

export class MemberInfo implements IMemberInfo {
    memberKey?: number | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberCaption?: string | null;
    hierarchy?: string | null;
    level?: number | null;
    group?: boolean | null;
    translations?: MemberTranslationInfo[] | null;
    parentKey?: number | null;
    sortOrder?: number | null;
    isLeaf?: boolean | null;
    operator?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    memberStorage?: MemberStorage | null;
    baseKey?: number | null;
    timeBasedMember?: boolean | null;
    baseName?: string | null;
    properties?: MemberPropertyInfo[] | null;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : null as any;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.memberTag = data["memberTag"] !== undefined ? data["memberTag"] : null as any;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : null as any;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : null as any;
            this.level = data["level"] !== undefined ? data["level"] : null as any;
            this.group = data["group"] !== undefined ? data["group"] : null as any;
            if (Array.isArray(data["translations"])) {
                this.translations = [] as any;
                for (let item in data["translations"])
                    this.translations!.push(MemberTranslationInfo.fromJS(data["translations"][item]));
            }
            else {
                this.translations = null as any;
            }
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : null as any;
            this.operator = data["operator"] !== undefined ? data["operator"] : null as any;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : null as any;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : null as any;
            this.memberStorage = data["memberStorage"] !== undefined ? data["memberStorage"] : null as any;
            this.baseKey = data["baseKey"] !== undefined ? data["baseKey"] : null as any;
            this.timeBasedMember = data["timeBasedMember"] !== undefined ? data["timeBasedMember"] : null as any;
            this.baseName = data["baseName"] !== undefined ? data["baseName"] : null as any;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(MemberPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : null as any;
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["memberTag"] = this.memberTag !== undefined ? this.memberTag : null as any;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : null as any;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["group"] = this.group !== undefined ? this.group : null as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item in this.translations)
                data["translations"].push(this.translations[item] ? this.translations[item].toJSON() : null as any);
        }
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["startDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null as any;
        data["memberStorage"] = this.memberStorage !== undefined ? this.memberStorage : null as any;
        data["baseKey"] = this.baseKey !== undefined ? this.baseKey : null as any;
        data["timeBasedMember"] = this.timeBasedMember !== undefined ? this.timeBasedMember : null as any;
        data["baseName"] = this.baseName !== undefined ? this.baseName : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MemberInfo {
        const json = this.toJSON();
        let result = new MemberInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberInfo {
    memberKey?: number | null;
    memberName?: string | null;
    memberTag?: string | null;
    memberCaption?: string | null;
    hierarchy?: string | null;
    level?: number | null;
    group?: boolean | null;
    translations?: MemberTranslationInfo[] | null;
    parentKey?: number | null;
    sortOrder?: number | null;
    isLeaf?: boolean | null;
    operator?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    memberStorage?: MemberStorage | null;
    baseKey?: number | null;
    timeBasedMember?: boolean | null;
    baseName?: string | null;
    properties?: MemberPropertyInfo[] | null;
}

export class MemberTranslationInfo implements IMemberTranslationInfo {
    language?: string | null;
    caption?: string | null;

    constructor(data?: IMemberTranslationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] !== undefined ? data["language"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
        }
    }

    static fromJS(data: any): MemberTranslationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberTranslationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        return data;
    }

    clone(): MemberTranslationInfo {
        const json = this.toJSON();
        let result = new MemberTranslationInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberTranslationInfo {
    language?: string | null;
    caption?: string | null;
}

export enum MemberStorage {
    Standard = 0,
    Shared = 1,
    Static = 2,
}

export class MemberPropertyInfo implements IMemberPropertyInfo {
    propertyName?: string | null;
    propertyValue?: string | null;

    constructor(data?: IMemberPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : null as any;
            this.propertyValue = data["propertyValue"] !== undefined ? data["propertyValue"] : null as any;
        }
    }

    static fromJS(data: any): MemberPropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["propertyValue"] = this.propertyValue !== undefined ? this.propertyValue : null as any;
        return data;
    }

    clone(): MemberPropertyInfo {
        const json = this.toJSON();
        let result = new MemberPropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberPropertyInfo {
    propertyName?: string | null;
    propertyValue?: string | null;
}

export class MemberInfoSimple implements IMemberInfoSimple {
    memberKey?: number | null;
    memberName?: string | null;
    memberCaption?: string | null;
    parentKey?: number | null;
    isLeaf?: boolean | null;
    properties?: MemberPropertyInfo[] | null;

    constructor(data?: IMemberInfoSimple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : null as any;
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : null as any;
            this.parentKey = data["parentKey"] !== undefined ? data["parentKey"] : null as any;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : null as any;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(MemberPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
        }
    }

    static fromJS(data: any): MemberInfoSimple {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoSimple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : null as any;
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : null as any;
        data["parentKey"] = this.parentKey !== undefined ? this.parentKey : null as any;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MemberInfoSimple {
        const json = this.toJSON();
        let result = new MemberInfoSimple();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoSimple {
    memberKey?: number | null;
    memberName?: string | null;
    memberCaption?: string | null;
    parentKey?: number | null;
    isLeaf?: boolean | null;
    properties?: MemberPropertyInfo[] | null;
}

export class MemberChronologyInfo implements IMemberChronologyInfo {
    memberName?: string | null;
    memberCaption?: string | null;
    parentName?: string | null;
    parentCaption?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    memberInfoType?: MemberStorage | null;
    baseName?: string | null;

    constructor(data?: IMemberChronologyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberName = data["memberName"] !== undefined ? data["memberName"] : null as any;
            this.memberCaption = data["memberCaption"] !== undefined ? data["memberCaption"] : null as any;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : null as any;
            this.parentCaption = data["parentCaption"] !== undefined ? data["parentCaption"] : null as any;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : null as any;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : null as any;
            this.memberInfoType = data["memberInfoType"] !== undefined ? data["memberInfoType"] : null as any;
            this.baseName = data["baseName"] !== undefined ? data["baseName"] : null as any;
        }
    }

    static fromJS(data: any): MemberChronologyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberChronologyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberName"] = this.memberName !== undefined ? this.memberName : null as any;
        data["memberCaption"] = this.memberCaption !== undefined ? this.memberCaption : null as any;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        data["parentCaption"] = this.parentCaption !== undefined ? this.parentCaption : null as any;
        data["startDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null as any;
        data["memberInfoType"] = this.memberInfoType !== undefined ? this.memberInfoType : null as any;
        data["baseName"] = this.baseName !== undefined ? this.baseName : null as any;
        return data;
    }

    clone(): MemberChronologyInfo {
        const json = this.toJSON();
        let result = new MemberChronologyInfo();
        result.init(json);
        return result;
    }
}

export interface IMemberChronologyInfo {
    memberName?: string | null;
    memberCaption?: string | null;
    parentName?: string | null;
    parentCaption?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    memberInfoType?: MemberStorage | null;
    baseName?: string | null;
}

export class MemberInfoSingleGroupResult implements IMemberInfoSingleGroupResult {
    rowCount!: number;
    rowData?: MemberInfo[] | null;

    constructor(data?: IMemberInfoSingleGroupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : null as any;
            if (Array.isArray(data["rowData"])) {
                this.rowData = [] as any;
                for (let item in data["rowData"])
                    this.rowData!.push(MemberInfo.fromJS(data["rowData"][item]));
            }
            else {
                this.rowData = null as any;
            }
        }
    }

    static fromJS(data: any): MemberInfoSingleGroupResult {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoSingleGroupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.rowData)) {
            data["rowData"] = [];
            for (let item in this.rowData)
                data["rowData"].push(this.rowData[item] ? this.rowData[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MemberInfoSingleGroupResult {
        const json = this.toJSON();
        let result = new MemberInfoSingleGroupResult();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoSingleGroupResult {
    rowCount: number;
    rowData?: MemberInfo[] | null;
}

export class SingleGroupRequest implements ISingleGroupRequest {
    parentMemberKey?: number | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;

    constructor(data?: ISingleGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentMemberKey = data["parentMemberKey"] !== undefined ? data["parentMemberKey"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
        }
    }

    static fromJS(data: any): SingleGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SingleGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentMemberKey"] = this.parentMemberKey !== undefined ? this.parentMemberKey : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        return data;
    }

    clone(): SingleGroupRequest {
        const json = this.toJSON();
        let result = new SingleGroupRequest();
        result.init(json);
        return result;
    }
}

export interface ISingleGroupRequest {
    parentMemberKey?: number | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
}

export class MemberInfoPagedResults implements IMemberInfoPagedResults {
    results?: MemberInfo[] | null;

    constructor(data?: IMemberInfoPagedResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["results"])) {
                this.results = [] as any;
                for (let item in data["results"])
                    this.results!.push(MemberInfo.fromJS(data["results"][item]));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): MemberInfoPagedResults {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoPagedResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item in this.results)
                data["results"].push(this.results[item] ? this.results[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): MemberInfoPagedResults {
        const json = this.toJSON();
        let result = new MemberInfoPagedResults();
        result.init(json);
        return result;
    }
}

export interface IMemberInfoPagedResults {
    results?: MemberInfo[] | null;
}

export class HierarchyMemberPaging extends Paging implements IHierarchyMemberPaging {
    serverGroupLevel!: number;
    dimensionName?: string | null;
    hierarchyName?: string | null;

    constructor(data?: IHierarchyMemberPaging) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.serverGroupLevel = data["serverGroupLevel"] !== undefined ? data["serverGroupLevel"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
        }
    }

    static override fromJS(data: any): HierarchyMemberPaging {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyMemberPaging();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverGroupLevel"] = this.serverGroupLevel !== undefined ? this.serverGroupLevel : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): HierarchyMemberPaging {
        const json = this.toJSON();
        let result = new HierarchyMemberPaging();
        result.init(json);
        return result;
    }
}

export interface IHierarchyMemberPaging extends IPaging {
    serverGroupLevel: number;
    dimensionName?: string | null;
    hierarchyName?: string | null;
}

export enum HierarchySyncMode {
    AdditionsOnly = 0,
    AdditionsAndUpdates = 1,
    AdditionsUpdatesAndDeletes = 2,
}

export class DataImportActionResult implements IDataImportActionResult {
    insertCount!: number;
    updateCount!: number;
    deleteCount!: number;
    renameCount!: number;
    renameUpdateCount!: number;
    dataImportResult?: DataImportResult[] | null;

    constructor(data?: IDataImportActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.insertCount = data["insertCount"] !== undefined ? data["insertCount"] : null as any;
            this.updateCount = data["updateCount"] !== undefined ? data["updateCount"] : null as any;
            this.deleteCount = data["deleteCount"] !== undefined ? data["deleteCount"] : null as any;
            this.renameCount = data["renameCount"] !== undefined ? data["renameCount"] : null as any;
            this.renameUpdateCount = data["renameUpdateCount"] !== undefined ? data["renameUpdateCount"] : null as any;
            if (Array.isArray(data["dataImportResult"])) {
                this.dataImportResult = [] as any;
                for (let item in data["dataImportResult"])
                    this.dataImportResult!.push(DataImportResult.fromJS(data["dataImportResult"][item]));
            }
            else {
                this.dataImportResult = null as any;
            }
        }
    }

    static fromJS(data: any): DataImportActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insertCount"] = this.insertCount !== undefined ? this.insertCount : null as any;
        data["updateCount"] = this.updateCount !== undefined ? this.updateCount : null as any;
        data["deleteCount"] = this.deleteCount !== undefined ? this.deleteCount : null as any;
        data["renameCount"] = this.renameCount !== undefined ? this.renameCount : null as any;
        data["renameUpdateCount"] = this.renameUpdateCount !== undefined ? this.renameUpdateCount : null as any;
        if (Array.isArray(this.dataImportResult)) {
            data["dataImportResult"] = [];
            for (let item in this.dataImportResult)
                data["dataImportResult"].push(this.dataImportResult[item] ? this.dataImportResult[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DataImportActionResult {
        const json = this.toJSON();
        let result = new DataImportActionResult();
        result.init(json);
        return result;
    }
}

export interface IDataImportActionResult {
    insertCount: number;
    updateCount: number;
    deleteCount: number;
    renameCount: number;
    renameUpdateCount: number;
    dataImportResult?: DataImportResult[] | null;
}

export class DataImportResult implements IDataImportResult {
    action?: string | null;
    rowNo?: string | null;
    name?: string | null;
    newName?: string | null;
    parentName?: string | null;
    isLeaf!: boolean;
    tag?: string | null;
    operator?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    captions?: DataImportKeyValue[] | null;
    properties?: DataImportKeyValue[] | null;
    type?: string | null;

    constructor(data?: IDataImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"] !== undefined ? data["action"] : null as any;
            this.rowNo = data["rowNo"] !== undefined ? data["rowNo"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.newName = data["newName"] !== undefined ? data["newName"] : null as any;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : null as any;
            this.isLeaf = data["isLeaf"] !== undefined ? data["isLeaf"] : null as any;
            this.tag = data["tag"] !== undefined ? data["tag"] : null as any;
            this.operator = data["operator"] !== undefined ? data["operator"] : null as any;
            this.startDate = data["startDate"] !== undefined ? data["startDate"] : null as any;
            this.endDate = data["endDate"] !== undefined ? data["endDate"] : null as any;
            if (Array.isArray(data["captions"])) {
                this.captions = [] as any;
                for (let item in data["captions"])
                    this.captions!.push(DataImportKeyValue.fromJS(data["captions"][item]));
            }
            else {
                this.captions = null as any;
            }
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(DataImportKeyValue.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static fromJS(data: any): DataImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["rowNo"] = this.rowNo !== undefined ? this.rowNo : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["newName"] = this.newName !== undefined ? this.newName : null as any;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null as any;
        data["isLeaf"] = this.isLeaf !== undefined ? this.isLeaf : null as any;
        data["tag"] = this.tag !== undefined ? this.tag : null as any;
        data["operator"] = this.operator !== undefined ? this.operator : null as any;
        data["startDate"] = this.startDate !== undefined ? this.startDate : null as any;
        data["endDate"] = this.endDate !== undefined ? this.endDate : null as any;
        if (Array.isArray(this.captions)) {
            data["captions"] = [];
            for (let item in this.captions)
                data["captions"].push(this.captions[item] ? this.captions[item].toJSON() : null as any);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): DataImportResult {
        const json = this.toJSON();
        let result = new DataImportResult();
        result.init(json);
        return result;
    }
}

export interface IDataImportResult {
    action?: string | null;
    rowNo?: string | null;
    name?: string | null;
    newName?: string | null;
    parentName?: string | null;
    isLeaf: boolean;
    tag?: string | null;
    operator?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    captions?: DataImportKeyValue[] | null;
    properties?: DataImportKeyValue[] | null;
    type?: string | null;
}

export class DataImportKeyValue implements IDataImportKeyValue {
    key?: string | null;
    value?: string | null;

    constructor(data?: IDataImportKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
        }
    }

    static fromJS(data: any): DataImportKeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new DataImportKeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): DataImportKeyValue {
        const json = this.toJSON();
        let result = new DataImportKeyValue();
        result.init(json);
        return result;
    }
}

export interface IDataImportKeyValue {
    key?: string | null;
    value?: string | null;
}

export class ListInfo implements IListInfo {
    listDetails?: ListDetailsInfo | null;
    properties?: ListPropertyInfo[] | null;

    constructor(data?: IListInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listDetails = data["listDetails"] ? ListDetailsInfo.fromJS(data["listDetails"]) : null as any;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(ListPropertyInfo.fromJS(data["properties"][item]));
            }
            else {
                this.properties = null as any;
            }
        }
    }

    static fromJS(data: any): ListInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listDetails"] = this.listDetails ? this.listDetails.toJSON() : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item] ? this.properties[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ListInfo {
        const json = this.toJSON();
        let result = new ListInfo();
        result.init(json);
        return result;
    }
}

export interface IListInfo {
    listDetails?: ListDetailsInfo | null;
    properties?: ListPropertyInfo[] | null;
}

export class ListDetailsInfo implements IListDetailsInfo {
    listId!: number;
    list?: string | null;
    idOnly!: boolean;
    withSelection!: boolean;
    listTypeID?: number | null;
    listType?: string | null;
    headerListID?: number | null;
    headerList?: string | null;
    sortOrder!: number;
    system!: boolean;
    afterClose?: string | null;
    folder?: string | null;

    constructor(data?: IListDetailsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listId = data["listId"] !== undefined ? data["listId"] : null as any;
            this.list = data["list"] !== undefined ? data["list"] : null as any;
            this.idOnly = data["idOnly"] !== undefined ? data["idOnly"] : null as any;
            this.withSelection = data["withSelection"] !== undefined ? data["withSelection"] : null as any;
            this.listTypeID = data["listTypeID"] !== undefined ? data["listTypeID"] : null as any;
            this.listType = data["listType"] !== undefined ? data["listType"] : null as any;
            this.headerListID = data["headerListID"] !== undefined ? data["headerListID"] : null as any;
            this.headerList = data["headerList"] !== undefined ? data["headerList"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
            this.system = data["system"] !== undefined ? data["system"] : null as any;
            this.afterClose = data["afterClose"] !== undefined ? data["afterClose"] : null as any;
            this.folder = data["folder"] !== undefined ? data["folder"] : null as any;
        }
    }

    static fromJS(data: any): ListDetailsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListDetailsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId !== undefined ? this.listId : null as any;
        data["list"] = this.list !== undefined ? this.list : null as any;
        data["idOnly"] = this.idOnly !== undefined ? this.idOnly : null as any;
        data["withSelection"] = this.withSelection !== undefined ? this.withSelection : null as any;
        data["listTypeID"] = this.listTypeID !== undefined ? this.listTypeID : null as any;
        data["listType"] = this.listType !== undefined ? this.listType : null as any;
        data["headerListID"] = this.headerListID !== undefined ? this.headerListID : null as any;
        data["headerList"] = this.headerList !== undefined ? this.headerList : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        data["afterClose"] = this.afterClose !== undefined ? this.afterClose : null as any;
        data["folder"] = this.folder !== undefined ? this.folder : null as any;
        return data;
    }

    clone(): ListDetailsInfo {
        const json = this.toJSON();
        let result = new ListDetailsInfo();
        result.init(json);
        return result;
    }
}

export interface IListDetailsInfo {
    listId: number;
    list?: string | null;
    idOnly: boolean;
    withSelection: boolean;
    listTypeID?: number | null;
    listType?: string | null;
    headerListID?: number | null;
    headerList?: string | null;
    sortOrder: number;
    system: boolean;
    afterClose?: string | null;
    folder?: string | null;
}

export class ListPropertyInfo implements IListPropertyInfo {
    id!: number;
    propertyDetails?: ListPropertyDetailsInfo | null;
    listDetails?: ListDetailsInfo | null;
    propertyName?: string | null;
    propertyRename?: string | null;
    sortOrder!: number;
    system!: boolean;
    hide!: boolean;
    header!: boolean;
    filter?: string | null;
    selection!: boolean;

    constructor(data?: IListPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.propertyDetails = data["propertyDetails"] ? ListPropertyDetailsInfo.fromJS(data["propertyDetails"]) : null as any;
            this.listDetails = data["listDetails"] ? ListDetailsInfo.fromJS(data["listDetails"]) : null as any;
            this.propertyName = data["propertyName"] !== undefined ? data["propertyName"] : null as any;
            this.propertyRename = data["propertyRename"] !== undefined ? data["propertyRename"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
            this.system = data["system"] !== undefined ? data["system"] : null as any;
            this.hide = data["hide"] !== undefined ? data["hide"] : null as any;
            this.header = data["header"] !== undefined ? data["header"] : null as any;
            this.filter = data["filter"] !== undefined ? data["filter"] : null as any;
            this.selection = data["selection"] !== undefined ? data["selection"] : null as any;
        }
    }

    static fromJS(data: any): ListPropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListPropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["propertyDetails"] = this.propertyDetails ? this.propertyDetails.toJSON() : null as any;
        data["listDetails"] = this.listDetails ? this.listDetails.toJSON() : null as any;
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["propertyRename"] = this.propertyRename !== undefined ? this.propertyRename : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        data["hide"] = this.hide !== undefined ? this.hide : null as any;
        data["header"] = this.header !== undefined ? this.header : null as any;
        data["filter"] = this.filter !== undefined ? this.filter : null as any;
        data["selection"] = this.selection !== undefined ? this.selection : null as any;
        return data;
    }

    clone(): ListPropertyInfo {
        const json = this.toJSON();
        let result = new ListPropertyInfo();
        result.init(json);
        return result;
    }
}

export interface IListPropertyInfo {
    id: number;
    propertyDetails?: ListPropertyDetailsInfo | null;
    listDetails?: ListDetailsInfo | null;
    propertyName?: string | null;
    propertyRename?: string | null;
    sortOrder: number;
    system: boolean;
    hide: boolean;
    header: boolean;
    filter?: string | null;
    selection: boolean;
}

export class ListPropertyDetailsInfo implements IListPropertyDetailsInfo {
    propertyID!: number;
    property?: string | null;
    propertyType?: ListPropertyType | null;
    propertyLength?: number | null;
    propertyLinkID?: number | null;
    propertyLink?: string | null;
    organization?: boolean | null;
    defaultValue?: string | null;
    sortOrder?: number | null;
    system!: boolean;

    constructor(data?: IListPropertyDetailsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyID = data["propertyID"] !== undefined ? data["propertyID"] : null as any;
            this.property = data["property"] !== undefined ? data["property"] : null as any;
            this.propertyType = data["propertyType"] !== undefined ? data["propertyType"] : null as any;
            this.propertyLength = data["propertyLength"] !== undefined ? data["propertyLength"] : null as any;
            this.propertyLinkID = data["propertyLinkID"] !== undefined ? data["propertyLinkID"] : null as any;
            this.propertyLink = data["propertyLink"] !== undefined ? data["propertyLink"] : null as any;
            this.organization = data["organization"] !== undefined ? data["organization"] : null as any;
            this.defaultValue = data["defaultValue"] !== undefined ? data["defaultValue"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
            this.system = data["system"] !== undefined ? data["system"] : null as any;
        }
    }

    static fromJS(data: any): ListPropertyDetailsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ListPropertyDetailsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyID"] = this.propertyID !== undefined ? this.propertyID : null as any;
        data["property"] = this.property !== undefined ? this.property : null as any;
        data["propertyType"] = this.propertyType !== undefined ? this.propertyType : null as any;
        data["propertyLength"] = this.propertyLength !== undefined ? this.propertyLength : null as any;
        data["propertyLinkID"] = this.propertyLinkID !== undefined ? this.propertyLinkID : null as any;
        data["propertyLink"] = this.propertyLink !== undefined ? this.propertyLink : null as any;
        data["organization"] = this.organization !== undefined ? this.organization : null as any;
        data["defaultValue"] = this.defaultValue !== undefined ? this.defaultValue : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        return data;
    }

    clone(): ListPropertyDetailsInfo {
        const json = this.toJSON();
        let result = new ListPropertyDetailsInfo();
        result.init(json);
        return result;
    }
}

export interface IListPropertyDetailsInfo {
    propertyID: number;
    property?: string | null;
    propertyType?: ListPropertyType | null;
    propertyLength?: number | null;
    propertyLinkID?: number | null;
    propertyLink?: string | null;
    organization?: boolean | null;
    defaultValue?: string | null;
    sortOrder?: number | null;
    system: boolean;
}

export enum ListPropertyType {
    Character = 1,
    List = 2,
    Dimension = 3,
    Integer = 5,
    DateTime = 6,
    Boolean = 7,
    Bigint = 11,
    DimensionList = 12,
    PropertyList = 14,
    Table = 15,
    Model = 16,
    TableList = 17,
    DimensionType = 19,
    Decimal = 20,
}

export class ExtractHierarchyInfo implements IExtractHierarchyInfo {
    extractID!: number;
    extractName?: string | null;

    constructor(data?: IExtractHierarchyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : null as any;
            this.extractName = data["extractName"] !== undefined ? data["extractName"] : null as any;
        }
    }

    static fromJS(data: any): ExtractHierarchyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extractID"] = this.extractID !== undefined ? this.extractID : null as any;
        data["extractName"] = this.extractName !== undefined ? this.extractName : null as any;
        return data;
    }

    clone(): ExtractHierarchyInfo {
        const json = this.toJSON();
        let result = new ExtractHierarchyInfo();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyInfo {
    extractID: number;
    extractName?: string | null;
}

export class ExtractHierarchyDetail implements IExtractHierarchyDetail {
    dimension?: string | null;
    extractID!: number;
    extractName?: string | null;
    properties?: string[] | null;
    includePath!: boolean;
    includeKey!: boolean;
    includeShared!: boolean;
    order!: boolean;
    members?: ExtractHierarchiesMemberInfo[] | null;

    constructor(data?: IExtractHierarchyDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : null as any;
            this.extractName = data["extractName"] !== undefined ? data["extractName"] : null as any;
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item in data["properties"])
                    this.properties!.push(data["properties"][item]);
            }
            else {
                this.properties = null as any;
            }
            this.includePath = data["includePath"] !== undefined ? data["includePath"] : null as any;
            this.includeKey = data["includeKey"] !== undefined ? data["includeKey"] : null as any;
            this.includeShared = data["includeShared"] !== undefined ? data["includeShared"] : null as any;
            this.order = data["order"] !== undefined ? data["order"] : null as any;
            if (Array.isArray(data["members"])) {
                this.members = [] as any;
                for (let item in data["members"])
                    this.members!.push(ExtractHierarchiesMemberInfo.fromJS(data["members"][item]));
            }
            else {
                this.members = null as any;
            }
        }
    }

    static fromJS(data: any): ExtractHierarchyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["extractID"] = this.extractID !== undefined ? this.extractID : null as any;
        data["extractName"] = this.extractName !== undefined ? this.extractName : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item in this.properties)
                data["properties"].push(this.properties[item]);
        }
        data["includePath"] = this.includePath !== undefined ? this.includePath : null as any;
        data["includeKey"] = this.includeKey !== undefined ? this.includeKey : null as any;
        data["includeShared"] = this.includeShared !== undefined ? this.includeShared : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item in this.members)
                data["members"].push(this.members[item] ? this.members[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ExtractHierarchyDetail {
        const json = this.toJSON();
        let result = new ExtractHierarchyDetail();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyDetail {
    dimension?: string | null;
    extractID: number;
    extractName?: string | null;
    properties?: string[] | null;
    includePath: boolean;
    includeKey: boolean;
    includeShared: boolean;
    order: boolean;
    members?: ExtractHierarchiesMemberInfo[] | null;
}

export class ExtractHierarchiesMemberInfo implements IExtractHierarchiesMemberInfo {
    memberID!: number;
    relationship!: number;
    includeExclude!: number;

    constructor(data?: IExtractHierarchiesMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberID = data["memberID"] !== undefined ? data["memberID"] : null as any;
            this.relationship = data["relationship"] !== undefined ? data["relationship"] : null as any;
            this.includeExclude = data["includeExclude"] !== undefined ? data["includeExclude"] : null as any;
        }
    }

    static fromJS(data: any): ExtractHierarchiesMemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchiesMemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberID"] = this.memberID !== undefined ? this.memberID : null as any;
        data["relationship"] = this.relationship !== undefined ? this.relationship : null as any;
        data["includeExclude"] = this.includeExclude !== undefined ? this.includeExclude : null as any;
        return data;
    }

    clone(): ExtractHierarchiesMemberInfo {
        const json = this.toJSON();
        let result = new ExtractHierarchiesMemberInfo();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchiesMemberInfo {
    memberID: number;
    relationship: number;
    includeExclude: number;
}

export class PowerBIEmbedInfo implements IPowerBIEmbedInfo {
    reportId!: string;
    embedUrl?: string | null;
    accessToken?: string | null;

    constructor(data?: IPowerBIEmbedInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : null as any;
            this.embedUrl = data["embedUrl"] !== undefined ? data["embedUrl"] : null as any;
            this.accessToken = data["accessToken"] !== undefined ? data["accessToken"] : null as any;
        }
    }

    static fromJS(data: any): PowerBIEmbedInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBIEmbedInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId !== undefined ? this.reportId : null as any;
        data["embedUrl"] = this.embedUrl !== undefined ? this.embedUrl : null as any;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : null as any;
        return data;
    }

    clone(): PowerBIEmbedInfo {
        const json = this.toJSON();
        let result = new PowerBIEmbedInfo();
        result.init(json);
        return result;
    }
}

export interface IPowerBIEmbedInfo {
    reportId: string;
    embedUrl?: string | null;
    accessToken?: string | null;
}

export class Process implements IProcess {
    activities?: BaseProcessActivity[] | null;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item in data["activities"])
                    this.activities!.push(BaseProcessActivity.fromJS(data["activities"][item]));
            }
            else {
                this.activities = null as any;
            }
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item in this.activities)
                data["activities"].push(this.activities[item] ? this.activities[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): Process {
        const json = this.toJSON();
        let result = new Process();
        result.init(json);
        return result;
    }
}

export interface IProcess {
    activities?: BaseProcessActivity[] | null;
}

export abstract class BaseProcessActivity implements IBaseProcessActivity {
    name?: string | null;
    disabled?: boolean | null;
    advanceRule?: AdvanceRule | null;

    protected _discriminator: string;

    constructor(data?: IBaseProcessActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "BaseProcessActivity";
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.disabled = data["disabled"] !== undefined ? data["disabled"] : null as any;
            this.advanceRule = data["advanceRule"] !== undefined ? data["advanceRule"] : null as any;
        }
    }

    static fromJS(data: any): BaseProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ADOImportActivity") {
            let result = new ADOImportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NonInteractiveProcessActivity") {
            throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "ADOTriggerActivity") {
            let result = new ADOTriggerActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnaplanWorkflowActivity") {
            let result = new AnaplanWorkflowActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ArchiveXL3ReportActivity") {
            let result = new ArchiveXL3ReportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticFileImportProcessActivity") {
            let result = new AutomaticFileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticHierarchySyncProcessActivity") {
            let result = new AutomaticHierarchySyncProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AzureDataFactoryPipelineActivity") {
            let result = new AzureDataFactoryPipelineActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ConnectorProcessActivity") {
            let result = new ConnectorProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DelayProcessActivity") {
            let result = new DelayProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ExtractHierarchyProcessActivity") {
            let result = new ExtractHierarchyProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubProcessProcessActivity") {
            let result = new SubProcessProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HttpRequestProcessActivity") {
            let result = new HttpRequestProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ContainerProcessActivity") {
            throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LogMessageProcessActivity") {
            let result = new LogMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ModelDataExportProcessActivity") {
            let result = new ModelDataExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NoteProcessActivity") {
            let result = new NoteProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PublishModelToAnalysisServicesActivity") {
            let result = new PublishModelToAnalysisServicesActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunReportBookProcessActivity") {
            let result = new RunReportBookProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunWorkflowProcessActivity") {
            let result = new RunWorkflowProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ScriptProcessActivity") {
            let result = new ScriptProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SendEmailProcessActivity") {
            let result = new SendEmailProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SlackMessageProcessActivity") {
            let result = new SlackMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SqlServerStoredProcedureProcessActivity") {
            let result = new SqlServerStoredProcedureProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StartProcessActivity") {
            let result = new StartProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StopProcessActivity") {
            let result = new StopProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaExportProcessActivity") {
            let result = new VenaExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaImportProcessActivity") {
            let result = new VenaImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormInteractiveActivity") {
            throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "InteractiveProcessActivity") {
            throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "FileExportProcessActivity") {
            let result = new FileExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FileImportProcessActivity") {
            let result = new FileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ToDoProcessActivity") {
            let result = new ToDoProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StagingTableImportProcessActivity") {
            let result = new StagingTableImportProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseProcessActivity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["advanceRule"] = this.advanceRule !== undefined ? this.advanceRule : null as any;
        return data;
    }

    clone(): BaseProcessActivity {
        throw new Error("The abstract class 'BaseProcessActivity' cannot be instantiated.");
    }
}

export interface IBaseProcessActivity {
    name?: string | null;
    disabled?: boolean | null;
    advanceRule?: AdvanceRule | null;
}

export enum AdvanceRule {
    WhenAllPredecesors = 0,
    WhenFirstPredecesor = 1,
}

export abstract class NonInteractiveProcessActivity extends BaseProcessActivity implements INonInteractiveProcessActivity {
    timeout!: number;

    constructor(data?: INonInteractiveProcessActivity) {
        super(data);
        this._discriminator = "NonInteractiveProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.timeout = data["timeout"] !== undefined ? data["timeout"] : null as any;
        }
    }

    static override fromJS(data: any): NonInteractiveProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ADOImportActivity") {
            let result = new ADOImportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ADOTriggerActivity") {
            let result = new ADOTriggerActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnaplanWorkflowActivity") {
            let result = new AnaplanWorkflowActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ArchiveXL3ReportActivity") {
            let result = new ArchiveXL3ReportActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticFileImportProcessActivity") {
            let result = new AutomaticFileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AutomaticHierarchySyncProcessActivity") {
            let result = new AutomaticHierarchySyncProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AzureDataFactoryPipelineActivity") {
            let result = new AzureDataFactoryPipelineActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ConnectorProcessActivity") {
            let result = new ConnectorProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DelayProcessActivity") {
            let result = new DelayProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ExtractHierarchyProcessActivity") {
            let result = new ExtractHierarchyProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubProcessProcessActivity") {
            let result = new SubProcessProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HttpRequestProcessActivity") {
            let result = new HttpRequestProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ContainerProcessActivity") {
            throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LogMessageProcessActivity") {
            let result = new LogMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ModelDataExportProcessActivity") {
            let result = new ModelDataExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NoteProcessActivity") {
            let result = new NoteProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PublishModelToAnalysisServicesActivity") {
            let result = new PublishModelToAnalysisServicesActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunReportBookProcessActivity") {
            let result = new RunReportBookProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RunWorkflowProcessActivity") {
            let result = new RunWorkflowProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ScriptProcessActivity") {
            let result = new ScriptProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SendEmailProcessActivity") {
            let result = new SendEmailProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SlackMessageProcessActivity") {
            let result = new SlackMessageProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SqlServerStoredProcedureProcessActivity") {
            let result = new SqlServerStoredProcedureProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StartProcessActivity") {
            let result = new StartProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StopProcessActivity") {
            let result = new StopProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaExportProcessActivity") {
            let result = new VenaExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "VenaImportProcessActivity") {
            let result = new VenaImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StagingTableImportProcessActivity") {
            let result = new StagingTableImportProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeout"] = this.timeout !== undefined ? this.timeout : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): NonInteractiveProcessActivity {
        throw new Error("The abstract class 'NonInteractiveProcessActivity' cannot be instantiated.");
    }
}

export interface INonInteractiveProcessActivity extends IBaseProcessActivity {
    timeout: number;
}

export class ADOImportActivity extends NonInteractiveProcessActivity implements IADOImportActivity {
    datasource?: string | null;
    dataspace?: string | null;
    dataset?: string | null;
    tablename?: string | null;

    constructor(data?: IADOImportActivity) {
        super(data);
        this._discriminator = "ADOImportActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : null as any;
            this.dataspace = data["dataspace"] !== undefined ? data["dataspace"] : null as any;
            this.dataset = data["dataset"] !== undefined ? data["dataset"] : null as any;
            this.tablename = data["tablename"] !== undefined ? data["tablename"] : null as any;
        }
    }

    static override fromJS(data: any): ADOImportActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ADOImportActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : null as any;
        data["dataspace"] = this.dataspace !== undefined ? this.dataspace : null as any;
        data["dataset"] = this.dataset !== undefined ? this.dataset : null as any;
        data["tablename"] = this.tablename !== undefined ? this.tablename : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ADOImportActivity {
        const json = this.toJSON();
        let result = new ADOImportActivity();
        result.init(json);
        return result;
    }
}

export interface IADOImportActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    dataspace?: string | null;
    dataset?: string | null;
    tablename?: string | null;
}

export class ADOTriggerActivity extends NonInteractiveProcessActivity implements IADOTriggerActivity {
    datasource?: string | null;
    actionType?: string | null;
    dataspace?: string | null;
    actionID?: string | null;
    pipelineId?: string | null;

    constructor(data?: IADOTriggerActivity) {
        super(data);
        this._discriminator = "ADOTriggerActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : null as any;
            this.actionType = data["actionType"] !== undefined ? data["actionType"] : null as any;
            this.dataspace = data["dataspace"] !== undefined ? data["dataspace"] : null as any;
            this.actionID = data["actionID"] !== undefined ? data["actionID"] : null as any;
            this.pipelineId = data["pipelineId"] !== undefined ? data["pipelineId"] : null as any;
        }
    }

    static override fromJS(data: any): ADOTriggerActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ADOTriggerActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : null as any;
        data["actionType"] = this.actionType !== undefined ? this.actionType : null as any;
        data["dataspace"] = this.dataspace !== undefined ? this.dataspace : null as any;
        data["actionID"] = this.actionID !== undefined ? this.actionID : null as any;
        data["pipelineId"] = this.pipelineId !== undefined ? this.pipelineId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ADOTriggerActivity {
        const json = this.toJSON();
        let result = new ADOTriggerActivity();
        result.init(json);
        return result;
    }
}

export interface IADOTriggerActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    actionType?: string | null;
    dataspace?: string | null;
    actionID?: string | null;
    pipelineId?: string | null;
}

export class AnaplanWorkflowActivity extends NonInteractiveProcessActivity implements IAnaplanWorkflowActivity {
    datasource?: string | null;
    workflowID?: string | null;
    waitForCompletion!: boolean;
    workflowName?: string | null;

    constructor(data?: IAnaplanWorkflowActivity) {
        super(data);
        this._discriminator = "AnaplanWorkflowActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : null as any;
            this.workflowID = data["workflowID"] !== undefined ? data["workflowID"] : null as any;
            this.waitForCompletion = data["waitForCompletion"] !== undefined ? data["waitForCompletion"] : null as any;
            this.workflowName = data["workflowName"] !== undefined ? data["workflowName"] : null as any;
        }
    }

    static override fromJS(data: any): AnaplanWorkflowActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AnaplanWorkflowActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : null as any;
        data["workflowID"] = this.workflowID !== undefined ? this.workflowID : null as any;
        data["waitForCompletion"] = this.waitForCompletion !== undefined ? this.waitForCompletion : null as any;
        data["workflowName"] = this.workflowName !== undefined ? this.workflowName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AnaplanWorkflowActivity {
        const json = this.toJSON();
        let result = new AnaplanWorkflowActivity();
        result.init(json);
        return result;
    }
}

export interface IAnaplanWorkflowActivity extends INonInteractiveProcessActivity {
    datasource?: string | null;
    workflowID?: string | null;
    waitForCompletion: boolean;
    workflowName?: string | null;
}

export class ArchiveXL3ReportActivity extends NonInteractiveProcessActivity implements IArchiveXL3ReportActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    allowOverwrite!: boolean;
    overrideFileName?: string | null;
    useParmName!: boolean;
    format!: ArchiveXL3ReportFormat;
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IArchiveXL3ReportActivity) {
        super(data);
        this._discriminator = "ArchiveXL3ReportActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.share = data["share"] !== undefined ? data["share"] : null as any;
            this.folder = data["folder"] !== undefined ? data["folder"] : null as any;
            this.allowOverwrite = data["allowOverwrite"] !== undefined ? data["allowOverwrite"] : null as any;
            this.overrideFileName = data["overrideFileName"] !== undefined ? data["overrideFileName"] : null as any;
            this.useParmName = data["useParmName"] !== undefined ? data["useParmName"] : null as any;
            this.format = data["format"] !== undefined ? data["format"] : null as any;
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = null as any;
            }
        }
    }

    static override fromJS(data: any): ArchiveXL3ReportActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveXL3ReportActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["share"] = this.share !== undefined ? this.share : null as any;
        data["folder"] = this.folder !== undefined ? this.folder : null as any;
        data["allowOverwrite"] = this.allowOverwrite !== undefined ? this.allowOverwrite : null as any;
        data["overrideFileName"] = this.overrideFileName !== undefined ? this.overrideFileName : null as any;
        data["useParmName"] = this.useParmName !== undefined ? this.useParmName : null as any;
        data["format"] = this.format !== undefined ? this.format : null as any;
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item] ? this.activityFiles[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ArchiveXL3ReportActivity {
        const json = this.toJSON();
        let result = new ArchiveXL3ReportActivity();
        result.init(json);
        return result;
    }
}

export interface IArchiveXL3ReportActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    allowOverwrite: boolean;
    overrideFileName?: string | null;
    useParmName: boolean;
    format: ArchiveXL3ReportFormat;
    activityFiles?: ActivityFile[] | null;
}

export class ActivityFile implements IActivityFile {
    name?: string | null;
    path?: string | null;
    objectType!: FileSystemType;
    description?: string | null;
    outputOverride?: BookOutput | null;
    destinationOverride?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    newParameters?: FormParameterList | null;

    constructor(data?: IActivityFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.path = data["path"] !== undefined ? data["path"] : null as any;
            this.objectType = data["objectType"] !== undefined ? data["objectType"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.outputOverride = data["outputOverride"] !== undefined ? data["outputOverride"] : null as any;
            this.destinationOverride = data["destinationOverride"] !== undefined ? data["destinationOverride"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(KeyValuePairOfStringAndString.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            this.newParameters = data["newParameters"] ? FormParameterList.fromJS(data["newParameters"]) : null as any;
        }
    }

    static fromJS(data: any): ActivityFile {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["objectType"] = this.objectType !== undefined ? this.objectType : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["outputOverride"] = this.outputOverride !== undefined ? this.outputOverride : null as any;
        data["destinationOverride"] = this.destinationOverride !== undefined ? this.destinationOverride : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        data["newParameters"] = this.newParameters ? this.newParameters.toJSON() : null as any;
        return data;
    }

    clone(): ActivityFile {
        const json = this.toJSON();
        let result = new ActivityFile();
        result.init(json);
        return result;
    }
}

export interface IActivityFile {
    name?: string | null;
    path?: string | null;
    objectType: FileSystemType;
    description?: string | null;
    outputOverride?: BookOutput | null;
    destinationOverride?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    newParameters?: FormParameterList | null;
}

export enum BookOutput {
    Email = 0,
    File = 1,
    Slack = 2,
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): KeyValuePairOfStringAndString {
        const json = this.toJSON();
        let result = new KeyValuePairOfStringAndString();
        result.init(json);
        return result;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;
}

export class AutomaticFileImportProcessActivity extends NonInteractiveProcessActivity implements IAutomaticFileImportProcessActivity {
    tableName?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    query?: string | null;

    constructor(data?: IAutomaticFileImportProcessActivity) {
        super(data);
        this._discriminator = "AutomaticFileImportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.share = data["share"] !== undefined ? data["share"] : null as any;
            this.folder = data["folder"] !== undefined ? data["folder"] : null as any;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null as any;
            this.query = data["query"] !== undefined ? data["query"] : null as any;
        }
    }

    static override fromJS(data: any): AutomaticFileImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticFileImportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["share"] = this.share !== undefined ? this.share : null as any;
        data["folder"] = this.folder !== undefined ? this.folder : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AutomaticFileImportProcessActivity {
        const json = this.toJSON();
        let result = new AutomaticFileImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IAutomaticFileImportProcessActivity extends INonInteractiveProcessActivity {
    tableName?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    query?: string | null;
}

export class AutomaticHierarchySyncProcessActivity extends NonInteractiveProcessActivity implements IAutomaticHierarchySyncProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    stagingTable?: string | null;
    explorerLogPath?: string | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
    simulationMode!: boolean;
    reAssignMembers!: boolean;
    syncMode!: HierarchySyncMode;
    propertiesMode?: HierarchyPropertiesMode | null;

    constructor(data?: IAutomaticHierarchySyncProcessActivity) {
        super(data);
        this._discriminator = "AutomaticHierarchySyncProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.share = data["share"] !== undefined ? data["share"] : null as any;
            this.folder = data["folder"] !== undefined ? data["folder"] : null as any;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null as any;
            this.stagingTable = data["stagingTable"] !== undefined ? data["stagingTable"] : null as any;
            this.explorerLogPath = data["explorerLogPath"] !== undefined ? data["explorerLogPath"] : null as any;
            this.dimensionName = data["dimensionName"] !== undefined ? data["dimensionName"] : null as any;
            this.hierarchyName = data["hierarchyName"] !== undefined ? data["hierarchyName"] : null as any;
            this.simulationMode = data["simulationMode"] !== undefined ? data["simulationMode"] : null as any;
            this.reAssignMembers = data["reAssignMembers"] !== undefined ? data["reAssignMembers"] : null as any;
            this.syncMode = data["syncMode"] !== undefined ? data["syncMode"] : null as any;
            this.propertiesMode = data["propertiesMode"] !== undefined ? data["propertiesMode"] : null as any;
        }
    }

    static override fromJS(data: any): AutomaticHierarchySyncProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticHierarchySyncProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["share"] = this.share !== undefined ? this.share : null as any;
        data["folder"] = this.folder !== undefined ? this.folder : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["stagingTable"] = this.stagingTable !== undefined ? this.stagingTable : null as any;
        data["explorerLogPath"] = this.explorerLogPath !== undefined ? this.explorerLogPath : null as any;
        data["dimensionName"] = this.dimensionName !== undefined ? this.dimensionName : null as any;
        data["hierarchyName"] = this.hierarchyName !== undefined ? this.hierarchyName : null as any;
        data["simulationMode"] = this.simulationMode !== undefined ? this.simulationMode : null as any;
        data["reAssignMembers"] = this.reAssignMembers !== undefined ? this.reAssignMembers : null as any;
        data["syncMode"] = this.syncMode !== undefined ? this.syncMode : null as any;
        data["propertiesMode"] = this.propertiesMode !== undefined ? this.propertiesMode : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AutomaticHierarchySyncProcessActivity {
        const json = this.toJSON();
        let result = new AutomaticHierarchySyncProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IAutomaticHierarchySyncProcessActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    stagingTable?: string | null;
    explorerLogPath?: string | null;
    dimensionName?: string | null;
    hierarchyName?: string | null;
    simulationMode: boolean;
    reAssignMembers: boolean;
    syncMode: HierarchySyncMode;
    propertiesMode?: HierarchyPropertiesMode | null;
}

export enum HierarchyPropertiesMode {
    IncludePropertiesInSyncSource = 0,
    ExcludeAllProperties = 1,
    AllPropertiesRequired = 2,
}

export class AzureDataFactoryPipelineActivity extends NonInteractiveProcessActivity implements IAzureDataFactoryPipelineActivity {
    dataSource?: string | null;
    resourceGroupName?: string | null;
    dataFactoryName?: string | null;
    pipelineName?: string | null;
    parameters?: PipelineParameter[] | null;

    constructor(data?: IAzureDataFactoryPipelineActivity) {
        super(data);
        this._discriminator = "AzureDataFactoryPipelineActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.resourceGroupName = data["resourceGroupName"] !== undefined ? data["resourceGroupName"] : null as any;
            this.dataFactoryName = data["dataFactoryName"] !== undefined ? data["dataFactoryName"] : null as any;
            this.pipelineName = data["pipelineName"] !== undefined ? data["pipelineName"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(PipelineParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
        }
    }

    static override fromJS(data: any): AzureDataFactoryPipelineActivity {
        data = typeof data === 'object' ? data : {};
        let result = new AzureDataFactoryPipelineActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["resourceGroupName"] = this.resourceGroupName !== undefined ? this.resourceGroupName : null as any;
        data["dataFactoryName"] = this.dataFactoryName !== undefined ? this.dataFactoryName : null as any;
        data["pipelineName"] = this.pipelineName !== undefined ? this.pipelineName : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): AzureDataFactoryPipelineActivity {
        const json = this.toJSON();
        let result = new AzureDataFactoryPipelineActivity();
        result.init(json);
        return result;
    }
}

export interface IAzureDataFactoryPipelineActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    resourceGroupName?: string | null;
    dataFactoryName?: string | null;
    pipelineName?: string | null;
    parameters?: PipelineParameter[] | null;
}

export class PipelineParameter implements IPipelineParameter {
    key?: string | null;
    value?: string | null;

    constructor(data?: IPipelineParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
        }
    }

    static fromJS(data: any): PipelineParameter {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): PipelineParameter {
        const json = this.toJSON();
        let result = new PipelineParameter();
        result.init(json);
        return result;
    }
}

export interface IPipelineParameter {
    key?: string | null;
    value?: string | null;
}

export class ConnectorProcessActivity extends NonInteractiveProcessActivity implements IConnectorProcessActivity {

    constructor(data?: IConnectorProcessActivity) {
        super(data);
        this._discriminator = "ConnectorProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
    }

    static override fromJS(data: any): ConnectorProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectorProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ConnectorProcessActivity {
        const json = this.toJSON();
        let result = new ConnectorProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IConnectorProcessActivity extends INonInteractiveProcessActivity {
}

export class DelayProcessActivity extends NonInteractiveProcessActivity implements IDelayProcessActivity {
    timeInSeconds!: number;

    constructor(data?: IDelayProcessActivity) {
        super(data);
        this._discriminator = "DelayProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.timeInSeconds = data["timeInSeconds"] !== undefined ? data["timeInSeconds"] : null as any;
        }
    }

    static override fromJS(data: any): DelayProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new DelayProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeInSeconds"] = this.timeInSeconds !== undefined ? this.timeInSeconds : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DelayProcessActivity {
        const json = this.toJSON();
        let result = new DelayProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IDelayProcessActivity extends INonInteractiveProcessActivity {
    timeInSeconds: number;
}

export class ExtractHierarchyProcessActivity extends NonInteractiveProcessActivity implements IExtractHierarchyProcessActivity {
    extractID!: number;
    destinationStagingTable!: DestinationStagingTableType;
    destination!: DestinationType;
    prefix?: string | null;
    suffix?: string | null;
    override?: string | null;

    constructor(data?: IExtractHierarchyProcessActivity) {
        super(data);
        this._discriminator = "ExtractHierarchyProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.extractID = data["extractID"] !== undefined ? data["extractID"] : null as any;
            this.destinationStagingTable = data["destinationStagingTable"] !== undefined ? data["destinationStagingTable"] : null as any;
            this.destination = data["destination"] !== undefined ? data["destination"] : null as any;
            this.prefix = data["prefix"] !== undefined ? data["prefix"] : null as any;
            this.suffix = data["suffix"] !== undefined ? data["suffix"] : null as any;
            this.override = data["override"] !== undefined ? data["override"] : null as any;
        }
    }

    static override fromJS(data: any): ExtractHierarchyProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractHierarchyProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extractID"] = this.extractID !== undefined ? this.extractID : null as any;
        data["destinationStagingTable"] = this.destinationStagingTable !== undefined ? this.destinationStagingTable : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["suffix"] = this.suffix !== undefined ? this.suffix : null as any;
        data["override"] = this.override !== undefined ? this.override : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ExtractHierarchyProcessActivity {
        const json = this.toJSON();
        let result = new ExtractHierarchyProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IExtractHierarchyProcessActivity extends INonInteractiveProcessActivity {
    extractID: number;
    destinationStagingTable: DestinationStagingTableType;
    destination: DestinationType;
    prefix?: string | null;
    suffix?: string | null;
    override?: string | null;
}

export enum DestinationStagingTableType {
    AutoCreate = 0,
    AutoCreateWithPrefixSuffix = 1,
    Override = 2,
}

export enum DestinationType {
    StagingTableOnly = 0,
}

export class SubProcessProcessActivity extends NonInteractiveProcessActivity implements ISubProcessProcessActivity {
    subProcess?: InteractiveProcess | null;

    constructor(data?: ISubProcessProcessActivity) {
        super(data);
        this._discriminator = "SubProcessProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.subProcess = data["subProcess"] ? InteractiveProcess.fromJS(data["subProcess"]) : null as any;
        }
    }

    static override fromJS(data: any): SubProcessProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ForeachProcessActivity") {
            let result = new ForeachProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LockProcessActivity") {
            let result = new LockProcessActivity();
            result.init(data);
            return result;
        }
        let result = new SubProcessProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subProcess"] = this.subProcess ? this.subProcess.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SubProcessProcessActivity {
        const json = this.toJSON();
        let result = new SubProcessProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISubProcessProcessActivity extends INonInteractiveProcessActivity {
    subProcess?: InteractiveProcess | null;
}

export class ForeachProcessActivity extends SubProcessProcessActivity implements IForeachProcessActivity {
    dimensionQuery?: DimensionQuery | null;

    constructor(data?: IForeachProcessActivity) {
        super(data);
        this._discriminator = "ForeachProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dimensionQuery = data["dimensionQuery"] ? DimensionQuery.fromJS(data["dimensionQuery"]) : null as any;
        }
    }

    static override fromJS(data: any): ForeachProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ForeachProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimensionQuery"] = this.dimensionQuery ? this.dimensionQuery.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ForeachProcessActivity {
        const json = this.toJSON();
        let result = new ForeachProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IForeachProcessActivity extends ISubProcessProcessActivity {
    dimensionQuery?: DimensionQuery | null;
}

export class Query extends BaseElement implements IQuery {
    source?: string | null;

    constructor(data?: IQuery) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.source = data["source"] !== undefined ? data["source"] : null as any;
        }
    }

    static override fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Query {
        const json = this.toJSON();
        let result = new Query();
        result.init(json);
        return result;
    }
}

export interface IQuery extends IBaseElement {
    source?: string | null;
}

export class DimensionQuery extends Query implements IDimensionQuery {
    dimension?: string | null;
    model?: string | null;
    dimensionRole?: string | null;
    hierarchy?: string | null;
    ordering?: string | null;
    effectiveDate?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    securityForDimensionEmpty?: string | null;
    querySpec?: HierarchicalSpec | null;
    text?: string | null;
    queryTextLanguage?: string | null;
    attributes?: Attribute[] | null;
    isResolved!: boolean;

    constructor(data?: IDimensionQuery) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.model = data["model"] !== undefined ? data["model"] : null as any;
            this.dimensionRole = data["dimensionRole"] !== undefined ? data["dimensionRole"] : null as any;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : null as any;
            this.ordering = data["ordering"] !== undefined ? data["ordering"] : null as any;
            this.effectiveDate = data["effectiveDate"] !== undefined ? data["effectiveDate"] : null as any;
            this.securityProfile = data["securityProfile"] !== undefined ? data["securityProfile"] : null as any;
            this.securityProfileType = data["securityProfileType"] !== undefined ? data["securityProfileType"] : null as any;
            this.securityModel = data["securityModel"] !== undefined ? data["securityModel"] : null as any;
            this.securityForDimensionEmpty = data["securityForDimensionEmpty"] !== undefined ? data["securityForDimensionEmpty"] : null as any;
            this.querySpec = data["querySpec"] ? HierarchicalSpec.fromJS(data["querySpec"]) : null as any;
            this.text = data["text"] !== undefined ? data["text"] : null as any;
            this.queryTextLanguage = data["queryTextLanguage"] !== undefined ? data["queryTextLanguage"] : null as any;
            if (Array.isArray(data["attributes"])) {
                this.attributes = [] as any;
                for (let item in data["attributes"])
                    this.attributes!.push(Attribute.fromJS(data["attributes"][item]));
            }
            else {
                this.attributes = null as any;
            }
            this.isResolved = data["isResolved"] !== undefined ? data["isResolved"] : null as any;
        }
    }

    static override fromJS(data: any): DimensionQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["model"] = this.model !== undefined ? this.model : null as any;
        data["dimensionRole"] = this.dimensionRole !== undefined ? this.dimensionRole : null as any;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : null as any;
        data["ordering"] = this.ordering !== undefined ? this.ordering : null as any;
        data["effectiveDate"] = this.effectiveDate !== undefined ? this.effectiveDate : null as any;
        data["securityProfile"] = this.securityProfile !== undefined ? this.securityProfile : null as any;
        data["securityProfileType"] = this.securityProfileType !== undefined ? this.securityProfileType : null as any;
        data["securityModel"] = this.securityModel !== undefined ? this.securityModel : null as any;
        data["securityForDimensionEmpty"] = this.securityForDimensionEmpty !== undefined ? this.securityForDimensionEmpty : null as any;
        data["querySpec"] = this.querySpec ? this.querySpec.toJSON() : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["queryTextLanguage"] = this.queryTextLanguage !== undefined ? this.queryTextLanguage : null as any;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item in this.attributes)
                data["attributes"].push(this.attributes[item] ? this.attributes[item].toJSON() : null as any);
        }
        data["isResolved"] = this.isResolved !== undefined ? this.isResolved : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): DimensionQuery {
        const json = this.toJSON();
        let result = new DimensionQuery();
        result.init(json);
        return result;
    }
}

export interface IDimensionQuery extends IQuery {
    dimension?: string | null;
    model?: string | null;
    dimensionRole?: string | null;
    hierarchy?: string | null;
    ordering?: string | null;
    effectiveDate?: string | null;
    securityProfile?: string | null;
    securityProfileType?: string | null;
    securityModel?: string | null;
    securityForDimensionEmpty?: string | null;
    querySpec?: HierarchicalSpec | null;
    text?: string | null;
    queryTextLanguage?: string | null;
    attributes?: Attribute[] | null;
    isResolved: boolean;
}

export class Attribute extends BaseElement implements IAttribute {
    dimension?: string | null;
    dimensionRole?: string | null;

    constructor(data?: IAttribute) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.dimensionRole = data["dimensionRole"] !== undefined ? data["dimensionRole"] : null as any;
        }
    }

    static override fromJS(data: any): Attribute {
        data = typeof data === 'object' ? data : {};
        let result = new Attribute();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["dimensionRole"] = this.dimensionRole !== undefined ? this.dimensionRole : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Attribute {
        const json = this.toJSON();
        let result = new Attribute();
        result.init(json);
        return result;
    }
}

export interface IAttribute extends IBaseElement {
    dimension?: string | null;
    dimensionRole?: string | null;
}

export class InteractiveProcess implements IInteractiveProcess {
    nodes?: InteractiveProcessNode[] | null;
    edges?: InteractiveProcessEdge[] | null;
    startProperties?: InteractiveProcessStartProperties | null;

    constructor(data?: IInteractiveProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["nodes"])) {
                this.nodes = [] as any;
                for (let item in data["nodes"])
                    this.nodes!.push(InteractiveProcessNode.fromJS(data["nodes"][item]));
            }
            else {
                this.nodes = null as any;
            }
            if (Array.isArray(data["edges"])) {
                this.edges = [] as any;
                for (let item in data["edges"])
                    this.edges!.push(InteractiveProcessEdge.fromJS(data["edges"][item]));
            }
            else {
                this.edges = null as any;
            }
            this.startProperties = data["startProperties"] ? InteractiveProcessStartProperties.fromJS(data["startProperties"]) : null as any;
        }
    }

    static fromJS(data: any): InteractiveProcess {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item in this.nodes)
                data["nodes"].push(this.nodes[item] ? this.nodes[item].toJSON() : null as any);
        }
        if (Array.isArray(this.edges)) {
            data["edges"] = [];
            for (let item in this.edges)
                data["edges"].push(this.edges[item] ? this.edges[item].toJSON() : null as any);
        }
        data["startProperties"] = this.startProperties ? this.startProperties.toJSON() : null as any;
        return data;
    }

    clone(): InteractiveProcess {
        const json = this.toJSON();
        let result = new InteractiveProcess();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcess {
    nodes?: InteractiveProcessNode[] | null;
    edges?: InteractiveProcessEdge[] | null;
    startProperties?: InteractiveProcessStartProperties | null;
}

export class InteractiveProcessNode implements IInteractiveProcessNode {
    id?: string | null;
    left!: number;
    top!: number;
    w!: number;
    h!: number;
    type?: string | null;
    text?: string | null;
    state?: string | null;
    percent?: number | null;
    activity?: BaseProcessActivity | null;

    constructor(data?: IInteractiveProcessNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.left = data["left"] !== undefined ? data["left"] : null as any;
            this.top = data["top"] !== undefined ? data["top"] : null as any;
            this.w = data["w"] !== undefined ? data["w"] : null as any;
            this.h = data["h"] !== undefined ? data["h"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.text = data["text"] !== undefined ? data["text"] : null as any;
            this.state = data["state"] !== undefined ? data["state"] : null as any;
            this.percent = data["percent"] !== undefined ? data["percent"] : null as any;
            this.activity = data["activity"] ? BaseProcessActivity.fromJS(data["activity"]) : null as any;
        }
    }

    static fromJS(data: any): InteractiveProcessNode {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["left"] = this.left !== undefined ? this.left : null as any;
        data["top"] = this.top !== undefined ? this.top : null as any;
        data["w"] = this.w !== undefined ? this.w : null as any;
        data["h"] = this.h !== undefined ? this.h : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["percent"] = this.percent !== undefined ? this.percent : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        return data;
    }

    clone(): InteractiveProcessNode {
        const json = this.toJSON();
        let result = new InteractiveProcessNode();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessNode {
    id?: string | null;
    left: number;
    top: number;
    w: number;
    h: number;
    type?: string | null;
    text?: string | null;
    state?: string | null;
    percent?: number | null;
    activity?: BaseProcessActivity | null;
}

export class InteractiveProcessEdge implements IInteractiveProcessEdge {
    source?: string | null;
    target?: string | null;
    data?: InteractiveProcessEdgeData | null;
    geometry?: InteractiveProcessEdgeGeometryData | null;

    constructor(data?: IInteractiveProcessEdge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"] !== undefined ? data["source"] : null as any;
            this.target = data["target"] !== undefined ? data["target"] : null as any;
            this.data = data["data"] ? InteractiveProcessEdgeData.fromJS(data["data"]) : null as any;
            this.geometry = data["geometry"] ? InteractiveProcessEdgeGeometryData.fromJS(data["geometry"]) : null as any;
        }
    }

    static fromJS(data: any): InteractiveProcessEdge {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["target"] = this.target !== undefined ? this.target : null as any;
        data["data"] = this.data ? this.data.toJSON() : null as any;
        data["geometry"] = this.geometry ? this.geometry.toJSON() : null as any;
        return data;
    }

    clone(): InteractiveProcessEdge {
        const json = this.toJSON();
        let result = new InteractiveProcessEdge();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdge {
    source?: string | null;
    target?: string | null;
    data?: InteractiveProcessEdgeData | null;
    geometry?: InteractiveProcessEdgeGeometryData | null;
}

export class InteractiveProcessEdgeData implements IInteractiveProcessEdgeData {
    label?: string | null;
    id?: string | null;
    type?: string | null;

    constructor(data?: IInteractiveProcessEdgeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"] !== undefined ? data["label"] : null as any;
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static fromJS(data: any): InteractiveProcessEdgeData {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdgeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): InteractiveProcessEdgeData {
        const json = this.toJSON();
        let result = new InteractiveProcessEdgeData();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdgeData {
    label?: string | null;
    id?: string | null;
    type?: string | null;
}

export class InteractiveProcessEdgeGeometryData implements IInteractiveProcessEdgeGeometryData {
    segments?: number[][] | null;
    source?: number[] | null;
    target?: number[] | null;

    constructor(data?: IInteractiveProcessEdgeGeometryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["segments"])) {
                this.segments = [] as any;
                for (let item in data["segments"])
                    this.segments!.push(data["segments"][item]);
            }
            else {
                this.segments = null as any;
            }
            if (Array.isArray(data["source"])) {
                this.source = [] as any;
                for (let item in data["source"])
                    this.source!.push(data["source"][item]);
            }
            else {
                this.source = null as any;
            }
            if (Array.isArray(data["target"])) {
                this.target = [] as any;
                for (let item in data["target"])
                    this.target!.push(data["target"][item]);
            }
            else {
                this.target = null as any;
            }
        }
    }

    static fromJS(data: any): InteractiveProcessEdgeGeometryData {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessEdgeGeometryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item in this.segments)
                data["segments"].push(this.segments[item]);
        }
        if (Array.isArray(this.source)) {
            data["source"] = [];
            for (let item in this.source)
                data["source"].push(this.source[item]);
        }
        if (Array.isArray(this.target)) {
            data["target"] = [];
            for (let item in this.target)
                data["target"].push(this.target[item]);
        }
        return data;
    }

    clone(): InteractiveProcessEdgeGeometryData {
        const json = this.toJSON();
        let result = new InteractiveProcessEdgeGeometryData();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessEdgeGeometryData {
    segments?: number[][] | null;
    source?: number[] | null;
    target?: number[] | null;
}

export class InteractiveProcessStartProperties implements IInteractiveProcessStartProperties {
    dueDate?: string | null;
    processPropertiesFormPath?: string | null;

    constructor(data?: IInteractiveProcessStartProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dueDate = data["dueDate"] !== undefined ? data["dueDate"] : null as any;
            this.processPropertiesFormPath = data["processPropertiesFormPath"] !== undefined ? data["processPropertiesFormPath"] : null as any;
        }
    }

    static fromJS(data: any): InteractiveProcessStartProperties {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveProcessStartProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : null as any;
        data["processPropertiesFormPath"] = this.processPropertiesFormPath !== undefined ? this.processPropertiesFormPath : null as any;
        return data;
    }

    clone(): InteractiveProcessStartProperties {
        const json = this.toJSON();
        let result = new InteractiveProcessStartProperties();
        result.init(json);
        return result;
    }
}

export interface IInteractiveProcessStartProperties {
    dueDate?: string | null;
    processPropertiesFormPath?: string | null;
}

export class HttpRequestProcessActivity extends NonInteractiveProcessActivity implements IHttpRequestProcessActivity {
    dataSource?: string | null;
    verb!: HttpRequestProcessActivityVerb;
    path?: string | null;
    content?: string | null;
    resultStore?: string | null;

    constructor(data?: IHttpRequestProcessActivity) {
        super(data);
        this._discriminator = "HttpRequestProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.verb = data["verb"] !== undefined ? data["verb"] : null as any;
            this.path = data["path"] !== undefined ? data["path"] : null as any;
            this.content = data["content"] !== undefined ? data["content"] : null as any;
            this.resultStore = data["resultStore"] !== undefined ? data["resultStore"] : null as any;
        }
    }

    static override fromJS(data: any): HttpRequestProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["verb"] = this.verb !== undefined ? this.verb : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["resultStore"] = this.resultStore !== undefined ? this.resultStore : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): HttpRequestProcessActivity {
        const json = this.toJSON();
        let result = new HttpRequestProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IHttpRequestProcessActivity extends INonInteractiveProcessActivity {
    dataSource?: string | null;
    verb: HttpRequestProcessActivityVerb;
    path?: string | null;
    content?: string | null;
    resultStore?: string | null;
}

export enum HttpRequestProcessActivityVerb {
    Get = 0,
    Post = 1,
    Put = 2,
    Delete = 3,
}

export abstract class ContainerProcessActivity extends NonInteractiveProcessActivity implements IContainerProcessActivity {
    activities?: BaseProcessActivity[] | null;

    constructor(data?: IContainerProcessActivity) {
        super(data);
        this._discriminator = "ContainerProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item in data["activities"])
                    this.activities!.push(BaseProcessActivity.fromJS(data["activities"][item]));
            }
            else {
                this.activities = null as any;
            }
        }
    }

    static override fromJS(data: any): ContainerProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IfProcessActivity") {
            let result = new IfProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item in this.activities)
                data["activities"].push(this.activities[item] ? this.activities[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerProcessActivity {
        throw new Error("The abstract class 'ContainerProcessActivity' cannot be instantiated.");
    }
}

export interface IContainerProcessActivity extends INonInteractiveProcessActivity {
    activities?: BaseProcessActivity[] | null;
}

export class IfProcessActivity extends ContainerProcessActivity implements IIfProcessActivity {
    condition?: string | null;
    dataSource?: string | null;
    parameters?: SqlServerParameter[] | null;
    type!: IfProcessActivityScriptType;

    constructor(data?: IIfProcessActivity) {
        super(data);
        this._discriminator = "IfProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.condition = data["condition"] !== undefined ? data["condition"] : null as any;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static override fromJS(data: any): IfProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new IfProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition !== undefined ? this.condition : null as any;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): IfProcessActivity {
        const json = this.toJSON();
        let result = new IfProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IIfProcessActivity extends IContainerProcessActivity {
    condition?: string | null;
    dataSource?: string | null;
    parameters?: SqlServerParameter[] | null;
    type: IfProcessActivityScriptType;
}

export class SqlServerParameter implements ISqlServerParameter {
    key?: string | null;
    value?: string | null;

    constructor(data?: ISqlServerParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null as any;
            this.value = data["value"] !== undefined ? data["value"] : null as any;
        }
    }

    static fromJS(data: any): SqlServerParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SqlServerParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): SqlServerParameter {
        const json = this.toJSON();
        let result = new SqlServerParameter();
        result.init(json);
        return result;
    }
}

export interface ISqlServerParameter {
    key?: string | null;
    value?: string | null;
}

export enum IfProcessActivityScriptType {
    CSharp = 0,
    SQL = 1,
}

export class LockProcessActivity extends SubProcessProcessActivity implements ILockProcessActivity {
    lock?: string | null;
    maxLockSeconds?: number | null;

    constructor(data?: ILockProcessActivity) {
        super(data);
        this._discriminator = "LockProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.lock = data["lock"] !== undefined ? data["lock"] : null as any;
            this.maxLockSeconds = data["maxLockSeconds"] !== undefined ? data["maxLockSeconds"] : null as any;
        }
    }

    static override fromJS(data: any): LockProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new LockProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lock"] = this.lock !== undefined ? this.lock : null as any;
        data["maxLockSeconds"] = this.maxLockSeconds !== undefined ? this.maxLockSeconds : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LockProcessActivity {
        const json = this.toJSON();
        let result = new LockProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ILockProcessActivity extends ISubProcessProcessActivity {
    lock?: string | null;
    maxLockSeconds?: number | null;
}

export class LogMessageProcessActivity extends NonInteractiveProcessActivity implements ILogMessageProcessActivity {
    message?: string | null;
    level!: LogLevel;

    constructor(data?: ILogMessageProcessActivity) {
        super(data);
        this._discriminator = "LogMessageProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            this.level = data["level"] !== undefined ? data["level"] : null as any;
        }
    }

    static override fromJS(data: any): LogMessageProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new LogMessageProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): LogMessageProcessActivity {
        const json = this.toJSON();
        let result = new LogMessageProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ILogMessageProcessActivity extends INonInteractiveProcessActivity {
    message?: string | null;
    level: LogLevel;
}

export enum LogLevel {
    Debug = 0,
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
}

export class ModelDataExportProcessActivity extends NonInteractiveProcessActivity implements IModelDataExportProcessActivity {
    modelViewOrModel?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    compress?: boolean | null;
    format?: ModelDataExportProcessActivityFormat | null;

    constructor(data?: IModelDataExportProcessActivity) {
        super(data);
        this._discriminator = "ModelDataExportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.modelViewOrModel = data["modelViewOrModel"] !== undefined ? data["modelViewOrModel"] : null as any;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.share = data["share"] !== undefined ? data["share"] : null as any;
            this.folder = data["folder"] !== undefined ? data["folder"] : null as any;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null as any;
            this.compress = data["compress"] !== undefined ? data["compress"] : null as any;
            this.format = data["format"] !== undefined ? data["format"] : null as any;
        }
    }

    static override fromJS(data: any): ModelDataExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDataExportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelViewOrModel"] = this.modelViewOrModel !== undefined ? this.modelViewOrModel : null as any;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["share"] = this.share !== undefined ? this.share : null as any;
        data["folder"] = this.folder !== undefined ? this.folder : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["compress"] = this.compress !== undefined ? this.compress : null as any;
        data["format"] = this.format !== undefined ? this.format : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ModelDataExportProcessActivity {
        const json = this.toJSON();
        let result = new ModelDataExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IModelDataExportProcessActivity extends INonInteractiveProcessActivity {
    modelViewOrModel?: string | null;
    dataSource?: string | null;
    share?: string | null;
    folder?: string | null;
    fileName?: string | null;
    compress?: boolean | null;
    format?: ModelDataExportProcessActivityFormat | null;
}

export enum ModelDataExportProcessActivityFormat {
    JSON = 0,
    XML = 1,
    CSV = 2,
}

export class NoteProcessActivity extends NonInteractiveProcessActivity implements INoteProcessActivity {
    text?: string | null;

    constructor(data?: INoteProcessActivity) {
        super(data);
        this._discriminator = "NoteProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.text = data["text"] !== undefined ? data["text"] : null as any;
        }
    }

    static override fromJS(data: any): NoteProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new NoteProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text !== undefined ? this.text : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): NoteProcessActivity {
        const json = this.toJSON();
        let result = new NoteProcessActivity();
        result.init(json);
        return result;
    }
}

export interface INoteProcessActivity extends INonInteractiveProcessActivity {
    text?: string | null;
}

export class PublishModelToAnalysisServicesActivity extends NonInteractiveProcessActivity implements IPublishModelToAnalysisServicesActivity {
    modelName?: string | null;

    constructor(data?: IPublishModelToAnalysisServicesActivity) {
        super(data);
        this._discriminator = "PublishModelToAnalysisServicesActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
        }
    }

    static override fromJS(data: any): PublishModelToAnalysisServicesActivity {
        data = typeof data === 'object' ? data : {};
        let result = new PublishModelToAnalysisServicesActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PublishModelToAnalysisServicesActivity {
        const json = this.toJSON();
        let result = new PublishModelToAnalysisServicesActivity();
        result.init(json);
        return result;
    }
}

export interface IPublishModelToAnalysisServicesActivity extends INonInteractiveProcessActivity {
    modelName?: string | null;
}

export class RunReportBookProcessActivity extends NonInteractiveProcessActivity implements IRunReportBookProcessActivity {
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IRunReportBookProcessActivity) {
        super(data);
        this._discriminator = "RunReportBookProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = null as any;
            }
        }
    }

    static override fromJS(data: any): RunReportBookProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new RunReportBookProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item] ? this.activityFiles[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): RunReportBookProcessActivity {
        const json = this.toJSON();
        let result = new RunReportBookProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IRunReportBookProcessActivity extends INonInteractiveProcessActivity {
    activityFiles?: ActivityFile[] | null;
}

export class RunWorkflowProcessActivity extends NonInteractiveProcessActivity implements IRunWorkflowProcessActivity {
    fsWorkflow?: ActivityFile | null;
    asynchronous!: boolean;
    startOptions?: PipelineParameter[] | null;

    constructor(data?: IRunWorkflowProcessActivity) {
        super(data);
        this._discriminator = "RunWorkflowProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.fsWorkflow = data["fsWorkflow"] ? ActivityFile.fromJS(data["fsWorkflow"]) : null as any;
            this.asynchronous = data["asynchronous"] !== undefined ? data["asynchronous"] : null as any;
            if (Array.isArray(data["startOptions"])) {
                this.startOptions = [] as any;
                for (let item in data["startOptions"])
                    this.startOptions!.push(PipelineParameter.fromJS(data["startOptions"][item]));
            }
            else {
                this.startOptions = null as any;
            }
        }
    }

    static override fromJS(data: any): RunWorkflowProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new RunWorkflowProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fsWorkflow"] = this.fsWorkflow ? this.fsWorkflow.toJSON() : null as any;
        data["asynchronous"] = this.asynchronous !== undefined ? this.asynchronous : null as any;
        if (Array.isArray(this.startOptions)) {
            data["startOptions"] = [];
            for (let item in this.startOptions)
                data["startOptions"].push(this.startOptions[item] ? this.startOptions[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): RunWorkflowProcessActivity {
        const json = this.toJSON();
        let result = new RunWorkflowProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IRunWorkflowProcessActivity extends INonInteractiveProcessActivity {
    fsWorkflow?: ActivityFile | null;
    asynchronous: boolean;
    startOptions?: PipelineParameter[] | null;
}

export class ScriptProcessActivity extends NonInteractiveProcessActivity implements IScriptProcessActivity {
    script?: string | null;

    constructor(data?: IScriptProcessActivity) {
        super(data);
        this._discriminator = "ScriptProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.script = data["script"] !== undefined ? data["script"] : null as any;
        }
    }

    static override fromJS(data: any): ScriptProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ScriptProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["script"] = this.script !== undefined ? this.script : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ScriptProcessActivity {
        const json = this.toJSON();
        let result = new ScriptProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IScriptProcessActivity extends INonInteractiveProcessActivity {
    script?: string | null;
}

export class SendEmailProcessActivity extends NonInteractiveProcessActivity implements ISendEmailProcessActivity {
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    from?: string | null;
    subject?: string | null;
    body?: string | null;
    isBodyHtml!: boolean;

    constructor(data?: ISendEmailProcessActivity) {
        super(data);
        this._discriminator = "SendEmailProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.to = data["to"] !== undefined ? data["to"] : null as any;
            this.cc = data["cc"] !== undefined ? data["cc"] : null as any;
            this.bcc = data["bcc"] !== undefined ? data["bcc"] : null as any;
            this.from = data["from"] !== undefined ? data["from"] : null as any;
            this.subject = data["subject"] !== undefined ? data["subject"] : null as any;
            this.body = data["body"] !== undefined ? data["body"] : null as any;
            this.isBodyHtml = data["isBodyHtml"] !== undefined ? data["isBodyHtml"] : null as any;
        }
    }

    static override fromJS(data: any): SendEmailProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to !== undefined ? this.to : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["bcc"] = this.bcc !== undefined ? this.bcc : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["body"] = this.body !== undefined ? this.body : null as any;
        data["isBodyHtml"] = this.isBodyHtml !== undefined ? this.isBodyHtml : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SendEmailProcessActivity {
        const json = this.toJSON();
        let result = new SendEmailProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISendEmailProcessActivity extends INonInteractiveProcessActivity {
    to?: string | null;
    cc?: string | null;
    bcc?: string | null;
    from?: string | null;
    subject?: string | null;
    body?: string | null;
    isBodyHtml: boolean;
}

export class SlackMessageProcessActivity extends NonInteractiveProcessActivity implements ISlackMessageProcessActivity {
    message?: string | null;
    dataSource?: string | null;
    slackUserName?: string | null;
    slackSenderIconUrl?: string | null;
    slackChannelOverride?: string | null;
    isMarkdown!: boolean;

    constructor(data?: ISlackMessageProcessActivity) {
        super(data);
        this._discriminator = "SlackMessageProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.slackUserName = data["slackUserName"] !== undefined ? data["slackUserName"] : null as any;
            this.slackSenderIconUrl = data["slackSenderIconUrl"] !== undefined ? data["slackSenderIconUrl"] : null as any;
            this.slackChannelOverride = data["slackChannelOverride"] !== undefined ? data["slackChannelOverride"] : null as any;
            this.isMarkdown = data["isMarkdown"] !== undefined ? data["isMarkdown"] : null as any;
        }
    }

    static override fromJS(data: any): SlackMessageProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SlackMessageProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["slackUserName"] = this.slackUserName !== undefined ? this.slackUserName : null as any;
        data["slackSenderIconUrl"] = this.slackSenderIconUrl !== undefined ? this.slackSenderIconUrl : null as any;
        data["slackChannelOverride"] = this.slackChannelOverride !== undefined ? this.slackChannelOverride : null as any;
        data["isMarkdown"] = this.isMarkdown !== undefined ? this.isMarkdown : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SlackMessageProcessActivity {
        const json = this.toJSON();
        let result = new SlackMessageProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISlackMessageProcessActivity extends INonInteractiveProcessActivity {
    message?: string | null;
    dataSource?: string | null;
    slackUserName?: string | null;
    slackSenderIconUrl?: string | null;
    slackChannelOverride?: string | null;
    isMarkdown: boolean;
}

export class SqlServerStoredProcedureProcessActivity extends NonInteractiveProcessActivity implements ISqlServerStoredProcedureProcessActivity {
    type!: CalculationType;
    calcScriptFile?: ActivityFile | null;
    dataSource?: string | null;
    spName?: string | null;
    parameters?: SqlServerParameter[] | null;
    resultStore?: string | null;

    constructor(data?: ISqlServerStoredProcedureProcessActivity) {
        super(data);
        this._discriminator = "SqlServerStoredProcedureProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.calcScriptFile = data["calcScriptFile"] ? ActivityFile.fromJS(data["calcScriptFile"]) : null as any;
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.spName = data["spName"] !== undefined ? data["spName"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            this.resultStore = data["resultStore"] !== undefined ? data["resultStore"] : null as any;
        }
    }

    static override fromJS(data: any): SqlServerStoredProcedureProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SqlServerStoredProcedureProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["calcScriptFile"] = this.calcScriptFile ? this.calcScriptFile.toJSON() : null as any;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["spName"] = this.spName !== undefined ? this.spName : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        data["resultStore"] = this.resultStore !== undefined ? this.resultStore : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): SqlServerStoredProcedureProcessActivity {
        const json = this.toJSON();
        let result = new SqlServerStoredProcedureProcessActivity();
        result.init(json);
        return result;
    }
}

export interface ISqlServerStoredProcedureProcessActivity extends INonInteractiveProcessActivity {
    type: CalculationType;
    calcScriptFile?: ActivityFile | null;
    dataSource?: string | null;
    spName?: string | null;
    parameters?: SqlServerParameter[] | null;
    resultStore?: string | null;
}

export enum CalculationType {
    StoredProcedure = 0,
    CalcScript = 1,
}

export class StartProcessActivity extends NonInteractiveProcessActivity implements IStartProcessActivity {

    constructor(data?: IStartProcessActivity) {
        super(data);
        this._discriminator = "StartProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
    }

    static override fromJS(data: any): StartProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StartProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StartProcessActivity {
        const json = this.toJSON();
        let result = new StartProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStartProcessActivity extends INonInteractiveProcessActivity {
}

export class StopProcessActivity extends NonInteractiveProcessActivity implements IStopProcessActivity {
    reason?: string | null;

    constructor(data?: IStopProcessActivity) {
        super(data);
        this._discriminator = "StopProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.reason = data["reason"] !== undefined ? data["reason"] : null as any;
        }
    }

    static override fromJS(data: any): StopProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StopProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): StopProcessActivity {
        const json = this.toJSON();
        let result = new StopProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStopProcessActivity extends INonInteractiveProcessActivity {
    reason?: string | null;
}

export class VenaExportProcessActivity extends NonInteractiveProcessActivity implements IVenaExportProcessActivity {
    exportRequest?: ExportRequest | null;

    constructor(data?: IVenaExportProcessActivity) {
        super(data);
        this._discriminator = "VenaExportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.exportRequest = data["exportRequest"] ? ExportRequest.fromJS(data["exportRequest"]) : null as any;
        }
    }

    static override fromJS(data: any): VenaExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VenaExportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportRequest"] = this.exportRequest ? this.exportRequest.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): VenaExportProcessActivity {
        const json = this.toJSON();
        let result = new VenaExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IVenaExportProcessActivity extends INonInteractiveProcessActivity {
    exportRequest?: ExportRequest | null;
}

export abstract class RequestBase implements IRequestBase {

    constructor(data?: IRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): RequestBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): RequestBase {
        throw new Error("The abstract class 'RequestBase' cannot be instantiated.");
    }
}

export interface IRequestBase {
}

export class ExportRequest extends RequestBase implements IExportRequest {
    sourceDataSource?: string | null;
    sourceQuery?: string | null;
    destinationDataSource?: string | null;
    destinationModelName?: string | null;
    jobName?: string | null;
    type!: EtlTypeEnum;

    constructor(data?: IExportRequest) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.sourceDataSource = data["sourceDataSource"] !== undefined ? data["sourceDataSource"] : null as any;
            this.sourceQuery = data["sourceQuery"] !== undefined ? data["sourceQuery"] : null as any;
            this.destinationDataSource = data["destinationDataSource"] !== undefined ? data["destinationDataSource"] : null as any;
            this.destinationModelName = data["destinationModelName"] !== undefined ? data["destinationModelName"] : null as any;
            this.jobName = data["jobName"] !== undefined ? data["jobName"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static override fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceDataSource"] = this.sourceDataSource !== undefined ? this.sourceDataSource : null as any;
        data["sourceQuery"] = this.sourceQuery !== undefined ? this.sourceQuery : null as any;
        data["destinationDataSource"] = this.destinationDataSource !== undefined ? this.destinationDataSource : null as any;
        data["destinationModelName"] = this.destinationModelName !== undefined ? this.destinationModelName : null as any;
        data["jobName"] = this.jobName !== undefined ? this.jobName : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ExportRequest {
        const json = this.toJSON();
        let result = new ExportRequest();
        result.init(json);
        return result;
    }
}

export interface IExportRequest extends IRequestBase {
    sourceDataSource?: string | null;
    sourceQuery?: string | null;
    destinationDataSource?: string | null;
    destinationModelName?: string | null;
    jobName?: string | null;
    type: EtlTypeEnum;
}

export enum EtlTypeEnum {
    Hierarchy = 0,
    Attributes = 1,
    Intersections = 2,
    UserDefined = 3,
    Lids = 4,
}

export class VenaImportProcessActivity extends NonInteractiveProcessActivity implements IVenaImportProcessActivity {
    importRequest?: ImportRequest | null;

    constructor(data?: IVenaImportProcessActivity) {
        super(data);
        this._discriminator = "VenaImportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.importRequest = data["importRequest"] ? ImportRequest.fromJS(data["importRequest"]) : null as any;
        }
    }

    static override fromJS(data: any): VenaImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new VenaImportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importRequest"] = this.importRequest ? this.importRequest.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): VenaImportProcessActivity {
        const json = this.toJSON();
        let result = new VenaImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IVenaImportProcessActivity extends INonInteractiveProcessActivity {
    importRequest?: ImportRequest | null;
}

export class GetRequest extends RequestBase implements IGetRequest {
    dataSource?: string | null;
    modelName?: string | null;
    importType!: EtlTypeEnum;
    fileFormat!: FileFormatEnum;
    /** Query expression for import (HQL). May not be combined with WhereClause */
    queryExpression?: string | null;
    /** Where clause for import (HQL). May not be combined with QueryExpression */
    whereClause?: string | null;
    /** Name of the Vena table in staging DB to import from. */
    tableName?: string | null;

    constructor(data?: IGetRequest) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.modelName = data["modelName"] !== undefined ? data["modelName"] : null as any;
            this.importType = data["importType"] !== undefined ? data["importType"] : null as any;
            this.fileFormat = data["fileFormat"] !== undefined ? data["fileFormat"] : null as any;
            this.queryExpression = data["queryExpression"] !== undefined ? data["queryExpression"] : null as any;
            this.whereClause = data["whereClause"] !== undefined ? data["whereClause"] : null as any;
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
        }
    }

    static override fromJS(data: any): GetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["modelName"] = this.modelName !== undefined ? this.modelName : null as any;
        data["importType"] = this.importType !== undefined ? this.importType : null as any;
        data["fileFormat"] = this.fileFormat !== undefined ? this.fileFormat : null as any;
        data["queryExpression"] = this.queryExpression !== undefined ? this.queryExpression : null as any;
        data["whereClause"] = this.whereClause !== undefined ? this.whereClause : null as any;
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): GetRequest {
        const json = this.toJSON();
        let result = new GetRequest();
        result.init(json);
        return result;
    }
}

export interface IGetRequest extends IRequestBase {
    dataSource?: string | null;
    modelName?: string | null;
    importType: EtlTypeEnum;
    fileFormat: FileFormatEnum;
    /** Query expression for import (HQL). May not be combined with WhereClause */
    queryExpression?: string | null;
    /** Where clause for import (HQL). May not be combined with QueryExpression */
    whereClause?: string | null;
    /** Name of the Vena table in staging DB to import from. */
    tableName?: string | null;
}

export class ImportRequest extends GetRequest implements IImportRequest {
    destinationDataSource?: string | null;
    destinationTable?: string | null;
    useExistingTable?: boolean | null;

    constructor(data?: IImportRequest) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.destinationDataSource = data["destinationDataSource"] !== undefined ? data["destinationDataSource"] : null as any;
            this.destinationTable = data["destinationTable"] !== undefined ? data["destinationTable"] : null as any;
            this.useExistingTable = data["useExistingTable"] !== undefined ? data["useExistingTable"] : null as any;
        }
    }

    static override fromJS(data: any): ImportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationDataSource"] = this.destinationDataSource !== undefined ? this.destinationDataSource : null as any;
        data["destinationTable"] = this.destinationTable !== undefined ? this.destinationTable : null as any;
        data["useExistingTable"] = this.useExistingTable !== undefined ? this.useExistingTable : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ImportRequest {
        const json = this.toJSON();
        let result = new ImportRequest();
        result.init(json);
        return result;
    }
}

export interface IImportRequest extends IGetRequest {
    destinationDataSource?: string | null;
    destinationTable?: string | null;
    useExistingTable?: boolean | null;
}

export enum FileFormatEnum {
    CSV = 0,
    PSV = 1,
    TDF = 2,
}

export abstract class InteractiveProcessActivity extends BaseProcessActivity implements IInteractiveProcessActivity {
    supervisor?: string | null;
    contributor?: string | null;
    owner?: string | null;
    dueDate?: string | null;
    infoText?: string | null;

    constructor(data?: IInteractiveProcessActivity) {
        super(data);
        this._discriminator = "InteractiveProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.supervisor = data["Supervisor"] !== undefined ? data["Supervisor"] : null as any;
            this.contributor = data["Contributor"] !== undefined ? data["Contributor"] : null as any;
            this.owner = data["Owner"] !== undefined ? data["Owner"] : null as any;
            this.dueDate = data["dueDate"] !== undefined ? data["dueDate"] : null as any;
            this.infoText = data["infoText"] !== undefined ? data["infoText"] : null as any;
        }
    }

    static override fromJS(data: any): InteractiveProcessActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormInteractiveActivity") {
            throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
        }
        if (data["discriminator"] === "FileExportProcessActivity") {
            let result = new FileExportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FileImportProcessActivity") {
            let result = new FileImportProcessActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ToDoProcessActivity") {
            let result = new ToDoProcessActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Supervisor"] = this.supervisor !== undefined ? this.supervisor : null as any;
        data["Contributor"] = this.contributor !== undefined ? this.contributor : null as any;
        data["Owner"] = this.owner !== undefined ? this.owner : null as any;
        data["dueDate"] = this.dueDate !== undefined ? this.dueDate : null as any;
        data["infoText"] = this.infoText !== undefined ? this.infoText : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): InteractiveProcessActivity {
        throw new Error("The abstract class 'InteractiveProcessActivity' cannot be instantiated.");
    }
}

export interface IInteractiveProcessActivity extends IBaseProcessActivity {
    supervisor?: string | null;
    contributor?: string | null;
    owner?: string | null;
    dueDate?: string | null;
    infoText?: string | null;
}

export abstract class FormInteractiveActivity extends InteractiveProcessActivity implements IFormInteractiveActivity {
    activityFiles?: ActivityFile[] | null;

    constructor(data?: IFormInteractiveActivity) {
        super(data);
        this._discriminator = "FormInteractiveActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["activityFiles"])) {
                this.activityFiles = [] as any;
                for (let item in data["activityFiles"])
                    this.activityFiles!.push(ActivityFile.fromJS(data["activityFiles"][item]));
            }
            else {
                this.activityFiles = null as any;
            }
        }
    }

    static override fromJS(data: any): FormInteractiveActivity {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DataEntryActivity") {
            let result = new DataEntryActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReportingActivity") {
            let result = new ReportingActivity();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ReviewActivity") {
            let result = new ReviewActivity();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityFiles)) {
            data["activityFiles"] = [];
            for (let item in this.activityFiles)
                data["activityFiles"].push(this.activityFiles[item] ? this.activityFiles[item].toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FormInteractiveActivity {
        throw new Error("The abstract class 'FormInteractiveActivity' cannot be instantiated.");
    }
}

export interface IFormInteractiveActivity extends IInteractiveProcessActivity {
    activityFiles?: ActivityFile[] | null;
}

export class DataEntryActivity extends FormInteractiveActivity implements IDataEntryActivity {

    constructor(data?: IDataEntryActivity) {
        super(data);
        this._discriminator = "DataEntryActivity";
    }

    override init(data?: any) {
        super.init(data);
    }

    static override fromJS(data: any): DataEntryActivity {
        data = typeof data === 'object' ? data : {};
        let result = new DataEntryActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DataEntryActivity {
        const json = this.toJSON();
        let result = new DataEntryActivity();
        result.init(json);
        return result;
    }
}

export interface IDataEntryActivity extends IFormInteractiveActivity {
}

export class FileExportProcessActivity extends InteractiveProcessActivity implements IFileExportProcessActivity {
    dataSource?: string | null;
    query?: string | null;
    parameters?: SqlServerParameter[] | null;
    fileType?: FileExportType | null;

    constructor(data?: IFileExportProcessActivity) {
        super(data);
        this._discriminator = "FileExportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.dataSource = data["dataSource"] !== undefined ? data["dataSource"] : null as any;
            this.query = data["query"] !== undefined ? data["query"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(SqlServerParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            this.fileType = data["fileType"] !== undefined ? data["fileType"] : null as any;
        }
    }

    static override fromJS(data: any): FileExportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new FileExportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : null as any;
        data["query"] = this.query !== undefined ? this.query : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        data["fileType"] = this.fileType !== undefined ? this.fileType : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FileExportProcessActivity {
        const json = this.toJSON();
        let result = new FileExportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IFileExportProcessActivity extends IInteractiveProcessActivity {
    dataSource?: string | null;
    query?: string | null;
    parameters?: SqlServerParameter[] | null;
    fileType?: FileExportType | null;
}

export enum FileExportType {
    None = 0,
    Csv = 1,
    Tsv = 2,
    Excel = 3,
    Word = 4,
    Powerpoint = 5,
}

export class FileImportProcessActivity extends InteractiveProcessActivity implements IFileImportProcessActivity {
    tableName?: string | null;
    modelMappingName?: string | null;
    loadStagingData!: boolean;
    trackDataImport?: boolean | null;

    constructor(data?: IFileImportProcessActivity) {
        super(data);
        this._discriminator = "FileImportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.tableName = data["tableName"] !== undefined ? data["tableName"] : null as any;
            this.modelMappingName = data["modelMappingName"] !== undefined ? data["modelMappingName"] : null as any;
            this.loadStagingData = data["loadStagingData"] !== undefined ? data["loadStagingData"] : null as any;
            this.trackDataImport = data["trackDataImport"] !== undefined ? data["trackDataImport"] : null as any;
        }
    }

    static override fromJS(data: any): FileImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new FileImportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : null as any;
        data["modelMappingName"] = this.modelMappingName !== undefined ? this.modelMappingName : null as any;
        data["loadStagingData"] = this.loadStagingData !== undefined ? this.loadStagingData : null as any;
        data["trackDataImport"] = this.trackDataImport !== undefined ? this.trackDataImport : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FileImportProcessActivity {
        const json = this.toJSON();
        let result = new FileImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IFileImportProcessActivity extends IInteractiveProcessActivity {
    tableName?: string | null;
    modelMappingName?: string | null;
    loadStagingData: boolean;
    trackDataImport?: boolean | null;
}

export class ReportingActivity extends FormInteractiveActivity implements IReportingActivity {

    constructor(data?: IReportingActivity) {
        super(data);
        this._discriminator = "ReportingActivity";
    }

    override init(data?: any) {
        super.init(data);
    }

    static override fromJS(data: any): ReportingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ReportingActivity {
        const json = this.toJSON();
        let result = new ReportingActivity();
        result.init(json);
        return result;
    }
}

export interface IReportingActivity extends IFormInteractiveActivity {
}

export class ReviewActivity extends FormInteractiveActivity implements IReviewActivity {
    resetActivityStatesOnReject?: boolean | null;

    constructor(data?: IReviewActivity) {
        super(data);
        this._discriminator = "ReviewActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.resetActivityStatesOnReject = data["resetActivityStatesOnReject"] !== undefined ? data["resetActivityStatesOnReject"] : null as any;
        }
    }

    static override fromJS(data: any): ReviewActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetActivityStatesOnReject"] = this.resetActivityStatesOnReject !== undefined ? this.resetActivityStatesOnReject : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ReviewActivity {
        const json = this.toJSON();
        let result = new ReviewActivity();
        result.init(json);
        return result;
    }
}

export interface IReviewActivity extends IFormInteractiveActivity {
    resetActivityStatesOnReject?: boolean | null;
}

export class ToDoProcessActivity extends InteractiveProcessActivity implements IToDoProcessActivity {
    description?: string | null;

    constructor(data?: IToDoProcessActivity) {
        super(data);
        this._discriminator = "ToDoProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : null as any;
        }
    }

    static override fromJS(data: any): ToDoProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ToDoProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ToDoProcessActivity {
        const json = this.toJSON();
        let result = new ToDoProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IToDoProcessActivity extends IInteractiveProcessActivity {
    description?: string | null;
}

export class StagingTableImportProcessActivity extends NonInteractiveProcessActivity implements IStagingTableImportProcessActivity {
    modelMappingName?: string | null;
    trackDataImport?: boolean | null;
    skipValidation!: boolean;

    constructor(data?: IStagingTableImportProcessActivity) {
        super(data);
        this._discriminator = "StagingTableImportProcessActivity";
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.modelMappingName = data["modelMappingName"] !== undefined ? data["modelMappingName"] : null as any;
            this.trackDataImport = data["trackDataImport"] !== undefined ? data["trackDataImport"] : null as any;
            this.skipValidation = data["skipValidation"] !== undefined ? data["skipValidation"] : null as any;
        }
    }

    static override fromJS(data: any): StagingTableImportProcessActivity {
        data = typeof data === 'object' ? data : {};
        let result = new StagingTableImportProcessActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelMappingName"] = this.modelMappingName !== undefined ? this.modelMappingName : null as any;
        data["trackDataImport"] = this.trackDataImport !== undefined ? this.trackDataImport : null as any;
        data["skipValidation"] = this.skipValidation !== undefined ? this.skipValidation : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): StagingTableImportProcessActivity {
        const json = this.toJSON();
        let result = new StagingTableImportProcessActivity();
        result.init(json);
        return result;
    }
}

export interface IStagingTableImportProcessActivity extends INonInteractiveProcessActivity {
    modelMappingName?: string | null;
    trackDataImport?: boolean | null;
    skipValidation: boolean;
}

export class ProcessActivityExecutionState implements IProcessActivityExecutionState {
    processPath?: string | null;
    processStartTime!: Date;
    processRunId!: string;
    subProcessRunId!: string;
    activityRunId!: string;
    caption?: string | null;
    parentCaption?: string | null;
    burstingKey?: string | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    calculatedDueDate?: Date | null;
    status!: ActivityExecutionResultEnum;
    calculatedStatus!: ActivityExecutionResultEnum;
    supervisors?: string | null;
    contributors?: string | null;
    owners?: string | null;
    discriminator?: string | null;
    percentComplete!: number;

    constructor(data?: IProcessActivityExecutionState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processPath = data["processPath"] !== undefined ? data["processPath"] : null as any;
            this.processStartTime = data["processStartTime"] ? new Date(data["processStartTime"].toString()) : null as any;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : null as any;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.parentCaption = data["parentCaption"] !== undefined ? data["parentCaption"] : null as any;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : null as any;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : null as any;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : null as any;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null as any;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : null as any;
            this.calculatedDueDate = data["calculatedDueDate"] ? new Date(data["calculatedDueDate"].toString()) : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.calculatedStatus = data["calculatedStatus"] !== undefined ? data["calculatedStatus"] : null as any;
            this.supervisors = data["supervisors"] !== undefined ? data["supervisors"] : null as any;
            this.contributors = data["contributors"] !== undefined ? data["contributors"] : null as any;
            this.owners = data["owners"] !== undefined ? data["owners"] : null as any;
            this.discriminator = data["discriminator"] !== undefined ? data["discriminator"] : null as any;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : null as any;
        }
    }

    static fromJS(data: any): ProcessActivityExecutionState {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessActivityExecutionState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processPath"] = this.processPath !== undefined ? this.processPath : null as any;
        data["processStartTime"] = this.processStartTime ? this.processStartTime.toISOString() : null as any;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : null as any;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["parentCaption"] = this.parentCaption !== undefined ? this.parentCaption : null as any;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : null as any;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["calculatedDueDate"] = this.calculatedDueDate ? this.calculatedDueDate.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["calculatedStatus"] = this.calculatedStatus !== undefined ? this.calculatedStatus : null as any;
        data["supervisors"] = this.supervisors !== undefined ? this.supervisors : null as any;
        data["contributors"] = this.contributors !== undefined ? this.contributors : null as any;
        data["owners"] = this.owners !== undefined ? this.owners : null as any;
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : null as any;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : null as any;
        return data;
    }

    clone(): ProcessActivityExecutionState {
        const json = this.toJSON();
        let result = new ProcessActivityExecutionState();
        result.init(json);
        return result;
    }
}

export interface IProcessActivityExecutionState {
    processPath?: string | null;
    processStartTime: Date;
    processRunId: string;
    subProcessRunId: string;
    activityRunId: string;
    caption?: string | null;
    parentCaption?: string | null;
    burstingKey?: string | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    calculatedDueDate?: Date | null;
    status: ActivityExecutionResultEnum;
    calculatedStatus: ActivityExecutionResultEnum;
    supervisors?: string | null;
    contributors?: string | null;
    owners?: string | null;
    discriminator?: string | null;
    percentComplete: number;
}

export enum ActivityExecutionResultEnum {
    Unknown = 0,
    Success = 1,
    Yes = 2,
    No = 3,
    Approved = 4,
    Rejected = 5,
    Upcoming = 6,
    Queued = 7,
    Running = 8,
    Overdue = 9,
    Error = 10,
    Stopped = 11,
}

export class RecentProcessRunLogs implements IRecentProcessRunLogs {
    processRunId!: string;
    otherRecentRuns?: ProcessHistoryRun[] | null;
    logs?: ProcessRunActivityLog[] | null;

    constructor(data?: IRecentProcessRunLogs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            if (Array.isArray(data["otherRecentRuns"])) {
                this.otherRecentRuns = [] as any;
                for (let item in data["otherRecentRuns"])
                    this.otherRecentRuns!.push(ProcessHistoryRun.fromJS(data["otherRecentRuns"][item]));
            }
            else {
                this.otherRecentRuns = null as any;
            }
            if (Array.isArray(data["logs"])) {
                this.logs = [] as any;
                for (let item in data["logs"])
                    this.logs!.push(ProcessRunActivityLog.fromJS(data["logs"][item]));
            }
            else {
                this.logs = null as any;
            }
        }
    }

    static fromJS(data: any): RecentProcessRunLogs {
        data = typeof data === 'object' ? data : {};
        let result = new RecentProcessRunLogs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        if (Array.isArray(this.otherRecentRuns)) {
            data["otherRecentRuns"] = [];
            for (let item in this.otherRecentRuns)
                data["otherRecentRuns"].push(this.otherRecentRuns[item] ? this.otherRecentRuns[item].toJSON() : null as any);
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item in this.logs)
                data["logs"].push(this.logs[item] ? this.logs[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): RecentProcessRunLogs {
        const json = this.toJSON();
        let result = new RecentProcessRunLogs();
        result.init(json);
        return result;
    }
}

export interface IRecentProcessRunLogs {
    processRunId: string;
    otherRecentRuns?: ProcessHistoryRun[] | null;
    logs?: ProcessRunActivityLog[] | null;
}

export class ProcessHistoryRun implements IProcessHistoryRun {
    processRunId!: string;
    startTime!: Date;

    constructor(data?: IProcessHistoryRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ProcessHistoryRun {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessHistoryRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        return data;
    }

    clone(): ProcessHistoryRun {
        const json = this.toJSON();
        let result = new ProcessHistoryRun();
        result.init(json);
        return result;
    }
}

export interface IProcessHistoryRun {
    processRunId: string;
    startTime: Date;
}

export class ProcessRunLog implements IProcessRunLog {
    processRunId!: string;
    activityRunId?: string | null;
    time!: Date;
    level!: LogLevel;
    message?: string | null;

    constructor(data?: IProcessRunLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : null as any;
            this.time = data["time"] ? new Date(data["time"].toString()) : null as any;
            this.level = data["level"] !== undefined ? data["level"] : null as any;
            this.message = data["message"] !== undefined ? data["message"] : null as any;
        }
    }

    static fromJS(data: any): ProcessRunLog {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : null as any;
        data["time"] = this.time ? this.time.toISOString() : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): ProcessRunLog {
        const json = this.toJSON();
        let result = new ProcessRunLog();
        result.init(json);
        return result;
    }
}

export interface IProcessRunLog {
    processRunId: string;
    activityRunId?: string | null;
    time: Date;
    level: LogLevel;
    message?: string | null;
}

export class ProcessRunActivityLog extends ProcessRunLog implements IProcessRunActivityLog {
    activityName?: string | null;
    status?: string | null;
    feCaption?: string | null;

    constructor(data?: IProcessRunActivityLog) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.feCaption = data["feCaption"] !== undefined ? data["feCaption"] : null as any;
        }
    }

    static override fromJS(data: any): ProcessRunActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunActivityLog();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["feCaption"] = this.feCaption !== undefined ? this.feCaption : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ProcessRunActivityLog {
        const json = this.toJSON();
        let result = new ProcessRunActivityLog();
        result.init(json);
        return result;
    }
}

export interface IProcessRunActivityLog extends IProcessRunLog {
    activityName?: string | null;
    status?: string | null;
    feCaption?: string | null;
}

export class ProcessRun implements IProcessRun {
    logs?: ProcessRunLog[] | null;
    processRunId!: string;
    startTime!: Date;
    endTime?: Date | null;
    process?: string | null;
    status?: string | null;
    dueDate?: Date | null;
    startedByProcessRunId?: string | null;
    startedByActivityRunId?: string | null;
    sendNotifications!: boolean;

    constructor(data?: IProcessRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["logs"])) {
                this.logs = [] as any;
                for (let item in data["logs"])
                    this.logs!.push(ProcessRunLog.fromJS(data["logs"][item]));
            }
            else {
                this.logs = null as any;
            }
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null as any;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : null as any;
            this.process = data["process"] !== undefined ? data["process"] : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : null as any;
            this.startedByProcessRunId = data["startedByProcessRunId"] !== undefined ? data["startedByProcessRunId"] : null as any;
            this.startedByActivityRunId = data["startedByActivityRunId"] !== undefined ? data["startedByActivityRunId"] : null as any;
            this.sendNotifications = data["sendNotifications"] !== undefined ? data["sendNotifications"] : null as any;
        }
    }

    static fromJS(data: any): ProcessRun {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item in this.logs)
                data["logs"].push(this.logs[item] ? this.logs[item].toJSON() : null as any);
        }
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["process"] = this.process !== undefined ? this.process : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["startedByProcessRunId"] = this.startedByProcessRunId !== undefined ? this.startedByProcessRunId : null as any;
        data["startedByActivityRunId"] = this.startedByActivityRunId !== undefined ? this.startedByActivityRunId : null as any;
        data["sendNotifications"] = this.sendNotifications !== undefined ? this.sendNotifications : null as any;
        return data;
    }

    clone(): ProcessRun {
        const json = this.toJSON();
        let result = new ProcessRun();
        result.init(json);
        return result;
    }
}

export interface IProcessRun {
    logs?: ProcessRunLog[] | null;
    processRunId: string;
    startTime: Date;
    endTime?: Date | null;
    process?: string | null;
    status?: string | null;
    dueDate?: Date | null;
    startedByProcessRunId?: string | null;
    startedByActivityRunId?: string | null;
    sendNotifications: boolean;
}

export class TopicActivityMessage implements ITopicActivityMessage {
    type!: TopicActivityMessageType;
    tenant?: string | null;
    runAsUserName?: string | null;
    processRunId!: string;
    subProcessRunId?: string | null;
    activityName?: string | null;
    activityRunId!: string;
    caption?: string | null;
    burstingKey?: number | null;
    parentNodeId?: string | null;
    nodeId?: string | null;
    dueDate?: Date | null;
    sendNotifications!: boolean;

    constructor(data?: ITopicActivityMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : null as any;
            this.runAsUserName = data["runAsUserName"] !== undefined ? data["runAsUserName"] : null as any;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : null as any;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : null as any;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : null as any;
            this.parentNodeId = data["parentNodeId"] !== undefined ? data["parentNodeId"] : null as any;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : null as any;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : null as any;
            this.sendNotifications = data["sendNotifications"] !== undefined ? data["sendNotifications"] : null as any;
        }
    }

    static fromJS(data: any): TopicActivityMessage {
        data = typeof data === 'object' ? data : {};
        let result = new TopicActivityMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["tenant"] = this.tenant !== undefined ? this.tenant : null as any;
        data["runAsUserName"] = this.runAsUserName !== undefined ? this.runAsUserName : null as any;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : null as any;
        data["parentNodeId"] = this.parentNodeId !== undefined ? this.parentNodeId : null as any;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["sendNotifications"] = this.sendNotifications !== undefined ? this.sendNotifications : null as any;
        return data;
    }

    clone(): TopicActivityMessage {
        const json = this.toJSON();
        let result = new TopicActivityMessage();
        result.init(json);
        return result;
    }
}

export interface ITopicActivityMessage {
    type: TopicActivityMessageType;
    tenant?: string | null;
    runAsUserName?: string | null;
    processRunId: string;
    subProcessRunId?: string | null;
    activityName?: string | null;
    activityRunId: string;
    caption?: string | null;
    burstingKey?: number | null;
    parentNodeId?: string | null;
    nodeId?: string | null;
    dueDate?: Date | null;
    sendNotifications: boolean;
}

export enum TopicActivityMessageType {
    StartActivity = 0,
    ActivityOverdue = 1,
    RestartActivity = 2,
    DelayEnded = 3,
}

export class ActivityExecutionResultBase implements IActivityExecutionResultBase {
    type!: ActivityExecutionResultEnum;
    percentComplete!: number;

    constructor(data?: IActivityExecutionResultBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : null as any;
        }
    }

    static fromJS(data: any): ActivityExecutionResultBase {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityExecutionResultBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : null as any;
        return data;
    }

    clone(): ActivityExecutionResultBase {
        const json = this.toJSON();
        let result = new ActivityExecutionResultBase();
        result.init(json);
        return result;
    }
}

export interface IActivityExecutionResultBase {
    type: ActivityExecutionResultEnum;
    percentComplete: number;
}

export class ProcessSchedule implements IProcessSchedule {
    id?: number | null;
    scheduleName?: string | null;
    tenant?: string | null;
    runAsUserName?: string | null;
    cronExpression?: string | null;
    nextRunId?: number | null;
    nextRunUid?: string | null;
    nextRunTopic?: string | null;
    processPath?: string | null;
    timezone?: string | null;

    constructor(data?: IProcessSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.scheduleName = data["scheduleName"] !== undefined ? data["scheduleName"] : null as any;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : null as any;
            this.runAsUserName = data["runAsUserName"] !== undefined ? data["runAsUserName"] : null as any;
            this.cronExpression = data["cronExpression"] !== undefined ? data["cronExpression"] : null as any;
            this.nextRunId = data["nextRunId"] !== undefined ? data["nextRunId"] : null as any;
            this.nextRunUid = data["nextRunUid"] !== undefined ? data["nextRunUid"] : null as any;
            this.nextRunTopic = data["nextRunTopic"] !== undefined ? data["nextRunTopic"] : null as any;
            this.processPath = data["processPath"] !== undefined ? data["processPath"] : null as any;
            this.timezone = data["timezone"] !== undefined ? data["timezone"] : null as any;
        }
    }

    static fromJS(data: any): ProcessSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["scheduleName"] = this.scheduleName !== undefined ? this.scheduleName : null as any;
        data["tenant"] = this.tenant !== undefined ? this.tenant : null as any;
        data["runAsUserName"] = this.runAsUserName !== undefined ? this.runAsUserName : null as any;
        data["cronExpression"] = this.cronExpression !== undefined ? this.cronExpression : null as any;
        data["nextRunId"] = this.nextRunId !== undefined ? this.nextRunId : null as any;
        data["nextRunUid"] = this.nextRunUid !== undefined ? this.nextRunUid : null as any;
        data["nextRunTopic"] = this.nextRunTopic !== undefined ? this.nextRunTopic : null as any;
        data["processPath"] = this.processPath !== undefined ? this.processPath : null as any;
        data["timezone"] = this.timezone !== undefined ? this.timezone : null as any;
        return data;
    }

    clone(): ProcessSchedule {
        const json = this.toJSON();
        let result = new ProcessSchedule();
        result.init(json);
        return result;
    }
}

export interface IProcessSchedule {
    id?: number | null;
    scheduleName?: string | null;
    tenant?: string | null;
    runAsUserName?: string | null;
    cronExpression?: string | null;
    nextRunId?: number | null;
    nextRunUid?: string | null;
    nextRunTopic?: string | null;
    processPath?: string | null;
    timezone?: string | null;
}

export class RelationalQueryResult implements IRelationalQueryResult {
    noFields!: number;
    noRows!: number;
    fields?: string[] | null;
    fieldTypes?: string[] | null;
    data?: string[][] | null;

    constructor(data?: IRelationalQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.noFields = data["noFields"] !== undefined ? data["noFields"] : null as any;
            this.noRows = data["noRows"] !== undefined ? data["noRows"] : null as any;
            if (Array.isArray(data["fields"])) {
                this.fields = [] as any;
                for (let item in data["fields"])
                    this.fields!.push(data["fields"][item]);
            }
            else {
                this.fields = null as any;
            }
            if (Array.isArray(data["fieldTypes"])) {
                this.fieldTypes = [] as any;
                for (let item in data["fieldTypes"])
                    this.fieldTypes!.push(data["fieldTypes"][item]);
            }
            else {
                this.fieldTypes = null as any;
            }
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): RelationalQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new RelationalQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noFields"] = this.noFields !== undefined ? this.noFields : null as any;
        data["noRows"] = this.noRows !== undefined ? this.noRows : null as any;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item in this.fields)
                data["fields"].push(this.fields[item]);
        }
        if (Array.isArray(this.fieldTypes)) {
            data["fieldTypes"] = [];
            for (let item in this.fieldTypes)
                data["fieldTypes"].push(this.fieldTypes[item]);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): RelationalQueryResult {
        const json = this.toJSON();
        let result = new RelationalQueryResult();
        result.init(json);
        return result;
    }
}

export interface IRelationalQueryResult {
    noFields: number;
    noRows: number;
    fields?: string[] | null;
    fieldTypes?: string[] | null;
    data?: string[][] | null;
}

export class RelationalQueryRequest implements IRelationalQueryRequest {
    datasource?: string | null;
    queryText?: string | null;

    constructor(data?: IRelationalQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.datasource = data["datasource"] !== undefined ? data["datasource"] : null as any;
            this.queryText = data["queryText"] !== undefined ? data["queryText"] : null as any;
        }
    }

    static fromJS(data: any): RelationalQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelationalQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasource"] = this.datasource !== undefined ? this.datasource : null as any;
        data["queryText"] = this.queryText !== undefined ? this.queryText : null as any;
        return data;
    }

    clone(): RelationalQueryRequest {
        const json = this.toJSON();
        let result = new RelationalQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IRelationalQueryRequest {
    datasource?: string | null;
    queryText?: string | null;
}

export class CalcScriptResult implements ICalcScriptResult {
    batchId?: string | null;

    constructor(data?: ICalcScriptResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchId = data["batchId"] !== undefined ? data["batchId"] : null as any;
        }
    }

    static fromJS(data: any): CalcScriptResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalcScriptResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId !== undefined ? this.batchId : null as any;
        return data;
    }

    clone(): CalcScriptResult {
        const json = this.toJSON();
        let result = new CalcScriptResult();
        result.init(json);
        return result;
    }
}

export interface ICalcScriptResult {
    batchId?: string | null;
}

export class BookDefinition implements IBookDefinition {
    name?: string | null;
    password?: string | null;
    output!: BookOutput;
    compilation!: BookCompilation;
    destination?: string | null;
    parameters?: BookParameter[] | null;
    entries?: BookForm[] | null;

    constructor(data?: IBookDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.password = data["password"] !== undefined ? data["password"] : null as any;
            this.output = data["output"] !== undefined ? data["output"] : null as any;
            this.compilation = data["compilation"] !== undefined ? data["compilation"] : null as any;
            this.destination = data["destination"] !== undefined ? data["destination"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(BookParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            if (Array.isArray(data["entries"])) {
                this.entries = [] as any;
                for (let item in data["entries"])
                    this.entries!.push(BookForm.fromJS(data["entries"][item]));
            }
            else {
                this.entries = null as any;
            }
        }
    }

    static fromJS(data: any): BookDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new BookDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["output"] = this.output !== undefined ? this.output : null as any;
        data["compilation"] = this.compilation !== undefined ? this.compilation : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item in this.entries)
                data["entries"].push(this.entries[item] ? this.entries[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): BookDefinition {
        const json = this.toJSON();
        let result = new BookDefinition();
        result.init(json);
        return result;
    }
}

export interface IBookDefinition {
    name?: string | null;
    password?: string | null;
    output: BookOutput;
    compilation: BookCompilation;
    destination?: string | null;
    parameters?: BookParameter[] | null;
    entries?: BookForm[] | null;
}

export enum BookCompilation {
    Merged = 0,
    Zip = 1,
}

export class BookParameter implements IBookParameter {
    name?: string | null;
    label?: string | null;
    sourceId?: number | null;
    sourcePath?: string | null;
    sourceName?: string | null;

    constructor(data?: IBookParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.label = data["label"] !== undefined ? data["label"] : null as any;
            this.sourceId = data["sourceId"] !== undefined ? data["sourceId"] : null as any;
            this.sourcePath = data["sourcePath"] !== undefined ? data["sourcePath"] : null as any;
            this.sourceName = data["sourceName"] !== undefined ? data["sourceName"] : null as any;
        }
    }

    static fromJS(data: any): BookParameter {
        data = typeof data === 'object' ? data : {};
        let result = new BookParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : null as any;
        data["sourcePath"] = this.sourcePath !== undefined ? this.sourcePath : null as any;
        data["sourceName"] = this.sourceName !== undefined ? this.sourceName : null as any;
        return data;
    }

    clone(): BookParameter {
        const json = this.toJSON();
        let result = new BookParameter();
        result.init(json);
        return result;
    }
}

export interface IBookParameter {
    name?: string | null;
    label?: string | null;
    sourceId?: number | null;
    sourcePath?: string | null;
    sourceName?: string | null;
}

export class BookForm implements IBookForm {
    description?: string | null;
    id?: number | null;
    path?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;

    constructor(data?: IBookForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.path = data["path"] !== undefined ? data["path"] : null as any;
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(KeyValuePairOfStringAndString.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
            if (Array.isArray(data["tabNames"])) {
                this.tabNames = [] as any;
                for (let item in data["tabNames"])
                    this.tabNames!.push(KeyValuePairOfStringAndString.fromJS(data["tabNames"][item]));
            }
            else {
                this.tabNames = null as any;
            }
        }
    }

    static fromJS(data: any): BookForm {
        data = typeof data === 'object' ? data : {};
        let result = new BookForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["path"] = this.path !== undefined ? this.path : null as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        if (Array.isArray(this.tabNames)) {
            data["tabNames"] = [];
            for (let item in this.tabNames)
                data["tabNames"].push(this.tabNames[item] ? this.tabNames[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): BookForm {
        const json = this.toJSON();
        let result = new BookForm();
        result.init(json);
        return result;
    }
}

export interface IBookForm {
    description?: string | null;
    id?: number | null;
    path?: string | null;
    parameters?: KeyValuePairOfStringAndString[] | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;
}

export class ReportBookItem implements IReportBookItem {
    fileSystemObject?: FileSystemObjectContent | null;
    name?: string | null;
    password?: string | null;
    output!: BookOutput;
    compilation!: BookCompilation;
    destination?: string | null;
    entries?: ReportBookEntry[] | null;
    parameters?: BookAndFormParameter[] | null;

    constructor(data?: IReportBookItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemObject = data["fileSystemObject"] ? FileSystemObjectContent.fromJS(data["fileSystemObject"]) : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.password = data["password"] !== undefined ? data["password"] : null as any;
            this.output = data["output"] !== undefined ? data["output"] : null as any;
            this.compilation = data["compilation"] !== undefined ? data["compilation"] : null as any;
            this.destination = data["destination"] !== undefined ? data["destination"] : null as any;
            if (Array.isArray(data["entries"])) {
                this.entries = [] as any;
                for (let item in data["entries"])
                    this.entries!.push(ReportBookEntry.fromJS(data["entries"][item]));
            }
            else {
                this.entries = null as any;
            }
            if (Array.isArray(data["parameters"])) {
                this.parameters = [] as any;
                for (let item in data["parameters"])
                    this.parameters!.push(BookAndFormParameter.fromJS(data["parameters"][item]));
            }
            else {
                this.parameters = null as any;
            }
        }
    }

    static fromJS(data: any): ReportBookItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportBookItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemObject"] = this.fileSystemObject ? this.fileSystemObject.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["output"] = this.output !== undefined ? this.output : null as any;
        data["compilation"] = this.compilation !== undefined ? this.compilation : null as any;
        data["destination"] = this.destination !== undefined ? this.destination : null as any;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item in this.entries)
                data["entries"].push(this.entries[item] ? this.entries[item].toJSON() : null as any);
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item in this.parameters)
                data["parameters"].push(this.parameters[item] ? this.parameters[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ReportBookItem {
        const json = this.toJSON();
        let result = new ReportBookItem();
        result.init(json);
        return result;
    }
}

export interface IReportBookItem {
    fileSystemObject?: FileSystemObjectContent | null;
    name?: string | null;
    password?: string | null;
    output: BookOutput;
    compilation: BookCompilation;
    destination?: string | null;
    entries?: ReportBookEntry[] | null;
    parameters?: BookAndFormParameter[] | null;
}

export class ReportBookEntry implements IReportBookEntry {
    description?: string | null;
    fileSystemObject?: FileSystemObjectContent | null;
    parameters?: FormParameterList | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;

    constructor(data?: IReportBookEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.fileSystemObject = data["fileSystemObject"] ? FileSystemObjectContent.fromJS(data["fileSystemObject"]) : null as any;
            this.parameters = data["parameters"] ? FormParameterList.fromJS(data["parameters"]) : null as any;
            if (Array.isArray(data["tabNames"])) {
                this.tabNames = [] as any;
                for (let item in data["tabNames"])
                    this.tabNames!.push(KeyValuePairOfStringAndString.fromJS(data["tabNames"][item]));
            }
            else {
                this.tabNames = null as any;
            }
        }
    }

    static fromJS(data: any): ReportBookEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ReportBookEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["fileSystemObject"] = this.fileSystemObject ? this.fileSystemObject.toJSON() : null as any;
        data["parameters"] = this.parameters ? this.parameters.toJSON() : null as any;
        if (Array.isArray(this.tabNames)) {
            data["tabNames"] = [];
            for (let item in this.tabNames)
                data["tabNames"].push(this.tabNames[item] ? this.tabNames[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ReportBookEntry {
        const json = this.toJSON();
        let result = new ReportBookEntry();
        result.init(json);
        return result;
    }
}

export interface IReportBookEntry {
    description?: string | null;
    fileSystemObject?: FileSystemObjectContent | null;
    parameters?: FormParameterList | null;
    tabNames?: KeyValuePairOfStringAndString[] | null;
}

export class BookAndFormParameter implements IBookAndFormParameter {
    bookParameter?: BookParameter | null;
    formParameter?: FormParameter | null;

    constructor(data?: IBookAndFormParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookParameter = data["bookParameter"] ? BookParameter.fromJS(data["bookParameter"]) : null as any;
            this.formParameter = data["formParameter"] ? FormParameter.fromJS(data["formParameter"]) : null as any;
        }
    }

    static fromJS(data: any): BookAndFormParameter {
        data = typeof data === 'object' ? data : {};
        let result = new BookAndFormParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookParameter"] = this.bookParameter ? this.bookParameter.toJSON() : null as any;
        data["formParameter"] = this.formParameter ? this.formParameter.toJSON() : null as any;
        return data;
    }

    clone(): BookAndFormParameter {
        const json = this.toJSON();
        let result = new BookAndFormParameter();
        result.init(json);
        return result;
    }
}

export interface IBookAndFormParameter {
    bookParameter?: BookParameter | null;
    formParameter?: FormParameter | null;
}

export class BookDefinitionAndCurrentParameters implements IBookDefinitionAndCurrentParameters {
    bookDefinition?: BookDefinition | null;
    currentParameters?: FormParameterCurrentValue[] | null;

    constructor(data?: IBookDefinitionAndCurrentParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bookDefinition = data["bookDefinition"] ? BookDefinition.fromJS(data["bookDefinition"]) : null as any;
            if (Array.isArray(data["currentParameters"])) {
                this.currentParameters = [] as any;
                for (let item in data["currentParameters"])
                    this.currentParameters!.push(FormParameterCurrentValue.fromJS(data["currentParameters"][item]));
            }
            else {
                this.currentParameters = null as any;
            }
        }
    }

    static fromJS(data: any): BookDefinitionAndCurrentParameters {
        data = typeof data === 'object' ? data : {};
        let result = new BookDefinitionAndCurrentParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookDefinition"] = this.bookDefinition ? this.bookDefinition.toJSON() : null as any;
        if (Array.isArray(this.currentParameters)) {
            data["currentParameters"] = [];
            for (let item in this.currentParameters)
                data["currentParameters"].push(this.currentParameters[item] ? this.currentParameters[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): BookDefinitionAndCurrentParameters {
        const json = this.toJSON();
        let result = new BookDefinitionAndCurrentParameters();
        result.init(json);
        return result;
    }
}

export interface IBookDefinitionAndCurrentParameters {
    bookDefinition?: BookDefinition | null;
    currentParameters?: FormParameterCurrentValue[] | null;
}

export class RoleObject implements IRoleObject {
    roleid!: number;
    roleName?: string | null;
    users?: string[] | null;

    constructor(data?: IRoleObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleid = data["roleid"] !== undefined ? data["roleid"] : null as any;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null as any;
            if (Array.isArray(data["users"])) {
                this.users = [] as any;
                for (let item in data["users"])
                    this.users!.push(data["users"][item]);
            }
            else {
                this.users = null as any;
            }
        }
    }

    static fromJS(data: any): RoleObject {
        data = typeof data === 'object' ? data : {};
        let result = new RoleObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleid"] = this.roleid !== undefined ? this.roleid : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item in this.users)
                data["users"].push(this.users[item]);
        }
        return data;
    }

    clone(): RoleObject {
        const json = this.toJSON();
        let result = new RoleObject();
        result.init(json);
        return result;
    }
}

export interface IRoleObject {
    roleid: number;
    roleName?: string | null;
    users?: string[] | null;
}

export class SecureUserObject implements ISecureUserObject {
    userID!: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled!: boolean;
    isGloballyDisabled!: boolean;
    superuser?: boolean | null;
    email?: string | null;
    roles?: string[] | null;
    lastLoginDate?: Date | null;
    dateAdded?: Date | null;
    userDomain?: string | null;

    constructor(data?: ISecureUserObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"] !== undefined ? data["userID"] : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null as any;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : null as any;
            this.isGloballyDisabled = data["isGloballyDisabled"] !== undefined ? data["isGloballyDisabled"] : null as any;
            this.superuser = data["superuser"] !== undefined ? data["superuser"] : null as any;
            this.email = data["email"] !== undefined ? data["email"] : null as any;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = null as any;
            }
            this.lastLoginDate = data["lastLoginDate"] ? new Date(data["lastLoginDate"].toString()) : null as any;
            this.dateAdded = data["dateAdded"] ? new Date(data["dateAdded"].toString()) : null as any;
            this.userDomain = data["userDomain"] !== undefined ? data["userDomain"] : null as any;
        }
    }

    static fromJS(data: any): SecureUserObject {
        data = typeof data === 'object' ? data : {};
        let result = new SecureUserObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["isGloballyDisabled"] = this.isGloballyDisabled !== undefined ? this.isGloballyDisabled : null as any;
        data["superuser"] = this.superuser !== undefined ? this.superuser : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : null as any;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : null as any;
        data["userDomain"] = this.userDomain !== undefined ? this.userDomain : null as any;
        return data;
    }

    clone(): SecureUserObject {
        const json = this.toJSON();
        let result = new SecureUserObject();
        result.init(json);
        return result;
    }
}

export interface ISecureUserObject {
    userID: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled: boolean;
    isGloballyDisabled: boolean;
    superuser?: boolean | null;
    email?: string | null;
    roles?: string[] | null;
    lastLoginDate?: Date | null;
    dateAdded?: Date | null;
    userDomain?: string | null;
}

export class UserObject extends SecureUserObject implements IUserObject {

    constructor(data?: IUserObject) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
    }

    static override fromJS(data: any): UserObject {
        data = typeof data === 'object' ? data : {};
        let result = new UserObject();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): UserObject {
        const json = this.toJSON();
        let result = new UserObject();
        result.init(json);
        return result;
    }
}

export interface IUserObject extends ISecureUserObject {
}

export class Tenant implements ITenant {
    name?: string | null;
    caption?: string | null;
    webApiUrl?: string | null;
    portalUrl?: string | null;
    license?: string | null;
    environment?: string | null;
    bgColor?: string | null;
    analysisServicesCS?: string | null;
    isALMEnabled!: boolean;
    anaplanInternalConnectionKey?: string | null;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.webApiUrl = data["webApiUrl"] !== undefined ? data["webApiUrl"] : null as any;
            this.portalUrl = data["portalUrl"] !== undefined ? data["portalUrl"] : null as any;
            this.license = data["license"] !== undefined ? data["license"] : null as any;
            this.environment = data["environment"] !== undefined ? data["environment"] : null as any;
            this.bgColor = data["bgColor"] !== undefined ? data["bgColor"] : null as any;
            this.analysisServicesCS = data["analysisServicesCS"] !== undefined ? data["analysisServicesCS"] : null as any;
            this.isALMEnabled = data["isALMEnabled"] !== undefined ? data["isALMEnabled"] : null as any;
            this.anaplanInternalConnectionKey = data["anaplanInternalConnectionKey"] !== undefined ? data["anaplanInternalConnectionKey"] : null as any;
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["webApiUrl"] = this.webApiUrl !== undefined ? this.webApiUrl : null as any;
        data["portalUrl"] = this.portalUrl !== undefined ? this.portalUrl : null as any;
        data["license"] = this.license !== undefined ? this.license : null as any;
        data["environment"] = this.environment !== undefined ? this.environment : null as any;
        data["bgColor"] = this.bgColor !== undefined ? this.bgColor : null as any;
        data["analysisServicesCS"] = this.analysisServicesCS !== undefined ? this.analysisServicesCS : null as any;
        data["isALMEnabled"] = this.isALMEnabled !== undefined ? this.isALMEnabled : null as any;
        data["anaplanInternalConnectionKey"] = this.anaplanInternalConnectionKey !== undefined ? this.anaplanInternalConnectionKey : null as any;
        return data;
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    name?: string | null;
    caption?: string | null;
    webApiUrl?: string | null;
    portalUrl?: string | null;
    license?: string | null;
    environment?: string | null;
    bgColor?: string | null;
    analysisServicesCS?: string | null;
    isALMEnabled: boolean;
    anaplanInternalConnectionKey?: string | null;
}

export class AnaplanInternalConnectionResponse implements IAnaplanInternalConnectionResponse {
    keyName?: string | null;

    constructor(data?: IAnaplanInternalConnectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyName = data["keyName"] !== undefined ? data["keyName"] : null as any;
        }
    }

    static fromJS(data: any): AnaplanInternalConnectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnaplanInternalConnectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyName"] = this.keyName !== undefined ? this.keyName : null as any;
        return data;
    }

    clone(): AnaplanInternalConnectionResponse {
        const json = this.toJSON();
        let result = new AnaplanInternalConnectionResponse();
        result.init(json);
        return result;
    }
}

export interface IAnaplanInternalConnectionResponse {
    keyName?: string | null;
}

export class FluenceToken implements IFluenceToken {
    success!: boolean;
    username?: string | null;
    token?: string | null;
    message?: string | null;

    constructor(data?: IFluenceToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"] !== undefined ? data["success"] : null as any;
            this.username = data["username"] !== undefined ? data["username"] : null as any;
            this.token = data["token"] !== undefined ? data["token"] : null as any;
            this.message = data["message"] !== undefined ? data["message"] : null as any;
        }
    }

    static fromJS(data: any): FluenceToken {
        data = typeof data === 'object' ? data : {};
        let result = new FluenceToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["token"] = this.token !== undefined ? this.token : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): FluenceToken {
        const json = this.toJSON();
        let result = new FluenceToken();
        result.init(json);
        return result;
    }
}

export interface IFluenceToken {
    success: boolean;
    username?: string | null;
    token?: string | null;
    message?: string | null;
}

export class UserData implements IUserData {
    name?: string | null;
    userName?: string | null;
    tenant?: string | null;
    language?: string | null;
    logId?: string | null;
    environment?: string | null;
    roles?: string[] | null;
    isSuperUser!: boolean;
    initials?: string | null;
    ip?: string | null;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.tenant = data["tenant"] !== undefined ? data["tenant"] : null as any;
            this.language = data["language"] !== undefined ? data["language"] : null as any;
            this.logId = data["logId"] !== undefined ? data["logId"] : null as any;
            this.environment = data["environment"] !== undefined ? data["environment"] : null as any;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = null as any;
            }
            this.isSuperUser = data["isSuperUser"] !== undefined ? data["isSuperUser"] : null as any;
            this.initials = data["initials"] !== undefined ? data["initials"] : null as any;
            this.ip = data["ip"] !== undefined ? data["ip"] : null as any;
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["tenant"] = this.tenant !== undefined ? this.tenant : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["logId"] = this.logId !== undefined ? this.logId : null as any;
        data["environment"] = this.environment !== undefined ? this.environment : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        data["isSuperUser"] = this.isSuperUser !== undefined ? this.isSuperUser : null as any;
        data["initials"] = this.initials !== undefined ? this.initials : null as any;
        data["ip"] = this.ip !== undefined ? this.ip : null as any;
        return data;
    }

    clone(): UserData {
        const json = this.toJSON();
        let result = new UserData();
        result.init(json);
        return result;
    }
}

export interface IUserData {
    name?: string | null;
    userName?: string | null;
    tenant?: string | null;
    language?: string | null;
    logId?: string | null;
    environment?: string | null;
    roles?: string[] | null;
    isSuperUser: boolean;
    initials?: string | null;
    ip?: string | null;
}

export class ExtendedUserData extends UserData implements IExtendedUserData {
    moduleSecurity?: Module[] | null;
    featureFlags?: string[] | null;
    hasDashboard!: boolean;
    releaseInfo?: ReleaseInfo | null;
    welcomeMessage?: string | null;
    multiLanguageSupport?: string[] | null;
    themeName?: string | null;
    metadataAuditTrail?: string | null;
    modelSecurity?: string | null;
    jeSecurity?: string | null;
    allowMemberNamesWithLeadingZeroes?: string | null;
    workflowGanttChart?: string | null;
    jeConversion?: string | null;

    constructor(data?: IExtendedUserData) {
        super(data);
    }

    override init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["moduleSecurity"])) {
                this.moduleSecurity = [] as any;
                for (let item in data["moduleSecurity"])
                    this.moduleSecurity!.push(Module.fromJS(data["moduleSecurity"][item]));
            }
            else {
                this.moduleSecurity = null as any;
            }
            if (Array.isArray(data["featureFlags"])) {
                this.featureFlags = [] as any;
                for (let item in data["featureFlags"])
                    this.featureFlags!.push(data["featureFlags"][item]);
            }
            else {
                this.featureFlags = null as any;
            }
            this.hasDashboard = data["hasDashboard"] !== undefined ? data["hasDashboard"] : null as any;
            this.releaseInfo = data["releaseInfo"] ? ReleaseInfo.fromJS(data["releaseInfo"]) : null as any;
            this.welcomeMessage = data["welcomeMessage"] !== undefined ? data["welcomeMessage"] : null as any;
            if (Array.isArray(data["multiLanguageSupport"])) {
                this.multiLanguageSupport = [] as any;
                for (let item in data["multiLanguageSupport"])
                    this.multiLanguageSupport!.push(data["multiLanguageSupport"][item]);
            }
            else {
                this.multiLanguageSupport = null as any;
            }
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : null as any;
            this.metadataAuditTrail = data["metadataAuditTrail"] !== undefined ? data["metadataAuditTrail"] : null as any;
            this.modelSecurity = data["modelSecurity"] !== undefined ? data["modelSecurity"] : null as any;
            this.jeSecurity = data["jeSecurity"] !== undefined ? data["jeSecurity"] : null as any;
            this.allowMemberNamesWithLeadingZeroes = data["allowMemberNamesWithLeadingZeroes"] !== undefined ? data["allowMemberNamesWithLeadingZeroes"] : null as any;
            this.workflowGanttChart = data["workflowGanttChart"] !== undefined ? data["workflowGanttChart"] : null as any;
            this.jeConversion = data["jeConversion"] !== undefined ? data["jeConversion"] : null as any;
        }
    }

    static override fromJS(data: any): ExtendedUserData {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedUserData();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleSecurity)) {
            data["moduleSecurity"] = [];
            for (let item in this.moduleSecurity)
                data["moduleSecurity"].push(this.moduleSecurity[item] ? this.moduleSecurity[item].toJSON() : null as any);
        }
        if (Array.isArray(this.featureFlags)) {
            data["featureFlags"] = [];
            for (let item in this.featureFlags)
                data["featureFlags"].push(this.featureFlags[item]);
        }
        data["hasDashboard"] = this.hasDashboard !== undefined ? this.hasDashboard : null as any;
        data["releaseInfo"] = this.releaseInfo ? this.releaseInfo.toJSON() : null as any;
        data["welcomeMessage"] = this.welcomeMessage !== undefined ? this.welcomeMessage : null as any;
        if (Array.isArray(this.multiLanguageSupport)) {
            data["multiLanguageSupport"] = [];
            for (let item in this.multiLanguageSupport)
                data["multiLanguageSupport"].push(this.multiLanguageSupport[item]);
        }
        data["themeName"] = this.themeName !== undefined ? this.themeName : null as any;
        data["metadataAuditTrail"] = this.metadataAuditTrail !== undefined ? this.metadataAuditTrail : null as any;
        data["modelSecurity"] = this.modelSecurity !== undefined ? this.modelSecurity : null as any;
        data["jeSecurity"] = this.jeSecurity !== undefined ? this.jeSecurity : null as any;
        data["allowMemberNamesWithLeadingZeroes"] = this.allowMemberNamesWithLeadingZeroes !== undefined ? this.allowMemberNamesWithLeadingZeroes : null as any;
        data["workflowGanttChart"] = this.workflowGanttChart !== undefined ? this.workflowGanttChart : null as any;
        data["jeConversion"] = this.jeConversion !== undefined ? this.jeConversion : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ExtendedUserData {
        const json = this.toJSON();
        let result = new ExtendedUserData();
        result.init(json);
        return result;
    }
}

export interface IExtendedUserData extends IUserData {
    moduleSecurity?: Module[] | null;
    featureFlags?: string[] | null;
    hasDashboard: boolean;
    releaseInfo?: ReleaseInfo | null;
    welcomeMessage?: string | null;
    multiLanguageSupport?: string[] | null;
    themeName?: string | null;
    metadataAuditTrail?: string | null;
    modelSecurity?: string | null;
    jeSecurity?: string | null;
    allowMemberNamesWithLeadingZeroes?: string | null;
    workflowGanttChart?: string | null;
    jeConversion?: string | null;
}

export class Module implements IModule {
    id!: number;
    name?: string | null;
    category?: string | null;
    enabled!: boolean;
    displayOrder!: number;
    categoryOrder!: number;
    formID?: number | null;
    allowExport?: boolean | null;
    allowImport?: boolean | null;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.category = data["category"] !== undefined ? data["category"] : null as any;
            this.enabled = data["enabled"] !== undefined ? data["enabled"] : null as any;
            this.displayOrder = data["displayOrder"] !== undefined ? data["displayOrder"] : null as any;
            this.categoryOrder = data["categoryOrder"] !== undefined ? data["categoryOrder"] : null as any;
            this.formID = data["formID"] !== undefined ? data["formID"] : null as any;
            this.allowExport = data["allowExport"] !== undefined ? data["allowExport"] : null as any;
            this.allowImport = data["allowImport"] !== undefined ? data["allowImport"] : null as any;
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : null as any;
        data["categoryOrder"] = this.categoryOrder !== undefined ? this.categoryOrder : null as any;
        data["formID"] = this.formID !== undefined ? this.formID : null as any;
        data["allowExport"] = this.allowExport !== undefined ? this.allowExport : null as any;
        data["allowImport"] = this.allowImport !== undefined ? this.allowImport : null as any;
        return data;
    }

    clone(): Module {
        const json = this.toJSON();
        let result = new Module();
        result.init(json);
        return result;
    }
}

export interface IModule {
    id: number;
    name?: string | null;
    category?: string | null;
    enabled: boolean;
    displayOrder: number;
    categoryOrder: number;
    formID?: number | null;
    allowExport?: boolean | null;
    allowImport?: boolean | null;
}

export class ReleaseInfo implements IReleaseInfo {
    platform?: string | null;
    consolidationModule?: string | null;
    accountRecModule?: string | null;
    matchingModule?: string | null;

    constructor(data?: IReleaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.platform = data["platform"] !== undefined ? data["platform"] : null as any;
            this.consolidationModule = data["consolidationModule"] !== undefined ? data["consolidationModule"] : null as any;
            this.accountRecModule = data["accountRecModule"] !== undefined ? data["accountRecModule"] : null as any;
            this.matchingModule = data["matchingModule"] !== undefined ? data["matchingModule"] : null as any;
        }
    }

    static fromJS(data: any): ReleaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform !== undefined ? this.platform : null as any;
        data["consolidationModule"] = this.consolidationModule !== undefined ? this.consolidationModule : null as any;
        data["accountRecModule"] = this.accountRecModule !== undefined ? this.accountRecModule : null as any;
        data["matchingModule"] = this.matchingModule !== undefined ? this.matchingModule : null as any;
        return data;
    }

    clone(): ReleaseInfo {
        const json = this.toJSON();
        let result = new ReleaseInfo();
        result.init(json);
        return result;
    }
}

export interface IReleaseInfo {
    platform?: string | null;
    consolidationModule?: string | null;
    accountRecModule?: string | null;
    matchingModule?: string | null;
}

export class DimensionSecurity implements IDimensionSecurity {
    dimension?: string | null;
    hierarchy?: string | null;
    security?: HierarchySecurity[] | null;

    constructor(data?: IDimensionSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dimension = data["dimension"] !== undefined ? data["dimension"] : null as any;
            this.hierarchy = data["hierarchy"] !== undefined ? data["hierarchy"] : null as any;
            if (Array.isArray(data["security"])) {
                this.security = [] as any;
                for (let item in data["security"])
                    this.security!.push(HierarchySecurity.fromJS(data["security"][item]));
            }
            else {
                this.security = null as any;
            }
        }
    }

    static fromJS(data: any): DimensionSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new DimensionSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension !== undefined ? this.dimension : null as any;
        data["hierarchy"] = this.hierarchy !== undefined ? this.hierarchy : null as any;
        if (Array.isArray(this.security)) {
            data["security"] = [];
            for (let item in this.security)
                data["security"].push(this.security[item] ? this.security[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): DimensionSecurity {
        const json = this.toJSON();
        let result = new DimensionSecurity();
        result.init(json);
        return result;
    }
}

export interface IDimensionSecurity {
    dimension?: string | null;
    hierarchy?: string | null;
    security?: HierarchySecurity[] | null;
}

export class HierarchySecurity implements IHierarchySecurity {
    role?: string | null;
    details?: HierarchySecurityDetail[] | null;

    constructor(data?: IHierarchySecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] !== undefined ? data["role"] : null as any;
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item in data["details"])
                    this.details!.push(HierarchySecurityDetail.fromJS(data["details"][item]));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): HierarchySecurity {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchySecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role !== undefined ? this.role : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item in this.details)
                data["details"].push(this.details[item] ? this.details[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): HierarchySecurity {
        const json = this.toJSON();
        let result = new HierarchySecurity();
        result.init(json);
        return result;
    }
}

export interface IHierarchySecurity {
    role?: string | null;
    details?: HierarchySecurityDetail[] | null;
}

export class HierarchySecurityDetail implements IHierarchySecurityDetail {
    allowDeny!: AllowDeny;
    memberKey!: number;
    level?: number | null;
    memberRelationship!: DimensionSecurityMemberRelationship;

    constructor(data?: IHierarchySecurityDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowDeny = data["allowDeny"] !== undefined ? data["allowDeny"] : null as any;
            this.memberKey = data["memberKey"] !== undefined ? data["memberKey"] : null as any;
            this.level = data["level"] !== undefined ? data["level"] : null as any;
            this.memberRelationship = data["memberRelationship"] !== undefined ? data["memberRelationship"] : null as any;
        }
    }

    static fromJS(data: any): HierarchySecurityDetail {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchySecurityDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowDeny"] = this.allowDeny !== undefined ? this.allowDeny : null as any;
        data["memberKey"] = this.memberKey !== undefined ? this.memberKey : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["memberRelationship"] = this.memberRelationship !== undefined ? this.memberRelationship : null as any;
        return data;
    }

    clone(): HierarchySecurityDetail {
        const json = this.toJSON();
        let result = new HierarchySecurityDetail();
        result.init(json);
        return result;
    }
}

export interface IHierarchySecurityDetail {
    allowDeny: AllowDeny;
    memberKey: number;
    level?: number | null;
    memberRelationship: DimensionSecurityMemberRelationship;
}

export enum AllowDeny {
    Deny = 0,
    Allow = 1,
}

export enum DimensionSecurityMemberRelationship {
    Self = 0,
    Descendants = 1,
    SelfAndDescendants = 2,
    Children = 3,
    SelfAndChildren = 4,
}

export enum ModuleAccess {
    WorkflowManagement = 0,
    AdvancedForms = 3,
    SecurityUserManagementCreate = 4,
    SecurityUserManagementUpdate = 5,
    SecurityUserManagementDelete = 6,
    SecurityRoleManagementCreate = 7,
    SecurityRoleManagementUpdate = 8,
    SecurityRoleManagementDelete = 9,
    SecurityRoleManagementAssignAuthorization = 10,
    SecurityFileSystemSecurityAssign = 11,
    SecurityMetadataSecurityAssign = 12,
    SecuritySecurityReportingAccess = 13,
    SecurityAuditReportingAccess = 14,
    MetadataManagementModelManagementManage = 15,
    MetadataManagementModelViewsManage = 16,
    WorkflowManagementManage = 17,
    WorkflowManagementControl = 18,
    WorkflowManagementView = 19,
    ConfigurationStagingTablesManage = 20,
    ConfigurationDataSourcesConnectionsManage = 21,
    DataImportsDataImportDefinitionsManage = 22,
    DataImportsMappingsView = 23,
    DataImportsMappingsManage = 24,
    HomepagesHomepageManagementManage = 25,
    BasicForms = 26,
    ConfigurationJournalEntriesManageSettings = 29,
    JournalEntriesView = 30,
    JournalEntriesCreate = 31,
    SecurityRoleManagementUserReports = 33,
    ConsolidationMaintain = 34,
    AccountReconciliationMaintain = 35,
    FinancialReportingMaintain = 36,
    LogsEtlLogsView = 37,
    RestApiTokensCreate = 38,
    DataImportsAssignRolesToMappings = 39,
    ThemeCustomSettingsManage = 40,
    LogsMetadataAuditLogView = 41,
    DataImportsAssignRolesToDataImports = 42,
    MetadataManagementModelsCreateUpdate = 43,
    MetadataManagementModelsDelete = 44,
    MetadataManagementModelsView = 45,
    MatchingView = 46,
    MatchingMatch = 47,
    MatchingUnmatch = 48,
    MatchingSupport = 49,
    MatchingDelete = 50,
    ConfigurationJournalConfigurationDelete = 51,
    JournalEntriesUpdate = 52,
    JournalEntriesDelete = 53,
    JournalEntriesImport = 54,
    JournalEntriesPost = 55,
    JournalEntriesUnpost = 56,
    LandscapeManagementManage = 57,
    SecurityUserManagementView = 58,
    MetadataManagementModelManagementView = 59,
    MetadataRuntimeRead = 60,
    MaintenanceRuntimeRead = 61,
}

export class ModuleSecurityInfo implements IModuleSecurityInfo {
    roleName?: string | null;
    moduleId?: Module[] | null;

    constructor(data?: IModuleSecurityInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null as any;
            if (Array.isArray(data["moduleId"])) {
                this.moduleId = [] as any;
                for (let item in data["moduleId"])
                    this.moduleId!.push(Module.fromJS(data["moduleId"][item]));
            }
            else {
                this.moduleId = null as any;
            }
        }
    }

    static fromJS(data: any): ModuleSecurityInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleSecurityInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        if (Array.isArray(this.moduleId)) {
            data["moduleId"] = [];
            for (let item in this.moduleId)
                data["moduleId"].push(this.moduleId[item] ? this.moduleId[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ModuleSecurityInfo {
        const json = this.toJSON();
        let result = new ModuleSecurityInfo();
        result.init(json);
        return result;
    }
}

export interface IModuleSecurityInfo {
    roleName?: string | null;
    moduleId?: Module[] | null;
}

export class ExportRoleAuthInfo implements IExportRoleAuthInfo {
    moduleDescriptions?: ModuleDescription[] | null;
    securityParentGroups?: SecurityParentGroup[] | null;
    exportRoles?: string[] | null;

    constructor(data?: IExportRoleAuthInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["moduleDescriptions"])) {
                this.moduleDescriptions = [] as any;
                for (let item in data["moduleDescriptions"])
                    this.moduleDescriptions!.push(ModuleDescription.fromJS(data["moduleDescriptions"][item]));
            }
            else {
                this.moduleDescriptions = null as any;
            }
            if (Array.isArray(data["securityParentGroups"])) {
                this.securityParentGroups = [] as any;
                for (let item in data["securityParentGroups"])
                    this.securityParentGroups!.push(SecurityParentGroup.fromJS(data["securityParentGroups"][item]));
            }
            else {
                this.securityParentGroups = null as any;
            }
            if (Array.isArray(data["exportRoles"])) {
                this.exportRoles = [] as any;
                for (let item in data["exportRoles"])
                    this.exportRoles!.push(data["exportRoles"][item]);
            }
            else {
                this.exportRoles = null as any;
            }
        }
    }

    static fromJS(data: any): ExportRoleAuthInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRoleAuthInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleDescriptions)) {
            data["moduleDescriptions"] = [];
            for (let item in this.moduleDescriptions)
                data["moduleDescriptions"].push(this.moduleDescriptions[item] ? this.moduleDescriptions[item].toJSON() : null as any);
        }
        if (Array.isArray(this.securityParentGroups)) {
            data["securityParentGroups"] = [];
            for (let item in this.securityParentGroups)
                data["securityParentGroups"].push(this.securityParentGroups[item] ? this.securityParentGroups[item].toJSON() : null as any);
        }
        if (Array.isArray(this.exportRoles)) {
            data["exportRoles"] = [];
            for (let item in this.exportRoles)
                data["exportRoles"].push(this.exportRoles[item]);
        }
        return data;
    }

    clone(): ExportRoleAuthInfo {
        const json = this.toJSON();
        let result = new ExportRoleAuthInfo();
        result.init(json);
        return result;
    }
}

export interface IExportRoleAuthInfo {
    moduleDescriptions?: ModuleDescription[] | null;
    securityParentGroups?: SecurityParentGroup[] | null;
    exportRoles?: string[] | null;
}

export class ModuleDescription implements IModuleDescription {
    moduleId!: number;
    description?: string | null;

    constructor(data?: IModuleDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moduleId = data["moduleId"] !== undefined ? data["moduleId"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
        }
    }

    static fromJS(data: any): ModuleDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId !== undefined ? this.moduleId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): ModuleDescription {
        const json = this.toJSON();
        let result = new ModuleDescription();
        result.init(json);
        return result;
    }
}

export interface IModuleDescription {
    moduleId: number;
    description?: string | null;
}

export class SecurityParentGroup implements ISecurityParentGroup {
    name?: string | null;
    groups?: SecurityGroup[] | null;

    constructor(data?: ISecurityParentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            if (Array.isArray(data["groups"])) {
                this.groups = [] as any;
                for (let item in data["groups"])
                    this.groups!.push(SecurityGroup.fromJS(data["groups"][item]));
            }
            else {
                this.groups = null as any;
            }
        }
    }

    static fromJS(data: any): SecurityParentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityParentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item in this.groups)
                data["groups"].push(this.groups[item] ? this.groups[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): SecurityParentGroup {
        const json = this.toJSON();
        let result = new SecurityParentGroup();
        result.init(json);
        return result;
    }
}

export interface ISecurityParentGroup {
    name?: string | null;
    groups?: SecurityGroup[] | null;
}

export class SecurityGroup implements ISecurityGroup {
    name?: string | null;
    modules?: number[] | null;

    constructor(data?: ISecurityGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            if (Array.isArray(data["modules"])) {
                this.modules = [] as any;
                for (let item in data["modules"])
                    this.modules!.push(data["modules"][item]);
            }
            else {
                this.modules = null as any;
            }
        }
    }

    static fromJS(data: any): SecurityGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item in this.modules)
                data["modules"].push(this.modules[item]);
        }
        return data;
    }

    clone(): SecurityGroup {
        const json = this.toJSON();
        let result = new SecurityGroup();
        result.init(json);
        return result;
    }
}

export interface ISecurityGroup {
    name?: string | null;
    modules?: number[] | null;
}

export class FileSystemSecurity implements IFileSystemSecurity {
    fileSystemId!: number;
    objectRights?: AccessRights | null;
    folderRights?: AccessRights | null;
    children?: FileSystemSecurity[] | null;

    constructor(data?: IFileSystemSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileSystemId = data["fileSystemId"] !== undefined ? data["fileSystemId"] : null as any;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : null as any;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : null as any;
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item in data["children"])
                    this.children!.push(FileSystemSecurity.fromJS(data["children"][item]));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): FileSystemSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new FileSystemSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileSystemId"] = this.fileSystemId !== undefined ? this.fileSystemId : null as any;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : null as any;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item in this.children)
                data["children"].push(this.children[item] ? this.children[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): FileSystemSecurity {
        const json = this.toJSON();
        let result = new FileSystemSecurity();
        result.init(json);
        return result;
    }
}

export interface IFileSystemSecurity {
    fileSystemId: number;
    objectRights?: AccessRights | null;
    folderRights?: AccessRights | null;
    children?: FileSystemSecurity[] | null;
}

export class FileRoleSecurity implements IFileRoleSecurity {
    roleId!: number;
    roleName?: string | null;
    objectRights?: AccessRights | null;
    inheritObjectRights!: boolean;
    folderRights?: AccessRights | null;
    inheritFolderRights!: boolean;

    constructor(data?: IFileRoleSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null as any;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null as any;
            this.objectRights = data["objectRights"] !== undefined ? data["objectRights"] : null as any;
            this.inheritObjectRights = data["inheritObjectRights"] !== undefined ? data["inheritObjectRights"] : null as any;
            this.folderRights = data["folderRights"] !== undefined ? data["folderRights"] : null as any;
            this.inheritFolderRights = data["inheritFolderRights"] !== undefined ? data["inheritFolderRights"] : null as any;
        }
    }

    static fromJS(data: any): FileRoleSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new FileRoleSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : null as any;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null as any;
        data["objectRights"] = this.objectRights !== undefined ? this.objectRights : null as any;
        data["inheritObjectRights"] = this.inheritObjectRights !== undefined ? this.inheritObjectRights : null as any;
        data["folderRights"] = this.folderRights !== undefined ? this.folderRights : null as any;
        data["inheritFolderRights"] = this.inheritFolderRights !== undefined ? this.inheritFolderRights : null as any;
        return data;
    }

    clone(): FileRoleSecurity {
        const json = this.toJSON();
        let result = new FileRoleSecurity();
        result.init(json);
        return result;
    }
}

export interface IFileRoleSecurity {
    roleId: number;
    roleName?: string | null;
    objectRights?: AccessRights | null;
    inheritObjectRights: boolean;
    folderRights?: AccessRights | null;
    inheritFolderRights: boolean;
}

export class MigrationRequest implements IMigrationRequest {
    dryRun!: boolean;
    targetTenants?: string[] | null;

    constructor(data?: IMigrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dryRun = data["dryRun"] !== undefined ? data["dryRun"] : null as any;
            if (Array.isArray(data["targetTenants"])) {
                this.targetTenants = [] as any;
                for (let item in data["targetTenants"])
                    this.targetTenants!.push(data["targetTenants"][item]);
            }
            else {
                this.targetTenants = null as any;
            }
        }
    }

    static fromJS(data: any): MigrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : null as any;
        if (Array.isArray(this.targetTenants)) {
            data["targetTenants"] = [];
            for (let item in this.targetTenants)
                data["targetTenants"].push(this.targetTenants[item]);
        }
        return data;
    }

    clone(): MigrationRequest {
        const json = this.toJSON();
        let result = new MigrationRequest();
        result.init(json);
        return result;
    }
}

export interface IMigrationRequest {
    dryRun: boolean;
    targetTenants?: string[] | null;
}

export class MigrationJob implements IMigrationJob {
    jobId!: string;
    state!: MigrationJobState;
    request!: MigrationRequest;
    startedBy!: string;
    startedAt!: Date;
    completedAt?: Date | null;
    totalTenants!: number;
    processedTenants!: number;
    currentTenant?: string | null;
    result!: MigrationResult;
    failureMessage?: string | null;

    constructor(data?: IMigrationJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.request = new MigrationRequest();
            this.result = new MigrationResult();
        }
    }

    init(data?: any) {
        if (data) {
            this.jobId = data["jobId"] !== undefined ? data["jobId"] : null as any;
            this.state = data["state"] !== undefined ? data["state"] : null as any;
            this.request = data["request"] ? MigrationRequest.fromJS(data["request"]) : new MigrationRequest();
            this.startedBy = data["startedBy"] !== undefined ? data["startedBy"] : null as any;
            this.startedAt = data["startedAt"] ? new Date(data["startedAt"].toString()) : null as any;
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : null as any;
            this.totalTenants = data["totalTenants"] !== undefined ? data["totalTenants"] : null as any;
            this.processedTenants = data["processedTenants"] !== undefined ? data["processedTenants"] : null as any;
            this.currentTenant = data["currentTenant"] !== undefined ? data["currentTenant"] : null as any;
            this.result = data["result"] ? MigrationResult.fromJS(data["result"]) : new MigrationResult();
            this.failureMessage = data["failureMessage"] !== undefined ? data["failureMessage"] : null as any;
        }
    }

    static fromJS(data: any): MigrationJob {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId !== undefined ? this.jobId : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["request"] = this.request ? this.request.toJSON() : null as any;
        data["startedBy"] = this.startedBy !== undefined ? this.startedBy : null as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : null as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : null as any;
        data["totalTenants"] = this.totalTenants !== undefined ? this.totalTenants : null as any;
        data["processedTenants"] = this.processedTenants !== undefined ? this.processedTenants : null as any;
        data["currentTenant"] = this.currentTenant !== undefined ? this.currentTenant : null as any;
        data["result"] = this.result ? this.result.toJSON() : null as any;
        data["failureMessage"] = this.failureMessage !== undefined ? this.failureMessage : null as any;
        return data;
    }

    clone(): MigrationJob {
        const json = this.toJSON();
        let result = new MigrationJob();
        result.init(json);
        return result;
    }
}

export interface IMigrationJob {
    jobId: string;
    state: MigrationJobState;
    request: MigrationRequest;
    startedBy: string;
    startedAt: Date;
    completedAt?: Date | null;
    totalTenants: number;
    processedTenants: number;
    currentTenant?: string | null;
    result: MigrationResult;
    failureMessage?: string | null;
}

export enum MigrationJobState {
    Pending = 0,
    Running = 1,
    Completed = 2,
    Failed = 3,
}

export class MigrationResult implements IMigrationResult {
    success!: boolean;
    isDryRun!: boolean;
    totalProcessed!: number;
    migratedCount!: number;
    errorCount!: number;
    errorMessages!: string[];
    startTime!: Date;
    endTime?: Date | null;
    tenantResults!: TenantMigrationResult[];
    remainingPlaintext?: RemainingPlaintextCounts | null;

    constructor(data?: IMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errorMessages = [];
            this.tenantResults = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"] !== undefined ? data["success"] : null as any;
            this.isDryRun = data["isDryRun"] !== undefined ? data["isDryRun"] : null as any;
            this.totalProcessed = data["totalProcessed"] !== undefined ? data["totalProcessed"] : null as any;
            this.migratedCount = data["migratedCount"] !== undefined ? data["migratedCount"] : null as any;
            this.errorCount = data["errorCount"] !== undefined ? data["errorCount"] : null as any;
            if (Array.isArray(data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item in data["errorMessages"])
                    this.errorMessages!.push(data["errorMessages"][item]);
            }
            else {
                this.errorMessages = null as any;
            }
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null as any;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : null as any;
            if (Array.isArray(data["tenantResults"])) {
                this.tenantResults = [] as any;
                for (let item in data["tenantResults"])
                    this.tenantResults!.push(TenantMigrationResult.fromJS(data["tenantResults"][item]));
            }
            else {
                this.tenantResults = null as any;
            }
            this.remainingPlaintext = data["remainingPlaintext"] ? RemainingPlaintextCounts.fromJS(data["remainingPlaintext"]) : null as any;
        }
    }

    static fromJS(data: any): MigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["isDryRun"] = this.isDryRun !== undefined ? this.isDryRun : null as any;
        data["totalProcessed"] = this.totalProcessed !== undefined ? this.totalProcessed : null as any;
        data["migratedCount"] = this.migratedCount !== undefined ? this.migratedCount : null as any;
        data["errorCount"] = this.errorCount !== undefined ? this.errorCount : null as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item in this.errorMessages)
                data["errorMessages"].push(this.errorMessages[item]);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        if (Array.isArray(this.tenantResults)) {
            data["tenantResults"] = [];
            for (let item in this.tenantResults)
                data["tenantResults"].push(this.tenantResults[item] ? this.tenantResults[item].toJSON() : null as any);
        }
        data["remainingPlaintext"] = this.remainingPlaintext ? this.remainingPlaintext.toJSON() : null as any;
        return data;
    }

    clone(): MigrationResult {
        const json = this.toJSON();
        let result = new MigrationResult();
        result.init(json);
        return result;
    }
}

export interface IMigrationResult {
    success: boolean;
    isDryRun: boolean;
    totalProcessed: number;
    migratedCount: number;
    errorCount: number;
    errorMessages: string[];
    startTime: Date;
    endTime?: Date | null;
    tenantResults: TenantMigrationResult[];
    remainingPlaintext?: RemainingPlaintextCounts | null;
}

export class TenantMigrationResult implements ITenantMigrationResult {
    tenantName!: string;
    tenantId!: number;
    success!: boolean;
    appDataSourcesProcessed!: number;
    appDataSourcesMigrated!: number;
    tenantDataMigrated!: boolean;
    errors!: string[];

    constructor(data?: ITenantMigrationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null as any;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null as any;
            this.success = data["success"] !== undefined ? data["success"] : null as any;
            this.appDataSourcesProcessed = data["appDataSourcesProcessed"] !== undefined ? data["appDataSourcesProcessed"] : null as any;
            this.appDataSourcesMigrated = data["appDataSourcesMigrated"] !== undefined ? data["appDataSourcesMigrated"] : null as any;
            this.tenantDataMigrated = data["tenantDataMigrated"] !== undefined ? data["tenantDataMigrated"] : null as any;
            if (Array.isArray(data["errors"])) {
                this.errors = [] as any;
                for (let item in data["errors"])
                    this.errors!.push(data["errors"][item]);
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): TenantMigrationResult {
        data = typeof data === 'object' ? data : {};
        let result = new TenantMigrationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null as any;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null as any;
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["appDataSourcesProcessed"] = this.appDataSourcesProcessed !== undefined ? this.appDataSourcesProcessed : null as any;
        data["appDataSourcesMigrated"] = this.appDataSourcesMigrated !== undefined ? this.appDataSourcesMigrated : null as any;
        data["tenantDataMigrated"] = this.tenantDataMigrated !== undefined ? this.tenantDataMigrated : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item in this.errors)
                data["errors"].push(this.errors[item]);
        }
        return data;
    }

    clone(): TenantMigrationResult {
        const json = this.toJSON();
        let result = new TenantMigrationResult();
        result.init(json);
        return result;
    }
}

export interface ITenantMigrationResult {
    tenantName: string;
    tenantId: number;
    success: boolean;
    appDataSourcesProcessed: number;
    appDataSourcesMigrated: number;
    tenantDataMigrated: boolean;
    errors: string[];
}

export class RemainingPlaintextCounts implements IRemainingPlaintextCounts {
    tenantPrimary!: number;
    tenantSecondary!: number;
    tenantAzureAs!: number;
    tenantCache!: number;
    appDataSources!: number;
    tenantsScanned!: number;
    tenantColumnTotal!: number;
    total!: number;

    constructor(data?: IRemainingPlaintextCounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantPrimary = data["tenantPrimary"] !== undefined ? data["tenantPrimary"] : null as any;
            this.tenantSecondary = data["tenantSecondary"] !== undefined ? data["tenantSecondary"] : null as any;
            this.tenantAzureAs = data["tenantAzureAs"] !== undefined ? data["tenantAzureAs"] : null as any;
            this.tenantCache = data["tenantCache"] !== undefined ? data["tenantCache"] : null as any;
            this.appDataSources = data["appDataSources"] !== undefined ? data["appDataSources"] : null as any;
            this.tenantsScanned = data["tenantsScanned"] !== undefined ? data["tenantsScanned"] : null as any;
            this.tenantColumnTotal = data["tenantColumnTotal"] !== undefined ? data["tenantColumnTotal"] : null as any;
            this.total = data["total"] !== undefined ? data["total"] : null as any;
        }
    }

    static fromJS(data: any): RemainingPlaintextCounts {
        data = typeof data === 'object' ? data : {};
        let result = new RemainingPlaintextCounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantPrimary"] = this.tenantPrimary !== undefined ? this.tenantPrimary : null as any;
        data["tenantSecondary"] = this.tenantSecondary !== undefined ? this.tenantSecondary : null as any;
        data["tenantAzureAs"] = this.tenantAzureAs !== undefined ? this.tenantAzureAs : null as any;
        data["tenantCache"] = this.tenantCache !== undefined ? this.tenantCache : null as any;
        data["appDataSources"] = this.appDataSources !== undefined ? this.appDataSources : null as any;
        data["tenantsScanned"] = this.tenantsScanned !== undefined ? this.tenantsScanned : null as any;
        data["tenantColumnTotal"] = this.tenantColumnTotal !== undefined ? this.tenantColumnTotal : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        return data;
    }

    clone(): RemainingPlaintextCounts {
        const json = this.toJSON();
        let result = new RemainingPlaintextCounts();
        result.init(json);
        return result;
    }
}

export interface IRemainingPlaintextCounts {
    tenantPrimary: number;
    tenantSecondary: number;
    tenantAzureAs: number;
    tenantCache: number;
    appDataSources: number;
    tenantsScanned: number;
    tenantColumnTotal: number;
    total: number;
}

export class SignalRConnfig implements ISignalRConnfig {
    url?: string | null;
    token?: string | null;

    constructor(data?: ISignalRConnfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"] !== undefined ? data["url"] : null as any;
            this.token = data["token"] !== undefined ? data["token"] : null as any;
        }
    }

    static fromJS(data: any): SignalRConnfig {
        data = typeof data === 'object' ? data : {};
        let result = new SignalRConnfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["token"] = this.token !== undefined ? this.token : null as any;
        return data;
    }

    clone(): SignalRConnfig {
        const json = this.toJSON();
        let result = new SignalRConnfig();
        result.init(json);
        return result;
    }
}

export interface ISignalRConnfig {
    url?: string | null;
    token?: string | null;
}

export class TableData implements ITableData {
    metadata?: TableMetadata | null;
    data?: any[][] | null;

    constructor(data?: ITableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.metadata = data["metadata"] ? TableMetadata.fromJS(data["metadata"]) : null as any;
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item in data["data"])
                    this.data!.push(data["data"][item]);
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): TableData {
        data = typeof data === 'object' ? data : {};
        let result = new TableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadata"] = this.metadata ? this.metadata.toJSON() : null as any;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item in this.data)
                data["data"].push(this.data[item]);
        }
        return data;
    }

    clone(): TableData {
        const json = this.toJSON();
        let result = new TableData();
        result.init(json);
        return result;
    }
}

export interface ITableData {
    metadata?: TableMetadata | null;
    data?: any[][] | null;
}

export class TableMetadata implements ITableMetadata {
    columns?: TableColumnMetadata[] | null;
    rowCount!: number;

    constructor(data?: ITableMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["columns"])) {
                this.columns = [] as any;
                for (let item in data["columns"])
                    this.columns!.push(TableColumnMetadata.fromJS(data["columns"][item]));
            }
            else {
                this.columns = null as any;
            }
            this.rowCount = data["rowCount"] !== undefined ? data["rowCount"] : null as any;
        }
    }

    static fromJS(data: any): TableMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new TableMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item in this.columns)
                data["columns"].push(this.columns[item] ? this.columns[item].toJSON() : null as any);
        }
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        return data;
    }

    clone(): TableMetadata {
        const json = this.toJSON();
        let result = new TableMetadata();
        result.init(json);
        return result;
    }
}

export interface ITableMetadata {
    columns?: TableColumnMetadata[] | null;
    rowCount: number;
}

export class TableColumnMetadata implements ITableColumnMetadata {
    columnName?: string | null;
    columnCaption?: string | null;
    columnType?: string | null;
    validation?: TableColumnValidation | null;

    constructor(data?: ITableColumnMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.columnName = data["columnName"] !== undefined ? data["columnName"] : null as any;
            this.columnCaption = data["columnCaption"] !== undefined ? data["columnCaption"] : null as any;
            this.columnType = data["columnType"] !== undefined ? data["columnType"] : null as any;
            this.validation = data["validation"] ? TableColumnValidation.fromJS(data["validation"]) : null as any;
        }
    }

    static fromJS(data: any): TableColumnMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName !== undefined ? this.columnName : null as any;
        data["columnCaption"] = this.columnCaption !== undefined ? this.columnCaption : null as any;
        data["columnType"] = this.columnType !== undefined ? this.columnType : null as any;
        data["validation"] = this.validation ? this.validation.toJSON() : null as any;
        return data;
    }

    clone(): TableColumnMetadata {
        const json = this.toJSON();
        let result = new TableColumnMetadata();
        result.init(json);
        return result;
    }
}

export interface ITableColumnMetadata {
    columnName?: string | null;
    columnCaption?: string | null;
    columnType?: string | null;
    validation?: TableColumnValidation | null;
}

export class TableColumnValidation implements ITableColumnValidation {
    allowNulls!: boolean;
    rule?: string | null;

    constructor(data?: ITableColumnValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowNulls = data["allowNulls"] !== undefined ? data["allowNulls"] : null as any;
            this.rule = data["rule"] !== undefined ? data["rule"] : null as any;
        }
    }

    static fromJS(data: any): TableColumnValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TableColumnValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowNulls"] = this.allowNulls !== undefined ? this.allowNulls : null as any;
        data["rule"] = this.rule !== undefined ? this.rule : null as any;
        return data;
    }

    clone(): TableColumnValidation {
        const json = this.toJSON();
        let result = new TableColumnValidation();
        result.init(json);
        return result;
    }
}

export interface ITableColumnValidation {
    allowNulls: boolean;
    rule?: string | null;
}

export class ThemeInfo implements IThemeInfo {
    themeName?: string | null;
    isCurrentTheme!: boolean;
    themeCustomSettings?: ThemeCustomSettingsInfo[] | null;

    constructor(data?: IThemeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : null as any;
            this.isCurrentTheme = data["isCurrentTheme"] !== undefined ? data["isCurrentTheme"] : null as any;
            if (Array.isArray(data["themeCustomSettings"])) {
                this.themeCustomSettings = [] as any;
                for (let item in data["themeCustomSettings"])
                    this.themeCustomSettings!.push(ThemeCustomSettingsInfo.fromJS(data["themeCustomSettings"][item]));
            }
            else {
                this.themeCustomSettings = null as any;
            }
        }
    }

    static fromJS(data: any): ThemeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeName"] = this.themeName !== undefined ? this.themeName : null as any;
        data["isCurrentTheme"] = this.isCurrentTheme !== undefined ? this.isCurrentTheme : null as any;
        if (Array.isArray(this.themeCustomSettings)) {
            data["themeCustomSettings"] = [];
            for (let item in this.themeCustomSettings)
                data["themeCustomSettings"].push(this.themeCustomSettings[item] ? this.themeCustomSettings[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): ThemeInfo {
        const json = this.toJSON();
        let result = new ThemeInfo();
        result.init(json);
        return result;
    }
}

export interface IThemeInfo {
    themeName?: string | null;
    isCurrentTheme: boolean;
    themeCustomSettings?: ThemeCustomSettingsInfo[] | null;
}

export class ThemeCustomSettingsInfo implements IThemeCustomSettingsInfo {
    settingId!: number;
    themeName?: string | null;
    elementKey?: string | null;
    elementSetting?: string | null;

    constructor(data?: IThemeCustomSettingsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingId = data["settingId"] !== undefined ? data["settingId"] : null as any;
            this.themeName = data["themeName"] !== undefined ? data["themeName"] : null as any;
            this.elementKey = data["elementKey"] !== undefined ? data["elementKey"] : null as any;
            this.elementSetting = data["elementSetting"] !== undefined ? data["elementSetting"] : null as any;
        }
    }

    static fromJS(data: any): ThemeCustomSettingsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeCustomSettingsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId !== undefined ? this.settingId : null as any;
        data["themeName"] = this.themeName !== undefined ? this.themeName : null as any;
        data["elementKey"] = this.elementKey !== undefined ? this.elementKey : null as any;
        data["elementSetting"] = this.elementSetting !== undefined ? this.elementSetting : null as any;
        return data;
    }

    clone(): ThemeCustomSettingsInfo {
        const json = this.toJSON();
        let result = new ThemeCustomSettingsInfo();
        result.init(json);
        return result;
    }
}

export interface IThemeCustomSettingsInfo {
    settingId: number;
    themeName?: string | null;
    elementKey?: string | null;
    elementSetting?: string | null;
}

export class UserDetailsShort implements IUserDetailsShort {
    userName?: string | null;
    fullName?: string | null;
    email?: string | null;

    constructor(data?: IUserDetailsShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null as any;
            this.email = data["email"] !== undefined ? data["email"] : null as any;
        }
    }

    static fromJS(data: any): UserDetailsShort {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsShort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): UserDetailsShort {
        const json = this.toJSON();
        let result = new UserDetailsShort();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsShort {
    userName?: string | null;
    fullName?: string | null;
    email?: string | null;
}

export class UserImportResult implements IUserImportResult {
    importResults?: ImportResult[] | null;
    usersToImport?: UserObject[] | null;

    constructor(data?: IUserImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["importResults"])) {
                this.importResults = [] as any;
                for (let item in data["importResults"])
                    this.importResults!.push(ImportResult.fromJS(data["importResults"][item]));
            }
            else {
                this.importResults = null as any;
            }
            if (Array.isArray(data["usersToImport"])) {
                this.usersToImport = [] as any;
                for (let item in data["usersToImport"])
                    this.usersToImport!.push(UserObject.fromJS(data["usersToImport"][item]));
            }
            else {
                this.usersToImport = null as any;
            }
        }
    }

    static fromJS(data: any): UserImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importResults)) {
            data["importResults"] = [];
            for (let item in this.importResults)
                data["importResults"].push(this.importResults[item] ? this.importResults[item].toJSON() : null as any);
        }
        if (Array.isArray(this.usersToImport)) {
            data["usersToImport"] = [];
            for (let item in this.usersToImport)
                data["usersToImport"].push(this.usersToImport[item] ? this.usersToImport[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): UserImportResult {
        const json = this.toJSON();
        let result = new UserImportResult();
        result.init(json);
        return result;
    }
}

export interface IUserImportResult {
    importResults?: ImportResult[] | null;
    usersToImport?: UserObject[] | null;
}

export class ImportResult implements IImportResult {
    lineNumber!: number;
    errorCode?: number | null;
    warningCode?: number | null;
    variable?: any | null;
    type?: string | null;

    constructor(data?: IImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lineNumber = data["lineNumber"] !== undefined ? data["lineNumber"] : null as any;
            this.errorCode = data["errorCode"] !== undefined ? data["errorCode"] : null as any;
            this.warningCode = data["warningCode"] !== undefined ? data["warningCode"] : null as any;
            this.variable = data["variable"] !== undefined ? data["variable"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
        }
    }

    static fromJS(data: any): ImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null as any;
        data["errorCode"] = this.errorCode !== undefined ? this.errorCode : null as any;
        data["warningCode"] = this.warningCode !== undefined ? this.warningCode : null as any;
        data["variable"] = this.variable !== undefined ? this.variable : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): ImportResult {
        const json = this.toJSON();
        let result = new ImportResult();
        result.init(json);
        return result;
    }
}

export interface IImportResult {
    lineNumber: number;
    errorCode?: number | null;
    warningCode?: number | null;
    variable?: any | null;
    type?: string | null;
}

export class ApiToken implements IApiToken {
    token?: string | null;
    description?: string | null;
    creationDate?: Date | null;
    expirationDate?: Date | null;

    constructor(data?: IApiToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"] !== undefined ? data["token"] : null as any;
            this.description = data["description"] !== undefined ? data["description"] : null as any;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : null as any;
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiToken {
        data = typeof data === 'object' ? data : {};
        let result = new ApiToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null as any;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : null as any;
        return data;
    }

    clone(): ApiToken {
        const json = this.toJSON();
        let result = new ApiToken();
        result.init(json);
        return result;
    }
}

export interface IApiToken {
    token?: string | null;
    description?: string | null;
    creationDate?: Date | null;
    expirationDate?: Date | null;
}

export class WhatsNewArticle implements IWhatsNewArticle {
    id!: number;
    name?: string | null;
    sortOrder!: number;
    language?: string | null;
    versionFrom?: string | null;
    versionTo?: string | null;
    showDemoScheduleButton!: boolean;
    moreDetailsLink?: string | null;
    htmlText?: string | null;
    modulesCommaSeparated?: string[] | null;

    constructor(data?: IWhatsNewArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null as any;
            this.name = data["name"] !== undefined ? data["name"] : null as any;
            this.sortOrder = data["sortOrder"] !== undefined ? data["sortOrder"] : null as any;
            this.language = data["language"] !== undefined ? data["language"] : null as any;
            this.versionFrom = data["versionFrom"] !== undefined ? data["versionFrom"] : null as any;
            this.versionTo = data["versionTo"] !== undefined ? data["versionTo"] : null as any;
            this.showDemoScheduleButton = data["showDemoScheduleButton"] !== undefined ? data["showDemoScheduleButton"] : null as any;
            this.moreDetailsLink = data["moreDetailsLink"] !== undefined ? data["moreDetailsLink"] : null as any;
            this.htmlText = data["htmlText"] !== undefined ? data["htmlText"] : null as any;
            if (Array.isArray(data["modulesCommaSeparated"])) {
                this.modulesCommaSeparated = [] as any;
                for (let item in data["modulesCommaSeparated"])
                    this.modulesCommaSeparated!.push(data["modulesCommaSeparated"][item]);
            }
            else {
                this.modulesCommaSeparated = null as any;
            }
        }
    }

    static fromJS(data: any): WhatsNewArticle {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsNewArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["versionFrom"] = this.versionFrom !== undefined ? this.versionFrom : null as any;
        data["versionTo"] = this.versionTo !== undefined ? this.versionTo : null as any;
        data["showDemoScheduleButton"] = this.showDemoScheduleButton !== undefined ? this.showDemoScheduleButton : null as any;
        data["moreDetailsLink"] = this.moreDetailsLink !== undefined ? this.moreDetailsLink : null as any;
        data["htmlText"] = this.htmlText !== undefined ? this.htmlText : null as any;
        if (Array.isArray(this.modulesCommaSeparated)) {
            data["modulesCommaSeparated"] = [];
            for (let item in this.modulesCommaSeparated)
                data["modulesCommaSeparated"].push(this.modulesCommaSeparated[item]);
        }
        return data;
    }

    clone(): WhatsNewArticle {
        const json = this.toJSON();
        let result = new WhatsNewArticle();
        result.init(json);
        return result;
    }
}

export interface IWhatsNewArticle {
    id: number;
    name?: string | null;
    sortOrder: number;
    language?: string | null;
    versionFrom?: string | null;
    versionTo?: string | null;
    showDemoScheduleButton: boolean;
    moreDetailsLink?: string | null;
    htmlText?: string | null;
    modulesCommaSeparated?: string[] | null;
}

export class WritebackData implements IWritebackData {
    model?: string | null;
    allocationMethod?: string | null;
    dimensions?: string[] | null;
    tuples?: WritebackTuple[] | null;

    constructor(data?: IWritebackData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.model = data["model"] !== undefined ? data["model"] : null as any;
            this.allocationMethod = data["allocationMethod"] !== undefined ? data["allocationMethod"] : null as any;
            if (Array.isArray(data["dimensions"])) {
                this.dimensions = [] as any;
                for (let item in data["dimensions"])
                    this.dimensions!.push(data["dimensions"][item]);
            }
            else {
                this.dimensions = null as any;
            }
            if (Array.isArray(data["tuples"])) {
                this.tuples = [] as any;
                for (let item in data["tuples"])
                    this.tuples!.push(WritebackTuple.fromJS(data["tuples"][item]));
            }
            else {
                this.tuples = null as any;
            }
        }
    }

    static fromJS(data: any): WritebackData {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model !== undefined ? this.model : null as any;
        data["allocationMethod"] = this.allocationMethod !== undefined ? this.allocationMethod : null as any;
        if (Array.isArray(this.dimensions)) {
            data["dimensions"] = [];
            for (let item in this.dimensions)
                data["dimensions"].push(this.dimensions[item]);
        }
        if (Array.isArray(this.tuples)) {
            data["tuples"] = [];
            for (let item in this.tuples)
                data["tuples"].push(this.tuples[item] ? this.tuples[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): WritebackData {
        const json = this.toJSON();
        let result = new WritebackData();
        result.init(json);
        return result;
    }
}

export interface IWritebackData {
    model?: string | null;
    allocationMethod?: string | null;
    dimensions?: string[] | null;
    tuples?: WritebackTuple[] | null;
}

export class WritebackTuple implements IWritebackTuple {
    names?: string[] | null;
    keys?: number[] | null;
    newValue?: string | null;

    constructor(data?: IWritebackTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["names"])) {
                this.names = [] as any;
                for (let item in data["names"])
                    this.names!.push(data["names"][item]);
            }
            else {
                this.names = null as any;
            }
            if (Array.isArray(data["keys"])) {
                this.keys = [] as any;
                for (let item in data["keys"])
                    this.keys!.push(data["keys"][item]);
            }
            else {
                this.keys = null as any;
            }
            this.newValue = data["newValue"] !== undefined ? data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): WritebackTuple {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item in this.names)
                data["names"].push(this.names[item]);
        }
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item in this.keys)
                data["keys"].push(this.keys[item]);
        }
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }

    clone(): WritebackTuple {
        const json = this.toJSON();
        let result = new WritebackTuple();
        result.init(json);
        return result;
    }
}

export interface IWritebackTuple {
    names?: string[] | null;
    keys?: number[] | null;
    newValue?: string | null;
}

export class WritebackResolvedSecurity implements IWritebackResolvedSecurity {
    restrictedHierarchies?: string[] | null;
    allowedMembers?: { [key: string]: number[]; } | null;
    allowedTuples?: TupleOfStringOfAndInt32Of[] | null;
    restrictTuples!: boolean;
    restrictMembers!: boolean;

    constructor(data?: IWritebackResolvedSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["restrictedHierarchies"])) {
                this.restrictedHierarchies = [] as any;
                for (let item in data["restrictedHierarchies"])
                    this.restrictedHierarchies!.push(data["restrictedHierarchies"][item]);
            }
            else {
                this.restrictedHierarchies = null as any;
            }
            if (data["allowedMembers"]) {
                this.allowedMembers = {} as any;
                for (let key in data["allowedMembers"]) {
                    if (data["allowedMembers"].hasOwnProperty(key))
                        (this.allowedMembers as any)![key] = data["allowedMembers"][key] !== undefined ? data["allowedMembers"][key] : [];
                }
            }
            else {
                this.allowedMembers = null as any;
            }
            if (Array.isArray(data["allowedTuples"])) {
                this.allowedTuples = [] as any;
                for (let item in data["allowedTuples"])
                    this.allowedTuples!.push(TupleOfStringOfAndInt32Of.fromJS(data["allowedTuples"][item]));
            }
            else {
                this.allowedTuples = null as any;
            }
            this.restrictTuples = data["restrictTuples"] !== undefined ? data["restrictTuples"] : null as any;
            this.restrictMembers = data["restrictMembers"] !== undefined ? data["restrictMembers"] : null as any;
        }
    }

    static fromJS(data: any): WritebackResolvedSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new WritebackResolvedSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.restrictedHierarchies)) {
            data["restrictedHierarchies"] = [];
            for (let item in this.restrictedHierarchies)
                data["restrictedHierarchies"].push(this.restrictedHierarchies[item]);
        }
        if (this.allowedMembers) {
            data["allowedMembers"] = {};
            for (let key in this.allowedMembers) {
                if (this.allowedMembers.hasOwnProperty(key))
                    (data["allowedMembers"] as any)[key] = this.allowedMembers[key] !== undefined ? this.allowedMembers[key] : null as any;
            }
        }
        if (Array.isArray(this.allowedTuples)) {
            data["allowedTuples"] = [];
            for (let item in this.allowedTuples)
                data["allowedTuples"].push(this.allowedTuples[item] ? this.allowedTuples[item].toJSON() : null as any);
        }
        data["restrictTuples"] = this.restrictTuples !== undefined ? this.restrictTuples : null as any;
        data["restrictMembers"] = this.restrictMembers !== undefined ? this.restrictMembers : null as any;
        return data;
    }

    clone(): WritebackResolvedSecurity {
        const json = this.toJSON();
        let result = new WritebackResolvedSecurity();
        result.init(json);
        return result;
    }
}

export interface IWritebackResolvedSecurity {
    restrictedHierarchies?: string[] | null;
    allowedMembers?: { [key: string]: number[]; } | null;
    allowedTuples?: TupleOfStringOfAndInt32Of[] | null;
    restrictTuples: boolean;
    restrictMembers: boolean;
}

export class TupleOfStringOfAndInt32Of implements ITupleOfStringOfAndInt32Of {
    item1?: string[] | null;
    item2?: number[] | null;

    constructor(data?: ITupleOfStringOfAndInt32Of) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["item1"])) {
                this.item1 = [] as any;
                for (let item in data["item1"])
                    this.item1!.push(data["item1"][item]);
            }
            else {
                this.item1 = null as any;
            }
            if (Array.isArray(data["item2"])) {
                this.item2 = [] as any;
                for (let item in data["item2"])
                    this.item2!.push(data["item2"][item]);
            }
            else {
                this.item2 = null as any;
            }
        }
    }

    static fromJS(data: any): TupleOfStringOfAndInt32Of {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringOfAndInt32Of();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item in this.item1)
                data["item1"].push(this.item1[item]);
        }
        if (Array.isArray(this.item2)) {
            data["item2"] = [];
            for (let item in this.item2)
                data["item2"].push(this.item2[item]);
        }
        return data;
    }

    clone(): TupleOfStringOfAndInt32Of {
        const json = this.toJSON();
        let result = new TupleOfStringOfAndInt32Of();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringOfAndInt32Of {
    item1?: string[] | null;
    item2?: number[] | null;
}

export class AddCubeCommentModel implements IAddCubeCommentModel {
    connectionKey?: string | null;
    commentXml?: string | null;
    parentMembers?: TupleOfStringAndStringAndInteger[] | null;

    constructor(data?: IAddCubeCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionKey = data["connectionKey"] !== undefined ? data["connectionKey"] : null as any;
            this.commentXml = data["commentXml"] !== undefined ? data["commentXml"] : null as any;
            if (Array.isArray(data["parentMembers"])) {
                this.parentMembers = [] as any;
                for (let item in data["parentMembers"])
                    this.parentMembers!.push(TupleOfStringAndStringAndInteger.fromJS(data["parentMembers"][item]));
            }
            else {
                this.parentMembers = null as any;
            }
        }
    }

    static fromJS(data: any): AddCubeCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCubeCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionKey"] = this.connectionKey !== undefined ? this.connectionKey : null as any;
        data["commentXml"] = this.commentXml !== undefined ? this.commentXml : null as any;
        if (Array.isArray(this.parentMembers)) {
            data["parentMembers"] = [];
            for (let item in this.parentMembers)
                data["parentMembers"].push(this.parentMembers[item] ? this.parentMembers[item].toJSON() : null as any);
        }
        return data;
    }

    clone(): AddCubeCommentModel {
        const json = this.toJSON();
        let result = new AddCubeCommentModel();
        result.init(json);
        return result;
    }
}

export interface IAddCubeCommentModel {
    connectionKey?: string | null;
    commentXml?: string | null;
    parentMembers?: TupleOfStringAndStringAndInteger[] | null;
}

export class TupleOfStringAndStringAndInteger implements ITupleOfStringAndStringAndInteger {
    item1?: string | null;
    item2?: string | null;
    item3!: number;

    constructor(data?: ITupleOfStringAndStringAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] !== undefined ? data["item1"] : null as any;
            this.item2 = data["item2"] !== undefined ? data["item2"] : null as any;
            this.item3 = data["item3"] !== undefined ? data["item3"] : null as any;
        }
    }

    static fromJS(data: any): TupleOfStringAndStringAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringAndStringAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : null as any;
        data["item2"] = this.item2 !== undefined ? this.item2 : null as any;
        data["item3"] = this.item3 !== undefined ? this.item3 : null as any;
        return data;
    }

    clone(): TupleOfStringAndStringAndInteger {
        const json = this.toJSON();
        let result = new TupleOfStringAndStringAndInteger();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringAndStringAndInteger {
    item1?: string | null;
    item2?: string | null;
    item3: number;
}

export class CubeCommentsByKeyModel implements ICubeCommentsByKeyModel {
    commentKeys?: string[] | null;
    mergeComments!: boolean;
    exactMatch!: boolean;

    constructor(data?: ICubeCommentsByKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["commentKeys"])) {
                this.commentKeys = [] as any;
                for (let item in data["commentKeys"])
                    this.commentKeys!.push(data["commentKeys"][item]);
            }
            else {
                this.commentKeys = null as any;
            }
            this.mergeComments = data["mergeComments"] !== undefined ? data["mergeComments"] : null as any;
            this.exactMatch = data["exactMatch"] !== undefined ? data["exactMatch"] : null as any;
        }
    }

    static fromJS(data: any): CubeCommentsByKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CubeCommentsByKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commentKeys)) {
            data["commentKeys"] = [];
            for (let item in this.commentKeys)
                data["commentKeys"].push(this.commentKeys[item]);
        }
        data["mergeComments"] = this.mergeComments !== undefined ? this.mergeComments : null as any;
        data["exactMatch"] = this.exactMatch !== undefined ? this.exactMatch : null as any;
        return data;
    }

    clone(): CubeCommentsByKeyModel {
        const json = this.toJSON();
        let result = new CubeCommentsByKeyModel();
        result.init(json);
        return result;
    }
}

export interface ICubeCommentsByKeyModel {
    commentKeys?: string[] | null;
    mergeComments: boolean;
    exactMatch: boolean;
}

export class GetCubeCommentsWithDescByKeyModel implements IGetCubeCommentsWithDescByKeyModel {
    commentKeys?: string[] | null;
    defaultMembers?: string[] | null;

    constructor(data?: IGetCubeCommentsWithDescByKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["commentKeys"])) {
                this.commentKeys = [] as any;
                for (let item in data["commentKeys"])
                    this.commentKeys!.push(data["commentKeys"][item]);
            }
            else {
                this.commentKeys = null as any;
            }
            if (Array.isArray(data["defaultMembers"])) {
                this.defaultMembers = [] as any;
                for (let item in data["defaultMembers"])
                    this.defaultMembers!.push(data["defaultMembers"][item]);
            }
            else {
                this.defaultMembers = null as any;
            }
        }
    }

    static fromJS(data: any): GetCubeCommentsWithDescByKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetCubeCommentsWithDescByKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.commentKeys)) {
            data["commentKeys"] = [];
            for (let item in this.commentKeys)
                data["commentKeys"].push(this.commentKeys[item]);
        }
        if (Array.isArray(this.defaultMembers)) {
            data["defaultMembers"] = [];
            for (let item in this.defaultMembers)
                data["defaultMembers"].push(this.defaultMembers[item]);
        }
        return data;
    }

    clone(): GetCubeCommentsWithDescByKeyModel {
        const json = this.toJSON();
        let result = new GetCubeCommentsWithDescByKeyModel();
        result.init(json);
        return result;
    }
}

export interface IGetCubeCommentsWithDescByKeyModel {
    commentKeys?: string[] | null;
    defaultMembers?: string[] | null;
}

export class TupleOfStringAndStringAndString implements ITupleOfStringAndStringAndString {
    item1?: string | null;
    item2?: string | null;
    item3?: string | null;

    constructor(data?: ITupleOfStringAndStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] !== undefined ? data["item1"] : null as any;
            this.item2 = data["item2"] !== undefined ? data["item2"] : null as any;
            this.item3 = data["item3"] !== undefined ? data["item3"] : null as any;
        }
    }

    static fromJS(data: any): TupleOfStringAndStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfStringAndStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : null as any;
        data["item2"] = this.item2 !== undefined ? this.item2 : null as any;
        data["item3"] = this.item3 !== undefined ? this.item3 : null as any;
        return data;
    }

    clone(): TupleOfStringAndStringAndString {
        const json = this.toJSON();
        let result = new TupleOfStringAndStringAndString();
        result.init(json);
        return result;
    }
}

export interface ITupleOfStringAndStringAndString {
    item1?: string | null;
    item2?: string | null;
    item3?: string | null;
}

export class ApiUserDetails implements IApiUserDetails {
    userId!: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled!: boolean;
    email?: string | null;
    roles?: string[] | null;

    constructor(data?: IApiUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null as any;
            this.userName = data["userName"] !== undefined ? data["userName"] : null as any;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null as any;
            this.isDisabled = data["isDisabled"] !== undefined ? data["isDisabled"] : null as any;
            this.email = data["email"] !== undefined ? data["email"] : null as any;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item in data["roles"])
                    this.roles!.push(data["roles"][item]);
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static fromJS(data: any): ApiUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item in this.roles)
                data["roles"].push(this.roles[item]);
        }
        return data;
    }

    clone(): ApiUserDetails {
        const json = this.toJSON();
        let result = new ApiUserDetails();
        result.init(json);
        return result;
    }
}

export interface IApiUserDetails {
    userId: number;
    userName?: string | null;
    fullName?: string | null;
    isDisabled: boolean;
    email?: string | null;
    roles?: string[] | null;
}

export class PowerBIReportInfo implements IPowerBIReportInfo {
    workspaceId?: string | null;
    reportId?: string | null;

    constructor(data?: IPowerBIReportInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.workspaceId = data["workspaceId"] !== undefined ? data["workspaceId"] : null as any;
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : null as any;
        }
    }

    static fromJS(data: any): PowerBIReportInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBIReportInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workspaceId"] = this.workspaceId !== undefined ? this.workspaceId : null as any;
        data["reportId"] = this.reportId !== undefined ? this.reportId : null as any;
        return data;
    }

    clone(): PowerBIReportInfo {
        const json = this.toJSON();
        let result = new PowerBIReportInfo();
        result.init(json);
        return result;
    }
}

export interface IPowerBIReportInfo {
    workspaceId?: string | null;
    reportId?: string | null;
}

export class ToastNotification implements IToastNotification {
    message?: string | null;
    type!: ToastType;
    operationId?: string | null;
    messageKey?: string | null;

    constructor(data?: IToastNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"] !== undefined ? data["message"] : null as any;
            this.type = data["type"] !== undefined ? data["type"] : null as any;
            this.operationId = data["operationId"] !== undefined ? data["operationId"] : null as any;
            this.messageKey = data["messageKey"] !== undefined ? data["messageKey"] : null as any;
        }
    }

    static fromJS(data: any): ToastNotification {
        data = typeof data === 'object' ? data : {};
        let result = new ToastNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["operationId"] = this.operationId !== undefined ? this.operationId : null as any;
        data["messageKey"] = this.messageKey !== undefined ? this.messageKey : null as any;
        return data;
    }

    clone(): ToastNotification {
        const json = this.toJSON();
        let result = new ToastNotification();
        result.init(json);
        return result;
    }
}

export interface IToastNotification {
    message?: string | null;
    type: ToastType;
    operationId?: string | null;
    messageKey?: string | null;
}

export enum ToastType {
    Info = 0,
    Success = 1,
    Warning = 2,
    Error = 3,
}

export class ProcessRunActivity implements IProcessRunActivity {
    uid?: string | null;
    processRunId!: string;
    subProcessRunId?: string | null;
    activityRunId!: string;
    caption?: string | null;
    burstingKey?: number | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    dueDate?: Date | null;
    status?: ActivityExecutionResultEnum | null;
    percentComplete?: number | null;
    dueDateMessageSeqNumber?: number | null;
    errorMessage?: string | null;

    constructor(data?: IProcessRunActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.uid = data["uid"] !== undefined ? data["uid"] : null as any;
            this.processRunId = data["processRunId"] !== undefined ? data["processRunId"] : null as any;
            this.subProcessRunId = data["subProcessRunId"] !== undefined ? data["subProcessRunId"] : null as any;
            this.activityRunId = data["activityRunId"] !== undefined ? data["activityRunId"] : null as any;
            this.caption = data["caption"] !== undefined ? data["caption"] : null as any;
            this.burstingKey = data["burstingKey"] !== undefined ? data["burstingKey"] : null as any;
            this.nodeId = data["nodeId"] !== undefined ? data["nodeId"] : null as any;
            this.activityName = data["activityName"] !== undefined ? data["activityName"] : null as any;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null as any;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : null as any;
            this.dueDate = data["dueDate"] ? new Date(data["dueDate"].toString()) : null as any;
            this.status = data["status"] !== undefined ? data["status"] : null as any;
            this.percentComplete = data["percentComplete"] !== undefined ? data["percentComplete"] : null as any;
            this.dueDateMessageSeqNumber = data["dueDateMessageSeqNumber"] !== undefined ? data["dueDateMessageSeqNumber"] : null as any;
            this.errorMessage = data["errorMessage"] !== undefined ? data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): ProcessRunActivity {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRunActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["processRunId"] = this.processRunId !== undefined ? this.processRunId : null as any;
        data["subProcessRunId"] = this.subProcessRunId !== undefined ? this.subProcessRunId : null as any;
        data["activityRunId"] = this.activityRunId !== undefined ? this.activityRunId : null as any;
        data["caption"] = this.caption !== undefined ? this.caption : null as any;
        data["burstingKey"] = this.burstingKey !== undefined ? this.burstingKey : null as any;
        data["nodeId"] = this.nodeId !== undefined ? this.nodeId : null as any;
        data["activityName"] = this.activityName !== undefined ? this.activityName : null as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : null as any;
        data["dueDateMessageSeqNumber"] = this.dueDateMessageSeqNumber !== undefined ? this.dueDateMessageSeqNumber : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }

    clone(): ProcessRunActivity {
        const json = this.toJSON();
        let result = new ProcessRunActivity();
        result.init(json);
        return result;
    }
}

export interface IProcessRunActivity {
    uid?: string | null;
    processRunId: string;
    subProcessRunId?: string | null;
    activityRunId: string;
    caption?: string | null;
    burstingKey?: number | null;
    nodeId?: string | null;
    activityName?: string | null;
    startTime?: Date | null;
    endTime?: Date | null;
    dueDate?: Date | null;
    status?: ActivityExecutionResultEnum | null;
    percentComplete?: number | null;
    dueDateMessageSeqNumber?: number | null;
    errorMessage?: string | null;
}

export class Item implements IItem {

    [key: string]: any;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): Item {
        const json = this.toJSON();
        let result = new Item();
        result.init(json);
        return result;
    }
}

export interface IItem {

    [key: string]: any;
}

export class Item2 implements IItem2 {

    [key: string]: any;

    constructor(data?: IItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }

    static fromJS(data: any): Item2 {
        data = typeof data === 'object' ? data : {};
        let result = new Item2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }

    clone(): Item2 {
        const json = this.toJSON();
        let result = new Item2();
        result.init(json);
        return result;
    }
}

export interface IItem2 {

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
